import { styled } from '@mui/system';
import {Typography} from "@material-ui/core";
import moment from "moment";

const DateCalc = (diff) => {
  var fupsomeDate = new Date();
  //console.log(fupsomeDate)
  fupsomeDate.setDate(fupsomeDate.getDate() + diff);
  const fupy = fupsomeDate.getFullYear();
  
  const fupm =
    fupsomeDate.getMonth() + 1 < 10
      ? "0" + (fupsomeDate.getMonth() + 1)
      : fupsomeDate.getMonth() + 1;
 
  const fupdt =
    fupsomeDate.getDate() < 10
      ? "0" + fupsomeDate.getDate()
      : fupsomeDate.getDate();
    
  const fupfinalDate = fupy + "-" + fupm + "-" + fupdt;
  //console.log(fupfinalDate)
  return fupfinalDate;
};

export const sslist=["AryanLohia", "Maria", "Vinayak", "Sucheta", "JatinSejwal", "TusharChauhan", "Paras", "ShristiGupta"]

export const getSumByKey = (arr, key) => {
  return arr.reduce(
    (accumulator, current) => accumulator + Number(current[key]),
    0
  );
};

export const getSumByKey2 = (arr, key) => {
  let sum=0
  for(let i=0;i<arr.length;i++){
    if(key in arr[i]){
      sum=sum+arr[i][key]
    }
  }
  return sum
};

export function DateCalc2 (date, diff) {
  var fupsomeDate = new Date(date);
  //console.log(fupsomeDate)
  fupsomeDate.setDate(fupsomeDate.getDate() + diff);
  const fupy = fupsomeDate.getFullYear();
  const fupm =
    fupsomeDate.getMonth() + 1 < 10
      ? "0" + (fupsomeDate.getMonth() + 1)
      : fupsomeDate.getMonth() + 1;
  const fupdt =
    fupsomeDate.getDate() < 10
      ? "0" + fupsomeDate.getDate()
      : fupsomeDate.getDate();
  const fupfinalDate = fupy + "-" + fupm + "-" + fupdt;
  //console.log(fupfinalDate)
  return fupfinalDate;
}
//console.log(DateCalc2("2022-12-29",30));
export function removeDuplicates2(arr) {
  return arr.filter((item,
      index) => arr.indexOf(item) === index);
}
//match 3 keys of an internal obejct in an array of objects to remove duplicate
export function removeDuplicatesmulti(array, nestedKey, key1, key2, key3) {
  const seen = new Set();

  return array.filter(item => {
    const nested = item[nestedKey];

    const uniqueKey = `${nested[key1]}|${nested[key2]}|${nested[key3]}`;

    if (seen.has(uniqueKey)) {
      return false;
    }

    seen.add(uniqueKey);
    return true;
  });
}
//match 3 keys of an array of objects to remove duplicate
export function removeDuplicatesmulti2(array, key1, key2, key3) {
  const seen = new Set();

  return array.filter(item => {
    const uniqueKey = `${item[key1]}|${item[key2]}|${item[key3]}`;

    if (seen.has(uniqueKey)) {
      return false;
    }

    seen.add(uniqueKey);
    return true;
  });
}

export function removeExistingFromArray2multi(array1, array2, nestedKey, key1, key2, key3) {
  const existing = new Set(
    array1.map(item => {
      const nested = item[nestedKey];
      return `${nested[key1]}|${nested[key2]}|${nested[key3]}`;
    })
  );

  return array2.filter(item => {
    const nested = item[nestedKey];
    const uniqueKey = `${nested[key1]}|${nested[key2]}|${nested[key3]}`;

    return !existing.has(uniqueKey);
  });
}


export const removeDuplicatesbysortingkey = (arr, key1, sortKey) => {
  const getValue = (obj, path) =>
    path.split(".").reduce((acc, key) => acc?.[key], obj);

  const map = new Map();

  arr.forEach((obj) => {
    const uniqueKey = getValue(obj, key1);
    const existing = map.get(uniqueKey);

    if (!existing) {
      map.set(uniqueKey, {
        first: obj,
        last: obj
      });
    } else {
      if (
        getValue(obj, sortKey) <
        getValue(existing.first, sortKey)
      ) {
        existing.first = obj;
      }

      if (
        getValue(obj, sortKey) >
        getValue(existing.last, sortKey)
      ) {
        existing.last = obj;
      }
    }
  });
   return Array.from(map.entries()).map(([uniqueKey, { first, last }]) => {
    // console.log("Trip ID:", uniqueKey);
    // console.log("First Object:", first);
    // console.log("Last Object:", last);
    // console.log("--------------------------");

    return {
      ...last,
      changelog: {
        ...last.changelog,
        "old_profit": first.changelog?.["old_profit"]
      }
    };
  });
};


export function formatDate2(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  var hh = d.getHours();
  var mm = d.getMinutes();
  var ss = d.getSeconds();
  var ms = d.getMilliseconds();
  //var newdate=year+"-"+day+"-"+month+"T"+hh+":"+mm+":"+ss+"."+ms+"Z"
  var newdate = day + "-" + month + "-" + year;
  return newdate;
}

export function formatDate3(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  var hh = d.getHours();
  var mm = d.getMinutes();
  var ss = d.getSeconds();
  var ms = d.getMilliseconds();
  //var newdate=year+"-"+day+"-"+month+"T"+hh+":"+mm+":"+ss+"."+ms+"Z"
  var newdate = day + "/" + month + "/" + year;
  return newdate;
}

export function identifydest(dest) {
  var desttype = 0;
  switch (dest) {
    case "Kashmir":
      desttype = 0;
      break;
    case "Himachal":
      desttype = 0;
      break;
    case "Andaman":
      desttype = 0;
      break;
    case "Goa":
      desttype = 0;
      break;
    case "Rajasthan":
      desttype = 0;
      break;
    case "Dubai":
      desttype = 1;
      break;
       case "Turkey":
      desttype = 1;
      break;
      case "Azerbaijan":
        desttype = 1;
        break;
        case "Georgia":
          desttype = 1;
          break;
          case "Kazakhstan":
            desttype = 1;
            break;
            case "Hong Kong":
              desttype = 1;
              break;
    case "Sikkim-Darjeeling":
      desttype = 0;
      break;
    case "Uttarakhand":
      desttype = 0;
      break;
    case "Kerala":
      desttype = 0;
      break;
    case "North-East":
      desttype = 0;
      break;
    case "Thailand":
      desttype = 1;
      break;
    case "Philippines":
      desttype = 1;
      break;
    case "Indonesia":
      desttype = 1;
      break;
    case "Maldives":
      desttype = 1;
      break;
    case "Mauritius":
      desttype = 1;
      break;
    case "Singapore":
      desttype = 1;
      break;
    case "Malaysia":
      desttype = 1;
      break;
    case "Sri Lanka":
        desttype = 1;
        break;
    case "Ladakh":
      desttype = 0;
      break;
    case "Europe":
        desttype = 1;
        break;
    case "Vietnam":
        desttype = 1;
        break;
      case "Seychelles":
        desttype = 1;
        break;
     case "Oman":
        desttype = 1;
        break;
    default:
      desttype = 0;

}
return desttype;
}

export function destAirport(dest) {
  var destairport = "";
  switch (dest) {
    case "Kashmir":
      destairport = "Srinagar";
      break;
    case "Himachal":
      destairport = "Chandigarh";
      break;
    case "Andaman":
      destairport = "Port Blair";
      break;
    case "Goa":
      destairport = "Panjim";
      break;
    case "Rajasthan":
      destairport = "Jaipur";
      break;
    case "Dubai":
      destairport = "Dubai";
      break;
    case "Sikkim-Darjeeling":
      destairport = "Siliguri";
      break;
    case "Uttarakhand":
      destairport = "New Delhi";
      break;
    case "Kerala":
      destairport = "Kochi";
      break;
    case "North-East":
      destairport = "Guwahati";
      break;
    case "Thailand":
      destairport = "Bangkok";
      break;
    case "Philippines":
      destairport = "Manila";
      break;
    case "Indonesia":
      destairport = "Denpasar";
      break;
    case "Maldives":
      destairport = "Male";
      break;
    case "Mauritius":
      destairport = "Mauritius";
      break;
    case "Singapore":
      destairport = "Singapore";
      break;
    case "Malaysia":
      destairport = "Kuala Lumpur";
      break;
    case "Ladakh":
      destairport = "Leh";
      break;
    case "Sri Lanka":
        destairport = "Colombo";
        break;
    case "Turkey":
        destairport = "Istanbul";
        break;
        case "Azerbaijan":
          destairport = "Baku";
          break;
          case "Kazakhstan":
            destairport = "Almaty";
            break;    
            case "Georgia":
              destairport = "Tbilisi";
              break; 
              case "Hong Kong":
              destairport = "Hong Kong";
              break;             
    default:
      destairport = "";

    //console.log(cuser)
  }
  return destairport;
}

export function destAirport2(dest) {
  var destairport = "";
  switch (dest) {
    case "AMD":
      destairport = "Ahmedabad";
      break;
    case "DEL":
      destairport = "New Delhi";
      break;
    case "BOM":
      destairport = "Mumbai";
      break;
    case "CCU":
      destairport = "Kolkata";
      break;
    case "IXB":
      destairport = "Bagdogra";
      break;
    case "HYD":
      destairport = "Hyderabad";
      break;
    case "BLR":
      destairport = "Bengaluru";
      break;
    case "COK":
      destairport = "Kochi";
      break;
    case "MAA":
      destairport = "Chennai";
      break;
    case "PNQ":
      destairport = "Pune";
      break;
    case "Thailand":
      destairport = "BKK";
      break;
    case "Philippines":
      destairport = "MNL";
      break;
    case "Indonesia":
      destairport = "DPS";
      break;
    case "Maldives":
      destairport = "MLE";
      break;
    case "Mauritius":
      destairport = "MRU";
      break;
    case "Singapore":
      destairport = "SIN";
      break;
    case "Malaysia":
      destairport = "KUL";
      break;
      case "Vietnam":
      destairport = "HAN";
      break;
    case "Ladakh":
      destairport = "IXL";
      break;
    case "Sri Lanka":
        destairport = "CMB";
        break;
        case "Turkey":
        destairport = "IST";
        break;
        case "Azerbaijan":
        destairport = "GYD";
        break;
        case "Georgia":
        destairport = "TBS";
        break;
        case "Kazakhstan":
        destairport = "ALA";
        break;
        case "Hong Kong":
              destairport = "HKG";
              break;  
    default:
      destairport = "";

    //console.log(cuser)
  }
  return destairport;
}

export function sortByKey(array, key) {
  return array.sort(function(a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}

export function sortByKeyDate(array, key) {
  return array.sort(function(a, b) {
      var x = new Date(a[key]); var y = new Date(b[key]);
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}

export function reversesortByKey(array, key) {
  return array.sort(function(a, b) {
      var x = a[key]; var y = b[key];
      return ((y < x) ? -1 : ((y > x) ? 1 : 0));
  });
}

export default DateCalc;

export function identifysheet(dest) {
  var sheettype = 0;
  switch (dest) {
    case "Kashmir":
      sheettype = "1RpPz2JFHqOXhvRVuX87C5vzugcQILoEsKdramLgaMj4";
      break;
    case "Himachal":
      sheettype = "1AY58VqvJpJ_a5dEBEgpaVmuhrAdVOlhHcjZhMTE0rNI";
      break;
    case "Andaman":
      sheettype = "1rusuYMTg3X3UpivQ1m6ynxXFWpUn1Ndjd09SyL_6ZUk";
      break;
    case "Goa":
      sheettype = "14BHtx_MEHDQFcUWGWUutu3yiPvXgDIlp8fbR865EJRA";
      break;
    case "Rajasthan":
      sheettype = 0;
      break;
    case "Dubai":
      sheettype = "16vDsSUBbJSGLSNcBM9Jik9OdTaRxNJTZL2_NfLf1218";
      break;
    case "Sikkim-Darjeeling":
      sheettype = "1Nyg_alLmZAwGt_1PetORbvbCZSnuw6C_-7nuMlbSpYM";
      break;
    case "Uttarakhand":
      sheettype = 0;
      break;
    case "Kerala":
      sheettype = "1OlEcR8eVmch9rWMCeZAGLs81hH6gejyOsvL7OTNTPFE";
      break;
    case "North-East":
      sheettype = 0;
      break;
    case "Thailand":
      sheettype = "1Eg_y7VNFabUbJmCzEYGlYPUqNIvwcbOT2Eq7DAnUsm8";
      break;
    case "Indonesia":
      sheettype = "1HhwSqo7jAQ1tu9_BNIskrzQTwnoVxWBc41JaVT0VjYc";
      break;
    case "Maldives":
      sheettype = 1;
      break;
    case "Mauritius":
      sheettype = 1;
      break;
    case "Singapore":
      sheettype = "1HD-1D_8vKKcuA0gr0cxwhUt9AdxjZNNruIQp7UW6Cpo";
      break;
    case "Malaysia":
      sheettype = "11Wm-MVPRaU1SuK2m_Qq4DWIhpeXJqpRddteRqlhkrMA";
      break;
    case "Ladakh":
      sheettype = "12o76xUUkcT_9IZDXrz97NjXIUZd0FhWKl6DDhJyquW0";
      break;

    default:
      sheettype = 0;

}
return sheettype;
}

export function identifycolumn(numadt, numchd) {
  var colnumber = 0;
  if(numadt==1 && numchd==0){
    colnumber=2
  }else if(numadt==2 && numchd==0){
    colnumber=3
  }else if(numadt==3 && numchd==0){
    colnumber=4
  }else if(numadt==4 && numchd==0){
    colnumber=5
  }else if(numadt==5 && numchd==0){
    colnumber=6
  }else if(numadt==6 && numchd==0){
    colnumber=7
  }else if(numadt==7 && numchd==0){
    colnumber=8
  }else if(numadt==8 && numchd==0){
    colnumber=9
  }else if(numadt==9 && numchd==0){
    colnumber=10
  }else if(numadt==1 && numchd==1){
    colnumber=11
  }else if(numadt==2 && numchd==1){
    colnumber=12
  }else if(numadt==2 && numchd==2){
    colnumber=13
  }else if(numadt==3 && numchd==1){
    colnumber=14
  }else if(numadt==3 && numchd==2){
    colnumber=15
  }else if(numadt==3 && numchd==3){
    colnumber=16
  }else if(numadt==4 && numchd==1){
    colnumber=17
  }else if(numadt==4 && numchd==2){
    colnumber=18
  }
return colnumber;
}

export function identifycolumn2(numadt, numchd) {
  var colnumber = 0;
  if(numadt==1 && numchd==0){
    colnumber="A1"
  }else if(numadt==2 && numchd==0){
    colnumber="A2"
  }else if(numadt==3 && numchd==0){
    colnumber="A3"
  }else if(numadt==4 && numchd==0){
    colnumber="A4"
  }else if(numadt==5 && numchd==0){
    colnumber="A5"
  }else if(numadt==6 && numchd==0){
    colnumber="A6"
  }else if(numadt==7 && numchd==0){
    colnumber="A7"
  }else if(numadt==8 && numchd==0){
    colnumber="A8"
  }else if(numadt==9 && numchd==0){
    colnumber="A9"
  }else if(numadt==10 && numchd==0){
    colnumber="A10"
  }else if(numadt==1 && numchd==1){
    colnumber="A1C1"
  }else if(numadt==2 && numchd==1){
    colnumber="A2C1"
  }else if(numadt==2 && numchd==2){
    colnumber="A2C2"
  }else if(numadt==3 && numchd==1){
    colnumber="A3C1"
  }else if(numadt==3 && numchd==2){
    colnumber="A3C2"
  }else if(numadt==3 && numchd==3){
    colnumber="A3C3"
  }else if(numadt==4 && numchd==1){
    colnumber="A4C1"
  }else if(numadt==4 && numchd==2){
    colnumber="A4C2"
  }else if(numadt==4 && numchd==3){
    colnumber="A4C3"
  }else if(numadt==5 && numchd==1){
    colnumber="A5C1"
  }else if(numadt==5 && numchd==2){
    colnumber="A5C2"
  }else if(numadt==5 && numchd==3){
    colnumber="A5C3"
  }else if(numadt==6 && numchd==1){
    colnumber="A6C1"
  }else if(numadt==6 && numchd==2){
    colnumber="A6C2"
  }else if(numadt==6 && numchd==3){
    colnumber="A6C3"
  }
return colnumber;
}

export function identifycurr(dest) {
  var curr = 0;
  switch (dest) {
    case "Kashmir":
      curr = 0;
      break;
    case "Himachal":
      curr = 0;
      break;
    case "Andaman":
      curr = 0;
      break;
    case "Goa":
      curr = 0;
      break;
    case "Rajasthan":
      curr = 0;
      break;
    case "Dubai":
      curr = 1;
      break;
    case "Sikkim-Darjeeling":
      curr = 0;
      break;
    case "Uttarakhand":
      curr = 0;
      break;
    case "Kerala":
      curr = 0;
      break;
    case "North-East":
      curr = 0;
      break;
    case "Thailand":
      curr = 3;
      break;
    case "Philippines":
      curr = 1;
      break;
    case "Indonesia":
      curr = 1;
      break;
    case "Vietnam":
      curr = 1;
      break;
    case "Maldives":
      curr = 1;
      break;
    case "Mauritius":
      curr = 1;
      break;
    case "Singapore":
      curr = 2;
      break;
    case "Malaysia":
      curr = 1;
      break;
    case "Sri Lanka":
        curr = 1;
        break;
        case "Turkey":
          curr = 4;
          break;
          case "Europe":
            curr = 4;
            break;
            case "Azerbaijan":
            curr = 1;
            break;
            case "Georgia":
            curr = 1;
            break;
            case "Kazakhstan":
            curr = 1;
            break;
            case "Hong Kong":
            curr = 1;
            break;
    case "Ladakh":
      curr = 0;
      break;

    default:
      curr = 0;

}
return curr;
}

export function identifycurrency(dest) {
  var curr = 0;
  switch (dest) {
    case "Kashmir":
      curr = "INR";
      break;
    case "Himachal":
      curr = "INR";
      break;
    case "Andaman":
      curr = "INR";
      break;
    case "Goa":
      curr = "INR";
      break;
    case "Rajasthan":
      curr = "INR";
      break;
    case "Dubai":
      curr = "USD";
      break;
    case "Sikkim-Darjeeling":
      curr = "INR";
      break;
    case "Uttarakhand":
      curr = "INR";
      break;
    case "Kerala":
      curr = "INR";
      break;
    case "North-East":
      curr = "INR";
      break;
    case "Thailand":
      curr = "USD";
      break;
    case "Philippines":
      curr = "USD";
      break;
    case "Indonesia":
      curr = "USD";
      break;
    case "Vietnam":
      curr = "USD";
      break;
    case "Maldives":
      curr = "USD";
      break;
    case "Mauritius":
      curr = "USD";
      break;
    case "Singapore":
      curr = "SGD";
      break;
    case "Malaysia":
      curr = "USD";
      break;
    case "Sri Lanka":
      curr = "USD";
        break;
        case "Turkey":
          curr = "EUR";
          break;
          case "Europe":
            curr = "EUR";
            break;
            case "Azerbaijan":
              curr = "USD";
            break;
            case "Georgia":
              curr = "USD";
            break;
            case "Kazakhstan":
              curr = "USD";
            break;
            case "Hong Kong":
              curr = "USD";
            break;
    case "Ladakh":
      curr = "INR";
      break;

    default:
      curr = "";

}
return curr;
}

export function identifydestpic(dest) {
  var desttype = "imgheader";
  switch (dest) {
    case "Kashmir":
      desttype = "kashmir1";
      break;
    case "Himachal":
      desttype = "himachal1";
      break;
    case "Andaman":
      desttype = "andaman1";
      break;
    case "Goa":
      desttype = "goa1";
      break;
    case "Rajasthan":
      desttype = "rajasthan1";
      break;
    case "Dubai":
      desttype = "dubai1";
      break;
    case "Sikkim-Darjeeling":
      desttype = "sgd1";
      break;
    case "Uttarakhand":
      desttype = "uttarakhand1";
      break;
    case "Kerala":
      desttype = "kerala1";
      break;
    case "North-East":
      desttype = "northeast1";
      break;
    case "Thailand":
      desttype = "thailand1";
      break;
    case "Philippines":
      desttype = "philippines1";
      break;
    case "Indonesia":
      desttype = "indonesia1";
      break;
    case "Vietnam":
      desttype = "vietnam1";
      break;
    case "Maldives":
      desttype = "maldives1";
      break;
    case "Mauritius":
      desttype = "mauritius1";
      break;
    case "Singapore":
      desttype = "singapore1";
      break;
    case "Malaysia":
      desttype = "malaysia1";
      break;
    case "Ladakh":
      desttype = "ladakh1";
      break;
    case "Sri Lanka":
      desttype = "sl1";
      break;
    case "Turkey":
      desttype = "turkey1";
      break;
    case "Europe":
      desttype = "europe1";
      break;
    case "Kazakhstan":
      desttype = "kazakhstan1";
      break;
    case "Azerbaijan":
      desttype = "azerbaijan1";
      break;
    case "Hong Kong":
      desttype = "hongkong1";
      break;
      case "Georgia":
      desttype = "georgia1";
      break;
    default:
      desttype = "imgheader";

}
return desttype;
}

export function identifydestpic2(dest) {
  var desttype = "bodyimage";
  switch (dest) {
    case "Kashmir":
      desttype = "kashmir2";
      break;
    case "Himachal":
      desttype = "himachal2";
      break;
    case "Andaman":
      desttype = "andaman2";
      break;
    case "Goa":
      desttype = "goa2";
      break;
    case "Rajasthan":
      desttype = "rajasthan2";
      break;
    case "Dubai":
      desttype = "dubai2";
      break;
    case "Sikkim-Darjeeling":
      desttype = "sgd2";
      break;
    case "Uttarakhand":
      desttype = "uttarakhand2";
      break;
    case "Kerala":
      desttype = "kerala2";
      break;
    case "North-East":
      desttype = "northeast2";
      break;
    case "Thailand":
      desttype = "thailand2";
      break;
    case "Philippines":
      desttype = "philippines2";
      break;
    case "Indonesia":
      desttype = "indonesia2";
      break;
    case "Maldives":
      desttype = "maldives2";
      break;
    case "Mauritius":
      desttype = "mauritius2";
      break;
    case "Singapore":
      desttype = "singapore2";
      break;
    case "Malaysia":
      desttype = "malaysia2";
      break;
    case "Ladakh":
      desttype = "ladakh2";
      break;
    case "Vietnam":
      desttype = "vietnam2";
      break;
      case "Sri Lanka":
        desttype = "sl2";
        break;
        case "Turkey":
          desttype = "turkey2";
          break;
          case "Europe":
            desttype = "europe2";
            break;
          case "Kazakhstan":
            desttype = "kazakhstan2";
            break;
          case "Azerbaijan":
            desttype = "azerbaijan2";
            break;
          case "Hong Kong":
            desttype = "hongkong2";
            break;
            case "Georgia":
              desttype = "georgia2";
              break;
    default:
      desttype = "bodyimage";

}
return desttype;
}

export function identifydestpic3(dest) {
  var desttype = "footerimage";
  switch (dest) {
    case "Kashmir":
      desttype = "kashmir3";
      break;
    case "Himachal":
      desttype = "himachal3";
      break;
    case "Andaman":
      desttype = "andaman3";
      break;
    case "Goa":
      desttype = "goa3";
      break;
    case "Rajasthan":
      desttype = "rajasthan3";
      break;
    case "Dubai":
      desttype = "dubai3";
      break;
    case "Sikkim-Darjeeling":
      desttype = "sgd3";
      break;
    case "Uttarakhand":
      desttype = "uttarakhand3";
      break;
    case "Kerala":
      desttype = "kerala3";
      break;
    case "North-East":
      desttype = "northeast3";
      break;
    case "Thailand":
      desttype = "thailand3";
      break;
    case "Philippines":
      desttype = "philippines3";
      break;
    case "Indonesia":
      desttype = "indonesia3";
      break;
    case "Maldives":
      desttype = "maldives3";
      break;
    case "Mauritius":
      desttype = "mauritius3";
      break;
    case "Singapore":
      desttype = "singapore3";
      break;
    case "Malaysia":
      desttype = "malaysia3";
      break;
    case "Ladakh":
      desttype = "ladakh3";
      break;
    case "Vietnam":
      desttype = "vietnam3";
      break;
      case "Sri Lanka":
        desttype = "sl3";
        break;
        case "Turkey":
          desttype = "turkey3";
          break;
          case "Europe":
      desttype = "europe3";
      break;
    case "Kazakhstan":
      desttype = "kazakhstan3";
      break;
    case "Azerbaijan":
      desttype = "azerbaijan3";
      break;
    case "Hong Kong":
      desttype = "hongkong3";
      break;
      case "Georgia":
        desttype = "georgia3";
        break;
    default:
      desttype = "footerimage";

}
return desttype;
}

export function identifydestpic4(dest) {
  var desttype = "footerimage";
  switch (dest) {
    case "Kashmir":
      desttype = "kashmir4";
      break;
    case "Himachal":
      desttype = "himachal4";
      break;
    case "Andaman":
      desttype = "andaman4";
      break;
    case "Goa":
      desttype = "goa4";
      break;
    case "Rajasthan":
      desttype = "rajasthan4";
      break;
    case "Dubai":
      desttype = "dubai4";
      break;
    case "Sikkim-Darjeeling":
      desttype = "sgd4";
      break;
    case "Uttarakhand":
      desttype = "uttarakhand4";
      break;
    case "Kerala":
      desttype = "kerala4";
      break;
    case "North-East":
      desttype = "northeast4";
      break;
    case "Thailand":
      desttype = "thailand4";
      break;
    case "Philippines":
      desttype = "philippines4";
      break;
    case "Indonesia":
      desttype = "indonesia4";
      break;
    case "Maldives":
      desttype = "maldives4";
      break;
    case "Mauritius":
      desttype = "mauritius4";
      break;
    case "Singapore":
      desttype = "singapore4";
      break;
    case "Malaysia":
      desttype = "malaysia4";
      break;
    case "Ladakh":
      desttype = "ladakh4";
      break;
    case "Vietnam":
      desttype = "vietnam4";
      break;
      case "Sri Lanka":
        desttype = "sl4";
        break;
        case "Turkey":
          desttype = "turkey4";
          break;
    default:
      desttype = "footerimage";

}
return desttype;
}

export function childagearray(numchild) {
  var desttype = [];
  switch (numchild) {
    case 1:
      desttype = [1];
      break;
      case 2:
        desttype = [1,2];
        break;
        case 3:
          desttype = [1,2,3];
          break;
          case 4:
            desttype = [1,2,3,4];
            break;
            case 5:
              desttype = [1,2,3,4,5];
              break;
              case 6:
                desttype = [1,2,3,4,5,6];
                break;
                case 7:
                  desttype = [1,2,3,4,5,6,7];
                  break;
                  case 8:
                    desttype = [1,2,3,4,5,6,7,8];
                    break;
                    case 9:
                      desttype = [1,2,3,4,5,6,7,8,9];
                      break;
   ;

    default:
      desttype = [];

}
return desttype;
}

export function destcode(dest) {
  var desttype =0;
  switch (dest) {
    case "Kashmir":
      desttype = "IN";
      break;
    case "Himachal":
      desttype = "IN";
      break;
    case "Andaman":
      desttype = "IN";
      break;
    case "Goa":
      desttype = "IN";
      break;
    case "Rajasthan":
      desttype = "IN";
      break;
    case "Dubai":
      desttype = "AE";
      break;
    case "Sikkim-Darjeeling":
      desttype = "IN";
      break;
    case "Uttarakhand":
      desttype = "IN";
      break;
    case "Kerala":
      desttype = "IN";
      break;
    case "North-East":
      desttype = "IN";
      break;
    case "Thailand":
      desttype = "TH";
      break;
    case "Philippines":
      desttype = "PH";
      break;
    case "Indonesia":
      desttype = "ID";
      break;
    case "Maldives":
      desttype = "MV";
      break;
    case "Mauritius":
      desttype = "MU";
      break;
    case "Singapore":
      desttype = "SG";
      break;
    case "Malaysia":
      desttype = "MY";
      break;
    case "Ladakh":
      desttype = "IN";
      break;
      case "Australia":
        desttype = "AU";
        break;
      
      case "Tamil Nadu":
        desttype = "IN";
      break;
      case "Vietnam":
      desttype = "VN";
      break;
      case "Sri Lanka":
      desttype = "LK";
      break;
      case "Seychelles":
      desttype = "SC";
      break;
      case "Turkey":
      desttype = "TR";
      break;
      case "Gujarat":
        desttype = "IN";
      break;
      case "Azerbaijan":
        desttype = "AZ";
      break;
      case "Kazakhstan":
        desttype = "KZ";
      break;
      case "Georgia":
        desttype = "GE";
      break;
      case "Uzbekistan":
        desttype = "UZ";
      break;
      case "Russia":
        desttype = "RU";
      break;
      case "Golden Triangle":
        desttype = "IN";
      break;

    default:
      desttype = 0;

}
return desttype;
}

export function citycode(city) {
  var desttype =0;
  switch (city) {
    case "Bangkok":
      desttype = 864;
      break;
    case "Pattaya":
      desttype = 882;
      break;
    case "Phuket":
      desttype = 893;
      break;
    case "Krabi":
      desttype = 4920;
      break;
    case "Hua Hin":
      desttype = 866;
      break;
      case "Koh Samui":
        desttype = 871;
        break;
        case "Chiang Mai":
          desttype = 1343;
          break;
    case "Dubai":
      desttype = 968;
      break;
    case "Abu Dhabi":
      desttype = 967;
      break;
      case "Singapore":
        desttype = 7355;
        break;
        case "Sentosa":
          desttype = 3288;
          break;
    case "Penang":
      desttype = 1190;
      break;
    case "Langkawi":
      desttype = 1189;
      break;
      case "Kuala Lumpur":
      desttype = 458;
      break;
    case "Bali":
      desttype = 326;
      break;
    case "Gili":
      desttype = 1490;
      break;
    case "Nusa Penida":
        desttype = 62336;
        break;
    case "Hanoi":
      desttype = 1496;
      break;
    case "Da Nang":
      desttype = 70470;
      break;
    case "Da Lat":
      desttype = 14393;
      break;
    case "Ho Chi Minh":
      desttype = 970;
      break;
    case "Phu Quoc":
      desttype = 10085;
      break;
      case "Sa Pa":
        desttype = 26806;
        break;
      
        case "Colombo":
          desttype = 1562;
          break;
          case "Bentota":
            desttype = 848;
            break;
            case "Kandy":
              desttype = 853;
              break;
      case "Jaipur":
      desttype = 8896;
      break;
      case "Jaisalmer":
        desttype = 17828;
      break;
      case "Jammu":
        desttype = 20803;
      break;
      case "Mussoorie":
        desttype = 26970;
      break;
      case "Rishikesh":
        desttype = 17054;
      break;
      case "Delhi":
        desttype = 7433;
      break;
      case "Calangute":
        desttype = 8466;
      break;
      case "Jodhpur":
        desttype = 16658;
      break;
      case "Kovalam":
        desttype = 9136;
      break;
      case "Kalimpong":
        desttype = 24361;
      break;
      case "Chennai":
        desttype = 14137;
      break;
      case "Kanyakumari":
        desttype = 27158;
      break;
      case "Kolkata":
        desttype = 9768;
      break;
      case "Hyderabad":
        desttype = 20801;
      break;
      case "Katra":
        desttype = 27048;
      break;
      case "Cochin":
        desttype = 9720;
      break;
      case "Kodaikanal":
        desttype = 14168;
      break;
      case "Kullu":
        desttype = 27027;
      break;
      case "Kumarakom":
        desttype = 9137;
      break;
      case "Leh":
        desttype = 19863;
      break;
      case "Manali":
        desttype = 27030;
      break;
      case "Udaipur":
        desttype = 8897;
      break;
      case "Munnar":
        desttype = 14310;
      break;
      case "Nainital":
        desttype = 26972;
      break;
      case "Ooty":
        desttype = 26913;
      break;
      case "Dharamsala":
        desttype = 27020;
      break;
      case "Anjuna":
        desttype = 8462;
      break;
      case "Panaji":
        desttype = 8463;
      break;
      case "Alleppey":
        desttype = 9134;
      break;
      case "Darjeeling":
        desttype = 23835;
      break;
      case "Gangtok":
        desttype = 24362;
      break;
      case "Poovar":
        desttype = 9133;
      break;
      case "Srinagar":
        desttype = 26816;
      break;
      case "Port Blair":
        desttype = 25443;
      break;
      case "Shimla":
        desttype = 17055;
      break;
      case "Wayanad":
        desttype = 27094;
      break;
      case "Dalhousie":
        desttype = 27019;
      break;
      case "Gulmarg":
        desttype = 27046;
      break;
      case "Havelock":
        desttype = 32485;
      break;
      case "Pelling":
        desttype = 26897;
      break;
      case "Lachung":
        desttype = 60445;
      break;
      case "Shillong":
        desttype = 27136;
      break;
      case "Coorg":
        desttype = 27065;
      break;
      case "Neill Island":
        desttype = 62290;
      break;
      case "Ravangla":
        desttype = 55843;
      break;
      case "Sonmarg":
        desttype = 27051;
      break;
      case "Kasol":
        desttype = 67774;
      break;
      case "Mirik":
        desttype = 67971;
      break;
      case "Pangong":
        desttype = 27050;
      break;
      case "Jispa":
        desttype = 65323;
      break;
      case "Nubra Valley":
        desttype = 76163;
      break;
      case "Sarchu":
        desttype = 27037;
      break;
      case "Hunder":
        desttype = 75279;
      break;
      case "Kargil":
        desttype = 27047;
      break;
      case "Lachen":
        desttype = 76652;
      break;
      case "Pahalgam":
        desttype = 27049;
      break;
      case "Candolim":
        desttype = 4056;
      break;
      case "Baga":
        desttype = 23982;
      break;
      case "Morjim":
        desttype = 65501;
      break;
      case "Colva":
        desttype = 8465;
      break;
      case "Vagator":
        desttype = 55837;
      break;
      case "Majorda":
        desttype = 72848;
      break;
      case "Bambolim":
        desttype = 83038;
      break;
      case "Mandrem":
        desttype = 67440;
      break;
      case "Bikaner":
        desttype = 16661;
      break;
      case "Mount Abu":
        desttype = 17822;
      break;
      case "Kurseong":
        desttype = 77307;
      break;
      case "Namchi":
        desttype = 26896;
      break;
      case "Rangpo":
        desttype = 94621;
      break;
      case "Lataguri":
        desttype = 67776;
      break;
      case "Jaldapara":
        desttype = 93613;
      break;
      case "Thekkady":
        desttype = 23646;
      break;
      case "Thiruvananthapuram":
        desttype = 76356;
      break;
      case "Varkala":
        desttype = 20172;
      break
      case "Palakkad":
        desttype = 27090;
      break
      case "Cherai":
        desttype = 67752;
      break
      case "Agra":
        desttype = 8895;
      break
      case "Bodrum":
        desttype = 914;
      break
      case "Istanbul":
        desttype = 924;
      break
      case "Pamukkale":
        desttype = 8885;
      break
      case "Goreme":
        desttype = 17326;
      break
      case "Kusadasi":
        desttype = 920;
      break
      case "Antalya":
        desttype = 930;
      break
      case "Ankara":
        desttype = 1863;
      break
      case "Izmir":
        desttype = 1789;
      break
      case "Konya":
        desttype = 20328;
      break
      case "Marmaris":
        desttype = 921;
      break
      case "Urgup":
        desttype = 10965;
      break
      case "Nevsehir":
        desttype = 14779;
      break
      case "Maldives":
        desttype = 200000;
      break
      case "Baku":
        desttype = 17123;
      break
      case "Sheki":
        desttype = 65393;
      break
      case "Ganja":
        desttype = 65907;
      break
      case "Gabala":
        desttype = 71639;
      break
      case "Shahdag":
        desttype = 79521;
      break
      case "Almaty":
        desttype = 3047;
      break
      case "Astana":
        desttype = 21483;
      break
      case "Tbilisi":
        desttype = 200004;
      break
      case "Kutaisi":
        desttype = 66693;
      break
      case "Batumi":
        desttype = 21592;
      break
      case "Gudauri":
        desttype = 55778;
      break
    default:
      desttype = 0;

}
return desttype;
}

export function getratingdata(rating){
  var data=""
  switch (rating) {
    case 1:
      data = "<HotelRating>1</HotelRating>\n         ";
      break;
      case 2:
      data = "<HotelRating>2</HotelRating>\n         ";
      break;
      case 3:
      data = "<HotelRating>3</HotelRating>\n         ";
      break;
      case 4:
      data = "<HotelRating>4</HotelRating>\n         ";
      break;
      case 5:
      data = "<HotelRating>5</HotelRating>\n         ";
      break;
      case 23:
      data = "<HotelRating>2</HotelRating>\n         <HotelRating>3</HotelRating>\n         ";
      break;
      case 34:
      data = "<HotelRating>3</HotelRating>\n         <HotelRating>4</HotelRating>\n         ";
      break;
      case 45:
      data = "<HotelRating>4</HotelRating>\n         <HotelRating>5</HotelRating>\n         ";
      break;
      case 234:
      data = "<HotelRating>2</HotelRating>\n         <HotelRating>3</HotelRating>\n         <HotelRating>4</HotelRating>\n";
      break;
      case 345:
      data = "<HotelRating>3</HotelRating>\n         <HotelRating>4</HotelRating>\n         <HotelRating>5</HotelRating>\n";
      break;
    case 12345:
      data = "<HotelRating>1</HotelRating>\n         <HotelRating>2</HotelRating>\n         <HotelRating>3</HotelRating>\n         <HotelRating>4</HotelRating>\n         <HotelRating>5</HotelRating>\n";
      break;
      default:
        data = "<HotelRating>1</HotelRating>\n         <HotelRating>2</HotelRating>\n         <HotelRating>3</HotelRating>\n         <HotelRating>4</HotelRating>\n         <HotelRating>5</HotelRating>\n";;

}
return data;
}

export function isNumericRegex(str) {
  return /^[0-9,]*$/.test(str);
}

export function getquality(status, ttb, platform, startdate, upgrade, pp, campaign, flightreq, ctype, frfailed){
  var quality=""
  var hq=0
if(startdate && (new Date(startdate).getTime()-new Date().getTime())/(1000*60*60*24)>240){
  quality="Iron"
}else{
if(platform){
  if(platform=="TripCrafters"){
    quality="Gold"
  }
  else if(platform=="Reference" || platform=="Call" || platform=="Others"){
    quality="Platinum"
  }
  else if(platform=="Google"){
    hq=1
  }
} 
if(campaign=="Call"){
  quality="Platinum"
}
if(campaign=="Destination Pages"){
  quality="Diamond"
}
if(quality==""){ 
  if(platform=="Organic"){
    if(status && ttb){
      if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within 2-3 days"){
        quality="Platinum"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within 2-3 days"){
        quality="Diamond"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within 2-3 days"){
        quality="Gold"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within 2-3 days"){
        quality="Gold"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within a week"){
        quality="Diamond"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within a week"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within a week"){
        quality="Diamond"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within a week"){
        quality="Gold"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within a month"){
        quality="Diamond"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within a month"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within a month"){
        quality="Gold"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within a month"){
        quality="Copper"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="Nothing decided as of now"){
        quality="Gold"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="Nothing decided as of now"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="Nothing decided as of now"){
        quality="Gold"
      }else if(status=="Looking for information only. Will plan later" && ttb=="Nothing decided as of now" && !hq){
        quality="Copper"
      }
    }else if(status){
      if(status=="Looking for information only. Will plan later" && !hq){
        quality="Copper"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet"){
        quality="Silver"
      }else if(status=="Definitely going on a trip. Planning in progress"){
        quality="Gold"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package"){
        quality="Diamond"
      }
    }else if(ttb){
      if(ttb=="I will book within 2-3 days"){
        quality="Diamond"
      }else if(ttb=="I will book within a week"){
        quality="Gold"
      }else if(ttb=="I will book within a month"){
        quality="Silver"
      }else if(ttb=="Nothing decided as of now"){
        quality="Silver"
      }
    }else{
      if(campaign=="Meta Chat"){
        quality="Diamond"
      }else{
        quality="Gold"
      }
      
    }
  }
  else{
    if(status && ttb){
      if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within 2-3 days"){
        quality="Platinum"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within 2-3 days"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within 2-3 days"){
        quality="Gold"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within 2-3 days" && !hq){
        quality="Iron"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within a week"){
        quality="Diamond"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within a week"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within a week" && !hq){
        quality="Copper"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within a week" && !hq){
        quality="Iron"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within a month"){
        quality="Silver"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within a month"){
        quality="Silver"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within a month" && !hq){
        quality="Copper"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within a month" && !hq){
        quality="Iron"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="Nothing decided as of now"){
        quality="Copper"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="Nothing decided as of now" && !hq){
        quality="Copper"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="Nothing decided as of now" && !hq){
        quality="Iron"
      }else if(status=="Looking for information only. Will plan later" && ttb=="Nothing decided as of now" && !hq){
        quality="Iron"
      }
    }else if(status){
      if(status=="Looking for information only. Will plan later" && !hq){
        quality="Iron"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && !hq){
        quality="Copper"
      }else if(status=="Definitely going on a trip. Planning in progress"){
        quality="Gold"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package"){
        quality="Diamond"
      }
    }else if(ttb){
      if(ttb=="I will book within 2-3 days"){
        quality="Diamond"
      }else if(ttb=="I will book within a week"){
        quality="Gold"
      }else if(ttb=="I will book within a month"){
        quality="Silver"
      }else if(ttb=="Nothing decided as of now" && !hq){
        quality="Iron"
      }
    }else{
      quality="Gold"
    }
  }
  
}

}
if(platform=="TripClap"){
  quality="Silver"
}

if(quality!=="Platinum" && pp=="No, yet to apply" && !hq){
  quality="Copper"
}
if(campaign){
  if(campaign=="Poptin"){
    quality="Silver"
  }
}
if(frfailed && platform=="Meta"){
  quality="Silver"
}
if(upgrade){
  quality="Titanium"

}
if(quality==""){
  quality="Gold"
}
if(ctype){
  if(ctype=="Repeat Customer"){
    quality="Rhodium"
  }
}

return quality
}

export function newgetqualitylead(lead, skipupgrade){
  const status=lead.lead_status
  const ttb=lead.time_to_book
  const platform=lead.lead_platform
  const startdate=lead.lead_travel_date
  const upgrade=lead.quality_upgrade
  const pp=lead.lead_passport 
  const campaign=lead.lead_campaign
  const flightreq=lead.flight_required
  const ctype=lead.customer_type
  const frfailed=lead.manual_fast_reach_failed
  const pax=Number(lead.lead_pax)
  const lp=lead.landing_page
  const created=lead.createdAt
  const destination=lead.lead_destination
  var quality=""
  var hq=0
if(startdate && (new Date(startdate).getTime()-new Date().getTime())/(1000*60*60*24)>240){
  quality="Iron"
}else{
if(platform){
  if(platform=="TripCrafters"){
    quality="Gold"
  }
  else if(platform=="Reference" || campaign=="Call" || campaign=="Others" || platform=="Others" ){
    quality="Rhodium"
  }
  else if(platform=="Google"){
    hq=1
  }
} 
if(quality==""){ 
  if(platform=="Organic"){
    if(status && ttb){
      if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within 2-3 days"){
        quality="Platinum"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within 2-3 days"){
        quality="Diamond"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within 2-3 days"){
        quality="Gold"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within 2-3 days"){
        quality="Gold"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within a week"){
        quality="Diamond"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within a week"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within a week"){
        quality="Diamond"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within a week"){
        quality="Gold"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within a month"){
        quality="Diamond"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within a month"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within a month"){
        quality="Gold"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within a month"){
        quality="Copper"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="Nothing decided as of now"){
        quality="Gold"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="Nothing decided as of now"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="Nothing decided as of now"){
        quality="Gold"
      }else if(status=="Looking for information only. Will plan later" && ttb=="Nothing decided as of now" && !hq){
        quality="Copper"
      }
    }else if(status){
      if(status=="Looking for information only. Will plan later" && !hq){
        quality="Copper"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet"){
        quality="Silver"
      }else if(status=="Definitely going on a trip. Planning in progress"){
        quality="Gold"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package"){
        quality="Diamond"
      }
    }else if(ttb){
      if(ttb=="I will book within 2-3 days"){
        quality="Diamond"
      }else if(ttb=="I will book within a week"){
        quality="Gold"
      }else if(ttb=="I will book within a month"){
        quality="Silver"
      }else if(ttb=="Nothing decided as of now"){
        quality="Silver"
      }
    }else{
      if(campaign=="Meta Chat"){
        quality="Diamond"
      }else{
        quality="Gold"
      }
      
    }
  }
  else{
    if(status && ttb){
      if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within 2-3 days"){
        quality="Platinum"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within 2-3 days"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within 2-3 days"){
        quality="Gold"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within 2-3 days" && !hq){
        quality="Iron"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within a week"){
        quality="Diamond"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within a week"){
        quality="Gold"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within a week" && !hq){
        quality="Copper"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within a week" && !hq){
        quality="Iron"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="I will book within a month"){
        quality="Silver"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="I will book within a month"){
        quality="Silver"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="I will book within a month" && !hq){
        quality="Copper"
      }else if(status=="Looking for information only. Will plan later" && ttb=="I will book within a month" && !hq){
        quality="Iron"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package" && ttb=="Nothing decided as of now"){
        quality="Copper"
      }else if(status=="Definitely going on a trip. Planning in progress" && ttb=="Nothing decided as of now" && !hq){
        quality="Copper"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && ttb=="Nothing decided as of now" && !hq){
        quality="Iron"
      }else if(status=="Looking for information only. Will plan later" && ttb=="Nothing decided as of now" && !hq){
        quality="Iron"
      }
    }else if(status){
      if(status=="Looking for information only. Will plan later" && !hq){
        quality="Iron"
      }else if(status=="Thinking about going on a trip but nothing has been decided yet" && !hq){
        quality="Copper"
      }else if(status=="Definitely going on a trip. Planning in progress"){
        quality="Gold"
      }else if(status=="Travel date, destination and people travelling all finalized. Just looking for a package"){
        quality="Diamond"
      }
    }else if(ttb){
      if(ttb=="I will book within 2-3 days"){
        quality="Diamond"
      }else if(ttb=="I will book within a week"){
        quality="Gold"
      }else if(ttb=="I will book within a month"){
        quality="Silver"
      }else if(ttb=="Nothing decided as of now" && !hq){
        quality="Iron"
      }
    }else{
      quality="Gold"
    }
  }
  
}

}
if(platform=="TripClap"){
  if(new Date(created).getTime()<new Date("2026-07-27").getTime()){
      quality="Silver"
  }else{
    if(((new Date(startdate).getTime()-new Date().getTime())/(1000*60*60*24*10))<1){
      quality="Silver"
    }else {
      if(pax>4){
      quality="Gold"
    }else{
      quality="Silver"
    }
    }
      
  }
  
}

if(quality=="Gold"){
  if(platform=="Others" || campaign=="Call"){
  quality="Rhodium"
  }
  if(campaign=="Destination Pages"){
  quality="Diamond"
  }
}

if(quality!=="Platinum" && pp=="No, yet to apply" && !hq){
  quality="Copper"
}
if(campaign){
  if(campaign=="Poptin"){
    quality="Silver"
  }
}
if(frfailed && platform=="Meta"){
  quality="Silver"
}
if(skipupgrade){

}else if(upgrade){
  quality="Titanium"

}
if(lp=="Instant Form"){
  if(destination.startsWith("Other")){
    quality="Silver"
  }else{
    quality="Gold"
  }
}

if(destination && destination.startsWith("Other") && new Date(created).getTime()>new Date("2026-10-01").getTime()){
  quality="Silver"
}

if(quality=="Silver" && pax>4){
  quality="Diamond"
}
if(quality==""){
  quality="Gold"
}
if(ctype){
  if(ctype=="Repeat Customer"){
    quality="Rhodium"
  }
}

return quality
}

export const getflightprofit=(trip)=>{
  return "flight_sp" in trip && "flight_cp" in trip?trip.flight_sp-trip.flight_cp:0
}



export const upsellprofittotal = (upsellData) => {
    let sum = 0;
    if(upsellData && Array.isArray(upsellData)){
    if (upsellData.length == 0) {
      return sum;
    } else {
      upsellData.map((item) =>
              item.inventory=="Hotel Upsell Ops"?sum:
             (item.inventory=="SIM" || item.inventory=="Insurance" || item.inventory=="Arrival Card"?
            (sum = sum + ((parseInt(item.sp)-parseInt(item.cp))/1.18)):
           (sum = sum + ((parseInt(item.sp)-parseInt(item.cp))/1.05)))
      );
    }
      return Math.round(sum);
    }
  
  };

export const hotelupsellprofittotal = (upsellData) => {
    let sum = 0;
    if(upsellData && Array.isArray(upsellData)){
    if (upsellData.length == 0) {
      return sum;
    } else {
      upsellData.map((item) =>
       
             item.inventory=="Hotel Upsell Ops"?
            
           (sum = sum + ((parseInt(item.sp)-parseInt(item.cp))/1.05)):sum
      );
    }
      return Math.round(sum);
    }
  
  };

export const profitwithoutupsell=(trip)=>{
    return ("cust_payments" in trip && "supplier_payments" in trip
    ? total(trip.cust_payments) -
      sptotal(trip.supplier_payments) -
      gettaxes(trip) -
      gettcs(trip)
    : 0)-("upsell" in trip && trip.upsell.length>0?upsellprofittotal(trip.upsell):0)
  }

  

export function getmonthtext(date){
  var monthtext=""
  var d = new Date(date)
  //console.log(d)
    var month = (d.getMonth() + 1)
    if(month==1){
      monthtext="January"
    }else if(month==2){
      monthtext="February"
    }else if(month==3){
      monthtext="March"
    }else if(month==4){
      monthtext="April"
    }else if(month==5){
      monthtext="May"
    }else if(month==6){
      monthtext="June"
    }else if(month==7){
      monthtext="July"
    }else if(month==8){
      monthtext="August"
    }else if(month==9){
      monthtext="September"
    }else if(month==10){
      monthtext="October"
    }else if(month==11){
      monthtext="November"
    }else if(month==12){
      monthtext="December"
    }
    
    return monthtext
}

export function getmonth(value){
  var monthtext={
    startdate:"",
    enddate:"",
  }
 
  var x=value.split(" ")
  var year=x[1]
  //console.log(year)
    if(x[0]=="January"){
      monthtext.startdate=year+"-01-01"
      monthtext.enddate=year+"-02-01"
    }else if(x[0]=="February"){
      monthtext.startdate=year+"-02-01"
      monthtext.enddate=year+"-03-01"
    }else if(x[0]=="March"){
      monthtext.startdate=year+"-03-01"
      monthtext.enddate=year+"-04-01"
    }else if(x[0]=="April"){
      monthtext.startdate=year+"-04-01"
      monthtext.enddate=year+"-05-01"
    }else if(x[0]=="May"){
      monthtext.startdate=year+"-05-01"
      monthtext.enddate=year+"-06-01"
    }else if(x[0]=="June"){
      monthtext.startdate=year+"-06-01"
      monthtext.enddate=year+"-07-01"
    }else if(x[0]=="July"){
      monthtext.startdate=year+"-07-01"
      monthtext.enddate=year+"-08-01"
    }else if(x[0]=="August"){
      monthtext.startdate=year+"-08-01"
      monthtext.enddate=year+"-09-01"
    }else if(x[0]=="September"){
      monthtext.startdate=year+"-09-01"
      monthtext.enddate=year+"-10-01"
    }else if(x[0]=="October"){
      monthtext.startdate=year+"-10-01"
      monthtext.enddate=year+"-11-01"
    }else if(x[0]=="November"){
      monthtext.startdate=year+"-11-01"
      monthtext.enddate=year+"-12-01"
    }else if(x[0]=="December"){
      monthtext.startdate=year+"-12-01"
      let x=parseInt(year)+1
      monthtext.enddate=x+"-01-01"
    }
    
    return monthtext
}

export function getmonth2(month, year){
  var monthtext={
    startdate:"",
    enddate:"",
  }
  //console.log(year)
    if(month==1){
      monthtext.startdate=year+"-01-01"
      monthtext.enddate=year+"-02-01"
    }else if(month==2){
      monthtext.startdate=year+"-02-01"
      monthtext.enddate=year+"-03-01"
    }else if(month==3){
      monthtext.startdate=year+"-03-01"
      monthtext.enddate=year+"-04-01"
    }else if(month==4){
      monthtext.startdate=year+"-04-01"
      monthtext.enddate=year+"-05-01"
    }else if(month==5){
      monthtext.startdate=year+"-05-01"
      monthtext.enddate=year+"-06-01"
    }else if(month==6){
      monthtext.startdate=year+"-06-01"
      monthtext.enddate=year+"-07-01"
    }else if(month==7){
      monthtext.startdate=year+"-07-01"
      monthtext.enddate=year+"-08-01"
    }else if(month==8){
      monthtext.startdate=year+"-08-01"
      monthtext.enddate=year+"-09-01"
    }else if(month==9){
      monthtext.startdate=year+"-09-01"
      monthtext.enddate=year+"-10-01"
    }else if(month==10){
      monthtext.startdate=year+"-10-01"
      monthtext.enddate=year+"-11-01"
    }else if(month==11){
      monthtext.startdate=year+"-11-01"
      monthtext.enddate=year+"-12-01"
    }else if(month==12){
      monthtext.startdate=year+"-12-01"
      let x=parseInt(year)+1
      monthtext.enddate=x+"-01-01"
    }
    
    return monthtext
}

export function getdaytext(number){
  var daytext=""
  
 
    if(number==1){
      daytext="Monday"
    }else if(number==2){
      daytext="Tuesday"
    }else if(number==3){
      daytext="Wednesday"
    }else if(number==4){
      daytext="Thursday"
    }else if(number==5){
      daytext="Friday"
    }else if(number==6){
      daytext="Saturday"
    }else if(number==0){
      daytext="Sunday"
    }
    
    return daytext
}

export function getnationality(country){
  var desttype=""
  
  switch (country) {
    case "India":
      desttype = "IN";
      break;
    case "Canada":
      desttype="CA";
      break;
      case "Greece":
      desttype="GR";
      break;
      case "Slovenia":
      desttype="SI";
      break;
      case "Saint Lucia":
      desttype="LC";
      break;
      case "United States":
      desttype="US";
      break;
      case "Czech Republic":
      desttype="CZ";
      break;
      case "Germany":
      desttype="DE";
      break;
      case "United Kingdom":
      desttype="UK";
      break;
      case "Albania":
      desttype="AL";
      break;
      case "Andorra":
      desttype="AD";
      break;
      case "Denmark":
      desttype="DK";
      break;
      case "Antigua And Barbuda":
      desttype="AG";
      break;
      case "Argentina":
      desttype="AR";
      break;
      case "Austria":
      desttype="AT";
      break;
      case "Armenia":
      desttype="AM";
      break;
      case "Aruba":
      desttype="AW";
      break;
      case "Australia":
      desttype="AU";
      break;
      case "Dominican Republic":
      desttype="DO";
      break;
      case "Ecuador":
      desttype="EC";
      break;
      case "Egypt":
      desttype="EG";
      break;
      case "Cameroon":
      desttype="CM";
      break;
      case "El Salvador":
      desttype="SV";
      break;
      case "Estonia":
      desttype="EE";
      break;
      case "Fiji":
      desttype="FJ";
      break;
      case "Finland":
      desttype="FI";
      break;
      case "Azerbaijan":
      desttype="AZ";
      break;
      case "Bahamas":
      desttype="BS";
      break;
      case "Bahrain":
      desttype="BH";
      break;
      case "Barbados":
      desttype="BB";
      break;
      case "Belarus":
      desttype="BY";
      break;
      case "Belgium":
      desttype="BE";
      break;
      case "Bolivia":
      desttype="BO";
      break;
      case "France":
      desttype="FR";
      break;
      case "Brazil":
      desttype="BR";
      break;
      case "Bulgaria":
      desttype="BG";
      break;
      case "Cambodia":
      desttype="KH";
      break;
      case "Cayman Islands":
      desttype="KY";
      break;
      case "New Zealand":
      desttype="NZ";
      break;
      case "Chile":
      desttype="CL";
      break;
      case "China":
      desttype="CN";
      break;
      case "Indonesia":
      desttype="ID";
      break;
      case "Colombia":
      desttype="CO";
      break;
      case "Costa Rica":
      desttype="CR";
      break;
      case "Croatia":
      desttype="HR";
      break;
      case "Cyprus":
      desttype="CY";
      break;
      case "Georgia":
      desttype="GE";
      break;
      case "Gibraltar":
      desttype="GI";
      break;
      case "Grenada":
      desttype="GD";
      break;
      case "Guadeloupe":
      desttype="GP";
      break;
      case "Guatemala":
      desttype="GT";
      break;
      case "Honduras":
      desttype="HN";
      break;
      case "Hong Kong":
      desttype="HK";
      break;
      case "Hungary":
      desttype="HU";
      break;
      case "Iceland":
      desttype="IS";
      break;
      
      case "Ireland":
      desttype="IE";
      break;
      case "Israel":
      desttype="IL";
      break;
      case "Italy":
      desttype="IT";
      break;
      case "Jamaica":
      desttype="JM";
      break;
      case "Japan":
      desttype="JP";
      break;
      case "Jordan":
      desttype="JO";
      break;
      case "South Korea":
      desttype="KR";
      break;
      case "Kuwait":
      desttype="KW";
      break;
      case "Latvia":
      desttype="LV";
      break;
      case "Liechtenstein":
      desttype="LI";
      break;
      case "Lithuania":
      desttype="LT";
      break;
      case "Luxembourg":
      desttype="LU";
      break;
      case "Macedonia":
      desttype="MK";
      break;
      case "Malaysia":
      desttype="MY";
      break;
      case "Malta":
      desttype="MT";
      break;
      case "Mexico":
      desttype="MX";
      break;
      case "Moldova":
      desttype="MD";
      break;
      case "Monaco":
      desttype="MC";
      break;
      case "Morocco":
      desttype="MA";
      break;
      case "Mozambique":
      desttype="MZ";
      break;
      case "Netherlands":
      desttype="NL";
      break;
      case "Norway":
      desttype="NO";
      break;
      case "Netherlands Antilles":
      desttype="AN";
      break;
      case "Nicaragua":
      desttype="NI";
      break;
      case "Oman":
      desttype="OM";
      break;
      case "Panama":
      desttype="PA";
      break;
      case "Paraguay":
      desttype="PY";
      break;
      case "Peru":
      desttype="PE";
      break;
      case "Philippines":
      desttype="PH";
      break;
      case "Poland":
      desttype="PL";
      break;
      case "Portugal":
      desttype="PT";
      break;
      case "Puerto Rico":
      desttype="PR";
      break;
      case "Qatar":
      desttype="QA";
      break;
      case "Romania":
      desttype="RO";
      break;
      case "Russia":
      desttype="RU";
      break;
      case "San Marino":
      desttype="SM";
      break;
      case "Serbia":
      desttype="RS";
      break;
      case "Singapore":
      desttype="SG";
      break;
      case "Slovakia":
      desttype="SK";
      break;
      case "South Africa":
      desttype="ZA";
      break;
      case "Spain":
      desttype="ES";
      break;
      case "Sri Lanka":
      desttype="LK";
      break;
      case "Sweden":
      desttype="SE";
      break;
      case "Switzerland":
      desttype="CH";
      break;
      case "Tanzania":
      desttype="TZ";
      break;
      case "Taiwan":
      desttype="TW";
      break;
      case "Thailand":
      desttype="TH";
      break;
     
      case "Tunisia":
      desttype="TN";
      break;
      case "Turkey":
      desttype="TR";
      break;
      case "Turks And Caicos Islands":
      desttype="TC";
      break;
      case "Ukraine":
      desttype="UA";
      break;
      case "United Arab Emirates":
      desttype="AE";
      break;
      case "Uruguay":
      desttype="UY";
      break;
      case "US Virgin Islands":
      desttype="VI";
      break;
      case "Uzbekistan":
      desttype="UZ";
      break;
      case "Vanuatu":
      desttype="VU";
      break;
      case "Venezuela":
      desttype="VE";
      break;
      case "Vietnam":
      desttype="VN";
      break;
      case "Bosnia And Herzegovina":
      desttype="BA";
      break;
      case "Brunei Darussalam":
      desttype="BN";
      break;
      case "Laos":
      desttype="LA";
      break;
      case "Nepal":
      desttype="NP";
      break;
      case "Ghana":
      desttype="GH";
      break;
      case "Saudi Arabia":
      desttype="SA";
      break;
      case "Trinidad And Tobago":
      desttype="TT";
      break;
      case "Yemen":
      desttype="YE";
      break;
      case "Djibouti":
      desttype="DJ";
      break;
      case "Macau":
      desttype="MO";
      break;
      case "Benin":
      desttype="BJ";
      break;
      case "Swaziland":
      desttype="SZ";
      break;
      case "Cuba":
      desttype="CU";
      break;
      case "Myanmar":
      desttype="MM";
      break;
      case "Martinique":
      desttype="MQ";
      break;
      case "Maldives":
      desttype="MV";
      break;
      case "Namibia":
      desttype="NA";
      break;
      case "Suriname":
      desttype="SR";
      break;
      case "Anguilla":
      desttype="AI";
      break;
      case "Saint Kitts And Nevis":
      desttype="KN";
      break;
      case "Montenegro":
      desttype="ME";
      break;
      case "Belize":
      desttype="BZ";
      break;
      case "Eritrea":
      desttype="ER";
      break;
      case "Kazakhstan":
      desttype="KZ";
      break;
      case "Kenya":
      desttype="KE";
      break;
      case "Lebanon":
      desttype="LB";
      break;
      case "Pakistan":
      desttype="PK";
      break;
      case "Papua New Guinea":
      desttype="PG";
      break;
      case "French Polynesia":
      desttype="PF";
      break;
      case "Zambia":
      desttype="ZM";
      break;
      case "Algeria":
      desttype="DZ";
      break;
      case "Zimbabwe":
      desttype="ZW";
      break;
      case "Bermuda":
      desttype="BM";
      break;
      case "Botswana":
      desttype="BW";
      break;
      case "Burkina Faso":
      desttype="BF";
      break;
      case "Uganda":
      desttype="UG";
      break;
      case "Cape Verde":
      desttype="CV";
      break;
      case "Syrian Arab Republic":
      desttype="SY";
      break;
      case "New Caledonia":
      desttype="NC";
      break;
      case "Palau":
      desttype="PW";
      break;
      case "Reunion":
      desttype="RE";
      break;
      case "Mauritius":
      desttype="MU";
      break;
      case "Mali":
      desttype="ML";
      break;
      case "Malawi":
      desttype="MW";
      break;
      case "Madagascar":
      desttype="MG";
      break;
      case "Libyan Arab Jamahiriya":
      desttype="LY";
      break;
      case "Iran":
      desttype="IR";
      break;
      case "Gambia":
      desttype="GM";
      break;
      case "Saint Martin":
      desttype="MF";
      break;
      case "Senegal":
      desttype="SN";
      break;
      case "Seychelles":
      desttype="SC";
      break;
      case "Angola":
      desttype="AO";
      break;
      case "British Virgin Islands":
      desttype="VG";
      break;
      case "Saint Vincent And The Grenadines":
      desttype="VC";
      break;
      case "Equatorial Guinea":
      desttype="GQ";
      break;
      case "Gabon":
      desttype="GA";
      break;
      case "Bangladesh":
      desttype="BD";
      break;
      case "Ethiopia":
      desttype="ET";
      break;
      case "Guam":
      desttype="GU";
      break;
      case "Nigeria":
      desttype="NG";
      break;
      case "Dominica":
      desttype="DM";
      break;
      case "Faroe Islands":
      desttype="FO";
      break;
      case "Rwanda":
      desttype="RW";
      break;
      case "Burundi":
      desttype="BI";
      break;
      case "Cook Islands":
      desttype="CK";
      break;
      case "Kyrgyzstan":
      desttype="KG";
      break;
      case "Tajikistan":
      desttype="TJ";
      break;
      case "Greenland":
      desttype="GL";
      break;
      case "Haiti":
      desttype="HT";
      break;
      case "Iraq":
      desttype="IQ";
      break;
      case "Liberia":
      desttype="LR";
      break;
      case "Palestinian Territory":
      desttype="PS";
      break;
      case "Micronesia":
      desttype="FM";
      break;
      case "Sudan":
      desttype="SD";
      break;
      case "Northern Mariana Island":
      desttype="MP";
      break;
      case "Sao Tome And Principe":
      desttype="ST";
      break;
      case "Saint Barthelemy":
      desttype="BL";
      break;
      case "Mauritania":
      desttype="MR";
      break;
      case "Guinea":
      desttype="GN";
      break;
      case "Guinea-Bissau":
      desttype="GW";
      break;
      case "French Guiana":
      desttype="GF";
      break;
      case "Samoa":
      desttype="WS";
      break;
      case "Tonga":
      desttype="TO";
      break;
      case "Afghanistan":
      desttype="AF";
      break;
      case "Guyana":
      desttype="GY";
      break;
      case "American Samo":
      desttype="AS";
      break;
      case "Bhutan":
      desttype="BT";
      break;
      case "Lesotho":
      desttype="LS";
      break;
      case "Mongolia":
      desttype="MN";
      break;
      case "Norfolk Island":
      desttype="NF";
      break;
      case "Svalbard And Jan Mayen":
      desttype="SJ";
      break;
      case "Togo":
      desttype="TG";
      break;
      case "Turkmenistan":
      desttype="TM";
      break;
      case "Comoros":
      desttype="KM";
      break;
      case "Jersey":
      desttype="JE";
      break;
      case "Kiribati":
      desttype="KI";
      break;
      case "Ivory Coast":
      desttype="CI";
      break;
      case "Marshall Islands":
      desttype="MH";
      break;
      case "Solomon Islands":
      desttype="SB";
      break;
      case "Democratic Republic of the Congo":
      desttype="CD";
      break;
      case "Central African Republic":
      desttype="CF";
      break;
      case "Chad":
      desttype="TD";
      break;
      case "Republic of the Congo":
      desttype="CG";
      break;
      case "Mayotte":
      desttype="YT";
      break;
      case "Montserrat":
      desttype="MS";
      break;
      case "Nauru":
      desttype="NR";
      break;
      case "Niger":
      desttype="NE";
      break;
      case "Sierra Leone":
      desttype="SL";
      break;
      case "Somalia":
      desttype="SO";
      break;
      case "Tuvalu":
      desttype="TV";
      break;
      case "Niue":
      desttype="NU";
      break;
      case "Bouvet Island":
      desttype="BV";
      break;
      case "British Indian Ocean Territory":
      desttype="IO";
      break;
      case "Christmas Island":
      desttype="CX";
      break;
      case "Cocos Islands":
      desttype="CC";
      break;
      case "Falkland Islands":
      desttype="FK";
      break;
      case "French Southern and Antarctic Territories":
      desttype="TF";
      break;
      case "Heard and McDonald Islands":
      desttype="HM";
      break;
      case "North Korea":
      desttype="KP";
      break;
      case "Pitcairn Island":
      desttype="PN";
      break;
      case "St. Pierre and Miquelon":
      desttype="PM";
      break;
      case "St. Helena":
      desttype="SH";
      break;
      case "Tokelau":
      desttype="TK";
      break;
      case "Wallis and Futuna":
      desttype="WF";
      break;
      case "Timor Leste":
      desttype="TL";
      break;
      case "Bonaire":
      desttype="";
      break;
      case "Curacao":
      desttype="CW";
      break;
      case "Sint Maarten":
      desttype="SX";
      break;
      case "South Sudan":
      desttype="SS";
      break;
      case "US Minor Outlying Islands":
      desttype="UM";
      break;
      case "Vatican City":
      desttype="VA";
      break;
          
    default:
      desttype = "IN";

  }
    
    return desttype
}

export function fcheck(dest, adult, child, price) {
  //console.log(dest, adult, child, price)
  var desttype = 0;
  if(price.airfare){
  switch (dest) {
    case "Kashmir":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>30000)
      desttype = 1;
      break;
    case "Himachal":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Andaman":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>40000)
      desttype = 1;
      break;
    case "Goa":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Rajasthan":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Dubai":
      if((price.airfare/(adult+child))<8000 || (price.airfare/(adult+child))>40000)
      desttype = 1;
      break;
    case "Sikkim-Darjeeling":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>30000)
      desttype = 1;
      break;
    case "Uttarakhand":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Kerala":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>30000)
      desttype = 1;
      break;
    case "North-East":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>35000)
      desttype = 1;
      break;
    case "Thailand":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>50000)
      desttype = 1;
      break;
    case "Philippines":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>70000)
      desttype = 1;
      break;
    case "Indonesia":
      //console.log(price.airfare)
      if((price.airfare/(adult+child))<15000 || (price.airfare/(adult+child))>60000)
      desttype = 1;
      break;
    case "Maldives":
      if((price.airfare/(adult+child))<8000 || (price.airfare/(adult+child))>50000)
      desttype = 1;
      break;
    case "Mauritius":
      if((price.airfare/(adult+child))<10000 || (price.airfare/(adult+child))>80000)
      desttype = 1;;
      break;
    case "Singapore":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>40000)
      desttype = 1;
      break;
    case "Malaysia":
      if((price.airfare/(adult+child))<8000 || (price.airfare/(adult+child))>50000)
      desttype = 1;
      break;
    case "Ladakh":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>30000)
      desttype = 1;
      break;
    case "Vietnam":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>70000)
      desttype = 1;
      break;
      case "Sri Lanka":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>50000)
      desttype = 1;
        break;
        case "Turkey":
          if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>100000)
          desttype = 1;
            break;
    default:
      desttype = 0;

}
  }
return desttype;
}

export function lcheck(dest, adult, child, price) {
   //console.log(dest, adult, child, price)
  var desttype = 0;
  if(price.landprice){
  switch (dest) {
    case "Kashmir":
      if(((price.landprice+price.otheritems)/(adult+child))<8000 || ((price.landprice+price.otheritems)/(adult+child))>40000)
      desttype = 1;
      break;
    case "Himachal":
      if(((price.landprice+price.otheritems)/(adult+child))<5000 || ((price.landprice+price.otheritems)/(adult+child))>30000)
      desttype = 1;
      break;
    case "Andaman":
      if(((price.landprice+price.otheritems)/(adult+child))<10000 || ((price.landprice+price.otheritems)/(adult+child))>40000)
      desttype = 1;
      break;
    case "Goa":
      if(((price.landprice+price.otheritems)/(adult+child))<8000 || ((price.landprice+price.otheritems)/(adult+child))>40000)
      desttype = 1;
      break;
    case "Rajasthan":
      if(((price.landprice+price.otheritems)/(adult+child))<8000 || ((price.landprice+price.otheritems)/(adult+child))>40000)
      desttype = 1;
      break;
    case "Dubai":
      if(((price.landprice+price.otheritems)/(adult+child))<20000 || ((price.landprice+price.otheritems)/(adult+child))>70000)
      desttype = 1;
      break;
    case "Sikkim-Darjeeling":
      if(((price.landprice+price.otheritems)/(adult+child))<10000 || ((price.landprice+price.otheritems)/(adult+child))>40000)
      desttype = 1;
      break;
    case "Uttarakhand":
      if(((price.landprice+price.otheritems)/(adult+child))<8000 || ((price.landprice+price.otheritems)/(adult+child))>40000)
      desttype = 1;
      break;
    case "Kerala":
      if(((price.landprice+price.otheritems)/(adult+child))<8000 || ((price.landprice+price.otheritems)/(adult+child))>40000)
      desttype = 1;
      break;
    case "North-East":
      if(((price.landprice+price.otheritems)/(adult+child))<8000 || ((price.landprice+price.otheritems)/(adult+child))>40000)
      desttype = 1;
      break;
    case "Thailand":
      if(((price.landprice+price.otheritems)/(adult+child))<10000 || ((price.landprice+price.otheritems)/(adult+child))>50000)
      desttype = 1;
      break;
    case "Philippines":
      if(((price.landprice+price.otheritems)/(adult+child))<10000 || ((price.landprice+price.otheritems)/(adult+child))>50000)
      desttype = 1;
      break;
    case "Indonesia":
      if(((price.landprice+price.otheritems)/(adult+child))<10000 || ((price.landprice+price.otheritems)/(adult+child))>50000)
      desttype = 1;
      break;
    case "Maldives":
      if(((price.landprice+price.otheritems)/(adult+child))<20000 || ((price.landprice+price.otheritems)/(adult+child))>150000)
      desttype = 1;
      break;
    case "Mauritius":
      if(((price.landprice+price.otheritems)/(adult+child))<20000 || ((price.landprice+price.otheritems)/(adult+child))>150000)
      desttype = 1;
      break;
    case "Singapore":
      if(((price.landprice+price.otheritems)/(adult+child))<20000 || ((price.landprice+price.otheritems)/(adult+child))>60000)
      desttype = 1;
      break;
    case "Malaysia":
      if(((price.landprice+price.otheritems)/(adult+child))<10000 || ((price.landprice+price.otheritems)/(adult+child))>50000)
      desttype = 1;
      break;
    case "Ladakh":
      if(((price.landprice+price.otheritems)/(adult+child))<15000 || ((price.landprice+price.otheritems)/(adult+child))>50000)
      desttype = 1;
      break;
    case "Vietnam":
      if(((price.landprice+price.otheritems)/(adult+child))<15000 || ((price.landprice+price.otheritems)/(adult+child))>70000)
      desttype = 1;
      break;
      case "Sri Lanka":
        if(((price.landprice+price.otheritems)/(adult+child))<15000 || ((price.landprice+price.otheritems)/(adult+child))>60000)
      desttype = 1;
        break;
        case "Turkey":
        if(((price.landprice+price.otheritems)/(adult+child))<15000 || ((price.landprice+price.otheritems)/(adult+child))>200000)
      desttype = 1;
        break;
    default:
      desttype = 0;

}
  }
return desttype;
}

export function landppcheck(dest, adult, child, price, duration) {
   //alert((price.landprice+price.otheritems)/((adult+child)*duration))
  var desttype = 0;
  if(price.landprice){
  switch (dest) {
    case "Kashmir":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>6000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<3000)
      desttype = 1;
      break;
    case "Himachal":
     if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>6000)
      desttype = 1;
      break;
    case "Andaman":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>7000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<3000)
      desttype = 1;
      break;
    case "Goa":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>6000)
      desttype = 1;
      break;
    case "Rajasthan":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>6000)
      desttype = 1;
      break;
    case "Dubai":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>10000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<5000)
      desttype = 1;
      break;
    case "Sikkim-Darjeeling":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>8000)
      desttype = 1;
      break;
    case "Uttarakhand":
     if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>6000)
      desttype = 1;
      break;
    case "Kerala":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>6000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<3000)
      desttype = 1;
      break;
    case "North-East":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>6000)
      desttype = 1;
      break;
    case "Thailand":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>8000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<4000)
      desttype = 1;
      break;
    case "Philippines":
     if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>10000)
      desttype = 1;
      break;
    case "Indonesia":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>10000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<4000)
      desttype = 1;
      break;
    case "Maldives":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>50000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<8000)
      desttype = 1;
      break;
    case "Mauritius":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>15000)
      desttype = 1;
      break;
    case "Singapore":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>12000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<5000)
      desttype = 1;
      break;
    case "Malaysia":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>10000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<4000)
      desttype = 1;
      break;
    case "Ladakh":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>6000)
      desttype = 1;
      break;
    case "Vietnam":
      if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>10000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<4000)
      desttype = 1;
      break;
      case "Sri Lanka":
        if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>9000 || ((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))<4000)
      desttype = 1;
        break;
        case "Turkey":
        if(((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration))>12000)
      desttype = 1;
        break;
    default:
      desttype = 0;

}
  }

return {value:((Number(price.landprice)+Number(price.otheritems))/((Number(adult)+Number(child))*duration)), flag:desttype};
}

export const converttoISO=(dateStr)=>{
 const [day, month, year] = dateStr.split("/");
 return new Date(`${year}-${month}-${day}T00:00:00.000Z`);
}

export const airportlist=[
    {city:"Mumbai", airport:"BOM", type:"DOM"},
    {city:"Goa (Vasco da Gama)", airport:"GOI", type:"DOM"},
    {city:"Kolkata", airport:"CCU", type:"DOM"},
    {city:"Amritsar", airport:"ATQ", type:"DOM"},
    {city:"New Delhi", airport:"DEL", type:"DOM"},
    {city:"Bengaluru", airport:"BLR", type:"DOM"},
    {city:"Bagdogra", airport:"IXB", type:"DOM"},
    {city:"Kochi", airport:"COK", type:"DOM"},
    {city:"Calicut", airport:"CCJ", type:"DOM"},
    {city:"Hyderabad", airport:"HYD", type:"DOM"},
    {city:"Chennai", airport:"MAA", type:"DOM"},
    {city:"Thiruvananthapuram", airport:"TRV", type:"DOM"},
    {city:"Ahmedabad", airport:"AMD", type:"DOM"},
    {city:"Aurangabad", airport:"IXU", type:"DOM"},
    {city:"Vadodara", airport:"BDQ", type:"DOM"},
    {city:"Bhopal", airport:"BHO", type:"DOM"},
    {city:"Indore", airport:"IDR", type:"DOM"},
    {city:"Nagpur", airport:"NAG", type:"DOM"},
    {city:"Pune", airport:"PNQ", type:"DOM"},
    {city:"Rajkot", airport:"RAJ", type:"DOM"},
    {city:"Siliguri", airport:"IXB", type:"DOM"},
    {city:"Bhubaneswar", airport:"BBI", type:"DOM"},
    {city:"Allahabad", airport:"IXD", type:"DOM"},
    {city:"Varanasi", airport:"VNS", type:"DOM"},
    {city:"Chandigarh", airport:"IXC", type:"DOM"},
    {city:"Gwalior", airport:"GWL", type:"DOM"},
    {city:"Jaipur", airport:"JAI", type:"DOM"},
    {city:"Coimbatore", airport:"CJB", type:"DOM"},
    {city:"Port Blair", airport:"IXZ", type:"DOM"},
    {city:"Guwahati", airport:"GAU", type:"DOM"},
    {city:"Visakhapatnam", airport:"VTZ", type:"DOM"},
    {city:"Srinagar", airport:"SXR", type:"DOM"},
    {city:"Mangalore", airport:"IXE", type:"DOM"},
    {city:"Mysore", airport:"MYQ", type:"DOM"},
    {city:"Nasik", airport:"ISK", type:"DOM"},
    {city:"Udaipur", airport:"UDR", type:"DOM"},
    {city:"Patna", airport:"PAT", type:"DOM"},
    {city:"Ranchi", airport:"IXR", type:"DOM"},
    {city:"Kanpur", airport:"KNU", type:"DOM"},
    {city:"Lucknow", airport:"LKO", type:"DOM"},
    {city:"Jammu", airport:"IXJ", type:"DOM"},
    {city:"Bilaspur", airport:"PAB", type:"DOM"},
    {city:"Bhavnagar", airport:"BHU", type:"DOM"},
    {city:"Hubli", airport:"HBX", type:"DOM"},
    {city:"Jamnagar", airport:"JGA", type:"DOM"},
    {city:"Raipur", airport:"RPR", type:"DOM"},
    {city:"Agartala", airport:"IXA", type:"DOM"},
    {city:"Durgapur", airport:"RDP", type:"DOM"},
    {city:"Dehradun", airport:"DED", type:"DOM"},
    {city:"Jodhpur", airport:"JDH", type:"DOM"},
    {city:"Madurai", airport:"IXM", type:"DOM"},
    {city:"Tiruchirappalli", airport:"TRZ", type:"DOM"},
  {city:"Bangkok", airport:"BKK", type:"INT"},
  {city:"Bangkok (DMK)", airport:"DMK", type:"INT"},
  {city:"Phuket", airport:"HKT", type:"INT"},
  {city:"Krabi", airport:"KBV", type:"INT"},
  {city:"Koh Samui", airport:"USM", type:"INT"},
  {city:"Kuala Lumpur", airport:"KUL", type:"INT"},
  {city:"Langkawi", airport:"LGK", type:"INT"},
  {city:"Penang", airport:"PEN", type:"INT"},
  {city:"Singapore", airport:"SIN", type:"INT"},
  {city:"Male", airport:"MLE", type:"INT"},
  {city:"Gan", airport:"GAN", type:"INT"},
  {city:"Denpasar", airport:"DPS", type:"INT"},
  {city:"Dubai", airport:"DXB", type:"INT"},
  {city:"Abu Dhabi", airport:"AUH", type:"INT"},
  {city:"Sharjah", airport:"SHJ", type:"INT"},
  {city:"Colombo", airport:"CMB", type:"INT"},
  {city:"Ho Chi Minh", airport:"SGN", type:"INT"},
  {city:"Hanoi", airport:"HAN", type:"INT"},
  {city:"Da Nang", airport:"DAD", type:"INT"},
  {city:"Phu Quoc", airport:"PQC", type:"INT"},
  {city:"Mauritius", airport:"MRU", type:"INT"},
  {city:"Istanbul", airport:"IST", type:"INT"},
  {city:"Antalya", airport:"AYT", type:"INT"},
  {city:"Ankara", airport:"ESB", type:"INT"},
  {city:"Izmir", airport:"ADB", type:"INT"},
  {city:"Nevsehir", airport:"NAV", type:"INT"},
  {city:"Konya", airport:"KYA", type:"INT"},
  {city:"Bodrum", airport:"BJV", type:"INT"},
  {city:"Dalaman", airport:"DLM", type:"INT"},
  {city:"Paris", airport:"CDG", type:"INT"},
  {city:"Geneva", airport:"GVA", type:"INT"},
  {city:"Rome", airport:"FCO", type:"INT"},
  {city:"London", airport:"LHR", type:"INT"},
  {city:"Frankfurt", airport:"FRA", type:"INT"},
  {city:"Amsterdam", airport:"AMS", type:"INT"},
  {city:"Vienna", airport:"VIE", type:"INT"},
  {city:"Munich", airport:"MUC", type:"INT"},
  {city:"Barcelona", airport:"BCN", type:"INT"},
  {city:"Madrid", airport:"MAD", type:"INT"},
  {city:"Milan", airport:"MXP", type:"INT"},
  {city:"Brussels", airport:"BRU", type:"INT"},
  {city:"Dublin", airport:"DUB", type:"INT"},
  {city:"Stockholm", airport:"ARN", type:"INT"},
  {city:"Copenhagen", airport:"CPH", type:"INT"},
  {city:"Zurich", airport:"ZRH", type:"INT"},
  {city:"Athens", airport:"ATH", type:"INT"},
  {city:"Warsaw", airport:"WAW", type:"INT"},
  {city:"Budapest", airport:"BUD", type:"INT"},
  {city:"Prague", airport:"PRG", type:"INT"},
  {city:"Oslo", airport:"OSL", type:"INT"},
  {city:"Nice", airport:"NCE", type:"INT"},
  {city:"Berlin", airport:"BER", type:"INT"},
  {city:"Lyon", airport:"LYS", type:"INT"},
  {city:"Helsinki", airport:"HEL", type:"INT"},
  {city:"Venice", airport:"VCE", type:"INT"},
  {city:"Edinburgh", airport:"EDI", type:"INT"},
  {city:"Zagreb", airport:"ZAG", type:"INT"},
  {city:"Santorini", airport:"JTR", type:"INT"},
  {city:"Tbilisi", airport:"TBS", type:"INT"},
  {city:"Baku", airport:"GYD", type:"INT"},
  {city:"Hong Kong", airport:"HKG", type:"INT"},
  {city:"Almaty", airport:"ALA", type:"INT"},
  {city:"Salzburg", airport:"SZG", type:"INT"},
  {city:"Naples", airport:"NAP", type:"INT"},
]

export function getairlinecode(airline){
  var text=""


    if(airline=="Indigo"){
      text="6E"
    }else if(airline=="Malayasia Airlines"){
      text="MH"
    }else if(airline=="Vistara"){
      text="UK"
    }else if(airline=="AI Express"){
      text="IX"
    }else if(airline=="SpiceJet"){
      text="SG"
    }else if(airline=="Lufthansa"){
      text="LH"
    }else if(airline=="Air India"){
      text="AI"
    }else if(airline=="Singapore Airlines"){
      text="SQ"
    }else if(airline=="Malindo Air"){
      text="OD"
    }else if(airline=="Thai Airways"){
      text="TG"
    }else if(airline=="Indonesia AirAsia"){
      text="QZ"
    }else if(airline=="Thai AirAsia"){
      text="FD"
    }else if(airline=="AirAsia"){
      text="AK"
    }else if(airline=="AirAsia India"){
      text="I5"
    }else if(airline=="Fly Dubai"){
      text="FZ"
    }else if(airline=="Scoot"){
      text="TZ"
    }else if(airline=="AirAsia X"){
      text="D7"
    }else if(airline=="Scoot Airlines"){
      text="TR"
    }else if(airline=="Emirates Airlines"){
      text="EK"
    }else if(airline=="Etihad Airlines"){
      text="EY"
    }else if(airline=="Batik Air"){
      text="ID"
    }else if(airline=="Qatar Airways"){
      text="QR"
    }else if(airline=="VietJet Airlines"){
      text="VJ"
    }else if(airline=="Gulf Air"){
      text="GF"
    }else if(airline=="SriLankan Airlines"){
      text="QR"
    }else if(airline=="Qantas Airways"){
      text="QF"
    }else if(airline=="Akasa Air"){
      text="QP"
    }else if(airline=="Bangkok Airways"){
      text="PG"
    }else if(airline=="Thai Smile"){
      text="WE"
    }else if(airline=="Thai Lion"){
      text="SL"
    }else if(airline=="Vietnam Airlines"){
      text="VN"
    }else if(airline=="Cathay Pacific"){
      text="CX"
    }else if(airline=="Bhutan Airlines"){
      text="B3"
    }else if(airline=="Turkish Airlines"){
      text="TK"
    }
    else if(airline=="Corendon Airlines"){
      text="XC"
    }
    else if(airline=="Pegasus Airlines"){
      text="PC"
    }
    else if(airline=="Southwind Airlines"){
      text="2S"
    }
    else if(airline=="SunExpress"){
      text="XQ"
    }
    else if(airline=="Azerbaijan Airlines"){
      text="J2"
    }
    else if(airline=="Azerbaijan Airlines"){
      text="J2"
    }
    else if(airline=="Air Arabia"){
      text="G9"
    }
    else if(airline=="Sun PhuQuoc Airways"){
      text="9G"
    }else if(airline=="Biman Bangladesh"){
      text="BG"
    }else if(airline=="Royal Brunei Airlines"){
      text="BI"
    }
    
    
    return text
}

export const airlinelist=["Indigo", "AI Express","Malaysia Airlines","Malayasia Airlines", "Vistara", "SpiceJet", "Lufthansa", "Air India", "Singapore Airlines", "Malindo Air", "Thai Airways","Indonesia AirAsia", "Thai AirAsia", "AirAsia", "AirAsia India", "Fly Dubai", "Scoot", "AirAsia X", "Scoot Airlines", "Emirates Airlines", "Etihad Airlines", "Batik Air", "Qatar Airways", "VietJet Airlines", "SriLankan Airlines", "Qantas Airways", "Akasa Air", "Bangkok Airways","Thai Smile", "Thai Lion", "Vietnam Airlines", "Cathay Pacific", "Oman Airways", "Bhutan Airlines", "Akasa Air", "SunExpress","Turkish Airlines", "Southwind Airlines","Pegasus Airlines", "Corendon Airlines", "Azerbaijan Airlines", "Air Arabia", "Cebu Pacific", "Philippine Airlines", "Philippines AirAsia", "Gulf Air", "Sun PhuQuoc Airways", "Biman Bangladesh", "Royal Brunei Airlines"]

export function insertAt(array, index, ...elementsArray) {
  return array.splice(index, 0, ...elementsArray);
}

export function removeDuplicates(arr, index) {
 
  // Create an array of objects
 

  // Declare a new array
  let newArray = [];

  // Declare an empty object
  let uniqueObject = {};

  // Loop for the array elements
  for (let i in arr) {

      // Extract the title
      var objTitle = arr[i][index];
      //console.log(index, objTitle)
      // Use the title as the index
      uniqueObject[objTitle] = arr[i];
  }

  // Loop to push unique object into array
  for (let i in uniqueObject) {
      newArray.push(uniqueObject[i]);
  }

  // Display the unique objects
  //console.log(newArray);
  return newArray;
}

export function removeObjectsWithSameKeyValue(arrayOfObjects, key) {
  const uniqueValues = new Set();
  const newArray = [];

  // Iterate through the array of objects
  for (const obj of arrayOfObjects) {
      const value = obj[key];

      // Check if the value for the key is unique
      if (!uniqueValues.has(value)) {
          newArray.push(obj);
          uniqueValues.add(value);
      }
  }

  return newArray;
}

export function classifyfup(fup){
  let temp=""
  let qp=0
  if (fup=="Call not picked"){
    temp=1
  }else if(fup=="Call not picked. WA sent"){
    temp=1
  }else if(fup=="Call disconnected by client"){
    temp=1
  }else if(fup=="Call not picked and no response on Whatsapp"){
    temp=1
    
  }else if(fup=="Asked to add flights. Shared quote with flights"){
    temp=6
   
  }else if(fup=="Fup done manually"){
    temp=7
  }else if(fup=="Quote shared"){
    temp=6
  }else if(fup=="Yet to view quote"){
    temp=16
  }else if(fup=="Need changes. Need to share updated quote"){
    temp=2
    qp=1
  }else if(fup=="Needed changes. Shared updated quote"){
    temp=6
  }else if(fup=="Will let you know tomorrow"){
    temp=20
  }else if(fup=="Will let you know"){
    temp=1
  }else if(fup=="Will let you know within 2-3 days"){
    temp=4
  }else if(fup=="Will let you know within a week"){
    temp=5
  }else if(fup=="Asked to call later"){
    temp=3
  }else if(fup=="Asked to call later after a few days"){
    temp=4
  }else if(fup=="Asked to call later after a week"){
    temp=5
  }else if(fup=="Our quote is costly. Shared other options"){
    temp=11
  }else if(fup=="Budget issue. Will let us know"){
    temp=1
  }else if(fup=="Budget issue. Shared other options"){
    temp=11
  }else if(fup=="Comparing packages with other agencies"){
    temp=11
  }else if(fup=="Okay with package. Will tell the final decision"){
    temp=3
  }else if(fup=="Plan on hold"){
    temp=10
  }else if(fup=="No response after multiple follow ups"){
    temp=12
  }else if(fup=="Will call you back if we are interested"){
    temp=18
  }else if(fup=="Everything finalized. Awaiting payment"){
    temp=7
  }else if(fup=="Need to share voucher or tickets"){
    temp=8
  }else if(fup=="Need to share insurance"){
    temp=8
  }else if(fup=="Need to confirm booking with supplier"){
    temp=8
  }else if(fup=="Need to make payment to supplier"){
    temp=8
  }else if(fup=="System fup - WA msg sent -Fup-1"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Fup-2"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Generic Fup-1"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Generic Fup-2"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Fup-3"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Fup-4"){
    temp=9
  }else if(fup=="Asked to cancel-on call"){
    temp=12
  }else if(fup=="System fup - WA msg sent -Asked to cancel-on call"){
    temp=12
  }else if(fup=="System fup - WA msg sent -Asked to cancel-on whatsapp"){
    temp=12
  }else if(fup=="Asked to cancel-on whatsapp"){
    temp=12
  }else if(fup=="Unable to meet guest requirements on product"){
    temp=12
  }else if(fup=="Asked to postpone"){
    temp=13
  }else if(fup=="Plan on hold"){
    temp=13
  }else if(fup=="Manual Cancellation"){
    temp=12
  }else if(fup=="Call not needed. Msg dropped"){
    temp=1
  }else if(fup=="System fup - WA msg sent -After quote sent"){
    temp=0
  }else if(fup=="System fup - WA msg sent -After quote sent-other options"){
    temp=0
  }else if(fup=="System fup - WA msg sent -After revised quote"){
    temp=0
  }else if(fup=="System fup - WA msg sent -Already book - not paid yet"){
    temp=14
  }else if(fup=="System fup - WA msg sent -Already book - paid"){
    temp=15
  }else if(fup=="System fup - WA msg sent -Asking old client for reference"){
    temp=7
  }else if(fup=="System fup - WA msg sent -Cancelled-1"){
    temp=8
  }else if(fup=="System fup - WA msg sent -Cancelled-2"){
    temp=8
  }else if(fup=="System fup - WA msg sent -Cancelled-3"){
    temp=8
  }else if(fup=="System fup - WA msg sent -Change hotels"){
    temp=2
    qp=1
  }else if(fup=="System fup - WA msg sent -Denying OG payment"){
    temp=3
  }else if(fup=="System fup - WA msg sent -Discuss with partner"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Flight price rise"){
    temp=3
  }else if(fup=="System fup - WA msg sent -Fup responses"){
    temp=0
  }else if(fup=="System fup - WA msg sent -Fup-2 Hot client"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Fup-3 Hot client"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Fup-4 Hot client"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Fup-5 Hot client"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Generic Fup-3"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Hot NR"){
    temp=0
  }else if(fup=="System fup - WA msg sent -Hotel selling out"){
    temp=3
    ///////////////
  }else if(fup=="System fup - WA msg sent -Price is high"){
    temp=3
  }else if(fup=="System fup - WA msg sent -Quote sent responses"){
    temp=0
  }else if(fup=="System fup - WA msg sent -Request competitor quote"){
    temp=3
  }else if(fup=="System fup - WA msg sent -Request competitor quote-2"){
    temp=3
  }else if(fup=="System fup - WA msg sent -Trust issue"){
    temp=7
  }else if(fup=="System fup - WA msg sent -Unable to go"){
    temp=8
  }else if(fup=="System fup - WA msg sent -Urgency Creation"){
    temp=3
  }else if(fup=="System fup - WA msg sent -Will let you know"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Will let you know-2"){
    temp=1
  }else if(fup=="System fup - WA msg sent -Will share quote"){
    temp=2
    qp=1
  }else if(fup=="System fup - WA msg sent -Will share quote-budget constraints"){
    temp=2
    qp=1
  }else if(fup=="System fup - WA msg sent -Will share quote-destination not sure"){
    temp=2
    qp=1
  }else if(fup=="System fup - WA msg sent -Will share quote-honeymoon"){
    temp=2
    qp=1
  }else if(fup=="System fup - WA msg sent -Will share quote-new hotels"){
    temp=2
    qp=1
  }else if(fup=="System fup - WA msg sent -Will share quote-premium properties"){
    temp=2
    qp=1
  }else if(fup=="System fup - WA msg sent -Will share quote-sample"){
    temp=2
    qp=1
  }else if(fup=="Need to share first quote"){
    temp=19
    qp=1
  }else if(fup=="Data entry only"){
    temp=17
  }else if(fup=="Asked to call at a specific time"){
    temp=17
  }else if(fup=="Waiting for rates"){
    temp=21
  }else if(fup=="Need more time-client is positive"){
    temp=1
  }else if(fup=="Extra attempt to be made"){
    temp=22
  }else if(fup=="Will contact you on my own"){
    temp=5
  }else if(fup=="Discussion going on over WA"){
    temp=17
  }else{
    temp=0
  }
  
 return {fup:temp, qp:qp}

}

export const calltrue2=(tripData)=>{
  var x=("lead") in tripData?getquality(tripData.lead.lead_status, tripData.lead.time_to_book, tripData.trip_channel, tripData.trip_start_date, tripData.lead.quality_upgrade, null):getquality(null, null, tripData.trip_channel, tripData.trip_start_date, null, null)
  //console.log(x)
  if(tripData.trip_status=="Hot"){
    return true;
  }else if (tripData.trip_status=="Active"){
    if("lead" in tripData && "potential" in tripData.lead && tripData.lead.potential){
      return true
    }else
    if(x=="Platinum" || x=="Diamond" || x=="Gold" || x=="Rhodium"){
      return true
    }else{
      let fup=fupclassarr(tripData.follow_up)
      //console.log(fup)
      if(fup.length>=4 && (fup[fup.length-1]=="NR" || fup[fup.length-1]=="Normal") && (fup[fup.length-2]=="NR" || fup[fup.length-2]=="Normal") && (fup[fup.length-3]=="NR" || fup[fup.length-3]=="Normal") && (fup[fup.length-4]=="NR" || fup[fup.length-4]=="Normal")){
        if("callrecord" in tripData && tripData.callrecord.length>2){
          return false
        }else{
          return true
        }
       
      }else{
        return false
      }
      
    }
  }else if(tripData.trip_status=="New"){
    return true
  }
}

export const fupclassarr=(follow_up)=>{
  let fup=[]
  for (let j=0; j<follow_up.length; j++){
    let id=0
    if((follow_up[j].fupautonote=="Call not picked and no response on Whatsapp" || follow_up[j].fupautonote=="No response after multiple follow ups"
        || follow_up[j].fupautonote=="Will call you back if we are interested" || follow_up[j].fupautonote=="Plan on hold" || follow_up[j].fupautonote=="Asked to call later after a week" || follow_up[j].fupautonote=="Asked to call later"
        || follow_up[j].fupautonote=="Asked to call later after a few days" || follow_up[j].fupautonote=="System fup - WA msg sent -Fup-3" || follow_up[j].fupautonote=="System fup - WA msg sent -Fup-4")){
          id=1
          fup=[...fup, "NR"]
        }
        if( (follow_up[j].fupautonote=="Call not picked. WA sent" || follow_up[j].fupautonote=="Yet to view quote"
        || follow_up[j].fupautonote=="Will let you know" || follow_up[j].fupautonote=="Call not picked"
        || follow_up[j].fupautonote=="Quote shared" || follow_up[j].fupautonote=="System fup - WA msg sent -Fup-1" || follow_up[j].fupautonote=="" || follow_up[j].fupautonote=="System fup - WA msg sent -Fup-2" || follow_up[j].fupautonote=="Okay with package. Will tell the final decision"  || follow_up[j].fupautonote=="System fup - WA msg sent -Generic Fup-1" || follow_up[j].fupautonote=="System fup - WA msg sent -Generic Fup-2" || follow_up[j].fupautonote=="Call not needed. Msg dropped")){
          id=1
          fup=[...fup, "Normal"]
        }
        if( (follow_up[j].fupautonote=="Asked to add flights. Shared quote with flights" || follow_up[j].fupautonote=="Need changes. Need to share updated quote"
        || follow_up[j].fupautonote=="Needed changes. Shared updated quote" || follow_up[j].fupautonote=="Will let you know tomorrow"
        || follow_up[j].fupautonote=="Will let you know within 2-3 days" || follow_up[j].fupautonote=="Will let you know within a week" || follow_up[j].fupautonote=="Our quote is costly. Shared other options" || follow_up[j].fupautonote=="Budget issue. Will let us know" || follow_up[j].fupautonote=="Budget issue. Shared other options" || follow_up[j].fupautonote=="Comparing packages with other agencies" || follow_up[j].fupautonote=="Everything finalized. Awaiting payment" || follow_up[j].fupautonote=="Need to share first quote")){
          fup=[...fup, "Progressive"]
          id=1
        }
        if( (follow_up[j].fupautonote=="Fup done manually" )){
          fup=[...fup, "Manual"]
          id=1
        }
        if( (follow_up[j].fupautonote=="Need to share voucher or tickets" || follow_up[j].fupautonote=="Need to share insurance" || follow_up[j].fupautonote=="Need to confirm booking with supplier" || follow_up[j].fupautonote=="Need to make payment to supplier")){
          fup=[...fup, "PS"]
          id=1
        }
        if( (follow_up[j].fupautonote=="Asked to cancel-on call" || follow_up[j].fupautonote=="Asked to cancel-on whatsapp" || follow_up[j].fupautonote=="Manual Cancellation" || follow_up[j].fupautonote=="Plan on hold" || follow_up[j].fupautonote=="System fup - WA msg sent -Asked to cancel-on call" ||  follow_up[j].fupautonote=="System fup - WA msg sent -Asked to cancel-on whatsapp" )){
          fup=[...fup, "Cancel"]
          id=1
        }
        if( (follow_up[j].fupautonote=="Asked to postpone" )){
          fup=[...fup, "Postpone"]
          id=1
        }
        if( (follow_up[j].fupautonote=="Data entry only")){
      
          id=1
        }
}
return fup
}

export function getLastTenChars(str) {
  // Remove all white spaces
  const noSpacesStr = str.replace(/\s+/g, '');
  
  // Return the last 10 characters
  return noSpacesStr.slice(-10);
}

export const total = (cpdata) => {
  let sum = 0;
  if(cpdata){
  if (cpdata.length == 0) {
    return sum;
  } else {
    cpdata.map((item) =>
      item.amount
        ? (item.status=="Waive Off"?sum:(!(item.status == "Refund" || item.status=="Credit Note" || item.status=="Refund Due" || item.status=="Internal Refund")
          ? (sum = sum + parseInt(item.amount))
          : (sum = sum - parseInt(item.amount))))
        : sum
    );
    return sum;
  }
}else{
  return sum
}
};

export const receivedwocreditnrefund = (cpdata) => {
  let sum = 0;
  if(cpdata){
  if (cpdata.length == 0) {
    return sum;
  } else {
    cpdata.map((item) =>
      item.amount
        ? (item.status=="Received"?(sum = sum + parseInt(item.amount)):sum)
       
        : sum
    );
    return sum;
  }
}else{
  return sum
}
};

export const waiveofftotal = (cpdata) => {
  let sum = 0;
  if(cpdata){
  if (cpdata.length == 0) {
    return sum;
  } else {
    cpdata.map((item) =>
      item.amount
        ? (item.status=="Waive Off"?
          sum = sum + parseInt(item.amount)
          : sum):sum
    );
    return sum;
  }
}else{
  return sum
}
};

export const sptotal = (spdata) => {
  let sum = 0;
  if (spdata.length == 0) {
    return sum;
  } else {
    spdata.map((item) =>
      item.amount
        ? item.status == "Forfeit"?sum:(!(item.status == "Refund" || item.status == "Refund Due" || item.status == "Refund claim by internal team")
          ? (sum = sum + parseInt(item.amount))
          : (sum = sum - parseInt(item.amount)))
        : sum
    );
    //console.log(sum)
    return sum;
  }
};

export const gettaxes=(tripData)=>{
  
  var taxes=0
    if(tripData.no_tax){
      taxes=0
    }else if(tripData.only_flight){
      var nontaxprofit2=(((tripData.flight_sp?tripData.flight_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))+((tripData.visa_sp?tripData.visa_sp:0)-(tripData.visa_cp?tripData.visa_cp:0))+((tripData.anc_sp?tripData.anc_sp:0)-(tripData.anc_cp?tripData.anc_cp:0))+((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))+((tripData.cruise_sp?tripData.cruise_sp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)))
      taxes=parseInt((nontaxprofit2-nontaxprofit2/1.18).toFixed(0))+parseInt((tripData.high_tax_amount?tripData.high_tax_amount/1.18*0.18:0).toFixed(0))
    }else{
    
    var landpart=total(tripData.cust_payments)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0)-(tripData.high_tax_amount?tripData.high_tax_amount:0)-gettcs(tripData)
    //console.log(landpart)
    if(tripData.land_sp>0){
      taxes=parseInt(((landpart-landpart/1.05)+(((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))-(((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))/1.18))).toFixed(0))+parseInt((tripData.high_tax_amount?tripData.high_tax_amount/1.18*0.18:0).toFixed(0))
    }else{
      var nontaxprofit=(((tripData.flight_sp?tripData.flight_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))+((tripData.visa_sp?tripData.visa_sp:0)-(tripData.visa_cp?tripData.visa_cp:0))+((tripData.anc_sp?tripData.anc_sp:0)-(tripData.anc_cp?tripData.anc_cp:0))+((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))+((tripData.cruise_sp?tripData.cruise_sp:0)-(tripData.cruise_cp?tripData.cruise_cp:0))+(tripData.high_tax_amount?tripData.high_tax_amount:0))
      taxes=(nontaxprofit-nontaxprofit/1.18).toFixed(0)
    }
  }
  return taxes
}

export const gettcs=(trip)=>{
  // if(trip.trip_id==95983){
  //   console.log(trip)
  // }
  
  var t=identifydest(trip.primary_destination)
   if(trip.primary_destination=="Maldives" && new Date(getconvdate(trip)).getTime()>new Date("2025-10-01").getTime()){
     t=0
   }
  if(t){
 
  var convdate=""
  
  var landpart=(total(trip.cust_payments)-(trip.visa_cp?trip.visa_cp:0)-(trip.anc_cp?trip.anc_cp:0)-(trip.extra_sp?trip.extra_sp:0)-(trip.flight_cp?trip.flight_cp:0))/1.05
  if(trip.trip_id==65267|| trip.trip_id==95983){
    // console.log(Math.round((parseInt(landpart))*0.05))
  }

  if(t && !trip.no_tax && !trip.only_flight && !trip.no_tcs && !trip.on_hold){
    if(trip.trip_status=="Converted"){
      convdate="status_history" in trip && "date" in trip.status_history?trip.status_history.date:""
      // if(trip.trip_id==82785){
      //   console.log(convdate)
      // }
  }else if(trip.trip_status=="Closed"){
     convdate="status_history" in trip && "date" in trip.status_history?trip.status_history.date:""
    // if(trip.trip_id==82785){
    //     console.log(convdate)
    //   }
  }
  
  if(new Date(trip.trip_start_date).getTime()>=new Date("2026-03-25").getTime()){
     landpart=(total(trip.cust_payments)-(trip.visa_cp?trip.visa_cp:0)-(trip.anc_cp?trip.anc_cp:0)-(trip.extra_sp?trip.extra_sp:0)-(trip.flight_cp?trip.flight_cp:0))/1.02
      if(trip.five_tcs){
            return landpart?Math.round((parseInt(landpart))*0.05):0
           }else{
            return landpart?Math.round((parseInt(landpart))*0.02):0
           }
      
  }
  else if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
    return 0
  }else if(new Date(convdate).getTime()>new Date("2023-08-15").getTime()){
    // console.log(trip.trip_id)
    
    // return 0
    if(trip.hightcs){
      landpart=(total(trip.cust_payments)-(trip.visa_cp?trip.visa_cp:0)-(trip.anc_cp?trip.anc_cp:0)-(trip.extra_sp?trip.extra_sp:0)-(trip.flight_cp?trip.flight_cp:0))/1.2
      if(trip.trip_id==65267|| trip.trip_id==95983){
        console.log(Math.round((parseInt(landpart))*0.2))
      }
      return landpart?Math.round((parseInt(landpart))*0.20):0
    }else{
      
      landpart=(total(trip.cust_payments)-(trip.visa_cp?trip.visa_cp:0)-(trip.anc_cp?trip.anc_cp:0)-(trip.extra_sp?trip.extra_sp:0)-(trip.flight_cp?trip.flight_cp:0))/1.05
      if(trip.trip_id==65267|| trip.trip_id==95983){
        console.log(Math.round((parseInt(landpart))*0.05))
      }
      return landpart?Math.round((parseInt(landpart))*0.05):0
    }
    
  }else{
    if(trip.hightcs){
    return landpart?Math.round((landpart)*0.20):0
    }else{
      return landpart?Math.round((landpart)*0.05):0
    }
    
  }
  
 
     
      
  }else{
    // if(trip.trip_id==23307){
    //   console.log(0)
    // }
      return 0
  }
//}
}else{
  return 0
}
}

export const gettcs2=(tripData)=>{
  if(tripData && "primary_destination" in tripData){
  var t=identifydest(tripData.primary_destination)
  if(tripData.primary_destination=="Maldives" && new Date(getconvdate(tripData)).getTime()>new Date("2025-10-01").getTime()){
     t=0
   }
  
  //var landpart=total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.flight_cp?tripData.flight_cp:0)-gettcs()
  var convdate=""
  var landpart=(total(tripData.cust_payments)-(tripData.high_tax_amount?tripData.high_tax_amount:0)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.05
  if(t && !tripData.no_tax && !tripData.only_flight && !tripData.no_tcs && !tripData.on_hold){
    if(tripData.trip_status=="Converted"){
        convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
    }else if(tripData.trip_status=="Closed"){
      convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
    }
    
    if(new Date(tripData.trip_start_date).getTime()>=new Date("2026-03-25").getTime()){
     landpart=(total(tripData.cust_payments)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.02
      if(tripData.five_tcs){
            return landpart?Math.round((parseInt(landpart))*0.05):0
           }else{
            return landpart?Math.round((parseInt(landpart))*0.02):0
           }
      
    }
    else if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
      return 0
    }else if(new Date(convdate).getTime()>new Date("2023-08-15").getTime()){
      //console.log(tripData.cruise_sp)
       if(tripData.hightcs){
          landpart=(total(tripData.cust_payments)-(tripData.high_tax_amount?tripData.high_tax_amount:0)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.2
          return landpart && landpart>0?Math.round((parseInt(landpart))*0.20):0
        }else{
          landpart=(total(tripData.cust_payments)-(tripData.high_tax_amount?tripData.high_tax_amount:0)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.05
          return landpart && landpart>0?Math.round((parseInt(landpart))*0.05):0
        }
      
    }else{
      if(tripData.hightcs){
        return tripData.land_sp?Math.round((tripData.land_sp)*0.20):0
      }else{
        return tripData.land_sp?Math.round((tripData.land_sp)*0.05):0
      }
    }

    
      
  }else{
      //console.log("DEF")
      //setprice({...price,tcs:0})
      return 0
  }
}else{
  return 0
}
}

export const pending = (cpdata) => {
  let sum = 0;
  if (cpdata.length == 0) {
    return sum;
  } else {
    cpdata.map((item) =>
      item.amount && item.status == "Pending"
        ? (sum = sum + parseInt(item.amount))
        : sum
    );
    return sum;
  }
};

export const creditnotetotal = (cpdata) => {
  let sum = 0;
  if (cpdata.length == 0) {
    return sum;
  } else {
    cpdata.map((item) =>
      item.amount && item.status == "Credit Note"
        ? (sum = sum + parseInt(item.amount))
        : sum
    );
    return sum;
  }
};

export const refundtotal = (cpdata) => {
  let sum = 0;
  if (cpdata.length == 0) {
    return sum;
  } else {
    cpdata.map((item) =>
      item.amount && (item.status == "Refund" || item.status == "Refund Due")
        ? (sum = sum + parseInt(item.amount))
        : sum
    );
    return sum;
  }
};

export const onlyreceivedtotal = (cpdata) => {
  let sum = 0;
  if (cpdata.length == 0) {
    return sum;
  } else {
    cpdata.map((item) =>
      item.amount && item.status == "Received"
        ? (sum = sum + parseInt(item.amount))
        : sum
    );
    return sum;
  }
};

export const supplierpending = (spdata) => {
  let sum = 0;
  if (spdata.length == 0) {
    return sum;
  } else {
    spdata.map((item) =>
      item.amount && item.status == "Pending"
        ? (sum = sum + parseInt(item.amount))
        : item.status == "Refund Due"?(sum = sum - parseInt(item.amount)):sum
    );
    return sum;
  }
};

export const getquote=(searchData)=>{
  if(searchData.dest=="Andaman"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 54998
        }else if(searchData.duration==5){
          return 55003
        }else if(searchData.duration==6){
          return 55006
        }else{
          return 55006
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 55011
        }else if(searchData.duration==5){
          return 55016
        }else if(searchData.duration==6){
          return 55018
        }else{
          return 55018
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 55022
        }else if(searchData.duration==5){
          return 55026
        }else if(searchData.duration==6){
          return 55028
        }else{
          return 55028
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 54876
        }else if(searchData.duration==5){
          return 54878
        }else if(searchData.duration==6){
          return 54879
        }else{
          return 54879
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 54876
        }else if(searchData.duration==5){
          return 54878
        }else if(searchData.duration==6){
          return 54879
        }else{
          return 54879
        }
      }else{
        if(searchData.duration==4){
          return 55041
        }else if(searchData.duration==5){
          return 55042
        }else if(searchData.duration==6){
          return 55044
        }else{
          return 55044
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 55086
        }else if(searchData.duration==5){
          return 55145
        }else if(searchData.duration==6){
          return 55149
        }else{
          return 55149
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 55154
        }else if(searchData.duration==5){
          return 55163
        }else if(searchData.duration==6){
          return 55166
        }else{
          return 55166
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 55170
        }else if(searchData.duration==5){
          return 55173
        }else if(searchData.duration==6){
          return 55174
        }else{
          return 55174
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 55059
        }else if(searchData.duration==5){
          return 55062
        }else if(searchData.duration==6){
          return 55063
        }else{
          return 55063
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 55059
        }else if(searchData.duration==5){
          return 55062
        }else if(searchData.duration==6){
          return 55063
        }else{
          return 55063
        }
      }else{
        if(searchData.duration==4){
          return 55177
        }else if(searchData.duration==5){
          return 55179
        }else if(searchData.duration==6){
          return 55181
        }else{
          return 55181
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 55306
        }else if(searchData.duration==5){
          return 55307
        }else if(searchData.duration==6){
          return 55309
        }else{
          return 55309
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 55312
        }else if(searchData.duration==5){
          return 55313
        }else if(searchData.duration==6){
          return 55316
        }else{
          return 55316
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 55319
        }else if(searchData.duration==5){
          return 55320
        }else if(searchData.duration==6){
          return 55326
        }else{
          return 55326
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 55295
        }else if(searchData.duration==5){
          return 55296
        }else if(searchData.duration==6){
          return 55304
        }else{
          return 55304
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 55295
        }else if(searchData.duration==5){
          return 55296
        }else if(searchData.duration==6){
          return 55304
        }else{
          return 55304
        }
      }else{
        if(searchData.duration==4){
          return 55334
        }else if(searchData.duration==5){
          return 55336
        }else if(searchData.duration==6){
          return 55338
        }else{
          return 55338
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 55350
        }else if(searchData.duration==5){
          return 55351
        }else if(searchData.duration==6){
          return 55353
        }else{
          return 55353
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 55354
        }else if(searchData.duration==5){
          return 55355
        }else if(searchData.duration==6){
          return 55356
        }else{
          return 55356
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 55357
        }else if(searchData.duration==5){
          return 55358
        }else if(searchData.duration==6){
          return 55360
        }else{
          return 55360
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 55346
        }else if(searchData.duration==5){
          return 55347
        }else if(searchData.duration==6){
          return 55349
        }else{
          return 55349
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 55346
        }else if(searchData.duration==5){
          return 55347
        }else if(searchData.duration==6){
          return 55349
        }else{
          return 55349
        }
      }else{
        if(searchData.duration==4){
          return 55361
        }else if(searchData.duration==5){
          return 55362
        }else if(searchData.duration==6){
          return 55364
        }else{
          return 55364
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 55378
        }else if(searchData.duration==5){
          return 55385
        }else if(searchData.duration==6){
          return 55386
        }else{
          return 55386
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 55388
        }else if(searchData.duration==5){
          return 55389
        }else if(searchData.duration==6){
          return 55390
        }else{
          return 55390
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 55391
        }else if(searchData.duration==5){
          return 55392
        }else if(searchData.duration==6){
          return 55393
        }else{
          return 55393
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 55369
        }else if(searchData.duration==5){
          return 55374
        }else if(searchData.duration==6){
          return 55375
        }else{
          return 55375
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 55369
        }else if(searchData.duration==5){
          return 55374
        }else if(searchData.duration==6){
          return 55375
        }else{
          return 55375
        }
      }else{
        if(searchData.duration==4){
          return 55394
        }else if(searchData.duration==5){
          return 55395
        }else if(searchData.duration==6){
          return 55396
        }else{
          return 55396
        }
      }
    }
  }else if(searchData.dest=="Thailand"){
    if(searchData.special=="Bangkok-Pattaya"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 66437
          }if(searchData.duration==4){
            return 66438
          }else if(searchData.duration==5){
            return 66440
          }else if(searchData.duration==6){
            return 66441
          }else{
            return 66441
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 55767
          }if(searchData.duration==4){
            return 55770
          }else if(searchData.duration==5){
            return 55772
          }else if(searchData.duration==6){
            return 55774
          }else{
            return 55774
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 55762
          }if(searchData.duration==4){
            return 55768
          }else if(searchData.duration==5){
            return 55769
          }else if(searchData.duration==6){
            return 55771
          }else{
            return 55771
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==3){
            return 66421
          }if(searchData.duration==4){
            return 55506
          }else if(searchData.duration==5){
            return 55660
          }else if(searchData.duration==6){
            return 55664
          }else{
            return 55664
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==3){
            return 66424
          }if(searchData.duration==4){
            return 66431
          }else if(searchData.duration==5){
            return 66432
          }else if(searchData.duration==6){
            return 66434
          }else{
            return 66434
          }
        }else{
          if(searchData.duration==3){
            return 66443
          }if(searchData.duration==4){
            return 66444
          }else if(searchData.duration==5){
            return 66445
          }else if(searchData.duration==6){
            return 66447
          }else{
            return 66447
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 66455
          }else if(searchData.duration==4){
            return 66457
          }else if(searchData.duration==5){
            return 66458
          }else if(searchData.duration==6){
            return 66460
          }else{
            return 66460
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 55811
          }else if(searchData.duration==4){
            return 55814
          }else if(searchData.duration==5){
            return 55817
          }else if(searchData.duration==6){
            return 55820
          }else{
            return 55820
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 55815
          }else if(searchData.duration==4){
            return 55818
          }else if(searchData.duration==5){
            return 55823
          }else if(searchData.duration==6){
            return 55825
          }else{
            return 55825
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==3){
            return 55777
          }else if(searchData.duration==4){
            return 55781
          }else if(searchData.duration==5){
            return 55799
          }else if(searchData.duration==6){
            return 55805
          }else{
            return 55805
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==3){
            return 66448
          }else if(searchData.duration==4){
            return 66451
          }else if(searchData.duration==5){
            return 66453
          }else if(searchData.duration==6){
            return 66454
          }else{
            return 66454
          }
        }else{
          if(searchData.duration==3){
            return 55796
          }else if(searchData.duration==4){
            return 55800
          }else if(searchData.duration==5){
            return 55804
          }else if(searchData.duration==6){
            return 55809
          }else{
            return 55809
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 56020
          }else if(searchData.duration==4){
            return 56022
          }else if(searchData.duration==5){
            return 56024
          }else if(searchData.duration==6){
            return 56026
          }else{
            return 56026
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 56028
          }else if(searchData.duration==4){
            return 56029
          }else if(searchData.duration==5){
            return 56030
          }else if(searchData.duration==6){
            return 56032
          }else{
            return 56032
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 56039
          }else if(searchData.duration==4){
            return 56040
          }else if(searchData.duration==5){
            return 56043
          }else if(searchData.duration==6){
            return 56046
          }else{
            return 56046
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==3){
            return 55877
          }else if(searchData.duration==4){
            return 55886
          }else if(searchData.duration==5){
            return 55893
          }else if(searchData.duration==6){
            return 55897
          }else{
            return 55897
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==3){
            return 55901
          }else if(searchData.duration==4){
            return 55909
          }else if(searchData.duration==5){
            return 56004
          }else if(searchData.duration==6){
            return 56005
          }else{
            return 56005
          }
        }else{
          if(searchData.duration==3){
            return 56020
          }else if(searchData.duration==4){
            return 56022
          }else if(searchData.duration==5){
            return 56024
          }else if(searchData.duration==6){
            return 56026
          }else{
            return 56026
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 56111
          }else if(searchData.duration==4){
            return 56114
          }else if(searchData.duration==5){
            return 56119
          }else if(searchData.duration==6){
            return 56128
          }else{
            return 56128
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 56135
          }else if(searchData.duration==4){
            return 56136
          }else if(searchData.duration==5){
            return 56137
          }else if(searchData.duration==6){
            return 56141
          }else{
            return 56141
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 56144
          }else if(searchData.duration==4){
            return 56160
          }else if(searchData.duration==5){
            return 56170
          }else if(searchData.duration==6){
            return 56172
          }else{
            return 56172
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==3){
            return 56055
          }else if(searchData.duration==4){
            return 56058
          }else if(searchData.duration==5){
            return 56061
          }else if(searchData.duration==6){
            return 56063
          }else{
            return 56063
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==3){
            return 56070
          }else if(searchData.duration==4){
            return 56072
          }else if(searchData.duration==5){
            return 56078
          }else if(searchData.duration==6){
            return 56110
          }else{
            return 56110
          }
        }else{
          if(searchData.duration==3){
            return 56111
          }else if(searchData.duration==4){
            return 56114
          }else if(searchData.duration==5){
            return 56119
          }else if(searchData.duration==6){
            return 56128
          }else{
            return 56128
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 56180
          }else if(searchData.duration==4){
            return 56182
          }else if(searchData.duration==5){
            return 56183
          }else if(searchData.duration==6){
            return 56186
          }else{
            return 56186
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 56190
          }else if(searchData.duration==4){
            return 56192
          }else if(searchData.duration==5){
            return 56194
          }else if(searchData.duration==6){
            return 56195
          }else{
            return 56195
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 56196
          }else if(searchData.duration==4){
            return 56198
          }else if(searchData.duration==5){
            return 56200
          }else if(searchData.duration==6){
            return 56202
          }else{
            return 56202
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==3){
            return 56174
          }else if(searchData.duration==4){
            return 56179
          }else if(searchData.duration==5){
            return 56184
          }else if(searchData.duration==6){
            return 56189
          }else{
            return 56189
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==3){
            return 56191
          }else if(searchData.duration==4){
            return 56193
          }else if(searchData.duration==5){
            return 56216
          }else if(searchData.duration==6){
            return 56223
          }else{
            return 56223
          }
        }else{
          if(searchData.duration==3){
            return 56180
          }else if(searchData.duration==4){
            return 56182
          }else if(searchData.duration==5){
            return 56183
          }else if(searchData.duration==6){
            return 56183
          }else{
            return 56183
          }
        }
      }
    }else{
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 55762
        }if(searchData.duration==4){
          return 55765
        }else if(searchData.duration==5){
          return 55758
        }else if(searchData.duration==6){
          return 55766
        }else{
          return 55766
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 55767
        }if(searchData.duration==4){
          return 55770
        }else if(searchData.duration==5){
          return 55772
        }else if(searchData.duration==6){
          return 55774
        }else{
          return 55774
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 55762
        }if(searchData.duration==4){
          return 55768
        }else if(searchData.duration==5){
          return 55769
        }else if(searchData.duration==6){
          return 55771
        }else{
          return 55771
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 55476
        }if(searchData.duration==4){
          return 55506
        }else if(searchData.duration==5){
          return 55660
        }else if(searchData.duration==6){
          return 55664
        }else{
          return 55664
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 55678
        }if(searchData.duration==4){
          return 55686
        }else if(searchData.duration==5){
          return 55743
        }else if(searchData.duration==6){
          return 55756
        }else{
          return 55756
        }
      }else{
        if(searchData.duration==3){
          return 55762
        }if(searchData.duration==4){
          return 55765
        }else if(searchData.duration==5){
          return 55758
        }else if(searchData.duration==6){
          return 55766
        }else{
          return 55766
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 55796
        }else if(searchData.duration==4){
          return 55800
        }else if(searchData.duration==5){
          return 55804
        }else if(searchData.duration==6){
          return 55809
        }else{
          return 55809
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 55811
        }else if(searchData.duration==4){
          return 55814
        }else if(searchData.duration==5){
          return 55817
        }else if(searchData.duration==6){
          return 55820
        }else{
          return 55820
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 55815
        }else if(searchData.duration==4){
          return 55818
        }else if(searchData.duration==5){
          return 55823
        }else if(searchData.duration==6){
          return 55825
        }else{
          return 55825
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 55777
        }else if(searchData.duration==4){
          return 55781
        }else if(searchData.duration==5){
          return 55799
        }else if(searchData.duration==6){
          return 55805
        }else{
          return 55805
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 55776
        }else if(searchData.duration==4){
          return 55778
        }else if(searchData.duration==5){
          return 55784
        }else if(searchData.duration==6){
          return 55790
        }else{
          return 55790
        }
      }else{
        if(searchData.duration==3){
          return 55796
        }else if(searchData.duration==4){
          return 55800
        }else if(searchData.duration==5){
          return 55804
        }else if(searchData.duration==6){
          return 55809
        }else{
          return 55809
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 56020
        }else if(searchData.duration==4){
          return 56022
        }else if(searchData.duration==5){
          return 56024
        }else if(searchData.duration==6){
          return 56026
        }else{
          return 56026
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 56028
        }else if(searchData.duration==4){
          return 56029
        }else if(searchData.duration==5){
          return 56030
        }else if(searchData.duration==6){
          return 56032
        }else{
          return 56032
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 56039
        }else if(searchData.duration==4){
          return 56040
        }else if(searchData.duration==5){
          return 56043
        }else if(searchData.duration==6){
          return 56046
        }else{
          return 56046
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 55877
        }else if(searchData.duration==4){
          return 55886
        }else if(searchData.duration==5){
          return 55893
        }else if(searchData.duration==6){
          return 55897
        }else{
          return 55897
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 55901
        }else if(searchData.duration==4){
          return 55909
        }else if(searchData.duration==5){
          return 56004
        }else if(searchData.duration==6){
          return 56005
        }else{
          return 56005
        }
      }else{
        if(searchData.duration==3){
          return 56020
        }else if(searchData.duration==4){
          return 56022
        }else if(searchData.duration==5){
          return 56024
        }else if(searchData.duration==6){
          return 56026
        }else{
          return 56026
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 56111
        }else if(searchData.duration==4){
          return 56114
        }else if(searchData.duration==5){
          return 56119
        }else if(searchData.duration==6){
          return 56128
        }else{
          return 56128
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 56135
        }else if(searchData.duration==4){
          return 56136
        }else if(searchData.duration==5){
          return 56137
        }else if(searchData.duration==6){
          return 56141
        }else{
          return 56141
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 56144
        }else if(searchData.duration==4){
          return 56160
        }else if(searchData.duration==5){
          return 56170
        }else if(searchData.duration==6){
          return 56172
        }else{
          return 56172
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 56055
        }else if(searchData.duration==4){
          return 56058
        }else if(searchData.duration==5){
          return 56061
        }else if(searchData.duration==6){
          return 56063
        }else{
          return 56063
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 56070
        }else if(searchData.duration==4){
          return 56072
        }else if(searchData.duration==5){
          return 56078
        }else if(searchData.duration==6){
          return 56110
        }else{
          return 56110
        }
      }else{
        if(searchData.duration==3){
          return 56111
        }else if(searchData.duration==4){
          return 56114
        }else if(searchData.duration==5){
          return 56119
        }else if(searchData.duration==6){
          return 56128
        }else{
          return 56128
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 56180
        }else if(searchData.duration==4){
          return 56182
        }else if(searchData.duration==5){
          return 56183
        }else if(searchData.duration==6){
          return 56186
        }else{
          return 56186
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 56190
        }else if(searchData.duration==4){
          return 56192
        }else if(searchData.duration==5){
          return 56194
        }else if(searchData.duration==6){
          return 56195
        }else{
          return 56195
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 56196
        }else if(searchData.duration==4){
          return 56198
        }else if(searchData.duration==5){
          return 56200
        }else if(searchData.duration==6){
          return 56202
        }else{
          return 56202
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 56174
        }else if(searchData.duration==4){
          return 56179
        }else if(searchData.duration==5){
          return 56184
        }else if(searchData.duration==6){
          return 56189
        }else{
          return 56189
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 56191
        }else if(searchData.duration==4){
          return 56193
        }else if(searchData.duration==5){
          return 56216
        }else if(searchData.duration==6){
          return 56223
        }else{
          return 56223
        }
      }else{
        if(searchData.duration==3){
          return 56180
        }else if(searchData.duration==4){
          return 56182
        }else if(searchData.duration==5){
          return 56183
        }else if(searchData.duration==6){
          return 56183
        }else{
          return 56183
        }
      }
    }
  }
  }else if(searchData.dest=="Dubai"){
    if(searchData.special=="Abu Dhabi stay"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61507
          }else if(searchData.duration==5){
            return 61509
          }else if(searchData.duration==6){
            return 61510
          }else{
            return 61510
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61501
          }else if(searchData.duration==5){
            return 61514
          }else if(searchData.duration==6){
            return 61523
          }else{
            return 61523
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61524
          }else if(searchData.duration==5){
            return 61525
          }else if(searchData.duration==6){
            return 61528
          }else{
            return 61528
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61470
          }else if(searchData.duration==5){
            return 61471
          }else if(searchData.duration==6){
            return 61475
          }else{
            return 61475
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61470
          }else if(searchData.duration==5){
            return 61471
          }else if(searchData.duration==6){
            return 61475
          }else{
            return 61475
          }
        }else{
          if(searchData.duration==4){
            return 60988
          }else if(searchData.duration==5){
            return 61467
          }else if(searchData.duration==6){
            return 61468
          }else{
            return 61468
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61545
          }else if(searchData.duration==5){
            return 61546
          }else if(searchData.duration==6){
            return 61547
          }else{
            return 61547
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61548
          }else if(searchData.duration==5){
            return 61549
          }else if(searchData.duration==6){
            return 61550
          }else{
            return 61550
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61551
          }else if(searchData.duration==5){
            return 61552
          }else if(searchData.duration==6){
            return 61553
          }else{
            return 61553
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61538
          }else if(searchData.duration==5){
            return 61540
          }else if(searchData.duration==6){
            return 61541
          }else{
            return 61541
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61542
          }else if(searchData.duration==5){
            return 61543
          }else if(searchData.duration==6){
            return 61544
          }else{
            return 61544
          }
        }else{
          if(searchData.duration==4){
            return 61518
          }else if(searchData.duration==5){
            return 61519
          }else if(searchData.duration==6){
            return 61539
          }else{
            return 61539
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61563
          }else if(searchData.duration==5){
            return 61564
          }else if(searchData.duration==6){
            return 61565
          }else{
            return 61565
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61566
          }else if(searchData.duration==5){
            return 61567
          }else if(searchData.duration==6){
            return 61568
          }else{
            return 61568
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61569
          }else if(searchData.duration==5){
            return 61570
          }else if(searchData.duration==6){
            return 61571
          }else{
            return 61571
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61557
          }else if(searchData.duration==5){
            return 61558
          }else if(searchData.duration==6){
            return 61559
          }else{
            return 61559
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61560
          }else if(searchData.duration==5){
            return 61561
          }else if(searchData.duration==6){
            return 61562
          }else{
            return 61562
          }
        }else{
          if(searchData.duration==4){
            return 61554
          }else if(searchData.duration==5){
            return 61555
          }else if(searchData.duration==6){
            return 61556
          }else{
            return 61556
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61591
          }else if(searchData.duration==5){
            return 61593
          }else if(searchData.duration==6){
            return 61594
          }else{
            return 61594
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62557
          }else if(searchData.duration==5){
            return 62561
          }else if(searchData.duration==6){
            return 62567
          }else{
            return 62567
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62573
          }else if(searchData.duration==5){
            return 62575
          }else if(searchData.duration==6){
            return 62585
          }else{
            return 62585
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61585
          }else if(searchData.duration==5){
            return 61586
          }else if(searchData.duration==6){
            return 61587
          }else{
            return 61587
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62539
          }else if(searchData.duration==5){
            return 62542
          }else if(searchData.duration==6){
            return 62549
          }else{
            return 62549
          }
        }else{
          if(searchData.duration==4){
            return 61581
          }else if(searchData.duration==5){
            return 61583
          }else if(searchData.duration==6){
            return 61584
          }else{
            return 61584
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61610
          }else if(searchData.duration==5){
            return 61611
          }else if(searchData.duration==6){
            return 61612
          }else{
            return 61612
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62572
          }else if(searchData.duration==5){
            return 62570
          }else if(searchData.duration==6){
            return 62566
          }else{
            return 62566
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62564
          }else if(searchData.duration==5){
            return 61617
          }else if(searchData.duration==6){
            return 62558
          }else{
            return 62558
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61604
          }else if(searchData.duration==5){
            return 61605
          }else if(searchData.duration==6){
            return 61606
          }else{
            return 61606
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62578
          }else if(searchData.duration==5){
            return 62577
          }else if(searchData.duration==6){
            return 62576
          }else{
            return 62576
          }
        }else{
          if(searchData.duration==4){
            return 61601
          }else if(searchData.duration==5){
            return 61602
          }else if(searchData.duration==6){
            return 61603
          }else{
            return 61603
          }
        }
      }
    }if(searchData.special=="FD Packages"){
       if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61507
          }else if(searchData.duration==5){
            return 61509
          }else if(searchData.duration==6){
            return 61510
          }else{
            return 61510
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61501
          }else if(searchData.duration==5){
            return 61514
          }else if(searchData.duration==6){
            return 61523
          }else{
            return 61523
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61524
          }else if(searchData.duration==5){
            return 61525
          }else if(searchData.duration==6){
            return 61528
          }else{
            return 61528
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61470
          }else if(searchData.duration==5){
            return 61471
          }else if(searchData.duration==6){
            return 61475
          }else{
            return 61475
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61470
          }else if(searchData.duration==5){
            return 61471
          }else if(searchData.duration==6){
            return 61475
          }else{
            return 61475
          }
        }else{
          if(searchData.duration==4){
            return 60988
          }else if(searchData.duration==5){
            return 61467
          }else if(searchData.duration==6){
            return 61468
          }else{
            return 61468
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61545
          }else if(searchData.duration==5){
            return 61546
          }else if(searchData.duration==6){
            return 61547
          }else{
            return 61547
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61548
          }else if(searchData.duration==5){
            return 61549
          }else if(searchData.duration==6){
            return 61550
          }else{
            return 61550
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61551
          }else if(searchData.duration==5){
            return 61552
          }else if(searchData.duration==6){
            return 61553
          }else{
            return 61553
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61538
          }else if(searchData.duration==5){
            return 61540
          }else if(searchData.duration==6){
            return 61541
          }else{
            return 61541
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61542
          }else if(searchData.duration==5){
            return 61543
          }else if(searchData.duration==6){
            return 61544
          }else{
            return 61544
          }
        }else{
          if(searchData.duration==4){
            return 61518
          }else if(searchData.duration==5){
            return 61519
          }else if(searchData.duration==6){
            return 61539
          }else{
            return 61539
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61563
          }else if(searchData.duration==5){
            return 61564
          }else if(searchData.duration==6){
            return 61565
          }else{
            return 61565
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61566
          }else if(searchData.duration==5){
            return 61567
          }else if(searchData.duration==6){
            return 61568
          }else{
            return 61568
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61569
          }else if(searchData.duration==5){
            return 61570
          }else if(searchData.duration==6){
            return 61571
          }else{
            return 61571
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61557
          }else if(searchData.duration==5){
            return 61558
          }else if(searchData.duration==6){
            return 61559
          }else{
            return 61559
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61560
          }else if(searchData.duration==5){
            return 61561
          }else if(searchData.duration==6){
            return 61562
          }else{
            return 61562
          }
        }else{
          if(searchData.duration==4){
            return 268779
          }else if(searchData.duration==5){
            return 268779
          }else if(searchData.duration==6){
            return 268779
          }else{
            return 268779
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61591
          }else if(searchData.duration==5){
            return 61593
          }else if(searchData.duration==6){
            return 61594
          }else{
            return 61594
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61595
          }else if(searchData.duration==5){
            return 61596
          }else if(searchData.duration==6){
            return 61597
          }else{
            return 61597
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61598
          }else if(searchData.duration==5){
            return 61599
          }else if(searchData.duration==6){
            return 61600
          }else{
            return 61600
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61585
          }else if(searchData.duration==5){
            return 61586
          }else if(searchData.duration==6){
            return 61587
          }else{
            return 61587
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61580
          }else if(searchData.duration==5){
            return 61588
          }else if(searchData.duration==6){
            return 61590
          }else{
            return 61590
          }
        }else{
          if(searchData.duration==4){
            return 61581
          }else if(searchData.duration==5){
            return 61583
          }else if(searchData.duration==6){
            return 61584
          }else{
            return 61584
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61610
          }else if(searchData.duration==5){
            return 61611
          }else if(searchData.duration==6){
            return 61612
          }else{
            return 61612
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61613
          }else if(searchData.duration==5){
            return 61614
          }else if(searchData.duration==6){
            return 61615
          }else{
            return 61615
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61616
          }else if(searchData.duration==5){
            return 62587
          }else if(searchData.duration==6){
            return 61618
          }else{
            return 61618
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61604
          }else if(searchData.duration==5){
            return 61605
          }else if(searchData.duration==6){
            return 61606
          }else{
            return 61606
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61607
          }else if(searchData.duration==5){
            return 61608
          }else if(searchData.duration==6){
            return 61609
          }else{
            return 61609
          }
        }else{
          if(searchData.duration==4){
            return 61601
          }else if(searchData.duration==5){
            return 61602
          }else if(searchData.duration==6){
            return 61603
          }else{
            return 61603
          }
        }
      }
    }else{
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61507
          }else if(searchData.duration==5){
            return 61509
          }else if(searchData.duration==6){
            return 61510
          }else{
            return 61510
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61501
          }else if(searchData.duration==5){
            return 61514
          }else if(searchData.duration==6){
            return 61523
          }else{
            return 61523
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61524
          }else if(searchData.duration==5){
            return 61525
          }else if(searchData.duration==6){
            return 61528
          }else{
            return 61528
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61470
          }else if(searchData.duration==5){
            return 61471
          }else if(searchData.duration==6){
            return 61475
          }else{
            return 61475
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61470
          }else if(searchData.duration==5){
            return 61471
          }else if(searchData.duration==6){
            return 61475
          }else{
            return 61475
          }
        }else{
          if(searchData.duration==4){
            return 60988
          }else if(searchData.duration==5){
            return 61467
          }else if(searchData.duration==6){
            return 61468
          }else{
            return 61468
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61545
          }else if(searchData.duration==5){
            return 61546
          }else if(searchData.duration==6){
            return 61547
          }else{
            return 61547
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61548
          }else if(searchData.duration==5){
            return 61549
          }else if(searchData.duration==6){
            return 61550
          }else{
            return 61550
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61551
          }else if(searchData.duration==5){
            return 61552
          }else if(searchData.duration==6){
            return 61553
          }else{
            return 61553
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61538
          }else if(searchData.duration==5){
            return 61540
          }else if(searchData.duration==6){
            return 61541
          }else{
            return 61541
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61542
          }else if(searchData.duration==5){
            return 61543
          }else if(searchData.duration==6){
            return 61544
          }else{
            return 61544
          }
        }else{
          if(searchData.duration==4){
            return 61518
          }else if(searchData.duration==5){
            return 61519
          }else if(searchData.duration==6){
            return 61539
          }else{
            return 61539
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61563
          }else if(searchData.duration==5){
            return 61564
          }else if(searchData.duration==6){
            return 61565
          }else{
            return 61565
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61566
          }else if(searchData.duration==5){
            return 61567
          }else if(searchData.duration==6){
            return 61568
          }else{
            return 61568
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61569
          }else if(searchData.duration==5){
            return 61570
          }else if(searchData.duration==6){
            return 61571
          }else{
            return 61571
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61557
          }else if(searchData.duration==5){
            return 61558
          }else if(searchData.duration==6){
            return 61559
          }else{
            return 61559
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61560
          }else if(searchData.duration==5){
            return 61561
          }else if(searchData.duration==6){
            return 61562
          }else{
            return 61562
          }
        }else{
          if(searchData.duration==4){
            return 61554
          }else if(searchData.duration==5){
            return 61555
          }else if(searchData.duration==6){
            return 61556
          }else{
            return 61556
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61591
          }else if(searchData.duration==5){
            return 61593
          }else if(searchData.duration==6){
            return 61594
          }else{
            return 61594
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61595
          }else if(searchData.duration==5){
            return 61596
          }else if(searchData.duration==6){
            return 61597
          }else{
            return 61597
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61598
          }else if(searchData.duration==5){
            return 61599
          }else if(searchData.duration==6){
            return 61600
          }else{
            return 61600
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61585
          }else if(searchData.duration==5){
            return 61586
          }else if(searchData.duration==6){
            return 61587
          }else{
            return 61587
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61580
          }else if(searchData.duration==5){
            return 61588
          }else if(searchData.duration==6){
            return 61590
          }else{
            return 61590
          }
        }else{
          if(searchData.duration==4){
            return 61581
          }else if(searchData.duration==5){
            return 61583
          }else if(searchData.duration==6){
            return 61584
          }else{
            return 61584
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 61610
          }else if(searchData.duration==5){
            return 61611
          }else if(searchData.duration==6){
            return 61612
          }else{
            return 61612
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 61613
          }else if(searchData.duration==5){
            return 61614
          }else if(searchData.duration==6){
            return 61615
          }else{
            return 61615
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 61616
          }else if(searchData.duration==5){
            return 62587
          }else if(searchData.duration==6){
            return 61618
          }else{
            return 61618
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 61604
          }else if(searchData.duration==5){
            return 61605
          }else if(searchData.duration==6){
            return 61606
          }else{
            return 61606
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 61607
          }else if(searchData.duration==5){
            return 61608
          }else if(searchData.duration==6){
            return 61609
          }else{
            return 61609
          }
        }else{
          if(searchData.duration==4){
            return 61601
          }else if(searchData.duration==5){
            return 61602
          }else if(searchData.duration==6){
            return 61603
          }else{
            return 61603
          }
        }
      }
    }
  }else if(searchData.dest=="Indonesia"){
    if(searchData.special=="Nusa Penida stay"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62139
          }else if(searchData.duration==5){
            return 62141
          }else if(searchData.duration==6){
            return 62143
          }else{
            return 62143
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62148
          }else if(searchData.duration==5){
            return 62149
          }else if(searchData.duration==6){
            return 62150
          }else{
            return 62150
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62154
          }else if(searchData.duration==5){
            return 62155
          }else if(searchData.duration==6){
            return 62157
          }else{
            return 62157
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62057
          }else if(searchData.duration==5){
            return 62064
          }else if(searchData.duration==6){
            return 62071
          }else{
            return 62071
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62075
          }else if(searchData.duration==5){
            return 62083
          }else if(searchData.duration==6){
            return 62087
          }else{
            return 62087
          }
        }else{
          if(searchData.duration==4){
            return 62158
          }else if(searchData.duration==5){
            return 62161
          }else if(searchData.duration==6){
            return 62165
          }else{
            return 62165
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62252
          }else if(searchData.duration==5){
            return 62264
          }else if(searchData.duration==6){
            return 62267
          }else{
            return 62267
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62277
          }else if(searchData.duration==5){
            return 62279
          }else if(searchData.duration==6){
            return 62281
          }else{
            return 62281
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62286
          }else if(searchData.duration==5){
            return 62290
          }else if(searchData.duration==6){
            return 62292
          }else{
            return 62292
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62207
          }else if(searchData.duration==5){
            return 62218
          }else if(searchData.duration==6){
            return 62221
          }else{
            return 62221
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62233
          }else if(searchData.duration==5){
            return 62236
          }else if(searchData.duration==6){
            return 62238
          }else{
            return 62238
          }
        }else{
          if(searchData.duration==4){
            return 62295
          }else if(searchData.duration==5){
            return 62296
          }else if(searchData.duration==6){
            return 62298
          }else{
            return 62298
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62420
          }else if(searchData.duration==5){
            return 62684
          }else if(searchData.duration==6){
            return 62688
          }else{
            return 62688
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62461
          }else if(searchData.duration==5){
            return 62691
          }else if(searchData.duration==6){
            return 62693
          }else{
            return 62693
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62486
          }else if(searchData.duration==5){
            return 62694
          }else if(searchData.duration==6){
            return 62695
          }else{
            return 62695
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62390
          }else if(searchData.duration==5){
            return 62678
          }else if(searchData.duration==6){
            return 62679
          }else{
            return 62679
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62399
          }else if(searchData.duration==5){
            return 62680
          }else if(searchData.duration==6){
            return 62681
          }else{
            return 62681
          }
        }else{
          if(searchData.duration==4){
            return 62504
          }else if(searchData.duration==5){
            return 62506
          }else if(searchData.duration==6){
            return 62508
          }else{
            return 62508
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62534
          }else if(searchData.duration==5){
            return 62743
          }else if(searchData.duration==6){
            return 62746
          }else{
            return 62746
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62543
          }else if(searchData.duration==5){
            return 62749
          }else if(searchData.duration==6){
            return 62752
          }else{
            return 62752
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62551
          }else if(searchData.duration==5){
            return 62756
          }else if(searchData.duration==6){
            return 62758
          }else{
            return 62758
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62519
          }else if(searchData.duration==5){
            return 62721
          }else if(searchData.duration==6){
            return 62722
          }else{
            return 62722
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62527
          }else if(searchData.duration==5){
            return 62725
          }else if(searchData.duration==6){
            return 62726
          }else{
            return 62726
          }
        }else{
          if(searchData.duration==4){
            return 62562
          }else if(searchData.duration==5){
            return 62568
          }else if(searchData.duration==6){
            return 62569
          }else{
            return 62569
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62630
          }else if(searchData.duration==5){
            return 62776
          }else if(searchData.duration==6){
            return 62778
          }else{
            return 62778
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62635
          }else if(searchData.duration==5){
            return 62780
          }else if(searchData.duration==6){
            return 62781
          }else{
            return 62781
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62643
          }else if(searchData.duration==5){
            return 62784
          }else if(searchData.duration==6){
            return 62787
          }else{
            return 62787
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62622
          }else if(searchData.duration==5){
            return 62763
          }else if(searchData.duration==6){
            return 62768
          }else{
            return 62768
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62626
          }else if(searchData.duration==5){
            return 62771
          }else if(searchData.duration==6){
            return 62774
          }else{
            return 62774
          }
        }else{
          if(searchData.duration==4){
            return 62660
          }else if(searchData.duration==5){
            return 62662
          }else if(searchData.duration==6){
            return 62666
          }else{
            return 62666
          }
        }
      }
    }else if(searchData.special=="Special Packages"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62139
          }else if(searchData.duration==5){
            return 62141
          }else if(searchData.duration==6){
            return 62143
          }else{
            return 62143
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62148
          }else if(searchData.duration==5){
            return 62149
          }else if(searchData.duration==6){
            return 62150
          }else{
            return 62150
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62154
          }else if(searchData.duration==5){
            return 62155
          }else if(searchData.duration==6){
            return 62157
          }else{
            return 62157
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62057
          }else if(searchData.duration==5){
            return 62064
          }else if(searchData.duration==6){
            return 62071
          }else{
            return 62071
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62075
          }else if(searchData.duration==5){
            return 62083
          }else if(searchData.duration==6){
            return 62087
          }else{
            return 62087
          }
        }else{
          if(searchData.duration==4){
            return 62158
          }else if(searchData.duration==5){
            return 62161
          }else if(searchData.duration==6){
            return 62165
          }else{
            return 62165
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62252
          }else if(searchData.duration==5){
            return 62264
          }else if(searchData.duration==6){
            return 62267
          }else{
            return 62267
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62277
          }else if(searchData.duration==5){
            return 62279
          }else if(searchData.duration==6){
            return 62281
          }else{
            return 62281
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62286
          }else if(searchData.duration==5){
            return 62290
          }else if(searchData.duration==6){
            return 62292
          }else{
            return 62292
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62207
          }else if(searchData.duration==5){
            return 62218
          }else if(searchData.duration==6){
            return 62221
          }else{
            return 62221
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62233
          }else if(searchData.duration==5){
            return 62236
          }else if(searchData.duration==6){
            return 62238
          }else{
            return 62238
          }
        }else{
          if(searchData.duration==4){
            return 62295
          }else if(searchData.duration==5){
            return 62296
          }else if(searchData.duration==6){
            return 62298
          }else{
            return 62298
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 265861
          }else if(searchData.duration==5){
            return 265861
          }else if(searchData.duration==6){
            return 265868
          }else{
            return 265861
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62461
          }else if(searchData.duration==5){
            return 62474
          }else if(searchData.duration==6){
            return 62483
          }else{
            return 62483
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62486
          }else if(searchData.duration==5){
            return 62813
          }else if(searchData.duration==6){
            return 62814
          }else{
            return 62814
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62390
          }else if(searchData.duration==5){
            return 62800
          }else if(searchData.duration==6){
            return 62802
          }else{
            return 62802
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62399
          }else if(searchData.duration==5){
            return 62804
          }else if(searchData.duration==6){
            return 62805
          }else{
            return 62805
          }
        }else{
          if(searchData.duration==4){
            return 265870
          }else if(searchData.duration==5){
            return 265870
          }else if(searchData.duration==6){
            return 265874
          }else{
            return 265870
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 265877
          }else if(searchData.duration==5){
            return 265877
          }else if(searchData.duration==6){
            return 265879
          }else{
            return 265879
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62543
          }else if(searchData.duration==5){
            return 62545
          }else if(searchData.duration==6){
            return 62547
          }else{
            return 62547
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62551
          }else if(searchData.duration==5){
            return 62825
          }else if(searchData.duration==6){
            return 62827
          }else{
            return 62827
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62519
          }else if(searchData.duration==5){
            return 62816
          }else if(searchData.duration==6){
            return 62817
          }else{
            return 62817
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62527
          }else if(searchData.duration==5){
            return 62818
          }else if(searchData.duration==6){
            return 62821
          }else{
            return 62821
          }
        }else{
          if(searchData.duration==4){
            return 265880
          }else if(searchData.duration==5){
            return 265880
          }else if(searchData.duration==6){
            return 265883
          }else{
            return 265883
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62630
          }else if(searchData.duration==5){
            return 62834
          }else if(searchData.duration==6){
            return 62835
          }else{
            return 62835
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62635
          }else if(searchData.duration==5){
            return 62837
          }else if(searchData.duration==6){
            return 62838
          }else{
            return 62838
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62643
          }else if(searchData.duration==5){
            return 62645
          }else if(searchData.duration==6){
            return 62648
          }else{
            return 62648
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62622
          }else if(searchData.duration==5){
            return 62829
          }else if(searchData.duration==6){
            return 62830
          }else{
            return 62830
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62626
          }else if(searchData.duration==5){
            return 62831
          }else if(searchData.duration==6){
            return 62833
          }else{
            return 62833
          }
        }else{
          if(searchData.duration==4){
            return 62660
          }else if(searchData.duration==5){
            return 62662
          }else if(searchData.duration==6){
            return 62666
          }else{
            return 62666
          }
        }
      }
    }else if(searchData.special=="Gili stay"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62139
          }else if(searchData.duration==5){
            return 62141
          }else if(searchData.duration==6){
            return 62143
          }else{
            return 62143
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62148
          }else if(searchData.duration==5){
            return 62149
          }else if(searchData.duration==6){
            return 62150
          }else{
            return 62150
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62154
          }else if(searchData.duration==5){
            return 62155
          }else if(searchData.duration==6){
            return 62157
          }else{
            return 62157
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62057
          }else if(searchData.duration==5){
            return 62064
          }else if(searchData.duration==6){
            return 62071
          }else{
            return 62071
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62075
          }else if(searchData.duration==5){
            return 62083
          }else if(searchData.duration==6){
            return 62087
          }else{
            return 62087
          }
        }else{
          if(searchData.duration==4){
            return 62158
          }else if(searchData.duration==5){
            return 62161
          }else if(searchData.duration==6){
            return 62165
          }else{
            return 62165
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62252
          }else if(searchData.duration==5){
            return 62264
          }else if(searchData.duration==6){
            return 62267
          }else{
            return 62267
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62277
          }else if(searchData.duration==5){
            return 62279
          }else if(searchData.duration==6){
            return 62281
          }else{
            return 62281
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62286
          }else if(searchData.duration==5){
            return 62290
          }else if(searchData.duration==6){
            return 62292
          }else{
            return 62292
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62207
          }else if(searchData.duration==5){
            return 62218
          }else if(searchData.duration==6){
            return 62221
          }else{
            return 62221
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62233
          }else if(searchData.duration==5){
            return 62236
          }else if(searchData.duration==6){
            return 62238
          }else{
            return 62238
          }
        }else{
          if(searchData.duration==4){
            return 62295
          }else if(searchData.duration==5){
            return 62296
          }else if(searchData.duration==6){
            return 62298
          }else{
            return 62298
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62420
          }else if(searchData.duration==5){
            return 62807
          }else if(searchData.duration==6){
            return 62808
          }else{
            return 62808
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62461
          }else if(searchData.duration==5){
            return 62474
          }else if(searchData.duration==6){
            return 62483
          }else{
            return 62483
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62486
          }else if(searchData.duration==5){
            return 62813
          }else if(searchData.duration==6){
            return 62814
          }else{
            return 62814
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62390
          }else if(searchData.duration==5){
            return 62800
          }else if(searchData.duration==6){
            return 62802
          }else{
            return 62802
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62399
          }else if(searchData.duration==5){
            return 62804
          }else if(searchData.duration==6){
            return 62805
          }else{
            return 62805
          }
        }else{
          if(searchData.duration==4){
            return 62504
          }else if(searchData.duration==5){
            return 62506
          }else if(searchData.duration==6){
            return 62508
          }else{
            return 62508
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62534
          }else if(searchData.duration==5){
            return 62822
          }else if(searchData.duration==6){
            return 62823
          }else{
            return 62823
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62543
          }else if(searchData.duration==5){
            return 62545
          }else if(searchData.duration==6){
            return 62547
          }else{
            return 62547
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62551
          }else if(searchData.duration==5){
            return 62825
          }else if(searchData.duration==6){
            return 62827
          }else{
            return 62827
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62519
          }else if(searchData.duration==5){
            return 62816
          }else if(searchData.duration==6){
            return 62817
          }else{
            return 62817
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62527
          }else if(searchData.duration==5){
            return 62818
          }else if(searchData.duration==6){
            return 62821
          }else{
            return 62821
          }
        }else{
          if(searchData.duration==4){
            return 62562
          }else if(searchData.duration==5){
            return 62568
          }else if(searchData.duration==6){
            return 62569
          }else{
            return 62569
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62630
          }else if(searchData.duration==5){
            return 62834
          }else if(searchData.duration==6){
            return 62835
          }else{
            return 62835
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62635
          }else if(searchData.duration==5){
            return 62837
          }else if(searchData.duration==6){
            return 62838
          }else{
            return 62838
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62643
          }else if(searchData.duration==5){
            return 62645
          }else if(searchData.duration==6){
            return 62648
          }else{
            return 62648
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62622
          }else if(searchData.duration==5){
            return 62829
          }else if(searchData.duration==6){
            return 62830
          }else{
            return 62830
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62626
          }else if(searchData.duration==5){
            return 62831
          }else if(searchData.duration==6){
            return 62833
          }else{
            return 62833
          }
        }else{
          if(searchData.duration==4){
            return 62660
          }else if(searchData.duration==5){
            return 62662
          }else if(searchData.duration==6){
            return 62666
          }else{
            return 62666
          }
        }
      }
    }else if(searchData.special=="Singapore stay"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62139
          }else if(searchData.duration==5){
            return 62141
          }else if(searchData.duration==6){
            return 62143
          }else{
            return 62143
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62148
          }else if(searchData.duration==5){
            return 62149
          }else if(searchData.duration==6){
            return 62150
          }else{
            return 62150
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62154
          }else if(searchData.duration==5){
            return 62155
          }else if(searchData.duration==6){
            return 62157
          }else{
            return 62157
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62057
          }else if(searchData.duration==5){
            return 62064
          }else if(searchData.duration==6){
            return 62071
          }else{
            return 62071
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62075
          }else if(searchData.duration==5){
            return 62083
          }else if(searchData.duration==6){
            return 62087
          }else{
            return 62087
          }
        }else{
          if(searchData.duration==4){
            return 62158
          }else if(searchData.duration==5){
            return 62161
          }else if(searchData.duration==6){
            return 62165
          }else{
            return 62165
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62252
          }else if(searchData.duration==5){
            return 62264
          }else if(searchData.duration==6){
            return 62267
          }else{
            return 62267
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62277
          }else if(searchData.duration==5){
            return 62279
          }else if(searchData.duration==6){
            return 62281
          }else{
            return 62281
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62286
          }else if(searchData.duration==5){
            return 62290
          }else if(searchData.duration==6){
            return 62292
          }else{
            return 62292
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62207
          }else if(searchData.duration==5){
            return 62218
          }else if(searchData.duration==6){
            return 62221
          }else{
            return 62221
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62233
          }else if(searchData.duration==5){
            return 62236
          }else if(searchData.duration==6){
            return 62238
          }else{
            return 62238
          }
        }else{
          if(searchData.duration==4){
            return 62295
          }else if(searchData.duration==5){
            return 62296
          }else if(searchData.duration==6){
            return 62298
          }else{
            return 62298
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62420
          }else if(searchData.duration==5){
            return 68617
          }else if(searchData.duration==6){
            return 68620
          }else{
            return 68620
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62461
          }else if(searchData.duration==5){
            return 68628
          }else if(searchData.duration==6){
            return 68632
          }else{
            return 68632
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62486
          }else if(searchData.duration==5){
            return 68643
          }else if(searchData.duration==6){
            return 68650
          }else{
            return 68650
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62390
          }else if(searchData.duration==5){
            return 68558
          }else if(searchData.duration==6){
            return 68586
          }else{
            return 68586
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62399
          }else if(searchData.duration==5){
            return 68596
          }else if(searchData.duration==6){
            return 68609
          }else{
            return 68609
          }
        }else{
          if(searchData.duration==4){
            return 62504
          }else if(searchData.duration==5){
            return 68541
          }else if(searchData.duration==6){
            return 68548
          }else{
            return 68548
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62534
          }else if(searchData.duration==5){
            return 68695
          }else if(searchData.duration==6){
            return 68700
          }else{
            return 68700
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62543
          }else if(searchData.duration==5){
            return 68701
          }else if(searchData.duration==6){
            return 68706
          }else{
            return 68706
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62551
          }else if(searchData.duration==5){
            return 68709
          }else if(searchData.duration==6){
            return 68711
          }else{
            return 68711
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62519
          }else if(searchData.duration==5){
            return 68673
          }else if(searchData.duration==6){
            return 68676
          }else{
            return 68676
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62527
          }else if(searchData.duration==5){
            return 68680
          }else if(searchData.duration==6){
            return 68690
          }else{
            return 68690
          }
        }else{
          if(searchData.duration==4){
            return 62562
          }else if(searchData.duration==5){
            return 68660
          }else if(searchData.duration==6){
            return 68667
          }else{
            return 68667
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62630
          }else if(searchData.duration==5){
            return 68728
          }else if(searchData.duration==6){
            return 68729
          }else{
            return 68729
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62635
          }else if(searchData.duration==5){
            return 68732
          }else if(searchData.duration==6){
            return 68735
          }else{
            return 68735
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62643
          }else if(searchData.duration==5){
            return 68737
          }else if(searchData.duration==6){
            return 68738
          }else{
            return 68738
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62622
          }else if(searchData.duration==5){
            return 68720
          }else if(searchData.duration==6){
            return 68721
          }else{
            return 68721
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62626
          }else if(searchData.duration==5){
            return 68723
          }else if(searchData.duration==6){
            return 68725
          }else{
            return 68725
          }
        }else{
          if(searchData.duration==4){
            return 62660
          }else if(searchData.duration==5){
            return 68716
          }else if(searchData.duration==6){
            return 68717
          }else{
            return 68717
          }
        }
      }
    }else if(searchData.special=="Malaysia stay"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62139
          }else if(searchData.duration==5){
            return 62141
          }else if(searchData.duration==6){
            return 62143
          }else{
            return 62143
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62148
          }else if(searchData.duration==5){
            return 62149
          }else if(searchData.duration==6){
            return 62150
          }else{
            return 62150
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62154
          }else if(searchData.duration==5){
            return 62155
          }else if(searchData.duration==6){
            return 62157
          }else{
            return 62157
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62057
          }else if(searchData.duration==5){
            return 62064
          }else if(searchData.duration==6){
            return 62071
          }else{
            return 62071
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62075
          }else if(searchData.duration==5){
            return 62083
          }else if(searchData.duration==6){
            return 62087
          }else{
            return 62087
          }
        }else{
          if(searchData.duration==4){
            return 62158
          }else if(searchData.duration==5){
            return 62161
          }else if(searchData.duration==6){
            return 62165
          }else{
            return 62165
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62252
          }else if(searchData.duration==5){
            return 62264
          }else if(searchData.duration==6){
            return 62267
          }else{
            return 62267
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62277
          }else if(searchData.duration==5){
            return 62279
          }else if(searchData.duration==6){
            return 62281
          }else{
            return 62281
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62286
          }else if(searchData.duration==5){
            return 62290
          }else if(searchData.duration==6){
            return 62292
          }else{
            return 62292
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62207
          }else if(searchData.duration==5){
            return 62218
          }else if(searchData.duration==6){
            return 62221
          }else{
            return 62221
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62233
          }else if(searchData.duration==5){
            return 62236
          }else if(searchData.duration==6){
            return 62238
          }else{
            return 62238
          }
        }else{
          if(searchData.duration==4){
            return 62295
          }else if(searchData.duration==5){
            return 62296
          }else if(searchData.duration==6){
            return 62298
          }else{
            return 62298
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62420
          }else if(searchData.duration==5){
            return 68891
          }else if(searchData.duration==6){
            return 68894
          }else{
            return 68894
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62461
          }else if(searchData.duration==5){
            return 68895
          }else if(searchData.duration==6){
            return 68952
          }else{
            return 68952
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62486
          }else if(searchData.duration==5){
            return 68953
          }else if(searchData.duration==6){
            return 68955
          }else{
            return 68955
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62390
          }else if(searchData.duration==5){
            return 68827
          }else if(searchData.duration==6){
            return 68830
          }else{
            return 68830
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62399
          }else if(searchData.duration==5){
            return 68889
          }else if(searchData.duration==6){
            return 68890
          }else{
            return 68890
          }
        }else{
          if(searchData.duration==4){
            return 62504
          }else if(searchData.duration==5){
            return 68956
          }else if(searchData.duration==6){
            return 68957
          }else{
            return 68957
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62534
          }else if(searchData.duration==5){
            return 68980
          }else if(searchData.duration==6){
            return 68982
          }else{
            return 68982
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62543
          }else if(searchData.duration==5){
            return 68983
          }else if(searchData.duration==6){
            return 68985
          }else{
            return 68985
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62551
          }else if(searchData.duration==5){
            return 68986
          }else if(searchData.duration==6){
            return 68988
          }else{
            return 68988
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62519
          }else if(searchData.duration==5){
            return 68840
          }else if(searchData.duration==6){
            return 68846
          }else{
            return 68846
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62527
          }else if(searchData.duration==5){
            return 68963
          }else if(searchData.duration==6){
            return 68979
          }else{
            return 68979
          }
        }else{
          if(searchData.duration==4){
            return 62562
          }else if(searchData.duration==5){
            return 68989
          }else if(searchData.duration==6){
            return 68990
          }else{
            return 68990
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62630
          }else if(searchData.duration==5){
            return 68999
          }else if(searchData.duration==6){
            return 69001
          }else{
            return 69001
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62635
          }else if(searchData.duration==5){
            return 69002
          }else if(searchData.duration==6){
            return 69003
          }else{
            return 69003
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62643
          }else if(searchData.duration==5){
            return 69005
          }else if(searchData.duration==6){
            return 69006
          }else{
            return 69006
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62622
          }else if(searchData.duration==5){
            return 68858
          }else if(searchData.duration==6){
            return 68863
          }else{
            return 68863
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62626
          }else if(searchData.duration==5){
            return 68993
          }else if(searchData.duration==6){
            return 68998
          }else{
            return 68998
          }
        }else{
          if(searchData.duration==4){
            return 62660
          }else if(searchData.duration==5){
            return 69007
          }else if(searchData.duration==6){
            return 69009
          }else{
            return 69009
          }
        }
      }
    }else{
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62139
          }else if(searchData.duration==5){
            return 62141
          }else if(searchData.duration==6){
            return 62143
          }else{
            return 62143
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62148
          }else if(searchData.duration==5){
            return 62149
          }else if(searchData.duration==6){
            return 62150
          }else{
            return 62150
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62154
          }else if(searchData.duration==5){
            return 62155
          }else if(searchData.duration==6){
            return 62157
          }else{
            return 62157
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62057
          }else if(searchData.duration==5){
            return 62064
          }else if(searchData.duration==6){
            return 62071
          }else{
            return 62071
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62075
          }else if(searchData.duration==5){
            return 62083
          }else if(searchData.duration==6){
            return 62087
          }else{
            return 62087
          }
        }else{
          if(searchData.duration==4){
            return 62158
          }else if(searchData.duration==5){
            return 62161
          }else if(searchData.duration==6){
            return 62165
          }else{
            return 62165
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62252
          }else if(searchData.duration==5){
            return 62264
          }else if(searchData.duration==6){
            return 62267
          }else{
            return 62267
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62277
          }else if(searchData.duration==5){
            return 62279
          }else if(searchData.duration==6){
            return 62281
          }else{
            return 62281
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62286
          }else if(searchData.duration==5){
            return 62290
          }else if(searchData.duration==6){
            return 62292
          }else{
            return 62292
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62207
          }else if(searchData.duration==5){
            return 62218
          }else if(searchData.duration==6){
            return 62221
          }else{
            return 62221
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62233
          }else if(searchData.duration==5){
            return 62236
          }else if(searchData.duration==6){
            return 62238
          }else{
            return 62238
          }
        }else{
          if(searchData.duration==4){
            return 62295
          }else if(searchData.duration==5){
            return 62296
          }else if(searchData.duration==6){
            return 62298
          }else{
            return 62298
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62420
          }else if(searchData.duration==5){
            return 62423
          }else if(searchData.duration==6){
            return 62436
          }else{
            return 62436
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62461
          }else if(searchData.duration==5){
            return 62474
          }else if(searchData.duration==6){
            return 62483
          }else{
            return 62483
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62486
          }else if(searchData.duration==5){
            return 62489
          }else if(searchData.duration==6){
            return 62490
          }else{
            return 62490
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62390
          }else if(searchData.duration==5){
            return 62393
          }else if(searchData.duration==6){
            return 62398
          }else{
            return 62398
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62399
          }else if(searchData.duration==5){
            return 62409
          }else if(searchData.duration==6){
            return 62414
          }else{
            return 62414
          }
        }else{
          if(searchData.duration==4){
            return 62504
          }else if(searchData.duration==5){
            return 62506
          }else if(searchData.duration==6){
            return 62508
          }else{
            return 62508
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62534
          }else if(searchData.duration==5){
            return 62538
          }else if(searchData.duration==6){
            return 62541
          }else{
            return 62541
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62543
          }else if(searchData.duration==5){
            return 62545
          }else if(searchData.duration==6){
            return 62547
          }else{
            return 62547
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62551
          }else if(searchData.duration==5){
            return 62556
          }else if(searchData.duration==6){
            return 62560
          }else{
            return 62560
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62519
          }else if(searchData.duration==5){
            return 62523
          }else if(searchData.duration==6){
            return 62525
          }else{
            return 62525
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62527
          }else if(searchData.duration==5){
            return 62532
          }else if(searchData.duration==6){
            return 62533
          }else{
            return 62533
          }
        }else{
          if(searchData.duration==4){
            return 62562
          }else if(searchData.duration==5){
            return 62568
          }else if(searchData.duration==6){
            return 62569
          }else{
            return 62569
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 62630
          }else if(searchData.duration==5){
            return 62632
          }else if(searchData.duration==6){
            return 62634
          }else{
            return 62634
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 62635
          }else if(searchData.duration==5){
            return 62636
          }else if(searchData.duration==6){
            return 62640
          }else{
            return 62640
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 62643
          }else if(searchData.duration==5){
            return 62645
          }else if(searchData.duration==6){
            return 62648
          }else{
            return 62648
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 62622
          }else if(searchData.duration==5){
            return 62624
          }else if(searchData.duration==6){
            return 62625
          }else{
            return 62625
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 62626
          }else if(searchData.duration==5){
            return 62627
          }else if(searchData.duration==6){
            return 62628
          }else{
            return 62628
          }
        }else{
          if(searchData.duration==4){
            return 62660
          }else if(searchData.duration==5){
            return 62662
          }else if(searchData.duration==6){
            return 62666
          }else{
            return 62666
          }
        }
      }
    }
  }else if(searchData.dest=="Singapore"){
    if(searchData.special=="2N Cruise"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63196
          }else if(searchData.duration==5){
            return 63197
          }else if(searchData.duration==6){
            return 63197
          }else{
            return 63197
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63200
          }else if(searchData.duration==5){
            return 63199
          }else if(searchData.duration==6){
            return 63199
          }else{
            return 63199
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63198
          }else if(searchData.duration==5){
            return 63201
          }else if(searchData.duration==6){
            return 63201
          }else{
            return 63201
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63190
          }else if(searchData.duration==5){
            return 63191
          }else if(searchData.duration==6){
            return 63191
          }else{
            return 63191
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63194
          }else if(searchData.duration==5){
            return 63195
          }else if(searchData.duration==6){
            return 63195
          }else{
            return 63195
          }
        }else{
          if(searchData.duration==4){
            return 63192
          }else if(searchData.duration==5){
            return 63193
          }else if(searchData.duration==6){
            return 63193
          }else{
            return 63193
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63208
          }else if(searchData.duration==5){
            return 63209
          }else if(searchData.duration==6){
            return 63209
          }else{
            return 63209
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63210
          }else if(searchData.duration==5){
            return 63211
          }else if(searchData.duration==6){
            return 63211
          }else{
            return 63211
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63212
          }else if(searchData.duration==5){
            return 63213
          }else if(searchData.duration==6){
            return 63213
          }else{
            return 63213
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63204
          }else if(searchData.duration==5){
            return 63205
          }else if(searchData.duration==6){
            return 63205
          }else{
            return 63205
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63206
          }else if(searchData.duration==5){
            return 63207
          }else if(searchData.duration==6){
            return 63207
          }else{
            return 63207
          }
        }else{
          if(searchData.duration==4){
            return 63202
          }else if(searchData.duration==5){
            return 63203
          }else if(searchData.duration==6){
            return 63203
          }else{
            return 63203
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63224
          }else if(searchData.duration==5){
            return 63225
          }else if(searchData.duration==6){
            return 63226
          }else{
            return 63226
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63227
          }else if(searchData.duration==5){
            return 63228
          }else if(searchData.duration==6){
            return 63229
          }else{
            return 63229
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63230
          }else if(searchData.duration==5){
            return 63231
          }else if(searchData.duration==6){
            return 63232
          }else{
            return 63232
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63218
          }else if(searchData.duration==5){
            return 63219
          }else if(searchData.duration==6){
            return 63220
          }else{
            return 63220
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63221
          }else if(searchData.duration==5){
            return 63222
          }else if(searchData.duration==6){
            return 63223
          }else{
            return 63223
          }
        }else{
          if(searchData.duration==4){
            return 63214
          }else if(searchData.duration==5){
            return 64619
          }else if(searchData.duration==6){
            return 63216
          }else{
            return 63216
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63242
          }else if(searchData.duration==5){
            return 64801
          }else if(searchData.duration==6){
            return 63242
          }else{
            return 64801
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63243
          }else if(searchData.duration==5){
            return 63246
          }else if(searchData.duration==6){
            return 63245
          }else{
            return 63245
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63247
          }else if(searchData.duration==5){
            return 63248
          }else if(searchData.duration==6){
            return 63249
          }else{
            return 63249
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63237
          }else if(searchData.duration==5){
            return 63238
          }else if(searchData.duration==6){
            return 63239
          }else{
            return 63239
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63240
          }else if(searchData.duration==5){
            return 63241
          }else if(searchData.duration==6){
            return 64793
          }else{
            return 64793
          }
        }else{
          if(searchData.duration==4){
            return 63233
          }else if(searchData.duration==5){
            return 63234
          }else if(searchData.duration==6){
            return 63235
          }else{
            return 63235
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 64764
          }else if(searchData.duration==5){
            return 64806
          }else if(searchData.duration==6){
            return 64764
          }else{
            return 64764
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 64770
          }else if(searchData.duration==5){
            return 63258
          }else if(searchData.duration==6){
            return 63259
          }else{
            return 63259
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63250
          }else if(searchData.duration==5){
            return 63260
          }else if(searchData.duration==6){
            return 63261
          }else{
            return 63261
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63253
          }else if(searchData.duration==5){
            return 63254
          }else if(searchData.duration==6){
            return 63255
          }else{
            return 63255
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63256
          }else if(searchData.duration==5){
            return 63257
          }else if(searchData.duration==6){
            return 64803
          }else{
            return 64803
          }
        }else{
          if(searchData.duration==4){
            return 64628
          }else if(searchData.duration==5){
            return 63251
          }else if(searchData.duration==6){
            return 63252
          }else{
            return 63252
          }
        }
      }
    }else if(searchData.special=="Bintan"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63196
          }else if(searchData.duration==5){
            return 63197
          }else if(searchData.duration==6){
            return 63197
          }else{
            return 63197
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63200
          }else if(searchData.duration==5){
            return 63199
          }else if(searchData.duration==6){
            return 63199
          }else{
            return 63199
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63198
          }else if(searchData.duration==5){
            return 63201
          }else if(searchData.duration==6){
            return 63201
          }else{
            return 63201
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63190
          }else if(searchData.duration==5){
            return 63191
          }else if(searchData.duration==6){
            return 63191
          }else{
            return 63191
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63194
          }else if(searchData.duration==5){
            return 63195
          }else if(searchData.duration==6){
            return 63195
          }else{
            return 63195
          }
        }else{
          if(searchData.duration==4){
            return 63192
          }else if(searchData.duration==5){
            return 63193
          }else if(searchData.duration==6){
            return 63193
          }else{
            return 63193
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63208
          }else if(searchData.duration==5){
            return 63209
          }else if(searchData.duration==6){
            return 63209
          }else{
            return 63209
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63210
          }else if(searchData.duration==5){
            return 63211
          }else if(searchData.duration==6){
            return 63211
          }else{
            return 63211
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63212
          }else if(searchData.duration==5){
            return 63213
          }else if(searchData.duration==6){
            return 63213
          }else{
            return 63213
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63204
          }else if(searchData.duration==5){
            return 63205
          }else if(searchData.duration==6){
            return 63205
          }else{
            return 63205
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63206
          }else if(searchData.duration==5){
            return 63207
          }else if(searchData.duration==6){
            return 63207
          }else{
            return 63207
          }
        }else{
          if(searchData.duration==4){
            return 63202
          }else if(searchData.duration==5){
            return 63203
          }else if(searchData.duration==6){
            return 63203
          }else{
            return 63203
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63224
          }else if(searchData.duration==5){
            return 63225
          }else if(searchData.duration==6){
            return 63226
          }else{
            return 63226
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63227
          }else if(searchData.duration==5){
            return 63228
          }else if(searchData.duration==6){
            return 63229
          }else{
            return 63229
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63230
          }else if(searchData.duration==5){
            return 63231
          }else if(searchData.duration==6){
            return 63232
          }else{
            return 63232
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63218
          }else if(searchData.duration==5){
            return 63219
          }else if(searchData.duration==6){
            return 63220
          }else{
            return 63220
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63221
          }else if(searchData.duration==5){
            return 63222
          }else if(searchData.duration==6){
            return 63223
          }else{
            return 63223
          }
        }else{
          if(searchData.duration==4){
            return 63214
          }else if(searchData.duration==5){
            return 64619
          }else if(searchData.duration==6){
            return 63216
          }else{
            return 63216
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63242
          }else if(searchData.duration==5){
            return 63242
          }else if(searchData.duration==6){
            return 64859
          }else{
            return 64859
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63243
          }else if(searchData.duration==5){
            return 63246
          }else if(searchData.duration==6){
            return 63245
          }else{
            return 63245
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63247
          }else if(searchData.duration==5){
            return 63248
          }else if(searchData.duration==6){
            return 63249
          }else{
            return 63249
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63237
          }else if(searchData.duration==5){
            return 63238
          }else if(searchData.duration==6){
            return 63239
          }else{
            return 63239
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63240
          }else if(searchData.duration==5){
            return 63241
          }else if(searchData.duration==6){
            return 63241
          }else{
            return 63241
          }
        }else{
          if(searchData.duration==4){
            return 63233
          }else if(searchData.duration==5){
            return 63234
          }else if(searchData.duration==6){
            return 63235
          }else{
            return 63235
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 64764
          }else if(searchData.duration==5){
            return 64764
          }else if(searchData.duration==6){
            return 64863
          }else{
            return 64863
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 64770
          }else if(searchData.duration==5){
            return 63258
          }else if(searchData.duration==6){
            return 63259
          }else{
            return 63259
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63250
          }else if(searchData.duration==5){
            return 63260
          }else if(searchData.duration==6){
            return 63261
          }else{
            return 63261
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63253
          }else if(searchData.duration==5){
            return 63254
          }else if(searchData.duration==6){
            return 63255
          }else{
            return 63255
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63256
          }else if(searchData.duration==5){
            return 63257
          }else if(searchData.duration==6){
            return 63257
          }else{
            return 63257
          }
        }else{
          if(searchData.duration==4){
            return 64628
          }else if(searchData.duration==5){
            return 63251
          }else if(searchData.duration==6){
            return 63252
          }else{
            return 63252
          }
        }
      }
    }else if(searchData.special=="Malaysia"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63196
          }else if(searchData.duration==5){
            return 63197
          }else if(searchData.duration==6){
            return 63197
          }else{
            return 63197
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63200
          }else if(searchData.duration==5){
            return 63199
          }else if(searchData.duration==6){
            return 63199
          }else{
            return 63199
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63198
          }else if(searchData.duration==5){
            return 63201
          }else if(searchData.duration==6){
            return 63201
          }else{
            return 63201
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63190
          }else if(searchData.duration==5){
            return 63191
          }else if(searchData.duration==6){
            return 63191
          }else{
            return 63191
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63194
          }else if(searchData.duration==5){
            return 63195
          }else if(searchData.duration==6){
            return 63195
          }else{
            return 63195
          }
        }else{
          if(searchData.duration==4){
            return 63192
          }else if(searchData.duration==5){
            return 63193
          }else if(searchData.duration==6){
            return 63193
          }else{
            return 63193
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63208
          }else if(searchData.duration==5){
            return 63209
          }else if(searchData.duration==6){
            return 63209
          }else{
            return 63209
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63210
          }else if(searchData.duration==5){
            return 63211
          }else if(searchData.duration==6){
            return 63211
          }else{
            return 63211
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63212
          }else if(searchData.duration==5){
            return 63213
          }else if(searchData.duration==6){
            return 63213
          }else{
            return 63213
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63204
          }else if(searchData.duration==5){
            return 63205
          }else if(searchData.duration==6){
            return 63205
          }else{
            return 63205
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63206
          }else if(searchData.duration==5){
            return 63207
          }else if(searchData.duration==6){
            return 63207
          }else{
            return 63207
          }
        }else{
          if(searchData.duration==4){
            return 63202
          }else if(searchData.duration==5){
            return 63203
          }else if(searchData.duration==6){
            return 63203
          }else{
            return 63203
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63224
          }else if(searchData.duration==5){
            return 63225
          }else if(searchData.duration==6){
            return 63226
          }else{
            return 63226
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63227
          }else if(searchData.duration==5){
            return 63228
          }else if(searchData.duration==6){
            return 65048
          }else{
            return 65048
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63230
          }else if(searchData.duration==5){
            return 63231
          }else if(searchData.duration==6){
            return 65049
          }else{
            return 65049
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63218
          }else if(searchData.duration==5){
            return 63219
          }else if(searchData.duration==6){
            return 65032
          }else{
            return 65032
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63221
          }else if(searchData.duration==5){
            return 63222
          }else if(searchData.duration==6){
            return 65044
          }else{
            return 65044
          }
        }else{
          if(searchData.duration==4){
            return 63214
          }else if(searchData.duration==5){
            return 64619
          }else if(searchData.duration==6){
            return 65021
          }else{
            return 65021
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63242
          }else if(searchData.duration==5){
            return 63242
          }else if(searchData.duration==6){
            return 63242
          }else{
            return 63242
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63243
          }else if(searchData.duration==5){
            return 63246
          }else if(searchData.duration==6){
            return 65061
          }else{
            return 65062
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63247
          }else if(searchData.duration==5){
            return 63248
          }else if(searchData.duration==6){
            return 63249
          }else{
            return 63249
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63237
          }else if(searchData.duration==5){
            return 63238
          }else if(searchData.duration==6){
            return 65055
          }else{
            return 65055
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63240
          }else if(searchData.duration==5){
            return 63241
          }else if(searchData.duration==6){
            return 65059
          }else{
            return 65059
          }
        }else{
          if(searchData.duration==4){
            return 63233
          }else if(searchData.duration==5){
            return 63234
          }else if(searchData.duration==6){
            return 65053
          }else{
            return 65053
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 64764
          }else if(searchData.duration==5){
            return 64764
          }else if(searchData.duration==6){
            return 64764
          }else{
            return 64764
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 64770
          }else if(searchData.duration==5){
            return 63258
          }else if(searchData.duration==6){
            return 65072
          }else{
            return 65072
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63250
          }else if(searchData.duration==5){
            return 63260
          }else if(searchData.duration==6){
            return 65074
          }else{
            return 65074
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63253
          }else if(searchData.duration==5){
            return 63254
          }else if(searchData.duration==6){
            return 65068
          }else{
            return 65068
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63256
          }else if(searchData.duration==5){
            return 63257
          }else if(searchData.duration==6){
            return 65070
          }else{
            return 65070
          }
        }else{
          if(searchData.duration==4){
            return 64628
          }else if(searchData.duration==5){
            return 63251
          }else if(searchData.duration==6){
            return 65065
          }else{
            return 65065
          }
        }
      }
    }else if(searchData.special=="Bali"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63196
          }else if(searchData.duration==5){
            return 63197
          }else if(searchData.duration==6){
            return 63197
          }else{
            return 63197
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63200
          }else if(searchData.duration==5){
            return 63199
          }else if(searchData.duration==6){
            return 63199
          }else{
            return 63199
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63198
          }else if(searchData.duration==5){
            return 63201
          }else if(searchData.duration==6){
            return 63201
          }else{
            return 63201
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63190
          }else if(searchData.duration==5){
            return 63191
          }else if(searchData.duration==6){
            return 63191
          }else{
            return 63191
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63194
          }else if(searchData.duration==5){
            return 63195
          }else if(searchData.duration==6){
            return 63195
          }else{
            return 63195
          }
        }else{
          if(searchData.duration==4){
            return 63192
          }else if(searchData.duration==5){
            return 63193
          }else if(searchData.duration==6){
            return 63193
          }else{
            return 63193
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63208
          }else if(searchData.duration==5){
            return 63209
          }else if(searchData.duration==6){
            return 63209
          }else{
            return 63209
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63210
          }else if(searchData.duration==5){
            return 63211
          }else if(searchData.duration==6){
            return 63211
          }else{
            return 63211
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63212
          }else if(searchData.duration==5){
            return 63213
          }else if(searchData.duration==6){
            return 63213
          }else{
            return 63213
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63204
          }else if(searchData.duration==5){
            return 63205
          }else if(searchData.duration==6){
            return 63205
          }else{
            return 63205
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63206
          }else if(searchData.duration==5){
            return 63207
          }else if(searchData.duration==6){
            return 63207
          }else{
            return 63207
          }
        }else{
          if(searchData.duration==4){
            return 63202
          }else if(searchData.duration==5){
            return 63203
          }else if(searchData.duration==6){
            return 63203
          }else{
            return 63203
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63224
          }else if(searchData.duration==5){
            return 68492
          }else if(searchData.duration==6){
            return 68494
          }else{
            return 68494
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63227
          }else if(searchData.duration==5){
            return 68495
          }else if(searchData.duration==6){
            return 68496
          }else{
            return 68496
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63230
          }else if(searchData.duration==5){
            return 68497
          }else if(searchData.duration==6){
            return 68499
          }else{
            return 68499
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63218
          }else if(searchData.duration==5){
            return 68466
          }else if(searchData.duration==6){
            return 68488
          }else{
            return 68488
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63221
          }else if(searchData.duration==5){
            return 68490
          }else if(searchData.duration==6){
            return 68491
          }else{
            return 68491
          }
        }else{
          if(searchData.duration==4){
            return 63214
          }else if(searchData.duration==5){
            return 68457
          }else if(searchData.duration==6){
            return 68464
          }else{
            return 68464
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63242
          }else if(searchData.duration==5){
            return 68552
          }else if(searchData.duration==6){
            return 68554
          }else{
            return 68554
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63243
          }else if(searchData.duration==5){
            return 68561
          }else if(searchData.duration==6){
            return 68644
          }else{
            return 68644
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63247
          }else if(searchData.duration==5){
            return 68659
          }else if(searchData.duration==6){
            return 68661
          }else{
            return 68661
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63237
          }else if(searchData.duration==5){
            return 68528
          }else if(searchData.duration==6){
            return 68530
          }else{
            return 68530
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63240
          }else if(searchData.duration==5){
            return 68547
          }else if(searchData.duration==6){
            return 68550
          }else{
            return 68550
          }
        }else{
          if(searchData.duration==4){
            return 63233
          }else if(searchData.duration==5){
            return 68470
          }else if(searchData.duration==6){
            return 68473
          }else{
            return 68473
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 64764
          }else if(searchData.duration==5){
            return 64764
          }else if(searchData.duration==6){
            return 64764
          }else{
            return 64764
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 64770
          }else if(searchData.duration==5){
            return 63258
          }else if(searchData.duration==6){
            return 63259
          }else{
            return 63259
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63250
          }else if(searchData.duration==5){
            return 63260
          }else if(searchData.duration==6){
            return 63261
          }else{
            return 63261
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63253
          }else if(searchData.duration==5){
            return 63254
          }else if(searchData.duration==6){
            return 63255
          }else{
            return 63255
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63256
          }else if(searchData.duration==5){
            return 63257
          }else if(searchData.duration==6){
            return 63257
          }else{
            return 63257
          }
        }else{
          if(searchData.duration==4){
            return 64628
          }else if(searchData.duration==5){
            return 63251
          }else if(searchData.duration==6){
            return 63252
          }else{
            return 63252
          }
        }
      }
    }
    else{
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63196
          }else if(searchData.duration==5){
            return 63197
          }else if(searchData.duration==6){
            return 63197
          }else{
            return 63197
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63200
          }else if(searchData.duration==5){
            return 63199
          }else if(searchData.duration==6){
            return 63199
          }else{
            return 63199
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63198
          }else if(searchData.duration==5){
            return 63201
          }else if(searchData.duration==6){
            return 63201
          }else{
            return 63201
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63190
          }else if(searchData.duration==5){
            return 63191
          }else if(searchData.duration==6){
            return 63191
          }else{
            return 63191
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63194
          }else if(searchData.duration==5){
            return 63195
          }else if(searchData.duration==6){
            return 63195
          }else{
            return 63195
          }
        }else{
          if(searchData.duration==4){
            return 63192
          }else if(searchData.duration==5){
            return 63193
          }else if(searchData.duration==6){
            return 63193
          }else{
            return 63193
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63208
          }else if(searchData.duration==5){
            return 63209
          }else if(searchData.duration==6){
            return 63209
          }else{
            return 63209
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63210
          }else if(searchData.duration==5){
            return 63211
          }else if(searchData.duration==6){
            return 63211
          }else{
            return 63211
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63212
          }else if(searchData.duration==5){
            return 63213
          }else if(searchData.duration==6){
            return 63213
          }else{
            return 63213
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63204
          }else if(searchData.duration==5){
            return 63205
          }else if(searchData.duration==6){
            return 63205
          }else{
            return 63205
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63206
          }else if(searchData.duration==5){
            return 63207
          }else if(searchData.duration==6){
            return 63207
          }else{
            return 63207
          }
        }else{
          if(searchData.duration==4){
            return 63202
          }else if(searchData.duration==5){
            return 63203
          }else if(searchData.duration==6){
            return 63203
          }else{
            return 63203
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63224
          }else if(searchData.duration==5){
            return 63225
          }else if(searchData.duration==6){
            return 63226
          }else{
            return 63226
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63227
          }else if(searchData.duration==5){
            return 63228
          }else if(searchData.duration==6){
            return 63229
          }else{
            return 63229
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63230
          }else if(searchData.duration==5){
            return 63231
          }else if(searchData.duration==6){
            return 63232
          }else{
            return 63232
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63218
          }else if(searchData.duration==5){
            return 63219
          }else if(searchData.duration==6){
            return 63220
          }else{
            return 63220
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63221
          }else if(searchData.duration==5){
            return 63222
          }else if(searchData.duration==6){
            return 63223
          }else{
            return 63223
          }
        }else{
          if(searchData.duration==4){
            return 63214
          }else if(searchData.duration==5){
            return 64619
          }else if(searchData.duration==6){
            return 63216
          }else{
            return 63216
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 63242
          }else if(searchData.duration==5){
            return 63242
          }else if(searchData.duration==6){
            return 63242
          }else{
            return 63242
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 63243
          }else if(searchData.duration==5){
            return 63246
          }else if(searchData.duration==6){
            return 63245
          }else{
            return 63245
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63247
          }else if(searchData.duration==5){
            return 63248
          }else if(searchData.duration==6){
            return 63249
          }else{
            return 63249
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63237
          }else if(searchData.duration==5){
            return 63238
          }else if(searchData.duration==6){
            return 63239
          }else{
            return 63239
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63240
          }else if(searchData.duration==5){
            return 63241
          }else if(searchData.duration==6){
            return 63241
          }else{
            return 63241
          }
        }else{
          if(searchData.duration==4){
            return 63233
          }else if(searchData.duration==5){
            return 63234
          }else if(searchData.duration==6){
            return 63235
          }else{
            return 63235
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 64764
          }else if(searchData.duration==5){
            return 68678
          }else if(searchData.duration==6){
            return 68682
          }else{
            return 68682
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 64770
          }else if(searchData.duration==5){
            return 68683
          }else if(searchData.duration==6){
            return 68685
          }else{
            return 68685
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 63250
          }else if(searchData.duration==5){
            return 68687
          }else if(searchData.duration==6){
            return 68689
          }else{
            return 68689
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 63253
          }else if(searchData.duration==5){
            return 68666
          }else if(searchData.duration==6){
            return 68671
          }else{
            return 68671
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 63256
          }else if(searchData.duration==5){
            return 68672
          }else if(searchData.duration==6){
            return 68675
          }else{
            return 68675
          }
        }else{
          if(searchData.duration==4){
            return 64628
          }else if(searchData.duration==5){
            return 68480
          }else if(searchData.duration==6){
            return 68482
          }else{
            return 68482
          }
        }
      }
    }
  }else if(searchData.dest=="Malaysia"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 65199
        }else if(searchData.duration==5){
          return 65200
        }else if(searchData.duration==6){
          return 65200
        }else{
          return 65200
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 65201
        }else if(searchData.duration==5){
          return 65204
        }else if(searchData.duration==6){
          return 65204
        }else{
          return 65204
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65206
        }else if(searchData.duration==5){
          return 65207
        }else if(searchData.duration==6){
          return 65207
        }else{
          return 65207
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 65193
        }else if(searchData.duration==5){
          return 65195
        }else if(searchData.duration==6){
          return 65195
        }else{
          return 65195
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 65196
        }else if(searchData.duration==5){
          return 65197
        }else if(searchData.duration==6){
          return 65197
        }else{
          return 65197
        }
      }else{
        if(searchData.duration==4){
          return 65189
        }else if(searchData.duration==5){
          return 65191
        }else if(searchData.duration==6){
          return 65191
        }else{
          return 65191
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 65317
        }else if(searchData.duration==5){
          return 65325
        }else if(searchData.duration==6){
          return 65325
        }else{
          return 65325
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 65326
        }else if(searchData.duration==5){
          return 65329
        }else if(searchData.duration==6){
          return 65329
        }else{
          return 65329
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65336
        }else if(searchData.duration==5){
          return 65340
        }else if(searchData.duration==6){
          return 65340
        }else{
          return 65340
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 65306
        }else if(searchData.duration==5){
          return 65309
        }else if(searchData.duration==6){
          return 65309
        }else{
          return 65309
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 65310
        }else if(searchData.duration==5){
          return 65316
        }else if(searchData.duration==6){
          return 65316
        }else{
          return 65316
        }
      }else{
        if(searchData.duration==4){
          return 65208
        }else if(searchData.duration==5){
          return 65293
        }else if(searchData.duration==6){
          return 65293
        }else{
          return 65293
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 65419
        }else if(searchData.duration==5){
          return 65428
        }else if(searchData.duration==6){
          return 65439
        }else{
          return 65439
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 65441
        }else if(searchData.duration==5){
          return 65442
        }else if(searchData.duration==6){
          return 65445
        }else{
          return 65445
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65448
        }else if(searchData.duration==5){
          return 65449
        }else if(searchData.duration==6){
          return 65447
        }else{
          return 65447
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 65375
        }else if(searchData.duration==5){
          return 65403
        }else if(searchData.duration==6){
          return 65410
        }else{
          return 65410
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 65412
        }else if(searchData.duration==5){
          return 65415
        }else if(searchData.duration==6){
          return 65417
        }else{
          return 65417
        }
      }else{
        if(searchData.duration==4){
          return 65348
        }else if(searchData.duration==5){
          return 65368
        }else if(searchData.duration==6){
          return 65372
        }else{
          return 65372
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 65466
        }else if(searchData.duration==5){
          return 65467
        }else if(searchData.duration==6){
          return 65465
        }else{
          return 65465
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 65468
        }else if(searchData.duration==5){
          return 65469
        }else if(searchData.duration==6){
          return 65470
        }else{
          return 65470
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65471
        }else if(searchData.duration==5){
          return 65472
        }else if(searchData.duration==6){
          return 65473
        }else{
          return 65473
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 65460
        }else if(searchData.duration==5){
          return 65461
        }else if(searchData.duration==6){
          return 65462
        }else{
          return 65462
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 65463
        }else if(searchData.duration==5){
          return 65464
        }else if(searchData.duration==6){
          return 65614
        }else{
          return 65614
        }
      }else{
        if(searchData.duration==4){
          return 65455
        }else if(searchData.duration==5){
          return 65456
        }else if(searchData.duration==6){
          return 65459
        }else{
          return 65459
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 65483
        }else if(searchData.duration==5){
          return 65484
        }else if(searchData.duration==6){
          return 65482
        }else{
          return 65482
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 65485
        }else if(searchData.duration==5){
          return 65486
        }else if(searchData.duration==6){
          return 65487
        }else{
          return 65487
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65488
        }else if(searchData.duration==5){
          return 65489
        }else if(searchData.duration==6){
          return 65490
        }else{
          return 65490
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 65477
        }else if(searchData.duration==5){
          return 65478
        }else if(searchData.duration==6){
          return 65479
        }else{
          return 65479
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 65480
        }else if(searchData.duration==5){
          return 65481
        }else if(searchData.duration==6){
          return 65619
        }else{
          return 65619
        }
      }else{
        if(searchData.duration==4){
          return 65474
        }else if(searchData.duration==5){
          return 65475
        }else if(searchData.duration==6){
          return 65476
        }else{
          return 65476
        }
      }
    }
  }else if(searchData.dest=="Kerala"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 64993
        }else if(searchData.duration==5){
          return 65004
        }else if(searchData.duration==6){
          return 65013
        }else{
          return 65013
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 64993
        }else if(searchData.duration==5){
          return 65004
        }else if(searchData.duration==6){
          return 65013
        }else{
          return 65013
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65252
        }else if(searchData.duration==5){
          return 65004
        }else if(searchData.duration==6){
          return 65013
        }else{
          return 65013
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 64993
        }else if(searchData.duration==5){
          return 65004
        }else if(searchData.duration==6){
          return 65013
        }else{
          return 65013
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 64993
        }else if(searchData.duration==5){
          return 65029
        }else if(searchData.duration==6){
          return 65013
        }else{
          return 65013
        }
      }else{
        if(searchData.duration==4){
          return 64993
        }else if(searchData.duration==5){
          return 65004
        }else if(searchData.duration==6){
          return 65013
        }else{
          return 65013
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 65051
        }else if(searchData.duration==5){
          return 65063
        }else if(searchData.duration==6){
          return 65069
        }else{
          return 65069
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 65051
        }else if(searchData.duration==5){
          return 65063
        }else if(searchData.duration==6){
          return 65069
        }else{
          return 65069
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65255
        }else if(searchData.duration==5){
          return 65063
        }else if(searchData.duration==6){
          return 65069
        }else{
          return 65069
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 65051
        }else if(searchData.duration==5){
          return 65063
        }else if(searchData.duration==6){
          return 65069
        }else{
          return 65069
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 65051
        }else if(searchData.duration==5){
          return 65075
        }else if(searchData.duration==6){
          return 65069
        }else{
          return 65069
        }
      }else{
        if(searchData.duration==4){
          return 65051
        }else if(searchData.duration==5){
          return 65063
        }else if(searchData.duration==6){
          return 65069
        }else{
          return 65069
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 65086
        }else if(searchData.duration==5){
          return 65089
        }else if(searchData.duration==6){
          return 65405
        }else{
          return 65405
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 65086
        }else if(searchData.duration==5){
          return 65089
        }else if(searchData.duration==6){
          return 65091
        }else{
          return 65091
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65257
        }else if(searchData.duration==5){
          return 65089
        }else if(searchData.duration==6){
          return 65091
        }else{
          return 65091
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 65086
        }else if(searchData.duration==5){
          return 65089
        }else if(searchData.duration==6){
          return 65091
        }else{
          return 65091
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 65086
        }else if(searchData.duration==5){
          return 65097
        }else if(searchData.duration==6){
          return 65401
        }else{
          return 65401
        }
      }else{
        if(searchData.duration==4){
          return 65086
        }else if(searchData.duration==5){
          return 65089
        }else if(searchData.duration==6){
          return 65091
        }else{
          return 65091
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 65086
        }else if(searchData.duration==5){
          return 65119
        }else if(searchData.duration==6){
          return 65404
        }else{
          return 65404
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 65102
        }else if(searchData.duration==5){
          return 65106
        }else if(searchData.duration==6){
          return 65114
        }else{
          return 65114
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65258
        }else if(searchData.duration==5){
          return 65106
        }else if(searchData.duration==6){
          return 65114
        }else{
          return 65114
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 65102
        }else if(searchData.duration==5){
          return 65106
        }else if(searchData.duration==6){
          return 65114
        }else{
          return 65114
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 65086
        }else if(searchData.duration==5){
          return 65115
        }else if(searchData.duration==6){
          return 65402
        }else{
          return 65402
        }
      }else{
        if(searchData.duration==4){
          return 65102
        }else if(searchData.duration==5){
          return 65106
        }else if(searchData.duration==6){
          return 65114
        }else{
          return 65114
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 65132
        }else if(searchData.duration==5){
          return 65150
        }else if(searchData.duration==6){
          return 65136
        }else{
          return 65136
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 65132
        }else if(searchData.duration==5){
          return 65135
        }else if(searchData.duration==6){
          return 65136
        }else{
          return 65136
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 65260
        }else if(searchData.duration==5){
          return 65135
        }else if(searchData.duration==6){
          return 65136
        }else{
          return 65136
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 65132
        }else if(searchData.duration==5){
          return 65135
        }else if(searchData.duration==6){
          return 65406
        }else{
          return 65406
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 65132
        }else if(searchData.duration==5){
          return 65144
        }else if(searchData.duration==6){
          return 65136
        }else{
          return 65136
        }
      }else{
        if(searchData.duration==4){
          return 65132
        }else if(searchData.duration==5){
          return 65135
        }else if(searchData.duration==6){
          return 65136
        }else{
          return 65136
        }
      }
    }
  }else if(searchData.dest=="Vietnam"){
    if(searchData.special=="Cruise Stay"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 66045
          }else if(searchData.duration==5){
            return 66049
          }else if(searchData.duration==6){
            return 66049
          }else{
            return 66049
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 66050
          }else if(searchData.duration==5){
            return 66052
          }else if(searchData.duration==6){
            return 66052
          }else{
            return 66052
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 66056
          }else if(searchData.duration==5){
            return 66059
          }else if(searchData.duration==6){
            return 66059
          }else{
            return 66059
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66026
          }else if(searchData.duration==5){
            return 66027
          }else if(searchData.duration==6){
            return 66027
          }else{
            return 66027
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66038
          }else if(searchData.duration==5){
            return 66041
          }else if(searchData.duration==6){
            return 66041
          }else{
            return 66041
          }
        }else{
          if(searchData.duration==4){
            return 66017
          }else if(searchData.duration==5){
            return 66023
          }else if(searchData.duration==6){
            return 66023
          }else{
            return 66023
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 66072
          }else if(searchData.duration==5){
            return 66073
          }else if(searchData.duration==6){
            return 66073
          }else{
            return 66073
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 66086
          }else if(searchData.duration==5){
            return 66098
          }else if(searchData.duration==6){
            return 66098
          }else{
            return 66098
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 66099
          }else if(searchData.duration==5){
            return 66100
          }else if(searchData.duration==6){
            return 66100
          }else{
            return 66100
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66064
          }else if(searchData.duration==5){
            return 66065
          }else if(searchData.duration==6){
            return 66065
          }else{
            return 66065
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66068
          }else if(searchData.duration==5){
            return 66069
          }else if(searchData.duration==6){
            return 66069
          }else{
            return 66069
          }
        }else{
          if(searchData.duration==4){
            return 66061
          }else if(searchData.duration==5){
            return 66062
          }else if(searchData.duration==6){
            return 66062
          }else{
            return 66062
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 66112
          }else if(searchData.duration==5){
            return 66113
          }else if(searchData.duration==6){
            return 66114
          }else{
            return 66114
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 66115
          }else if(searchData.duration==5){
            return 66116
          }else if(searchData.duration==6){
            return 66117
          }else{
            return 66117
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 66118
          }else if(searchData.duration==5){
            return 66119
          }else if(searchData.duration==6){
            return 66120
          }else{
            return 66120
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66106
          }else if(searchData.duration==5){
            return 66107
          }else if(searchData.duration==6){
            return 66108
          }else{
            return 66108
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66109
          }else if(searchData.duration==5){
            return 66110
          }else if(searchData.duration==6){
            return 66111
          }else{
            return 66111
          }
        }else{
          if(searchData.duration==4){
            return 66101
          }else if(searchData.duration==5){
            return 66102
          }else if(searchData.duration==6){
            return 66105
          }else{
            return 66105
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 66127
          }else if(searchData.duration==5){
            return 66354
          }else if(searchData.duration==6){
            return 66356
          }else{
            return 66356
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 66128
          }else if(searchData.duration==5){
            return 66129
          }else if(searchData.duration==6){
            return 66130
          }else{
            return 66130
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 66131
          }else if(searchData.duration==5){
            return 66353
          }else if(searchData.duration==6){
            return 66327
          }else{
            return 66327
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66124
          }else if(searchData.duration==5){
            return 66685
          }else if(searchData.duration==6){
            return 66688
          }else{
            return 66688
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66125
          }else if(searchData.duration==5){
            return 66126
          }else if(searchData.duration==6){
            return 66436
          }else{
            return 66436
          }
        }else{
          if(searchData.duration==4){
            return 66121
          }else if(searchData.duration==5){
            return 66122
          }else if(searchData.duration==6){
            return 66123
          }else{
            return 66123
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==4){
            return 66362
          }else if(searchData.duration==5){
            return 66365
          }else if(searchData.duration==6){
            return 66366
          }else{
            return 66366
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 66140
          }else if(searchData.duration==5){
            return 66141
          }else if(searchData.duration==6){
            return 66142
          }else{
            return 66142
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 66143
          }else if(searchData.duration==5){
            return 66144
          }else if(searchData.duration==6){
            return 66145
          }else{
            return 66145
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66137
          }else if(searchData.duration==5){
            return 66359
          }else if(searchData.duration==6){
            return 66360
          }else{
            return 66360
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66138
          }else if(searchData.duration==5){
            return 66139
          }else if(searchData.duration==6){
            return 66439
          }else{
            return 66439
          }
        }else{
          if(searchData.duration==4){
            return 66134
          }else if(searchData.duration==5){
            return 66135
          }else if(searchData.duration==6){
            return 66136
          }else{
            return 66136
          }
        }
      }
    }else if(searchData.special=="Phu Quoc"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 76027
          }else if(searchData.duration==4){
            return 75433
          }else if(searchData.duration==5){
            return 76033
          }else{
            return 76033
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 76035
          }else if(searchData.duration==4){
            return 76036
          }else if(searchData.duration==5){
            return 75436
          }else{
            return 75436
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 75437
          }else if(searchData.duration==4){
            return 76040
          }else if(searchData.duration==5){
            return 76043
          }else{
            return 76043
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66026
          }else if(searchData.duration==5){
            return 66027
          }else if(searchData.duration==6){
            return 66027
          }else{
            return 66027
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66038
          }else if(searchData.duration==5){
            return 66041
          }else if(searchData.duration==6){
            return 66041
          }else{
            return 66041
          }
        }else{
          if(searchData.duration==3){
            return 75424
          }else if(searchData.duration==4){
            return 75982
          }else if(searchData.duration==5){
            return 76025
          }else{
            return 76025
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 76050
          }else if(searchData.duration==4){
            return 76051
          }else if(searchData.duration==5){
            return 75500
          }else{
            return 75500
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 75503
          }else if(searchData.duration==4){
            return 76066
          }else if(searchData.duration==5){
            return 76067
          }else{
            return 76067
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 76071
          }else if(searchData.duration==4){
            return 75504
          }else if(searchData.duration==5){
            return 76073
          }else{
            return 76073
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66064
          }else if(searchData.duration==5){
            return 66065
          }else if(searchData.duration==6){
            return 66065
          }else{
            return 66065
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66068
          }else if(searchData.duration==5){
            return 66069
          }else if(searchData.duration==6){
            return 66069
          }else{
            return 66069
          }
        }else{
          if(searchData.duration==3){
            return 76044
          }else if(searchData.duration==4){
            return 75438
          }else if(searchData.duration==5){
            return 76047
          }else{
            return 76047
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 75526
          }else if(searchData.duration==4){
            return 76081
          }else if(searchData.duration==5){
            return 75715
          }else if(searchData.duration==6){
            return 75717
          }else if(searchData.duration==7){
            return 75719
          }else{
            return 75719
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 76087
          }else if(searchData.duration==4){
            return 75527
          }else if(searchData.duration==5){
            return 76089
          }else{
            return 76089
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 76091
          }else if(searchData.duration==4){
            return 76093
          }else if(searchData.duration==5){
            return 75722
          }else if(searchData.duration==6){
            return 75723
          }else if(searchData.duration==7){
            return 75724
          }else{
            return 75724
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66106
          }else if(searchData.duration==5){
            return 66107
          }else if(searchData.duration==6){
            return 66108
          }else{
            return 66108
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66109
          }else if(searchData.duration==5){
            return 66110
          }else if(searchData.duration==6){
            return 66111
          }else{
            return 66111
          }
        }else{
          if(searchData.duration==3){
            return 76079
          }else if(searchData.duration==4){
            return 76080
          }else if(searchData.duration==5){
            return 75697
          }else if(searchData.duration==6){
            return 75703
          }else if(searchData.duration==7){
            return 75709
          }else{
            return 75709
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==5){
            return 75740
          }else if(searchData.duration==6){
            return 75741
          }else if(searchData.duration==7){
            return 75742
          }else{
            return 75742
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==5){
            return 66127
          }else if(searchData.duration==6){
            return 66689
          }else if(searchData.duration==7){
            return 66691
          }else{
            return 66691
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 75743
          }else if(searchData.duration==5){
            return 75744
          }else if(searchData.duration==6){
            return 75745
          }else{
            return 75745
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66124
          }else if(searchData.duration==5){
            return 66685
          }else if(searchData.duration==6){
            return 66688
          }else{
            return 66688
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66125
          }else if(searchData.duration==5){
            return 66126
          }else if(searchData.duration==6){
            return 66436
          }else{
            return 66436
          }
        }else{
          if(searchData.duration==5){
            return 75727
          }else if(searchData.duration==6){
            return 75729
          }else if(searchData.duration==7){
            return 75735
          }else{
            return 75735
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==5){
            return 75759
          }else if(searchData.duration==6){
            return 75760
          }else if(searchData.duration==7){
            return 75761
          }else{
            return 75761
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==5){
            return 75775
          }else if(searchData.duration==6){
            return 75782
          }else if(searchData.duration==7){
            return 75784
          }else{
            return 75784
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 66143
          }else if(searchData.duration==5){
            return 66144
          }else if(searchData.duration==6){
            return 66145
          }else{
            return 66145
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 66137
          }else if(searchData.duration==5){
            return 66694
          }else if(searchData.duration==6){
            return 66695
          }else{
            return 66695
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 66138
          }else if(searchData.duration==5){
            return 66139
          }else if(searchData.duration==6){
            return 66439
          }else{
            return 66439
          }
        }else{
          if(searchData.duration==5){
            return 75754
          }else if(searchData.duration==6){
            return 75756
          }else if(searchData.duration==7){
            return 75758
          }else{
            return 75758
          }
        }
      }
  }else if(searchData.special=="FD"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Party lovers"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else{
        if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }
      }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Party lovers"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else{
        if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Party lovers"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else{
        if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Party lovers"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else{
        if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }
      }else if(searchData.budget=="Luxury"){
         if(searchData.type=="Romantic"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Party lovers"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }else{
        if(searchData.duration==3){
            return 225446
          }else if(searchData.duration==4){
            return 225446
          }else if(searchData.duration==5){
            return 225446
          }else{
            return 225446
          }
        }
      }
  }else{
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 66045
        }else if(searchData.duration==5){
          return 66049
        }else if(searchData.duration==6){
          return 66049
        }else{
          return 66049
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 66050
        }else if(searchData.duration==5){
          return 66052
        }else if(searchData.duration==6){
          return 66052
        }else{
          return 66052
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 66056
        }else if(searchData.duration==5){
          return 66059
        }else if(searchData.duration==6){
          return 66059
        }else{
          return 66059
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 66026
        }else if(searchData.duration==5){
          return 66027
        }else if(searchData.duration==6){
          return 66027
        }else{
          return 66027
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 66038
        }else if(searchData.duration==5){
          return 66041
        }else if(searchData.duration==6){
          return 66041
        }else{
          return 66041
        }
      }else{
        if(searchData.duration==4){
          return 66017
        }else if(searchData.duration==5){
          return 66023
        }else if(searchData.duration==6){
          return 66023
        }else{
          return 66023
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 66072
        }else if(searchData.duration==5){
          return 66073
        }else if(searchData.duration==6){
          return 66073
        }else{
          return 66073
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 66086
        }else if(searchData.duration==5){
          return 66098
        }else if(searchData.duration==6){
          return 66098
        }else{
          return 66098
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 66099
        }else if(searchData.duration==5){
          return 66100
        }else if(searchData.duration==6){
          return 66100
        }else{
          return 66100
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 66064
        }else if(searchData.duration==5){
          return 66065
        }else if(searchData.duration==6){
          return 66065
        }else{
          return 66065
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 66068
        }else if(searchData.duration==5){
          return 66069
        }else if(searchData.duration==6){
          return 66069
        }else{
          return 66069
        }
      }else{
        if(searchData.duration==4){
          return 66061
        }else if(searchData.duration==5){
          return 66062
        }else if(searchData.duration==6){
          return 66062
        }else{
          return 66062
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 66112
        }else if(searchData.duration==5){
          return 66113
        }else if(searchData.duration==6){
          return 66114
        }else{
          return 66114
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 66115
        }else if(searchData.duration==5){
          return 66116
        }else if(searchData.duration==6){
          return 66117
        }else{
          return 66117
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 66118
        }else if(searchData.duration==5){
          return 66119
        }else if(searchData.duration==6){
          return 66120
        }else{
          return 66120
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 66106
        }else if(searchData.duration==5){
          return 66107
        }else if(searchData.duration==6){
          return 66108
        }else{
          return 66108
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 66109
        }else if(searchData.duration==5){
          return 66110
        }else if(searchData.duration==6){
          return 66111
        }else{
          return 66111
        }
      }else{
        if(searchData.duration==4){
          return 66101
        }else if(searchData.duration==5){
          return 66102
        }else if(searchData.duration==6){
          return 66105
        }else{
          return 66105
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 66127
        }else if(searchData.duration==5){
          return 66689
        }else if(searchData.duration==6){
          return 66691
        }else{
          return 66691
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 66128
        }else if(searchData.duration==5){
          return 66129
        }else if(searchData.duration==6){
          return 66130
        }else{
          return 66130
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 66131
        }else if(searchData.duration==5){
          return 66132
        }else if(searchData.duration==6){
          return 66133
        }else{
          return 66133
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 66124
        }else if(searchData.duration==5){
          return 66685
        }else if(searchData.duration==6){
          return 66688
        }else{
          return 66688
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 66125
        }else if(searchData.duration==5){
          return 66126
        }else if(searchData.duration==6){
          return 66436
        }else{
          return 66436
        }
      }else{
        if(searchData.duration==4){
          return 66121
        }else if(searchData.duration==5){
          return 66122
        }else if(searchData.duration==6){
          return 66123
        }else{
          return 66123
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 66362
        }else if(searchData.duration==5){
          return 66696
        }else if(searchData.duration==6){
          return 66698
        }else{
          return 66698
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 66140
        }else if(searchData.duration==5){
          return 66141
        }else if(searchData.duration==6){
          return 66142
        }else{
          return 66142
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 66143
        }else if(searchData.duration==5){
          return 66144
        }else if(searchData.duration==6){
          return 66145
        }else{
          return 66145
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 66137
        }else if(searchData.duration==5){
          return 66694
        }else if(searchData.duration==6){
          return 66695
        }else{
          return 66695
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 66138
        }else if(searchData.duration==5){
          return 66139
        }else if(searchData.duration==6){
          return 66439
        }else{
          return 66439
        }
      }else{
        if(searchData.duration==4){
          return 66134
        }else if(searchData.duration==5){
          return 66135
        }else if(searchData.duration==6){
          return 66136
        }else{
          return 66136
        }
      }
    }
  }
  }else if(searchData.dest=="Sri Lanka"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 67182
        }else if(searchData.duration==5){
          return 67183
        }else if(searchData.duration==6){
          return 67183
        }else{
          return 67183
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 67184
        }else if(searchData.duration==5){
          return 67185
        }else if(searchData.duration==6){
          return 67185
        }else{
          return 67185
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 67186
        }else if(searchData.duration==5){
          return 67188
        }else if(searchData.duration==6){
          return 67188
        }else{
          return 67188
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 67165
        }else if(searchData.duration==5){
          return 67166
        }else if(searchData.duration==6){
          return 67166
        }else{
          return 67166
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 67177
        }else if(searchData.duration==5){
          return 67181
        }else if(searchData.duration==6){
          return 67181
        }else{
          return 67181
        }
      }else{
        if(searchData.duration==4){
          return 67141
        }else if(searchData.duration==5){
          return 67161
        }else if(searchData.duration==6){
          return 67161
        }else{
          return 67161
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 67439
        }else if(searchData.duration==5){
          return 67440
        }else if(searchData.duration==6){
          return 67440
        }else{
          return 67440
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 67441
        }else if(searchData.duration==5){
          return 67442
        }else if(searchData.duration==6){
          return 67442
        }else{
          return 67442
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 67443
        }else if(searchData.duration==5){
          return 67446
        }else if(searchData.duration==6){
          return 67446
        }else{
          return 67446
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 67428
        }else if(searchData.duration==5){
          return 67430
        }else if(searchData.duration==6){
          return 67430
        }else{
          return 67430
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 67433
        }else if(searchData.duration==5){
          return 67437
        }else if(searchData.duration==6){
          return 67437
        }else{
          return 67437
        }
      }else{
        if(searchData.duration==4){
          return 67426
        }else if(searchData.duration==5){
          return 67427
        }else if(searchData.duration==6){
          return 67427
        }else{
          return 67427
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 67462
        }else if(searchData.duration==5){
          return 67463
        }else if(searchData.duration==6){
          return 67464
        }else{
          return 67464
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 67466
        }else if(searchData.duration==5){
          return 67468
        }else if(searchData.duration==6){
          return 67469
        }else{
          return 67469
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 67479
        }else if(searchData.duration==5){
          return 67480
        }else if(searchData.duration==6){
          return 67482
        }else{
          return 67482
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 67455
        }else if(searchData.duration==5){
          return 67456
        }else if(searchData.duration==6){
          return 67457
        }else{
          return 67457
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 67458
        }else if(searchData.duration==5){
          return 67459
        }else if(searchData.duration==6){
          return 67461
        }else{
          return 67461
        }
      }else{
        if(searchData.duration==4){
          return 67451
        }else if(searchData.duration==5){
          return 67452
        }else if(searchData.duration==6){
          return 67454
        }else{
          return 67454
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 67830
        }else if(searchData.duration==5){
          return 67831
        }else if(searchData.duration==6){
          return 67833
        }else{
          return 67833
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 67834
        }else if(searchData.duration==5){
          return 67836
        }else if(searchData.duration==6){
          return 67837
        }else{
          return 67837
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 67839
        }else if(searchData.duration==5){
          return 67841
        }else if(searchData.duration==6){
          return 67842
        }else{
          return 67842
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 67810
        }else if(searchData.duration==5){
          return 67811
        }else if(searchData.duration==6){
          return 67812
        }else{
          return 67812
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 67815
        }else if(searchData.duration==5){
          return 67825
        }else if(searchData.duration==6){
          return 67828
        }else{
          return 67828
        }
      }else{
        if(searchData.duration==4){
          return 67803
        }else if(searchData.duration==5){
          return 67806
        }else if(searchData.duration==6){
          return 67809
        }else{
          return 67809
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 67867
        }else if(searchData.duration==5){
          return 67871
        }else if(searchData.duration==6){
          return 67872
        }else{
          return 67872
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 67873
        }else if(searchData.duration==5){
          return 67874
        }else if(searchData.duration==6){
          return 67875
        }else{
          return 67875
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 67876
        }else if(searchData.duration==5){
          return 67877
        }else if(searchData.duration==6){
          return 67878
        }else{
          return 67878
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 67859
        }else if(searchData.duration==5){
          return 67860
        }else if(searchData.duration==6){
          return 67862
        }else{
          return 67862
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 67863
        }else if(searchData.duration==5){
          return 67865
        }else if(searchData.duration==6){
          return 67866
        }else{
          return 67866
        }
      }else{
        if(searchData.duration==4){
          return 67850
        }else if(searchData.duration==5){
          return 67856
        }else if(searchData.duration==6){
          return 67857
        }else{
          return 67857
        }
      }
    }
  }else if(searchData.dest=="Kashmir"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 75858
        }else if(searchData.duration==5){
          return 75864
        }else if(searchData.duration==6){
          return 75866
        }else{
          return 75866
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 75825
        }else if(searchData.duration==5){
          return 75832
        }else if(searchData.duration==6){
          return 75833
        }else{
          return 75833
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 75847
        }else if(searchData.duration==5){
          return 75849
        }else if(searchData.duration==6){
          return 75853
        }else{
          return 75853
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 75825
        }else if(searchData.duration==5){
          return 75832
        }else if(searchData.duration==6){
          return 75833
        }else{
          return 75833
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 75847
        }else if(searchData.duration==5){
          return 75849
        }else if(searchData.duration==6){
          return 75853
        }else{
          return 75853
        }
      }else{
        if(searchData.duration==4){
          return 75825
        }else if(searchData.duration==5){
          return 75832
        }else if(searchData.duration==6){
          return 75833
        }else{
          return 75833
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 75965
        }else if(searchData.duration==5){
          return 75971
        }else if(searchData.duration==6){
          return 75970
        }else{
          return 75970
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 75972
        }else if(searchData.duration==5){
          return 75977
        }else if(searchData.duration==6){
          return 75978
        }else{
          return 75978
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 75878
        }else if(searchData.duration==5){
          return 75961
        }else if(searchData.duration==6){
          return 75963
        }else{
          return 75963
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 75870
        }else if(searchData.duration==5){
          return 75873
        }else if(searchData.duration==6){
          return 75874
        }else{
          return 75874
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 75878
        }else if(searchData.duration==5){
          return 75961
        }else if(searchData.duration==6){
          return 75963
        }else{
          return 75963
        }
      }else{
        if(searchData.duration==4){
          return 75870
        }else if(searchData.duration==5){
          return 75873
        }else if(searchData.duration==6){
          return 75874
        }else{
          return 75874
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 76005
        }else if(searchData.duration==5){
          return 76010
        }else if(searchData.duration==6){
          return 76012
        }else{
          return 76012
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 76015
        }else if(searchData.duration==5){
          return 76018
        }else if(searchData.duration==6){
          return 76020
        }else{
          return 76020
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 75983
        }else if(searchData.duration==5){
          return 75985
        }else if(searchData.duration==6){
          return 75986
        }else{
          return 75986
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 75983
        }else if(searchData.duration==5){
          return 75985
        }else if(searchData.duration==6){
          return 75986
        }else{
          return 75986
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 75990
        }else if(searchData.duration==5){
          return 75998
        }else if(searchData.duration==6){
          return 76000
        }else{
          return 76000
        }
      }else{
        if(searchData.duration==4){
          return 75990
        }else if(searchData.duration==5){
          return 75998
        }else if(searchData.duration==6){
          return 76000
        }else{
          return 76000
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 76105
        }else if(searchData.duration==5){
          return 76106
        }else if(searchData.duration==6){
          return 76107
        }else{
          return 76107
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 76120
        }else if(searchData.duration==5){
          return 76122
        }else if(searchData.duration==6){
          return 76124
        }else{
          return 76124
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 76061
        }else if(searchData.duration==5){
          return 76064
        }else if(searchData.duration==6){
          return 76082
        }else{
          return 76082
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 76061
        }else if(searchData.duration==5){
          return 76064
        }else if(searchData.duration==6){
          return 76082
        }else{
          return 76082
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 76090
        }else if(searchData.duration==5){
          return 76095
        }else if(searchData.duration==6){
          return 76100
        }else{
          return 76100
        }
      }else{
        if(searchData.duration==4){
          return 76105
        }else if(searchData.duration==5){
          return 76106
        }else if(searchData.duration==6){
          return 76107
        }else{
          return 76107
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 76159
        }else if(searchData.duration==5){
          return 76161
        }else if(searchData.duration==6){
          return 76162
        }else{
          return 76162
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 76163
        }else if(searchData.duration==5){
          return 76167
        }else if(searchData.duration==6){
          return 76169
        }else{
          return 76169
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 76151
        }else if(searchData.duration==5){
          return 76153
        }else if(searchData.duration==6){
          return 76155
        }else{
          return 76155
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 76145
        }else if(searchData.duration==5){
          return 76147
        }else if(searchData.duration==6){
          return 76149
        }else{
          return 76149
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 76151
        }else if(searchData.duration==5){
          return 76153
        }else if(searchData.duration==6){
          return 76155
        }else{
          return 76155
        }
      }else{
        if(searchData.duration==4){
          return 76145
        }else if(searchData.duration==5){
          return 76147
        }else if(searchData.duration==6){
          return 76149
        }else{
          return 76149
        }
      }
    }
  }else if(searchData.dest=="Azerbaijan"){
    if(searchData.special=="Shahdag"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146075
        }else if(searchData.duration==5){
          return 146079
        }else if(searchData.duration==6){
          return 146078
        }else{
          return 146078
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145848
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145848
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 145997
        }else if(searchData.duration==5){
          return 146023
        }else if(searchData.duration==6){
          return 146011
        }else{
          return 146011
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145848
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }else{
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145848
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146080
        }else if(searchData.duration==5){
          return 146082
        }else if(searchData.duration==6){
          return 146083
        }else{
          return 146083
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145861
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145861
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146028
        }else if(searchData.duration==5){
          return 146030
        }else if(searchData.duration==6){
          return 146032
        }else{
          return 146032
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145861
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }else{
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145861
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146085
        }else if(searchData.duration==5){
          return 146087
        }else if(searchData.duration==6){
          return 146088
        }else{
          return 146088
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145867
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145867
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146040
        }else if(searchData.duration==5){
          return 146041
        }else if(searchData.duration==6){
          return 146043
        }else{
          return 146043
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145867
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }else{
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145867
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146090
        }else if(searchData.duration==5){
          return 146091
        }else if(searchData.duration==6){
          return 146094
        }else{
          return 146094
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146053
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 146066
        }else{
          return 146066
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else{
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146090
        }else if(searchData.duration==5){
          return 146091
        }else if(searchData.duration==6){
          return 146092
        }else{
          return 146092
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146053
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else{
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
    }
  }
  }else if(searchData.special=="Gabala"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146075
        }else if(searchData.duration==5){
          return 146077
        }else if(searchData.duration==6){
          return 146078
        }else{
          return 146078
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145853
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145853
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 145997
        }else if(searchData.duration==5){
          return 146000
        }else if(searchData.duration==6){
          return 146011
        }else{
          return 146011
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145853
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }else{
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145853
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146080
        }else if(searchData.duration==5){
          return 146084
        }else if(searchData.duration==6){
          return 146083
        }else{
          return 146083
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145865
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145865
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146028
        }else if(searchData.duration==5){
          return 146034
        }else if(searchData.duration==6){
          return 146032
        }else{
          return 146032
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145865
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }else{
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145865
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146085
        }else if(searchData.duration==5){
          return 146089
        }else if(searchData.duration==6){
          return 146088
        }else{
          return 146088
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145871
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145871
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146040
        }else if(searchData.duration==5){
          return 146046
        }else if(searchData.duration==6){
          return 146043
        }else{
          return 146043
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145871
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }else{
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145871
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146090
        }else if(searchData.duration==5){
          return 146091
        }else if(searchData.duration==6){
          return 146092
        }else{
          return 146092
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146053
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else{
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146090
        }else if(searchData.duration==5){
          return 146091
        }else if(searchData.duration==6){
          return 146092
        }else{
          return 146092
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146053
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else{
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
    }
  }
  }else{
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146075
        }else if(searchData.duration==5){
          return 146077
        }else if(searchData.duration==6){
          return 146078
        }else{
          return 146078
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145848
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145848
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 145997
        }else if(searchData.duration==5){
          return 146000
        }else if(searchData.duration==6){
          return 146011
        }else{
          return 146011
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145848
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }else{
        if(searchData.duration==4){
          return 145763
        }else if(searchData.duration==5){
          return 145848
        }else if(searchData.duration==6){
          return 145849
        }else{
          return 145849
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146080
        }else if(searchData.duration==5){
          return 146082
        }else if(searchData.duration==6){
          return 146083
        }else{
          return 146083
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145861
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145861
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146028
        }else if(searchData.duration==5){
          return 146030
        }else if(searchData.duration==6){
          return 146032
        }else{
          return 146032
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145861
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }else{
        if(searchData.duration==4){
          return 145859
        }else if(searchData.duration==5){
          return 145861
        }else if(searchData.duration==6){
          return 145863
        }else{
          return 145863
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146085
        }else if(searchData.duration==5){
          return 146087
        }else if(searchData.duration==6){
          return 146088
        }else{
          return 146088
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145867
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145867
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146040
        }else if(searchData.duration==5){
          return 146041
        }else if(searchData.duration==6){
          return 146043
        }else{
          return 146043
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145867
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }else{
        if(searchData.duration==4){
          return 145866
        }else if(searchData.duration==5){
          return 145867
        }else if(searchData.duration==6){
          return 145869
        }else{
          return 145869
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146090
        }else if(searchData.duration==5){
          return 146091
        }else if(searchData.duration==6){
          return 146092
        }else{
          return 146092
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146053
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else{
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 146090
        }else if(searchData.duration==5){
          return 146091
        }else if(searchData.duration==6){
          return 146092
        }else{
          return 146092
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 146053
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
      }else{
        if(searchData.duration==4){
          return 145873
        }else if(searchData.duration==5){
          return 145875
        }else if(searchData.duration==6){
          return 145877
        }else{
          return 145877
        }
    }
  }
  }
  }else if(searchData.dest=="Kazakhstan"){
    
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 151990
        }else if(searchData.duration==5){
          return 152011
        }else if(searchData.duration==6){
          return 152017
        }else{
          return 152017
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 151990
        }else if(searchData.duration==5){
          return 152011
        }else if(searchData.duration==6){
          return 152017
        }else{
          return 152017
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 151990
        }else if(searchData.duration==5){
          return 152011
        }else if(searchData.duration==6){
          return 152017
        }else{
          return 152017
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 152040
        }else if(searchData.duration==5){
          return 152041
        }else if(searchData.duration==6){
          return 152042
        }else{
          return 152042
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 151990
        }else if(searchData.duration==5){
          return 152011
        }else if(searchData.duration==6){
          return 152017
        }else{
          return 152017
        }
      }else{
        if(searchData.duration==4){
          return 151990
        }else if(searchData.duration==5){
          return 152011
        }else if(searchData.duration==6){
          return 152017
        }else{
          return 152017
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 152021
        }else if(searchData.duration==5){
          return 152022
        }else if(searchData.duration==6){
          return 152023
        }else{
          return 152023
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 152021
        }else if(searchData.duration==5){
          return 152022
        }else if(searchData.duration==6){
          return 152023
        }else{
          return 152023
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 152021
        }else if(searchData.duration==5){
          return 152022
        }else if(searchData.duration==6){
          return 152023
        }else{
          return 152023
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 152043
        }else if(searchData.duration==5){
          return 152044
        }else if(searchData.duration==6){
          return 152047
        }else{
          return 152047
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 152021
        }else if(searchData.duration==5){
          return 152022
        }else if(searchData.duration==6){
          return 152023
        }else{
          return 152023
        }
      }else{
        if(searchData.duration==4){
          return 152021
        }else if(searchData.duration==5){
          return 152022
        }else if(searchData.duration==6){
          return 152023
        }else{
          return 152023
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 152025
        }else if(searchData.duration==5){
          return 152027
        }else if(searchData.duration==6){
          return 152029
        }else{
          return 152029
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 152025
        }else if(searchData.duration==5){
          return 152027
        }else if(searchData.duration==6){
          return 152029
        }else{
          return 152029
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 152025
        }else if(searchData.duration==5){
          return 152027
        }else if(searchData.duration==6){
          return 152029
        }else{
          return 152029
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 152048
        }else if(searchData.duration==5){
          return 152049
        }else if(searchData.duration==6){
          return 152050
        }else{
          return 152050
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 152025
        }else if(searchData.duration==5){
          return 152027
        }else if(searchData.duration==6){
          return 152029
        }else{
          return 152029
        }
      }else{
        if(searchData.duration==4){
          return 152025
        }else if(searchData.duration==5){
          return 152027
        }else if(searchData.duration==6){
          return 152029
        }else{
          return 152029
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 152034
        }else if(searchData.duration==5){
          return 152036
        }else if(searchData.duration==6){
          return 152039
        }else{
          return 152039
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 152034
        }else if(searchData.duration==5){
          return 152036
        }else if(searchData.duration==6){
          return 152039
        }else{
          return 152039
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 152034
        }else if(searchData.duration==5){
          return 152036
        }else if(searchData.duration==6){
          return 152039
        }else{
          return 152039
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 152052
        }else if(searchData.duration==5){
          return 152053
        }else if(searchData.duration==6){
          return 152055
        }else{
          return 152055
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 152034
        }else if(searchData.duration==5){
          return 152036
        }else if(searchData.duration==6){
          return 152039
        }else{
          return 152039
        }
      }else{
        if(searchData.duration==4){
          return 152034
        }else if(searchData.duration==5){
          return 152036
        }else if(searchData.duration==6){
          return 152039
        }else{
          return 152039
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 152056
        }else if(searchData.duration==5){
          return 152057
        }else if(searchData.duration==6){
          return 152058
        }else{
          return 152058
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 152056
        }else if(searchData.duration==5){
          return 152057
        }else if(searchData.duration==6){
          return 152058
        }else{
          return 152058
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 152056
        }else if(searchData.duration==5){
          return 152057
        }else if(searchData.duration==6){
          return 152058
        }else{
          return 152058
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 152056
        }else if(searchData.duration==5){
          return 152057
        }else if(searchData.duration==6){
          return 152058
        }else{
          return 152058
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 152056
        }else if(searchData.duration==5){
          return 152057
        }else if(searchData.duration==6){
          return 152058
        }else{
          return 152058
        }
      }else{
        if(searchData.duration==4){
          return 152056
        }else if(searchData.duration==5){
          return 152057
        }else if(searchData.duration==6){
          return 152058
        }else{
          return 152058
        }
    }
  }

  }else if(searchData.dest=="Rajasthan"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 154057
        }if(searchData.duration==4){
          return 154069
        }else if(searchData.duration==5){
          return 154101
        }else if(searchData.duration==6){
          return 154138
        }else{
          return 154138
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 154057
        }if(searchData.duration==4){
          return 154069
        }else if(searchData.duration==5){
          return 154101
        }else if(searchData.duration==6){
          return 154138
        }else{
          return 154138
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 154057
        }if(searchData.duration==4){
          return 154069
        }else if(searchData.duration==5){
          return 154101
        }else if(searchData.duration==6){
          return 154138
        }else{
          return 154138
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 154057
        }if(searchData.duration==4){
          return 154069
        }else if(searchData.duration==5){
          return 154101
        }else if(searchData.duration==6){
          return 154138
        }else{
          return 154138
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 154057
        }if(searchData.duration==4){
          return 154069
        }else if(searchData.duration==5){
          return 154101
        }else if(searchData.duration==6){
          return 154138
        }else{
          return 154138
        }
      }else{
        if(searchData.duration==3){
          return 154057
        }if(searchData.duration==4){
          return 154069
        }else if(searchData.duration==5){
          return 154101
        }else if(searchData.duration==6){
          return 154138
        }else{
          return 154138
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 154156
        }if(searchData.duration==4){
          return 154165
        }else if(searchData.duration==5){
          return 154961
        }else if(searchData.duration==6){
          return 154934
        }else{
          return 154934
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 154156
        }if(searchData.duration==4){
          return 154165
        }else if(searchData.duration==5){
          return 154169
        }else if(searchData.duration==6){
          return 154938
        }else{
          return 154938
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 154156
        }if(searchData.duration==4){
          return 154165
        }else if(searchData.duration==5){
          return 154963
        }else if(searchData.duration==6){
          return 154940
        }else{
          return 154940
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 154156
        }if(searchData.duration==4){
          return 154165
        }else if(searchData.duration==5){
          return 154169
        }else if(searchData.duration==6){
          return 154170
        }else{
          return 154170
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 154156
        }if(searchData.duration==4){
          return 154165
        }else if(searchData.duration==5){
          return 154955
        }else if(searchData.duration==6){
          return 154931
        }else{
          return 154931
        }
      }else{
        if(searchData.duration==3){
          return 154156
        }if(searchData.duration==4){
          return 154165
        }else if(searchData.duration==5){
          return 154968
        }else if(searchData.duration==6){
          return 154170
        }else{
          return 154170
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 154181
        }if(searchData.duration==4){
          return 155025
        }else if(searchData.duration==5){
          return 155027
        }else if(searchData.duration==6){
          return 155028
        }else{
          return 155028
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 154181
        }if(searchData.duration==4){
          return 155033
        }else if(searchData.duration==5){
          return 155036
        }else if(searchData.duration==6){
          return 155039
        }else{
          return 155039
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 154181
        }if(searchData.duration==4){
          return 154182
        }else if(searchData.duration==5){
          return 155121
        }else if(searchData.duration==6){
          return 155123
        }else{
          return 154186
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 154181
        }if(searchData.duration==4){
          return 154996
        }else if(searchData.duration==5){
          return 154184
        }else if(searchData.duration==6){
          return 154186
        }else{
          return 154186
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 154181
        }if(searchData.duration==4){
          return 154999
        }else if(searchData.duration==5){
          return 155022
        }else if(searchData.duration==6){
          return 155024
        }else{
          return 155024
        }
      }else{
        if(searchData.duration==3){
          return 154181
        }if(searchData.duration==4){
          return 154182
        }else if(searchData.duration==5){
          return 154184
        }else if(searchData.duration==6){
          return 154186
        }else{
          return 154186
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 154189
        }if(searchData.duration==4){
          return 154194
        }else if(searchData.duration==5){
          return 155145
        }else if(searchData.duration==6){
          return 155147
        }else{
          return 155147
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 154189
        }if(searchData.duration==4){
          return 155148
        }else if(searchData.duration==5){
          return 155151
        }else if(searchData.duration==6){
          return 155153
        }else{
          return 155153
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 155154
        }if(searchData.duration==4){
          return 155155
        }else if(searchData.duration==5){
          return 155157
        }else if(searchData.duration==6){
          return 155163
        }else{
          return 155163
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 154189
        }if(searchData.duration==4){
          return 154194
        }else if(searchData.duration==5){
          return 154200
        }else if(searchData.duration==6){
          return 154201
        }else{
          return 154201
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 155133
        }if(searchData.duration==4){
          return 155136
        }else if(searchData.duration==5){
          return 155138
        }else if(searchData.duration==6){
          return 155142
        }else{
          return 155142
        }
      }else{
        if(searchData.duration==3){
          return 154189
        }if(searchData.duration==4){
          return 154194
        }else if(searchData.duration==5){
          return 154200
        }else if(searchData.duration==6){
          return 154201
        }else{
          return 154201
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 154204
        }if(searchData.duration==4){
          return 154205
        }else if(searchData.duration==5){
          return 155184
        }else if(searchData.duration==6){
          return 155186
        }else{
          return 155186
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 154204
        }if(searchData.duration==4){
          return 154205
        }else if(searchData.duration==5){
          return 155191
        }else if(searchData.duration==6){
          return 155195
        }else{
          return 155195
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 155197
        }if(searchData.duration==4){
          return 155199
        }else if(searchData.duration==5){
          return 155202
        }else if(searchData.duration==6){
          return 155205
        }else{
          return 155205
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 154204
        }if(searchData.duration==4){
          return 154205
        }else if(searchData.duration==5){
          return 155168
        }else if(searchData.duration==6){
          return 155172
        }else{
          return 155172
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 155175
        }if(searchData.duration==4){
          return 155177
        }else if(searchData.duration==5){
          return 155179
        }else if(searchData.duration==6){
          return 155181
        }else{
          return 155181
        }
      }else{
        if(searchData.duration==3){
          return 154204
        }if(searchData.duration==4){
          return 154205
        }else if(searchData.duration==5){
          return 154206
        }else if(searchData.duration==6){
          return 154208
        }else{
          return 154208
        }
      }
    }
   

  }else if(searchData.dest=="Sikkim-Darjeeling"){
    if(searchData.special=="Only Gangtok"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 151179
        }if(searchData.duration==4){
          return 150745
        }else if(searchData.duration==5){
          return 150746
        }else if(searchData.duration==6){
          return 150746
        }else{
          return 150746
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 151181
        }if(searchData.duration==4){
          return 150757
        }else if(searchData.duration==5){
          return 150760
        }else if(searchData.duration==6){
          return 150760
        }else{
          return 150760
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 151182
        }if(searchData.duration==4){
          return 150765
        }else if(searchData.duration==5){
          return 150768
        }else if(searchData.duration==6){
          return 150768
        }else{
          return 150768
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 151174
        }if(searchData.duration==4){
          return 150790
        }else if(searchData.duration==5){
          return 150791
        }else if(searchData.duration==6){
          return 150791
        }else{
          return 150791
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 151177
        }if(searchData.duration==4){
          return 150729
        }else if(searchData.duration==5){
          return 150732
        }else if(searchData.duration==6){
          return 150732
        }else{
          return 150732
        }
      }else{
        if(searchData.duration==3){
          return 151183
        }if(searchData.duration==4){
          return 150778
        }else if(searchData.duration==5){
          return 150780
        }else if(searchData.duration==6){
          return 150780
        }else{
          return 150780
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 151187
        }if(searchData.duration==4){
          return 150845
        }else if(searchData.duration==5){
          return 150849
        }else if(searchData.duration==6){
          return 150850
        }else{
          return 150850
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 151188
        }if(searchData.duration==4){
          return 150828
        }else if(searchData.duration==5){
          return 150835
        }else if(searchData.duration==6){
          return 150841
        }else{
          return 150841
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 151187
        }if(searchData.duration==4){
          return 150845
        }else if(searchData.duration==5){
          return 150849
        }else if(searchData.duration==6){
          return 150850
        }else{
          return 150850
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 151187
        }if(searchData.duration==4){
          return 150845
        }else if(searchData.duration==5){
          return 150849
        }else if(searchData.duration==6){
          return 150850
        }else{
          return 150850
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 151188
        }if(searchData.duration==4){
          return 150828
        }else if(searchData.duration==5){
          return 150835
        }else if(searchData.duration==6){
          return 150841
        }else{
          return 150841
        }
      }else{
        if(searchData.duration==3){
          return 151188
        }if(searchData.duration==4){
          return 150828
        }else if(searchData.duration==5){
          return 150835
        }else if(searchData.duration==6){
          return 150841
        }else{
          return 150841
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 151190
        }if(searchData.duration==4){
          return 150874
        }else if(searchData.duration==5){
          return 150875
        }else if(searchData.duration==6){
          return 150876
        }else{
          return 150876
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 151191
        }if(searchData.duration==4){
          return 150858
        }else if(searchData.duration==5){
          return 150865
        }else if(searchData.duration==6){
          return 150871
        }else{
          return 150871
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 151190
        }if(searchData.duration==4){
          return 150874
        }else if(searchData.duration==5){
          return 150875
        }else if(searchData.duration==6){
          return 150876
        }else{
          return 150876
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 151190
        }if(searchData.duration==4){
          return 150874
        }else if(searchData.duration==5){
          return 150875
        }else if(searchData.duration==6){
          return 150876
        }else{
          return 150876
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 151191
        }if(searchData.duration==4){
          return 150858
        }else if(searchData.duration==5){
          return 150865
        }else if(searchData.duration==6){
          return 150871
        }else{
          return 150871
        }
      }else{
        if(searchData.duration==3){
          return 151191
        }if(searchData.duration==4){
          return 150858
        }else if(searchData.duration==5){
          return 150865
        }else if(searchData.duration==6){
          return 150871
        }else{
          return 150871
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 151193
        }if(searchData.duration==4){
          return 150897
        }else if(searchData.duration==5){
          return 150898
        }else if(searchData.duration==6){
          return 150900
        }else{
          return 150900
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 151194
        }if(searchData.duration==4){
          return 150885
        }else if(searchData.duration==5){
          return 150886
        }else if(searchData.duration==6){
          return 150893
        }else{
          return 150893
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 151193
        }if(searchData.duration==4){
          return 150897
        }else if(searchData.duration==5){
          return 150898
        }else if(searchData.duration==6){
          return 150900
        }else{
          return 150900
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 151193
        }if(searchData.duration==4){
          return 150897
        }else if(searchData.duration==5){
          return 150898
        }else if(searchData.duration==6){
          return 150900
        }else{
          return 150900
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 151194
        }if(searchData.duration==4){
          return 150885
        }else if(searchData.duration==5){
          return 150886
        }else if(searchData.duration==6){
          return 150893
        }else{
          return 150893
        }
      }else{
        if(searchData.duration==3){
          return 151194
        }if(searchData.duration==4){
          return 150885
        }else if(searchData.duration==5){
          return 150886
        }else if(searchData.duration==6){
          return 150893
        }else{
          return 150893
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 151197
        }if(searchData.duration==4){
          return 150919
        }else if(searchData.duration==5){
          return 150920
        }else if(searchData.duration==6){
          return 150921
        }else{
          return 150921
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 151207
        }if(searchData.duration==4){
          return 150913
        }else if(searchData.duration==5){
          return 150914
        }else if(searchData.duration==6){
          return 150915
        }else{
          return 150915
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 151197
        }if(searchData.duration==4){
          return 150919
        }else if(searchData.duration==5){
          return 150920
        }else if(searchData.duration==6){
          return 150921
        }else{
          return 150921
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 151197
        }if(searchData.duration==4){
          return 150919
        }else if(searchData.duration==5){
          return 150920
        }else if(searchData.duration==6){
          return 150921
        }else{
          return 150921
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 151207
        }if(searchData.duration==4){
          return 150913
        }else if(searchData.duration==5){
          return 150914
        }else if(searchData.duration==6){
          return 150915
        }else{
          return 150915
        }
      }else{
        if(searchData.duration==3){
          return 151207
        }if(searchData.duration==4){
          return 150913
        }else if(searchData.duration==5){
          return 150914
        }else if(searchData.duration==6){
          return 150915
        }else{
          return 150915
        }
      }
    }
  }else if(searchData.special=="Lachen & Lachung"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150744
        }if(searchData.duration==4){
          return 150745
        }else if(searchData.duration==5){
          return 150746
        }else if(searchData.duration==6){
          return 151220
        }else{
          return 151220
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150755
        }if(searchData.duration==4){
          return 150757
        }else if(searchData.duration==5){
          return 150760
        }else if(searchData.duration==6){
          return 151220
        }else{
          return 151220
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150764
        }if(searchData.duration==4){
          return 150765
        }else if(searchData.duration==5){
          return 150768
        }else if(searchData.duration==6){
          return 151220
        }else{
          return 151220
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150787
        }if(searchData.duration==4){
          return 150790
        }else if(searchData.duration==5){
          return 150791
        }else if(searchData.duration==6){
          return 151220
        }else{
          return 151220
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150722
        }if(searchData.duration==4){
          return 150729
        }else if(searchData.duration==5){
          return 150732
        }else if(searchData.duration==6){
          return 151220
        }else{
          return 151220
        }
      }else{
        if(searchData.duration==3){
          return 150774
        }if(searchData.duration==4){
          return 150778
        }else if(searchData.duration==5){
          return 150780
        }else if(searchData.duration==6){
          return 151220
        }else{
          return 151220
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150844
        }if(searchData.duration==4){
          return 150845
        }else if(searchData.duration==5){
          return 150849
        }else if(searchData.duration==6){
          return 151221
        }else{
          return 151221
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150808
        }if(searchData.duration==4){
          return 150828
        }else if(searchData.duration==5){
          return 150835
        }else if(searchData.duration==6){
          return 151221
        }else{
          return 151221
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150844
        }if(searchData.duration==4){
          return 150845
        }else if(searchData.duration==5){
          return 150849
        }else if(searchData.duration==6){
          return 151221
        }else{
          return 151221
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150844
        }if(searchData.duration==4){
          return 150845
        }else if(searchData.duration==5){
          return 150849
        }else if(searchData.duration==6){
          return 151221
        }else{
          return 151221
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150808
        }if(searchData.duration==4){
          return 150828
        }else if(searchData.duration==5){
          return 150835
        }else if(searchData.duration==6){
          return 151221
        }else{
          return 151221
        }
      }else{
        if(searchData.duration==3){
          return 150808
        }if(searchData.duration==4){
          return 150828
        }else if(searchData.duration==5){
          return 150835
        }else if(searchData.duration==6){
          return 151221
        }else{
          return 151221
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150872
        }if(searchData.duration==4){
          return 150874
        }else if(searchData.duration==5){
          return 150875
        }else if(searchData.duration==6){
          return 151224
        }else{
          return 151224
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150857
        }if(searchData.duration==4){
          return 150858
        }else if(searchData.duration==5){
          return 150865
        }else if(searchData.duration==6){
          return 151224
        }else{
          return 151224
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150872
        }if(searchData.duration==4){
          return 150874
        }else if(searchData.duration==5){
          return 150875
        }else if(searchData.duration==6){
          return 151224
        }else{
          return 151224
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150872
        }if(searchData.duration==4){
          return 150874
        }else if(searchData.duration==5){
          return 150875
        }else if(searchData.duration==6){
          return 151224
        }else{
          return 151224
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150857
        }if(searchData.duration==4){
          return 150858
        }else if(searchData.duration==5){
          return 150865
        }else if(searchData.duration==6){
          return 151224
        }else{
          return 151224
        }
      }else{
        if(searchData.duration==3){
          return 150857
        }if(searchData.duration==4){
          return 150858
        }else if(searchData.duration==5){
          return 150865
        }else if(searchData.duration==6){
          return 151224
        }else{
          return 151224
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150896
        }if(searchData.duration==4){
          return 150897
        }else if(searchData.duration==5){
          return 150898
        }else if(searchData.duration==6){
          return 151226
        }else{
          return 151226
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150880
        }if(searchData.duration==4){
          return 150885
        }else if(searchData.duration==5){
          return 150886
        }else if(searchData.duration==6){
          return 151226
        }else{
          return 151226
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150896
        }if(searchData.duration==4){
          return 150897
        }else if(searchData.duration==5){
          return 150898
        }else if(searchData.duration==6){
          return 151226
        }else{
          return 151226
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150896
        }if(searchData.duration==4){
          return 150897
        }else if(searchData.duration==5){
          return 150898
        }else if(searchData.duration==6){
          return 151226
        }else{
          return 151226
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150880
        }if(searchData.duration==4){
          return 150885
        }else if(searchData.duration==5){
          return 150886
        }else if(searchData.duration==6){
          return 151226
        }else{
          return 151226
        }
      }else{
        if(searchData.duration==3){
          return 150880
        }if(searchData.duration==4){
          return 150885
        }else if(searchData.duration==5){
          return 150886
        }else if(searchData.duration==6){
          return 151226
        }else{
          return 151226
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150917
        }if(searchData.duration==4){
          return 150919
        }else if(searchData.duration==5){
          return 150920
        }else if(searchData.duration==6){
          return 151227
        }else{
          return 151227
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150912
        }if(searchData.duration==4){
          return 150913
        }else if(searchData.duration==5){
          return 150914
        }else if(searchData.duration==6){
          return 151227
        }else{
          return 151227
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150917
        }if(searchData.duration==4){
          return 150919
        }else if(searchData.duration==5){
          return 150920
        }else if(searchData.duration==6){
          return 151227
        }else{
          return 151227
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150917
        }if(searchData.duration==4){
          return 150919
        }else if(searchData.duration==5){
          return 150920
        }else if(searchData.duration==6){
          return 151227
        }else{
          return 151227
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150912
        }if(searchData.duration==4){
          return 150913
        }else if(searchData.duration==5){
          return 150914
        }else if(searchData.duration==6){
          return 151227
        }else{
          return 151227
        }
      }else{
        if(searchData.duration==3){
          return 150912
        }if(searchData.duration==4){
          return 150913
        }else if(searchData.duration==5){
          return 150914
        }else if(searchData.duration==6){
          return 151227
        }else{
          return 151227
        }
      }
    }
  }else{
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150744
        }if(searchData.duration==4){
          return 150745
        }else if(searchData.duration==5){
          return 150746
        }else if(searchData.duration==6){
          return 150746
        }else{
          return 150746
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150755
        }if(searchData.duration==4){
          return 150757
        }else if(searchData.duration==5){
          return 150760
        }else if(searchData.duration==6){
          return 150760
        }else{
          return 150760
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150764
        }if(searchData.duration==4){
          return 150765
        }else if(searchData.duration==5){
          return 150768
        }else if(searchData.duration==6){
          return 150768
        }else{
          return 150768
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150787
        }if(searchData.duration==4){
          return 150790
        }else if(searchData.duration==5){
          return 150791
        }else if(searchData.duration==6){
          return 150791
        }else{
          return 150791
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150722
        }if(searchData.duration==4){
          return 150729
        }else if(searchData.duration==5){
          return 150732
        }else if(searchData.duration==6){
          return 150732
        }else{
          return 150732
        }
      }else{
        if(searchData.duration==3){
          return 150774
        }if(searchData.duration==4){
          return 150778
        }else if(searchData.duration==5){
          return 150780
        }else if(searchData.duration==6){
          return 150780
        }else{
          return 150780
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150844
        }if(searchData.duration==4){
          return 150845
        }else if(searchData.duration==5){
          return 150849
        }else if(searchData.duration==6){
          return 150850
        }else{
          return 150850
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150808
        }if(searchData.duration==4){
          return 150828
        }else if(searchData.duration==5){
          return 150835
        }else if(searchData.duration==6){
          return 150841
        }else{
          return 150841
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150844
        }if(searchData.duration==4){
          return 150845
        }else if(searchData.duration==5){
          return 150849
        }else if(searchData.duration==6){
          return 150850
        }else{
          return 150850
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150844
        }if(searchData.duration==4){
          return 150845
        }else if(searchData.duration==5){
          return 150849
        }else if(searchData.duration==6){
          return 150850
        }else{
          return 150850
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150808
        }if(searchData.duration==4){
          return 150828
        }else if(searchData.duration==5){
          return 150835
        }else if(searchData.duration==6){
          return 150841
        }else{
          return 150841
        }
      }else{
        if(searchData.duration==3){
          return 150808
        }if(searchData.duration==4){
          return 150828
        }else if(searchData.duration==5){
          return 150835
        }else if(searchData.duration==6){
          return 150841
        }else{
          return 150841
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150872
        }if(searchData.duration==4){
          return 150874
        }else if(searchData.duration==5){
          return 150875
        }else if(searchData.duration==6){
          return 150876
        }else{
          return 150876
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150857
        }if(searchData.duration==4){
          return 150858
        }else if(searchData.duration==5){
          return 150865
        }else if(searchData.duration==6){
          return 150871
        }else{
          return 150871
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150872
        }if(searchData.duration==4){
          return 150874
        }else if(searchData.duration==5){
          return 150875
        }else if(searchData.duration==6){
          return 150876
        }else{
          return 150876
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150872
        }if(searchData.duration==4){
          return 150874
        }else if(searchData.duration==5){
          return 150875
        }else if(searchData.duration==6){
          return 150876
        }else{
          return 150876
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150857
        }if(searchData.duration==4){
          return 150858
        }else if(searchData.duration==5){
          return 150865
        }else if(searchData.duration==6){
          return 150871
        }else{
          return 150871
        }
      }else{
        if(searchData.duration==3){
          return 150857
        }if(searchData.duration==4){
          return 150858
        }else if(searchData.duration==5){
          return 150865
        }else if(searchData.duration==6){
          return 150871
        }else{
          return 150871
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150896
        }if(searchData.duration==4){
          return 150897
        }else if(searchData.duration==5){
          return 150898
        }else if(searchData.duration==6){
          return 150900
        }else{
          return 150900
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150880
        }if(searchData.duration==4){
          return 150885
        }else if(searchData.duration==5){
          return 150886
        }else if(searchData.duration==6){
          return 150893
        }else{
          return 150893
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150896
        }if(searchData.duration==4){
          return 150897
        }else if(searchData.duration==5){
          return 150898
        }else if(searchData.duration==6){
          return 150900
        }else{
          return 150900
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150896
        }if(searchData.duration==4){
          return 150897
        }else if(searchData.duration==5){
          return 150898
        }else if(searchData.duration==6){
          return 150900
        }else{
          return 150900
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150880
        }if(searchData.duration==4){
          return 150885
        }else if(searchData.duration==5){
          return 150886
        }else if(searchData.duration==6){
          return 150893
        }else{
          return 150893
        }
      }else{
        if(searchData.duration==3){
          return 150880
        }if(searchData.duration==4){
          return 150885
        }else if(searchData.duration==5){
          return 150886
        }else if(searchData.duration==6){
          return 150893
        }else{
          return 150893
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 150917
        }if(searchData.duration==4){
          return 150919
        }else if(searchData.duration==5){
          return 150920
        }else if(searchData.duration==6){
          return 150921
        }else{
          return 150921
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==3){
          return 150912
        }if(searchData.duration==4){
          return 150913
        }else if(searchData.duration==5){
          return 150914
        }else if(searchData.duration==6){
          return 150915
        }else{
          return 150915
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
          return 150917
        }if(searchData.duration==4){
          return 150919
        }else if(searchData.duration==5){
          return 150920
        }else if(searchData.duration==6){
          return 150921
        }else{
          return 150921
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==3){
          return 150917
        }if(searchData.duration==4){
          return 150919
        }else if(searchData.duration==5){
          return 150920
        }else if(searchData.duration==6){
          return 150921
        }else{
          return 150921
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==3){
          return 150912
        }if(searchData.duration==4){
          return 150913
        }else if(searchData.duration==5){
          return 150914
        }else if(searchData.duration==6){
          return 150915
        }else{
          return 150915
        }
      }else{
        if(searchData.duration==3){
          return 150912
        }if(searchData.duration==4){
          return 150913
        }else if(searchData.duration==5){
          return 150914
        }else if(searchData.duration==6){
          return 150915
        }else{
          return 150915
        }
      }
    }
  }
  }else if(searchData.dest=="Turkey"){
    if(searchData.special=="Multi-city"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157369
        }else if(searchData.duration==5){
          return 155512
        }else if(searchData.duration==6){
          return 155518
        }else{
          return 155518
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 156707
        }else if(searchData.duration==5){
          return 157366
        }else if(searchData.duration==6){
          return 156705
        }else{
          return 156705
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 156707
        }else if(searchData.duration==5){
          return 157366
        }else if(searchData.duration==6){
          return 156705
        }else{
          return 156705
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157372
        }else if(searchData.duration==5){
          return 155502
        }else if(searchData.duration==6){
          return 156703
        }else{
          return 156703
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 156694
        }else if(searchData.duration==5){
          return 156695
        }else if(searchData.duration==6){
          return 156696
        }else{
          return 156696
        }
      }else{
        if(searchData.duration==4){
          return 155224
        }else if(searchData.duration==5){
          return 155248
        }else if(searchData.duration==6){
          return 155522
        }else{
          return 155522
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157369
        }else if(searchData.duration==5){
          return 155512
        }else if(searchData.duration==6){
          return 155518
        }else{
          return 155518
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 156707
        }else if(searchData.duration==5){
          return 157366
        }else if(searchData.duration==6){
          return 156705
        }else{
          return 156705
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 156707
        }else if(searchData.duration==5){
          return 157366
        }else if(searchData.duration==6){
          return 156705
        }else{
          return 156705
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157372
        }else if(searchData.duration==5){
          return 155502
        }else if(searchData.duration==6){
          return 156703
        }else{
          return 156703
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 156694
        }else if(searchData.duration==5){
          return 156695
        }else if(searchData.duration==6){
          return 156696
        }else{
          return 156696
        }
      }else{
        if(searchData.duration==4){
          return 155224
        }else if(searchData.duration==5){
          return 155248
        }else if(searchData.duration==6){
          return 155252
        }else{
          return 155252
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157387
        }else if(searchData.duration==5){
          return 155754
        }else if(searchData.duration==6){
          return 155756
        }else{
          return 155756
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 156717
        }else if(searchData.duration==5){
          return 156710
        }else if(searchData.duration==6){
          return 156712
        }else{
          return 156712
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 156717
        }else if(searchData.duration==5){
          return 156710
        }else if(searchData.duration==6){
          return 156712
        }else{
          return 156712
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157384
        }else if(searchData.duration==5){
          return 155753
        }else if(searchData.duration==6){
          return 157385
        }else{
          return 157385
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 156697
        }else if(searchData.duration==5){
          return 156702
        }else if(searchData.duration==6){
          return 157397
        }else{
          return 157397
        }
      }else{
        if(searchData.duration==4){
          return 155750
        }else if(searchData.duration==5){
          return 157381
        }else if(searchData.duration==6){
          return 155758
        }else{
          return 155758
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157406
        }else if(searchData.duration==5){
          return 155799
        }else if(searchData.duration==6){
          return 155802
        }else{
          return 155802
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 156756
        }else if(searchData.duration==5){
          return 156757
        }else if(searchData.duration==6){
          return 156755
        }else{
          return 156755
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 156756
        }else if(searchData.duration==5){
          return 156757
        }else if(searchData.duration==6){
          return 156755
        }else{
          return 156755
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157403
        }else if(searchData.duration==5){
          return 155785
        }else if(searchData.duration==6){
          return 157405
        }else{
          return 157405
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 157408
        }else if(searchData.duration==5){
          return 156721
        }else if(searchData.duration==6){
          return 156722
        }else{
          return 156722
        }
      }else{
        if(searchData.duration==4){
          return 155783
        }else if(searchData.duration==5){
          return 155766
        }else if(searchData.duration==6){
          return 155805
        }else{
          return 155805
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157420
        }else if(searchData.duration==5){
          return 155829
        }else if(searchData.duration==6){
          return 155832
        }else{
          return 155832
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 157421
        }else if(searchData.duration==5){
          return 156760
        }else if(searchData.duration==6){
          return 156766
        }else{
          return 156766
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 157421
        }else if(searchData.duration==5){
          return 156760
        }else if(searchData.duration==6){
          return 156766
        }else{
          return 156766
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157414
        }else if(searchData.duration==5){
          return 155828
        }else if(searchData.duration==6){
          return 157419
        }else{
          return 157419
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 156750
        }else if(searchData.duration==5){
          return 156751
        }else if(searchData.duration==6){
          return 156752
        }else{
          return 156752
        }
      }else{
        if(searchData.duration==4){
          return 155824
        }else if(searchData.duration==5){
          return 155820
        }else if(searchData.duration==6){
          return 155834
        }else{
          return 155834
        }
      }
    }
  }else{
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157369
        }else if(searchData.duration==5){
          return 155512
        }else if(searchData.duration==6){
          return 155518
        }else{
          return 155518
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 156707
        }else if(searchData.duration==5){
          return 157366
        }else if(searchData.duration==6){
          return 156705
        }else{
          return 156705
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 156707
        }else if(searchData.duration==5){
          return 157366
        }else if(searchData.duration==6){
          return 156705
        }else{
          return 156705
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157372
        }else if(searchData.duration==5){
          return 155502
        }else if(searchData.duration==6){
          return 156703
        }else{
          return 156703
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 156694
        }else if(searchData.duration==5){
          return 156695
        }else if(searchData.duration==6){
          return 156696
        }else{
          return 156696
        }
      }else{
        if(searchData.duration==4){
          return 155224
        }else if(searchData.duration==5){
          return 155248
        }else if(searchData.duration==6){
          return 155252
        }else{
          return 155252
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157369
        }else if(searchData.duration==5){
          return 155512
        }else if(searchData.duration==6){
          return 155518
        }else{
          return 155518
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 156707
        }else if(searchData.duration==5){
          return 157366
        }else if(searchData.duration==6){
          return 156705
        }else{
          return 156705
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 156707
        }else if(searchData.duration==5){
          return 157366
        }else if(searchData.duration==6){
          return 156705
        }else{
          return 156705
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157372
        }else if(searchData.duration==5){
          return 155502
        }else if(searchData.duration==6){
          return 156703
        }else{
          return 156703
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 156694
        }else if(searchData.duration==5){
          return 156695
        }else if(searchData.duration==6){
          return 156696
        }else{
          return 156696
        }
      }else{
        if(searchData.duration==4){
          return 155224
        }else if(searchData.duration==5){
          return 155248
        }else if(searchData.duration==6){
          return 155252
        }else{
          return 155252
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157387
        }else if(searchData.duration==5){
          return 155754
        }else if(searchData.duration==6){
          return 155756
        }else{
          return 155756
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 156717
        }else if(searchData.duration==5){
          return 156710
        }else if(searchData.duration==6){
          return 156712
        }else{
          return 156712
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 156717
        }else if(searchData.duration==5){
          return 156710
        }else if(searchData.duration==6){
          return 156712
        }else{
          return 156712
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157384
        }else if(searchData.duration==5){
          return 155753
        }else if(searchData.duration==6){
          return 157385
        }else{
          return 157385
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 156697
        }else if(searchData.duration==5){
          return 156699
        }else if(searchData.duration==6){
          return 157397
        }else{
          return 157397
        }
      }else{
        if(searchData.duration==4){
          return 155737
        }else if(searchData.duration==5){
          return 155741
        }else if(searchData.duration==6){
          return 155747
        }else{
          return 155747
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157406
        }else if(searchData.duration==5){
          return 155799
        }else if(searchData.duration==6){
          return 155802
        }else{
          return 155802
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 156756
        }else if(searchData.duration==5){
          return 156757
        }else if(searchData.duration==6){
          return 156755
        }else{
          return 156755
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 156756
        }else if(searchData.duration==5){
          return 156757
        }else if(searchData.duration==6){
          return 156755
        }else{
          return 156755
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157403
        }else if(searchData.duration==5){
          return 155785
        }else if(searchData.duration==6){
          return 157405
        }else{
          return 157405
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 157408
        }else if(searchData.duration==5){
          return 156720
        }else if(searchData.duration==6){
          return 156722
        }else{
          return 156722
        }
      }else{
        if(searchData.duration==4){
          return 155763
        }else if(searchData.duration==5){
          return 155766
        }else if(searchData.duration==6){
          return 155771
        }else{
          return 155771
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 157420
        }else if(searchData.duration==5){
          return 155829
        }else if(searchData.duration==6){
          return 155832
        }else{
          return 155832
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 157421
        }else if(searchData.duration==5){
          return 156760
        }else if(searchData.duration==6){
          return 156764
        }else{
          return 156764
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 157421
        }else if(searchData.duration==5){
          return 156760
        }else if(searchData.duration==6){
          return 156764
        }else{
          return 156764
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 157414
        }else if(searchData.duration==5){
          return 155828
        }else if(searchData.duration==6){
          return 157419
        }else{
          return 157419
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 156750
        }else if(searchData.duration==5){
          return 156751
        }else if(searchData.duration==6){
          return 156752
        }else{
          return 156752
        }
      }else{
        if(searchData.duration==4){
          return 155809
        }else if(searchData.duration==5){
          return 155820
        }else if(searchData.duration==6){
          return 155821
        }else{
          return 155821
        }
      }
    }
  }
  }else if(searchData.dest=="Hong Kong"){
    
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 186257
        }else if(searchData.duration==5){
          return 186368
        }else{
          return 186368
        }
      }else if(searchData.type=="Family with kids"){
       if(searchData.duration==4){
          return 186257
        }else if(searchData.duration==5){
          return 186368
        }else{
          return 186368
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 186257
        }else if(searchData.duration==5){
          return 186368
        }else{
          return 186368
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 186257
        }else if(searchData.duration==5){
          return 186368
        }else{
          return 186368
        }
      }else if(searchData.type=="Adventure junkies"){
       if(searchData.duration==4){
          return 186257
        }else if(searchData.duration==5){
          return 186368
        }else{
          return 186368
        }
      }else{
       if(searchData.duration==4){
          return 186257
        }else if(searchData.duration==5){
          return 186368
        }else{
          return 186368
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 186435
        }else if(searchData.duration==5){
          return 186438
        }else{
          return 186438
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 186435
        }else if(searchData.duration==5){
          return 186438
        }else{
          return 186438
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 186435
        }else if(searchData.duration==5){
          return 186438
        }else{
          return 186438
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==4){
          return 186435
        }else if(searchData.duration==5){
          return 186438
        }else{
          return 186438
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 186435
        }else if(searchData.duration==5){
          return 186438
        }else{
          return 186438
        }
      }else{
       if(searchData.duration==4){
          return 186435
        }else if(searchData.duration==5){
          return 186438
        }else{
          return 186438
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 186446
        }else if(searchData.duration==5){
          return 186470
        }else if(searchData.duration==6){
          return 186465
        }else{
          return 186465
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 186446
        }else if(searchData.duration==5){
          return 186470
        }else if(searchData.duration==6){
          return 186465
        }else{
          return 186465
        }
      }else if(searchData.type=="Family without kids"){
       if(searchData.duration==4){
          return 186446
        }else if(searchData.duration==5){
          return 186470
        }else if(searchData.duration==6){
          return 186465
        }else{
          return 186465
        }
      }else if(searchData.type=="Party lovers"){
       if(searchData.duration==4){
          return 186446
        }else if(searchData.duration==5){
          return 186470
        }else if(searchData.duration==6){
          return 186465
        }else{
          return 186465
        }
      }else if(searchData.type=="Adventure junkies"){
       if(searchData.duration==4){
          return 186446
        }else if(searchData.duration==5){
          return 186470
        }else if(searchData.duration==6){
          return 186465
        }else{
          return 186465
        }
      }else{
        if(searchData.duration==4){
          return 186446
        }else if(searchData.duration==5){
          return 186470
        }else if(searchData.duration==6){
          return 186465
        }else{
          return 186465
        }
      }
    }else if(searchData.budget=="High"){
     if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 186483
        }else if(searchData.duration==5){
          return 186497
        }else if(searchData.duration==6){
          return 186501
        }else{
          return 186501
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==4){
          return 186483
        }else if(searchData.duration==5){
          return 186497
        }else if(searchData.duration==6){
          return 186501
        }else{
          return 186501
        }
      }else if(searchData.type=="Family without kids"){
       if(searchData.duration==4){
          return 186483
        }else if(searchData.duration==5){
          return 186497
        }else if(searchData.duration==6){
          return 186501
        }else{
          return 186501
        }
      }else if(searchData.type=="Party lovers"){
       if(searchData.duration==4){
          return 186483
        }else if(searchData.duration==5){
          return 186497
        }else if(searchData.duration==6){
          return 186501
        }else{
          return 186501
        }
      }else if(searchData.type=="Adventure junkies"){
       if(searchData.duration==4){
          return 186483
        }else if(searchData.duration==5){
          return 186497
        }else if(searchData.duration==6){
          return 186501
        }else{
          return 186501
        }
      }else{
        if(searchData.duration==4){
          return 186483
        }else if(searchData.duration==5){
          return 186497
        }else if(searchData.duration==6){
          return 186501
        }else{
          return 186501
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==4){
          return 186508
        }else if(searchData.duration==5){
          return 186511
        }else if(searchData.duration==6){
          return 186513
        }else{
          return 186513
        }
      }else if(searchData.type=="Family with kids"){
         if(searchData.duration==4){
          return 186508
        }else if(searchData.duration==5){
          return 186511
        }else if(searchData.duration==6){
          return 186513
        }else{
          return 186513
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==4){
          return 186508
        }else if(searchData.duration==5){
          return 186511
        }else if(searchData.duration==6){
          return 186513
        }else{
          return 186513
        }
      }else if(searchData.type=="Party lovers"){
         if(searchData.duration==4){
          return 186508
        }else if(searchData.duration==5){
          return 186511
        }else if(searchData.duration==6){
          return 186513
        }else{
          return 186513
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==4){
          return 186508
        }else if(searchData.duration==5){
          return 186511
        }else if(searchData.duration==6){
          return 186513
        }else{
          return 186513
        }
      }else{
        if(searchData.duration==4){
          return 186508
        }else if(searchData.duration==5){
          return 186511
        }else if(searchData.duration==6){
          return 186513
        }else{
          return 186513
        }
    }
  }
  }else if(searchData.dest=="Uttarakhand"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==2){
          return 191771
        }if(searchData.duration==3){
          return 191856
        }else if(searchData.duration==4){
          return 191906
        }else if(searchData.duration==5){
          return 191936
        }else{
          return 191936
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==2){
          return 191771
        }if(searchData.duration==3){
          return 191856
        }else if(searchData.duration==4){
          return 191906
        }else if(searchData.duration==5){
          return 191936
        }else{
          return 191936
        }
      }else if(searchData.type=="Family without kids"){
         if(searchData.duration==2){
          return 191771
        }if(searchData.duration==3){
          return 191856
        }else if(searchData.duration==4){
          return 191906
        }else if(searchData.duration==5){
          return 191936
        }else{
          return 191936
        }
      }else if(searchData.type=="Party lovers"){
         if(searchData.duration==2){
          return 191771
        }if(searchData.duration==3){
          return 191856
        }else if(searchData.duration==4){
          return 191906
        }else if(searchData.duration==5){
          return 191936
        }else{
          return 191936
        }
      }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==2){
          return 191771
        }if(searchData.duration==3){
          return 191856
        }else if(searchData.duration==4){
          return 191906
        }else if(searchData.duration==5){
          return 191936
        }else{
          return 191936
        }
      }else{
        if(searchData.duration==2){
          return 191771
        }if(searchData.duration==3){
          return 191856
        }else if(searchData.duration==4){
          return 191906
        }else if(searchData.duration==5){
          return 191936
        }else{
          return 191936
        }
      }
    }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
       if(searchData.duration==2){
          return 191953
        }if(searchData.duration==3){
          return 191974
        }else if(searchData.duration==4){
          return 191977
        }else if(searchData.duration==5){
          return 191980
        }else{
          return 191980
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==2){
          return 191953
        }if(searchData.duration==3){
          return 191974
        }else if(searchData.duration==4){
          return 191977
        }else if(searchData.duration==5){
          return 191980
        }else{
          return 191980
        }
      }else if(searchData.type=="Family without kids"){
       if(searchData.duration==2){
          return 191953
        }if(searchData.duration==3){
          return 191974
        }else if(searchData.duration==4){
          return 191977
        }else if(searchData.duration==5){
          return 191980
        }else{
          return 191980
        }
      }else if(searchData.type=="Party lovers"){
       if(searchData.duration==2){
          return 191953
        }if(searchData.duration==3){
          return 191974
        }else if(searchData.duration==4){
          return 191977
        }else if(searchData.duration==5){
          return 191980
        }else{
          return 191980
        }
      }else if(searchData.type=="Adventure junkies"){
       if(searchData.duration==2){
          return 191953
        }if(searchData.duration==3){
          return 191974
        }else if(searchData.duration==4){
          return 191977
        }else if(searchData.duration==5){
          return 191980
        }else{
          return 191980
        }
      }else{
       if(searchData.duration==2){
          return 191953
        }if(searchData.duration==3){
          return 191974
        }else if(searchData.duration==4){
          return 191977
        }else if(searchData.duration==5){
          return 191980
        }else{
          return 191980
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
       if(searchData.duration==2){
          return 192008
        }if(searchData.duration==3){
          return 192068
        }else if(searchData.duration==4){
          return 192070
        }else if(searchData.duration==5){
          return 192072
        }else{
          return 192072
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==2){
          return 192008
        }if(searchData.duration==3){
          return 192068
        }else if(searchData.duration==4){
          return 192070
        }else if(searchData.duration==5){
          return 192072
        }else{
          return 192072
        }
      }else if(searchData.type=="Family without kids"){
       if(searchData.duration==2){
          return 192008
        }if(searchData.duration==3){
          return 192068
        }else if(searchData.duration==4){
          return 192070
        }else if(searchData.duration==5){
          return 192072
        }else{
          return 192072
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==2){
          return 192008
        }if(searchData.duration==3){
          return 192068
        }else if(searchData.duration==4){
          return 192070
        }else if(searchData.duration==5){
          return 192072
        }else{
          return 192072
        }
      }else if(searchData.type=="Adventure junkies"){
        if(searchData.duration==2){
          return 192008
        }if(searchData.duration==3){
          return 192068
        }else if(searchData.duration==4){
          return 192070
        }else if(searchData.duration==5){
          return 192072
        }else{
          return 192072
        }
      }else{
       if(searchData.duration==2){
          return 192008
        }if(searchData.duration==3){
          return 192068
        }else if(searchData.duration==4){
          return 192070
        }else if(searchData.duration==5){
          return 192072
        }else{
          return 192072
        }
      }
    }else if(searchData.budget=="High"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==2){
          return 192095
        }if(searchData.duration==3){
          return 192099
        }else if(searchData.duration==4){
          return 192100
        }else if(searchData.duration==5){
          return 192101
        }else{
          return 192101
        }
      }else if(searchData.type=="Family with kids"){
        if(searchData.duration==2){
          return 192095
        }if(searchData.duration==3){
          return 192099
        }else if(searchData.duration==4){
          return 192100
        }else if(searchData.duration==5){
          return 192101
        }else{
          return 192101
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==2){
          return 192095
        }if(searchData.duration==3){
          return 192099
        }else if(searchData.duration==4){
          return 192100
        }else if(searchData.duration==5){
          return 192101
        }else{
          return 192101
        }
      }else if(searchData.type=="Party lovers"){
        if(searchData.duration==2){
          return 192095
        }if(searchData.duration==3){
          return 192099
        }else if(searchData.duration==4){
          return 192100
        }else if(searchData.duration==5){
          return 192101
        }else{
          return 192101
        }
      }else if(searchData.type=="Adventure junkies"){
       if(searchData.duration==2){
          return 192095
        }if(searchData.duration==3){
          return 192099
        }else if(searchData.duration==4){
          return 192100
        }else if(searchData.duration==5){
          return 192101
        }else{
          return 192101
        }
      }else{
       if(searchData.duration==2){
          return 192095
        }if(searchData.duration==3){
          return 192099
        }else if(searchData.duration==4){
          return 192100
        }else if(searchData.duration==5){
          return 192101
        }else{
          return 192101
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
       if(searchData.duration==2){
          return 192120
        }if(searchData.duration==3){
          return 192162
        }else if(searchData.duration==4){
          return 192169
        }else if(searchData.duration==5){
          return 192171
        }else{
          return 192171
        }
      }else if(searchData.type=="Family with kids"){
       if(searchData.duration==2){
          return 192120
        }if(searchData.duration==3){
          return 192162
        }else if(searchData.duration==4){
          return 192169
        }else if(searchData.duration==5){
          return 192171
        }else{
          return 192171
        }
      }else if(searchData.type=="Family without kids"){
        if(searchData.duration==2){
          return 192120
        }if(searchData.duration==3){
          return 192162
        }else if(searchData.duration==4){
          return 192169
        }else if(searchData.duration==5){
          return 192171
        }else{
          return 192171
        }
      }else if(searchData.type=="Party lovers"){
         if(searchData.duration==2){
          return 192120
        }if(searchData.duration==3){
          return 192162
        }else if(searchData.duration==4){
          return 192169
        }else if(searchData.duration==5){
          return 192171
        }else{
          return 192171
        }
      }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==2){
          return 192120
        }if(searchData.duration==3){
          return 192162
        }else if(searchData.duration==4){
          return 192169
        }else if(searchData.duration==5){
          return 192171
        }else{
          return 192171
        }
      }else{
         if(searchData.duration==2){
          return 192120
        }if(searchData.duration==3){
          return 192162
        }else if(searchData.duration==4){
          return 192169
        }else if(searchData.duration==5){
          return 192171
        }else{
          return 192171
        }
      }
    }
   

  }else if(searchData.dest=="Philippines"){
   if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==4){
            return 209201
          }else if(searchData.duration==5){
            return 209202
          }else if(searchData.duration==6){
            return 209204
          }else{
            return 209204
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 209207
          }else if(searchData.duration==5){
            return 209209
          }else if(searchData.duration==6){
            return 209211
          }else{
            return 209211
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 209399
          }else if(searchData.duration==5){
            return 209395
          }else if(searchData.duration==6){
            return 209431
          }else{
            return 209431
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 209186
          }else if(searchData.duration==5){
            return 209187
          }else if(searchData.duration==6){
            return 209196
          }else{
            return 209196
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 209446
          }else if(searchData.duration==5){
            return 209455
          }else if(searchData.duration==6){
            return 209456
          }else{
            return 209456
          }
        }else{
          if(searchData.duration==4){
            return 209171
          }else if(searchData.duration==5){
            return 209178
          }else if(searchData.duration==6){
            return 209183
          }else{
            return 209183
          }
        }
      }else if(searchData.budget=="Low"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==4){
            return 209480
          }else if(searchData.duration==5){
            return 209482
          }else if(searchData.duration==6){
            return 209483
          }else{
            return 209483
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 209485
          }else if(searchData.duration==5){
            return 209486
          }else if(searchData.duration==6){
            return 209489
          }else{
            return 209489
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 209492
          }else if(searchData.duration==5){
            return 209494
          }else if(searchData.duration==6){
            return 209495
          }else{
            return 209495
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 209477
          }else if(searchData.duration==5){
            return 209478
          }else if(searchData.duration==6){
            return 209479
          }else{
            return 209479
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 209497
          }else if(searchData.duration==5){
            return 209499
          }else if(searchData.duration==6){
            return 209500
          }else{
            return 209500
          }
        }else{
          if(searchData.duration==4){
            return 209462
          }else if(searchData.duration==5){
            return 209465
          }else if(searchData.duration==6){
            return 209475
          }else{
            return 209475
          }
        }
      }else if(searchData.budget=="Medium"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==4){
            return 209522
          }else if(searchData.duration==5){
            return 209523
          }else if(searchData.duration==6){
            return 209525
          }else{
            return 209525
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 209526
          }else if(searchData.duration==5){
            return 209528
          }else if(searchData.duration==6){
            return 209550
          }else{
            return 209550
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 209551
          }else if(searchData.duration==5){
            return 209552
          }else if(searchData.duration==6){
            return 209553
          }else{
            return 209553
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 209518
          }else if(searchData.duration==5){
            return 209520
          }else if(searchData.duration==6){
            return 209521
          }else{
            return 209521
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 209554
          }else if(searchData.duration==5){
            return 209555
          }else if(searchData.duration==6){
            return 209556
          }else{
            return 209556
          }
        }else{
          if(searchData.duration==4){
            return 209511
          }else if(searchData.duration==5){
            return 209512
          }else if(searchData.duration==6){
            return 209515
          }else{
            return 209515
          }
        }
      }else if(searchData.budget=="High"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==4){
            return 209586
          }else if(searchData.duration==5){
            return 209588
          }else if(searchData.duration==6){
            return 209589
          }else{
            return 209589
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 209590
          }else if(searchData.duration==5){
            return 209591
          }else if(searchData.duration==6){
            return 209594
          }else{
            return 209594
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 209595
          }else if(searchData.duration==5){
            return 209597
          }else if(searchData.duration==6){
            return 209598
          }else{
            return 209598
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 209580
          }else if(searchData.duration==5){
            return 209583
          }else if(searchData.duration==6){
            return 209585
          }else{
            return 209585
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 209599
          }else if(searchData.duration==5){
            return 209600
          }else if(searchData.duration==6){
            return 209601
          }else{
            return 209601
          }
        }else{
          if(searchData.duration==4){
            return 209577
          }else if(searchData.duration==5){
            return 209578
          }else if(searchData.duration==6){
            return 209579
          }else{
            return 209579
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==4){
            return 209616
          }else if(searchData.duration==5){
            return 209617
          }else if(searchData.duration==6){
            return 209618
          }else{
            return 209618
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==4){
            return 209619
          }else if(searchData.duration==5){
            return 209620
          }else if(searchData.duration==6){
            return 209621
          }else{
            return 209621
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==4){
            return 209622
          }else if(searchData.duration==5){
            return 209623
          }else if(searchData.duration==6){
            return 209625
          }else{
            return 209625
          }
        }else if(searchData.type=="Party lovers"){
          if(searchData.duration==4){
            return 209610
          }else if(searchData.duration==5){
            return 209612
          }else if(searchData.duration==6){
            return 209614
          }else{
            return 209614
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==4){
            return 209628
          }else if(searchData.duration==5){
            return 209629
          }else if(searchData.duration==6){
            return 209630
          }else{
            return 209630
          }
        }else{
          if(searchData.duration==4){
            return 209604
          }else if(searchData.duration==5){
            return 209606
          }else if(searchData.duration==6){
            return 209609
          }else{
            return 209609
          }
        }
      }
  }else if(searchData.dest=="Goa"){
   if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==2){
            return 212066
          }else if(searchData.duration==3){
            return 212067
          }else if(searchData.duration==4){
            return 212070
          }else if(searchData.duration==5){
            return 212072
          }else if(searchData.duration==6){
            return 212073
          }else{
            return 212073
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 205209
          }else if(searchData.duration==3){
            return 205210
          }else if(searchData.duration==4){
            return 205211
          }else if(searchData.duration==5){
            return 205212
          }else if(searchData.duration==6){
            return 205213
          }else{
            return 205213
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 205197
          }else if(searchData.duration==3){
            return 205199
          }else if(searchData.duration==4){
            return 205201
          }else if(searchData.duration==5){
            return 205202
          }else if(searchData.duration==6){
            return 205203
          }else{
            return 205203
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 205097
          }else if(searchData.duration==3){
            return 205098
          }else if(searchData.duration==4){
            return 205115
          }else if(searchData.duration==5){
            return 205117
          }else if(searchData.duration==6){
            return 205124
          }else{
            return 205124
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 205190
          }else if(searchData.duration==3){
            return 205191
          }else if(searchData.duration==4){
            return 205193
          }else if(searchData.duration==5){
            return 205195
          }else if(searchData.duration==6){
            return 205196
          }else{
            return 205196
          }
        }else{
           if(searchData.duration==2){
            return 205214
          }else if(searchData.duration==3){
            return 205215
          }else if(searchData.duration==4){
            return 205216
          }else if(searchData.duration==5){
            return 205217
          }else if(searchData.duration==6){
            return 205218
          }else{
            return 205218
          }
        }
      }else if(searchData.budget=="Low"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==2){
            return 212075
          }else if(searchData.duration==3){
            return 212076
          }else if(searchData.duration==4){
            return 212078
          }else if(searchData.duration==5){
            return 212080
          }else if(searchData.duration==6){
            return 212082
          }else{
            return 212082
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 205240
          }else if(searchData.duration==3){
            return 205241
          }else if(searchData.duration==4){
            return 205244
          }else if(searchData.duration==5){
            return 205246
          }else if(searchData.duration==6){
            return 205247
          }else{
            return 205247
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 205248
          }else if(searchData.duration==3){
            return 205256
          }else if(searchData.duration==4){
            return 205258
          }else if(searchData.duration==5){
            return 205259
          }else if(searchData.duration==6){
            return 205260
          }else{
            return 205260
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 205125
          }else if(searchData.duration==3){
            return 205130
          }else if(searchData.duration==4){
            return 205132
          }else if(searchData.duration==5){
            return 205133
          }else if(searchData.duration==6){
            return 205134
          }else{
            return 205134
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 205232
          }else if(searchData.duration==3){
            return 205233
          }else if(searchData.duration==4){
            return 205234
          }else if(searchData.duration==5){
            return 205235
          }else if(searchData.duration==6){
            return 205236
          }else{
            return 205236
          }
        }else{
           if(searchData.duration==2){
            return 205281
          }else if(searchData.duration==3){
            return 205283
          }else if(searchData.duration==4){
            return 205285
          }else if(searchData.duration==5){
            return 205287
          }else if(searchData.duration==6){
            return 205288
          }else{
            return 205288
          }
        }
      }else if(searchData.budget=="Medium"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==2){
            return 212084
          }else if(searchData.duration==3){
            return 212085
          }else if(searchData.duration==4){
            return 212087
          }else if(searchData.duration==5){
            return 212089
          }else if(searchData.duration==6){
            return 212090
          }else{
            return 212090
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 205306
          }else if(searchData.duration==3){
            return 205308
          }else if(searchData.duration==4){
            return 205310
          }else if(searchData.duration==5){
            return 205312
          }else if(searchData.duration==6){
            return 205313
          }else{
            return 205313
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 205332
          }else if(searchData.duration==3){
            return 205346
          }else if(searchData.duration==4){
            return 205348
          }else if(searchData.duration==5){
            return 205349
          }else if(searchData.duration==6){
            return 205352
          }else{
            return 205352
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 205146
          }else if(searchData.duration==3){
            return 205148
          }else if(searchData.duration==4){
            return 205149
          }else if(searchData.duration==5){
            return 205151
          }else if(searchData.duration==6){
            return 205155
          }else{
            return 205155
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 205291
          }else if(searchData.duration==3){
            return 205293
          }else if(searchData.duration==4){
            return 205301
          }else if(searchData.duration==5){
            return 205302
          }else if(searchData.duration==6){
            return 205304
          }else{
            return 205304
          }
        }else{
           if(searchData.duration==2){
            return 205318
          }else if(searchData.duration==3){
            return 205321
          }else if(searchData.duration==4){
            return 205325
          }else if(searchData.duration==5){
            return 205328
          }else if(searchData.duration==6){
            return 205329
          }else{
            return 205329
          }
        }
      }else if(searchData.budget=="High"){
       if(searchData.type=="Romantic"){
          if(searchData.duration==2){
            return 212093
          }else if(searchData.duration==3){
            return 212094
          }else if(searchData.duration==4){
            return 212096
          }else if(searchData.duration==5){
            return 212098
          }else if(searchData.duration==6){
            return 212099
          }else{
            return 212099
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 205362
          }else if(searchData.duration==3){
            return 205364
          }else if(searchData.duration==4){
            return 205368
          }else if(searchData.duration==5){
            return 205370
          }else if(searchData.duration==6){
            return 205371
          }else{
            return 205371
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 205372
          }else if(searchData.duration==3){
            return 205379
          }else if(searchData.duration==4){
            return 205381
          }else if(searchData.duration==5){
            return 205383
          }else if(searchData.duration==6){
            return 205384
          }else{
            return 205384
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 205161
          }else if(searchData.duration==3){
            return 205162
          }else if(searchData.duration==4){
            return 205164
          }else if(searchData.duration==5){
            return 205165
          }else if(searchData.duration==6){
            return 205173
          }else{
            return 205173
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 205354
          }else if(searchData.duration==3){
            return 205355
          }else if(searchData.duration==4){
            return 205359
          }else if(searchData.duration==5){
            return 205360
          }else if(searchData.duration==6){
            return 205361
          }else{
            return 205361
          }
        }else{
           if(searchData.duration==2){
            return 205386
          }else if(searchData.duration==3){
            return 205387
          }else if(searchData.duration==4){
            return 205401
          }else if(searchData.duration==5){
            return 205402
          }else if(searchData.duration==6){
            return 205403
          }else{
            return 205403
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
          if(searchData.duration==2){
            return 212100
          }else if(searchData.duration==3){
            return 212101
          }else if(searchData.duration==4){
            return 212102
          }else if(searchData.duration==5){
            return 212104
          }else if(searchData.duration==6){
            return 212107
          }else{
            return 212107
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 205431
          }else if(searchData.duration==3){
            return 205433
          }else if(searchData.duration==4){
            return 205434
          }else if(searchData.duration==5){
            return 205436
          }else if(searchData.duration==6){
            return 205437
          }else{
            return 205437
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 205424
          }else if(searchData.duration==3){
            return 205426
          }else if(searchData.duration==4){
            return 205427
          }else if(searchData.duration==5){
            return 205428
          }else if(searchData.duration==6){
            return 205429
          }else{
            return 205429
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 205177
          }else if(searchData.duration==3){
            return 205179
          }else if(searchData.duration==4){
            return 205181
          }else if(searchData.duration==5){
            return 205183
          }else if(searchData.duration==6){
            return 205185
          }else{
            return 205185
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 205413
          }else if(searchData.duration==3){
            return 212111
          }else if(searchData.duration==4){
            return 205415
          }else if(searchData.duration==5){
            return 205418
          }else if(searchData.duration==6){
            return 205423
          }else{
            return 205423
          }
        }else{
           if(searchData.duration==2){
            return 205440
          }else if(searchData.duration==3){
            return 205441
          }else if(searchData.duration==4){
            return 205444
          }else if(searchData.duration==5){
            return 205454
          }else if(searchData.duration==6){
            return 205455
          }else{
            return 205455
          }
        }
      }
  }else if(searchData.dest=="Meghalaya"){
    if(searchData.special=="Kaziranga"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==2){
            return 220427
          }else if(searchData.duration==3){
            return 220428
          }else if(searchData.duration==4){
            return 220429
          }else if(searchData.duration==5){
            return 220431
          }else if(searchData.duration==6){
            return 220435
          }else{
            return 220435
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 220437
          }else if(searchData.duration==3){
            return 220438
          }else if(searchData.duration==4){
            return 220439
          }else if(searchData.duration==5){
            return 220441
          }else if(searchData.duration==6){
            return 220443
          }else{
            return 220443
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220445
          }else if(searchData.duration==3){
            return 220446
          }else if(searchData.duration==4){
            return 220447
          }else if(searchData.duration==5){
            return 220451
          }else if(searchData.duration==6){
            return 220453
          }else{
            return 220453
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 220406
          }else if(searchData.duration==3){
            return 220407
          }else if(searchData.duration==4){
            return 220408
          }else if(searchData.duration==5){
            return 220411
          }else if(searchData.duration==6){
            return 220414
          }else{
            return 220414
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220417
          }else if(searchData.duration==3){
            return 220418
          }else if(searchData.duration==4){
            return 220419
          }else if(searchData.duration==5){
            return 220422
          }else if(searchData.duration==6){
            return 220424
          }else{
            return 220424
          }
        }else{
           if(searchData.duration==2){
            return 220455
          }else if(searchData.duration==3){
            return 220456
          }else if(searchData.duration==4){
            return 220459
          }else if(searchData.duration==5){
            return 220463
          }else if(searchData.duration==6){
            return 220466
          }else{
            return 220466
          }
        }
      }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
           if(searchData.duration==2){
            return 220516
          }else if(searchData.duration==3){
            return 220517
          }else if(searchData.duration==4){
            return 220518
          }else if(searchData.duration==5){
            return 220520
          }else if(searchData.duration==6){
            return 220522
          }else{
            return 220522
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 220524
          }else if(searchData.duration==3){
            return 220525
          }else if(searchData.duration==4){
            return 220529
          }else if(searchData.duration==5){
            return 220530
          }else if(searchData.duration==6){
            return 220532
          }else{
            return 220532
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220534
          }else if(searchData.duration==3){
            return 220535
          }else if(searchData.duration==4){
            return 220537
          }else if(searchData.duration==5){
            return 220540
          }else if(searchData.duration==6){
            return 220543
          }else{
            return 220543
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 220485
          }else if(searchData.duration==3){
            return 220492
          }else if(searchData.duration==4){
            return 220496
          }else if(searchData.duration==5){
            return 220498
          }else if(searchData.duration==6){
            return 220499
          }else{
            return 220499
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220505
          }else if(searchData.duration==3){
            return 220506
          }else if(searchData.duration==4){
            return 220508
          }else if(searchData.duration==5){
            return 220510
          }else if(searchData.duration==6){
            return 220513
          }else{
            return 220513
          }
        }else{
           if(searchData.duration==2){
            return 220547
          }else if(searchData.duration==3){
            return 220548
          }else if(searchData.duration==4){
            return 220549
          }else if(searchData.duration==5){
            return 220552
          }else if(searchData.duration==6){
            return 220554
          }else{
            return 220554
          }
        }
      }else if(searchData.budget=="Medium"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==2){
            return 220565
          }else if(searchData.duration==3){
            return 220566
          }else if(searchData.duration==4){
            return 220567
          }else if(searchData.duration==5){
            return 220574
          }else if(searchData.duration==6){
            return 220576
          }else{
            return 220576
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 220578
          }else if(searchData.duration==3){
            return 220580
          }else if(searchData.duration==4){
            return 220581
          }else if(searchData.duration==5){
            return 220585
          }else if(searchData.duration==6){
            return 220588
          }else{
            return 220588
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220590
          }else if(searchData.duration==3){
            return 220591
          }else if(searchData.duration==4){
            return 220593
          }else if(searchData.duration==5){
            return 220596
          }else if(searchData.duration==6){
            return 220598
          }else{
            return 220598
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 199383
          }else if(searchData.duration==3){
            return 199385
          }else if(searchData.duration==4){
            return 199389
          }else if(searchData.duration==5){
            return 199398
          }else if(searchData.duration==6){
            return 199414
          }else{
            return 199414
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220557
          }else if(searchData.duration==3){
            return 220558
          }else if(searchData.duration==4){
            return 220559
          }else if(searchData.duration==5){
            return 220561
          }else if(searchData.duration==6){
            return 220563
          }else{
            return 220563
          }
        }else{
           if(searchData.duration==2){
            return 220600
          }else if(searchData.duration==3){
            return 220601
          }else if(searchData.duration==4){
            return 220604
          }else if(searchData.duration==5){
            return 220606
          }else if(searchData.duration==6){
            return 220609
          }else{
            return 220609
          }
        }
      }else if(searchData.budget=="High"){
       if(searchData.type=="Romantic"){
          if(searchData.duration==2){
            return 220621
          }else if(searchData.duration==3){
            return 220622
          }else if(searchData.duration==4){
            return 220623
          }else if(searchData.duration==5){
            return 220625
          }else if(searchData.duration==6){
            return 220628
          }else{
            return 220628
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==2){
            return 220630
          }else if(searchData.duration==3){
            return 220631
          }else if(searchData.duration==4){
            return 220632
          }else if(searchData.duration==5){
            return 220635
          }else if(searchData.duration==6){
            return 220637
          }else{
            return 220637
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220640
          }else if(searchData.duration==3){
            return 220641
          }else if(searchData.duration==4){
            return 220642
          }else if(searchData.duration==5){
            return 220644
          }else if(searchData.duration==6){
            return 220646
          }else{
            return 220646
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 199427
          }else if(searchData.duration==3){
            return 199429
          }else if(searchData.duration==4){
            return 199432
          }else if(searchData.duration==5){
            return 199438
          }else if(searchData.duration==6){
            return 199446
          }else{
            return 199446
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220612
          }else if(searchData.duration==3){
            return 220613
          }else if(searchData.duration==4){
            return 220614
          }else if(searchData.duration==5){
            return 220616
          }else if(searchData.duration==6){
            return 220619
          }else{
            return 220619
          }
        }else{
            if(searchData.duration==2){
            return 220648
          }else if(searchData.duration==3){
            return 220649
          }else if(searchData.duration==4){
            return 220651
          }else if(searchData.duration==5){
            return 220654
          }else if(searchData.duration==6){
            return 220656
          }else{
            return 220656
          }
        }
      }else if(searchData.budget=="Luxury"){
       if(searchData.type=="Romantic"){
          if(searchData.duration==2){
            return 220621
          }else if(searchData.duration==3){
            return 220622
          }else if(searchData.duration==4){
            return 220623
          }else if(searchData.duration==5){
            return 220625
          }else if(searchData.duration==6){
            return 220628
          }else{
            return 220628
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==2){
            return 220630
          }else if(searchData.duration==3){
            return 220631
          }else if(searchData.duration==4){
            return 220632
          }else if(searchData.duration==5){
            return 220635
          }else if(searchData.duration==6){
            return 220637
          }else{
            return 220637
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220640
          }else if(searchData.duration==3){
            return 220641
          }else if(searchData.duration==4){
            return 220642
          }else if(searchData.duration==5){
            return 220644
          }else if(searchData.duration==6){
            return 220646
          }else{
            return 220646
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 199427
          }else if(searchData.duration==3){
            return 199429
          }else if(searchData.duration==4){
            return 199432
          }else if(searchData.duration==5){
            return 199438
          }else if(searchData.duration==6){
            return 199446
          }else{
            return 199446
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220612
          }else if(searchData.duration==3){
            return 220613
          }else if(searchData.duration==4){
            return 220614
          }else if(searchData.duration==5){
            return 220616
          }else if(searchData.duration==6){
            return 220619
          }else{
            return 220619
          }
        }else{
            if(searchData.duration==2){
            return 220648
          }else if(searchData.duration==3){
            return 220649
          }else if(searchData.duration==4){
            return 220651
          }else if(searchData.duration==5){
            return 220654
          }else if(searchData.duration==6){
            return 220656
          }else{
            return 220656
          }
        }
      }
    }else{
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==2){
            return 220427
          }else if(searchData.duration==3){
            return 220428
          }else if(searchData.duration==4){
            return 220429
          }else if(searchData.duration==5){
            return 220430
          }else if(searchData.duration==6){
            return 220433
          }else{
            return 220433
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 220437
          }else if(searchData.duration==3){
            return 220438
          }else if(searchData.duration==4){
            return 220439
          }else if(searchData.duration==5){
            return 220440
          }else if(searchData.duration==6){
            return 220442
          }else{
            return 220442
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220445
          }else if(searchData.duration==3){
            return 220446
          }else if(searchData.duration==4){
            return 220447
          }else if(searchData.duration==5){
            return 220449
          }else if(searchData.duration==6){
            return 220452
          }else{
            return 220452
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 220406
          }else if(searchData.duration==3){
            return 220407
          }else if(searchData.duration==4){
            return 220408
          }else if(searchData.duration==5){
            return 220410
          }else if(searchData.duration==6){
            return 220412
          }else{
            return 220412
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220417
          }else if(searchData.duration==3){
            return 220418
          }else if(searchData.duration==4){
            return 220419
          }else if(searchData.duration==5){
            return 220420
          }else if(searchData.duration==6){
            return 220423
          }else{
            return 220423
          }
        }else{
           if(searchData.duration==2){
            return 220455
          }else if(searchData.duration==3){
            return 220456
          }else if(searchData.duration==4){
            return 220459
          }else if(searchData.duration==5){
            return 220462
          }else if(searchData.duration==6){
            return 220464
          }else{
            return 220464
          }
        }
      }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
           if(searchData.duration==2){
            return 220516
          }else if(searchData.duration==3){
            return 220517
          }else if(searchData.duration==4){
            return 220518
          }else if(searchData.duration==5){
            return 220519
          }else if(searchData.duration==6){
            return 220521
          }else{
            return 220521
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 220524
          }else if(searchData.duration==3){
            return 220525
          }else if(searchData.duration==4){
            return 220529
          }else if(searchData.duration==5){
            return 220526
          }else if(searchData.duration==6){
            return 220531
          }else{
            return 220531
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220534
          }else if(searchData.duration==3){
            return 220535
          }else if(searchData.duration==4){
            return 220537
          }else if(searchData.duration==5){
            return 220539
          }else if(searchData.duration==6){
            return 220542
          }else{
            return 220542
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 220485
          }else if(searchData.duration==3){
            return 220492
          }else if(searchData.duration==4){
            return 220496
          }else if(searchData.duration==5){
            return 220497
          }else if(searchData.duration==6){
            return 220500
          }else{
            return 220500
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220505
          }else if(searchData.duration==3){
            return 220506
          }else if(searchData.duration==4){
            return 220508
          }else if(searchData.duration==5){
            return 220509
          }else if(searchData.duration==6){
            return 220511
          }else{
            return 220511
          }
        }else{
           if(searchData.duration==2){
            return 220547
          }else if(searchData.duration==3){
            return 220548
          }else if(searchData.duration==4){
            return 220549
          }else if(searchData.duration==5){
            return 220551
          }else if(searchData.duration==6){
            return 220553
          }else{
            return 220553
          }
        }
      }else if(searchData.budget=="Medium"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==2){
            return 220565
          }else if(searchData.duration==3){
            return 220566
          }else if(searchData.duration==4){
            return 220567
          }else if(searchData.duration==5){
            return 220572
          }else if(searchData.duration==6){
            return 220575
          }else{
            return 220575
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==2){
            return 220578
          }else if(searchData.duration==3){
            return 220580
          }else if(searchData.duration==4){
            return 220581
          }else if(searchData.duration==5){
            return 220584
          }else if(searchData.duration==6){
            return 220586
          }else{
            return 220586
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220590
          }else if(searchData.duration==3){
            return 220591
          }else if(searchData.duration==4){
            return 220593
          }else if(searchData.duration==5){
            return 220595
          }else if(searchData.duration==6){
            return 220586
          }else{
            return 220586
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 199383
          }else if(searchData.duration==3){
            return 199385
          }else if(searchData.duration==4){
            return 199389
          }else if(searchData.duration==5){
            return 199393
          }else if(searchData.duration==6){
            return 199403
          }else{
            return 199403
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220557
          }else if(searchData.duration==3){
            return 220558
          }else if(searchData.duration==4){
            return 220559
          }else if(searchData.duration==5){
            return 220560
          }else if(searchData.duration==6){
            return 220562
          }else{
            return 220562
          }
        }else{
           if(searchData.duration==2){
            return 220600
          }else if(searchData.duration==3){
            return 220601
          }else if(searchData.duration==4){
            return 220604
          }else if(searchData.duration==5){
            return 220605
          }else if(searchData.duration==6){
            return 220607
          }else{
            return 220607
          }
        }
      }else if(searchData.budget=="High"){
       if(searchData.type=="Romantic"){
          if(searchData.duration==2){
            return 220621
          }else if(searchData.duration==3){
            return 220622
          }else if(searchData.duration==4){
            return 220623
          }else if(searchData.duration==5){
            return 220624
          }else if(searchData.duration==6){
            return 220626
          }else{
            return 220626
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==2){
            return 220630
          }else if(searchData.duration==3){
            return 220631
          }else if(searchData.duration==4){
            return 220632
          }else if(searchData.duration==5){
            return 220634
          }else if(searchData.duration==6){
            return 220636
          }else{
            return 220636
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220640
          }else if(searchData.duration==3){
            return 220641
          }else if(searchData.duration==4){
            return 220642
          }else if(searchData.duration==5){
            return 220643
          }else if(searchData.duration==6){
            return 220645
          }else{
            return 220645
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 199427
          }else if(searchData.duration==3){
            return 199429
          }else if(searchData.duration==4){
            return 199432
          }else if(searchData.duration==5){
            return 199434
          }else if(searchData.duration==6){
            return 199445
          }else{
            return 199445
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220612
          }else if(searchData.duration==3){
            return 220613
          }else if(searchData.duration==4){
            return 220614
          }else if(searchData.duration==5){
            return 220615
          }else if(searchData.duration==6){
            return 220617
          }else{
            return 220617
          }
        }else{
            if(searchData.duration==2){
            return 220648
          }else if(searchData.duration==3){
            return 220649
          }else if(searchData.duration==4){
            return 220651
          }else if(searchData.duration==5){
            return 220653
          }else if(searchData.duration==6){
            return 220655
          }else{
            return 220655
          }
        }
      }else if(searchData.budget=="Luxury"){
       if(searchData.type=="Romantic"){
          if(searchData.duration==2){
            return 220621
          }else if(searchData.duration==3){
            return 220622
          }else if(searchData.duration==4){
            return 220623
          }else if(searchData.duration==5){
            return 220624
          }else if(searchData.duration==6){
            return 220626
          }else{
            return 220626
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==2){
            return 220630
          }else if(searchData.duration==3){
            return 220631
          }else if(searchData.duration==4){
            return 220632
          }else if(searchData.duration==5){
            return 220634
          }else if(searchData.duration==6){
            return 220636
          }else{
            return 220636
          }
        }else if(searchData.type=="Family without kids"){
           if(searchData.duration==2){
            return 220640
          }else if(searchData.duration==3){
            return 220641
          }else if(searchData.duration==4){
            return 220642
          }else if(searchData.duration==5){
            return 220643
          }else if(searchData.duration==6){
            return 220645
          }else{
            return 220645
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==2){
            return 199427
          }else if(searchData.duration==3){
            return 199429
          }else if(searchData.duration==4){
            return 199432
          }else if(searchData.duration==5){
            return 199434
          }else if(searchData.duration==6){
            return 199445
          }else{
            return 199445
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==2){
            return 220612
          }else if(searchData.duration==3){
            return 220613
          }else if(searchData.duration==4){
            return 220614
          }else if(searchData.duration==5){
            return 220615
          }else if(searchData.duration==6){
            return 220617
          }else{
            return 220617
          }
        }else{
            if(searchData.duration==2){
            return 220648
          }else if(searchData.duration==3){
            return 220649
          }else if(searchData.duration==4){
            return 220651
          }else if(searchData.duration==5){
            return 220653
          }else if(searchData.duration==6){
            return 220655
          }else{
            return 220655
          }
        }
      }
    }
  }else if(searchData.dest=="Arunachal Pradesh"){
      if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==5){
            return 220071
          }else if(searchData.duration==6){
            return 220072
          }else if(searchData.duration==7){
            return 220073
          }else if(searchData.duration==8){
            return 220074
          }else if(searchData.duration==10){
            return 220075
          }else{
            return 220075
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 220076
          }else if(searchData.duration==6){
            return 220077
          }else if(searchData.duration==7){
            return 220079
          }else if(searchData.duration==8){
            return 220080
          }else if(searchData.duration==10){
            return 220082
          }else{
            return 220082
          }
        }else if(searchData.type=="Family without kids"){
             if(searchData.duration==5){
            return 220084
          }else if(searchData.duration==6){
            return 220085
          }else if(searchData.duration==7){
            return 220086
          }else if(searchData.duration==8){
            return 220087
          }else if(searchData.duration==10){
            return 220088
          }else{
            return 220088
          }
        }else if(searchData.type=="Party lovers"){
        if(searchData.duration==5){
            return 220071
          }else if(searchData.duration==6){
            return 220072
          }else if(searchData.duration==7){
            return 220073
          }else if(searchData.duration==8){
            return 220074
          }else if(searchData.duration==10){
            return 220075
          }else{
            return 220075
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==5){
            return 220053
          }else if(searchData.duration==6){
            return 220054
          }else if(searchData.duration==7){
            return 220055
          }else if(searchData.duration==8){
            return 220056
          }else if(searchData.duration==10){
            return 220058
          }else{
            return 220058
          }
        }else{
           if(searchData.duration==5){
            return 220089
          }else if(searchData.duration==6){
            return 220090
          }else if(searchData.duration==7){
            return 220091
          }else if(searchData.duration==8){
            return 220087
          }else if(searchData.duration==10){
            return 220101
          }else{
            return 220101
          }
        }
      }else if(searchData.budget=="Low"){
      if(searchData.type=="Romantic"){
           if(searchData.duration==5){
            return 220144
          }else if(searchData.duration==6){
            return 220145
          }else if(searchData.duration==7){
            return 220147
          }else if(searchData.duration==8){
            return 220149
          }else if(searchData.duration==10){
            return 220151
          }else{
            return 220151
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 220152
          }else if(searchData.duration==6){
            return 220153
          }else if(searchData.duration==7){
            return 220154
          }else if(searchData.duration==8){
            return 220155
          }else if(searchData.duration==10){
            return 220157
          }else{
            return 220157
          }
        }else if(searchData.type=="Family without kids"){
             if(searchData.duration==5){
            return 220162
          }else if(searchData.duration==6){
            return 220163
          }else if(searchData.duration==7){
            return 220165
          }else if(searchData.duration==8){
            return 220166
          }else if(searchData.duration==10){
            return 220168
          }else{
            return 220168
          }
        }else if(searchData.type=="Party lovers"){
        if(searchData.duration==5){
            return 220071
          }else if(searchData.duration==6){
            return 220072
          }else if(searchData.duration==7){
            return 220073
          }else if(searchData.duration==8){
            return 220074
          }else if(searchData.duration==10){
            return 220075
          }else{
            return 220075
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==5){
            return 220102
          }else if(searchData.duration==6){
            return 220104
          }else if(searchData.duration==7){
            return 220105
          }else if(searchData.duration==8){
            return 220106
          }else if(searchData.duration==10){
            return 220107
          }else{
            return 220107
          }
        }else{
           if(searchData.duration==5){
            return 220171
          }else if(searchData.duration==6){
            return 220172
          }else if(searchData.duration==7){
            return 220174
          }else if(searchData.duration==8){
            return 220176
          }else if(searchData.duration==10){
            return 220177
          }else{
            return 220177
          }
        }
      }else if(searchData.budget=="Medium"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==5){
            return 220185
          }else if(searchData.duration==6){
            return 220187
          }else if(searchData.duration==7){
            return 220188
          }else if(searchData.duration==8){
            return 220189
          }else if(searchData.duration==10){
            return 220189
          }else{
            return 220189
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 220192
          }else if(searchData.duration==6){
            return 220194
          }else if(searchData.duration==7){
            return 220195
          }else if(searchData.duration==8){
            return 220196
          }else if(searchData.duration==10){
            return 220197
          }else{
            return 220197
          }
        }else if(searchData.type=="Family without kids"){
             if(searchData.duration==5){
            return 220198
          }else if(searchData.duration==6){
            return 220199
          }else if(searchData.duration==7){
            return 220200
          }else if(searchData.duration==8){
            return 220201
          }else if(searchData.duration==10){
            return 220203
          }else{
            return 220203
          }
        }else if(searchData.type=="Party lovers"){
        if(searchData.duration==5){
            return 220113
          }else if(searchData.duration==6){
            return 220117
          }else if(searchData.duration==7){
            return 220119
          }else if(searchData.duration==8){
            return 220120
          }else if(searchData.duration==10){
            return 220121
          }else{
            return 220121
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==5){
            return 220180
          }else if(searchData.duration==6){
            return 220181
          }else if(searchData.duration==7){
            return 220182
          }else if(searchData.duration==8){
            return 220183
          }else if(searchData.duration==10){
            return 220184
          }else{
            return 220184
          }
        }else{
           if(searchData.duration==5){
            return 220204
          }else if(searchData.duration==6){
            return 220205
          }else if(searchData.duration==7){
            return 220206
          }else if(searchData.duration==8){
            return 220208
          }else if(searchData.duration==10){
            return 220210
          }else{
            return 220210
          }
        }
      }else if(searchData.budget=="High"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==5){
            return 220224
          }else if(searchData.duration==6){
            return 220225
          }else if(searchData.duration==7){
            return 220226
          }else if(searchData.duration==8){
            return 220228
          }else if(searchData.duration==10){
            return 220229
          }else{
            return 220229
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 220230
          }else if(searchData.duration==6){
            return 220233
          }else if(searchData.duration==7){
            return 220235
          }else if(searchData.duration==8){
            return 220236
          }else if(searchData.duration==10){
            return 220237
          }else{
            return 220237
          }
        }else if(searchData.type=="Family without kids"){
             if(searchData.duration==5){
            return 220238
          }else if(searchData.duration==6){
            return 220239
          }else if(searchData.duration==7){
            return 220240
          }else if(searchData.duration==8){
            return 220241
          }else if(searchData.duration==10){
            return 220242
          }else{
            return 220242
          }
        }else if(searchData.type=="Party lovers"){
        if(searchData.duration==5){
            return 220122
          }else if(searchData.duration==6){
            return 220124
          }else if(searchData.duration==7){
            return 220125
          }else if(searchData.duration==8){
            return 220126
          }else if(searchData.duration==10){
            return 220128
          }else{
            return 220128
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==5){
            return 220212
          }else if(searchData.duration==6){
            return 220213
          }else if(searchData.duration==7){
            return 220216
          }else if(searchData.duration==8){
            return 220220
          }else if(searchData.duration==10){
            return 220221
          }else{
            return 220221
          }
        }else{
           if(searchData.duration==5){
            return 220243
          }else if(searchData.duration==6){
            return 220244
          }else if(searchData.duration==7){
            return 220245
          }else if(searchData.duration==8){
            return 220246
          }else if(searchData.duration==10){
            return 220247
          }else{
            return 220247
          }
        }
      }else if(searchData.budget=="Luxury"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==5){
            return 220224
          }else if(searchData.duration==6){
            return 220225
          }else if(searchData.duration==7){
            return 220226
          }else if(searchData.duration==8){
            return 220228
          }else if(searchData.duration==10){
            return 220229
          }else{
            return 220229
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 220230
          }else if(searchData.duration==6){
            return 220233
          }else if(searchData.duration==7){
            return 220235
          }else if(searchData.duration==8){
            return 220236
          }else if(searchData.duration==10){
            return 220237
          }else{
            return 220237
          }
        }else if(searchData.type=="Family without kids"){
             if(searchData.duration==5){
            return 220238
          }else if(searchData.duration==6){
            return 220239
          }else if(searchData.duration==7){
            return 220240
          }else if(searchData.duration==8){
            return 220241
          }else if(searchData.duration==10){
            return 220242
          }else{
            return 220242
          }
        }else if(searchData.type=="Party lovers"){
        if(searchData.duration==5){
            return 220122
          }else if(searchData.duration==6){
            return 220124
          }else if(searchData.duration==7){
            return 220125
          }else if(searchData.duration==8){
            return 220126
          }else if(searchData.duration==10){
            return 220128
          }else{
            return 220128
          }
        }else if(searchData.type=="Adventure junkies"){
          if(searchData.duration==5){
            return 220212
          }else if(searchData.duration==6){
            return 220213
          }else if(searchData.duration==7){
            return 220216
          }else if(searchData.duration==8){
            return 220220
          }else if(searchData.duration==10){
            return 220221
          }else{
            return 220221
          }
        }else{
           if(searchData.duration==5){
            return 220243
          }else if(searchData.duration==6){
            return 220244
          }else if(searchData.duration==7){
            return 220245
          }else if(searchData.duration==8){
            return 220246
          }else if(searchData.duration==10){
            return 220247
          }else{
            return 220247
          }
        }
      }
  }else if(searchData.dest=="Himachal"){
     if(searchData.special=="Spiti Chandigarh"){
      if(searchData.type=="Cheapest"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 202395
          }else if(searchData.duration==6){
            return 202401
          }else if(searchData.duration==8){
            return 202412
          }else if(searchData.duration==9){
            return 201951
          }else if(searchData.duration==10){
            return 201948
          }else{
            return 202426
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221448
          }else if(searchData.duration==6){
            return 221450
          }else if(searchData.duration==8){
            return 221454
          }else if(searchData.duration==9){
            return 201951
          }else if(searchData.duration==10){
            return 221462
          }else{
            return 221462
          }
        }else if(searchData.type=="Family without kids"){
             if(searchData.duration==5){
            return 221484
          }else if(searchData.duration==6){
            return 221486
          }else if(searchData.duration==8){
            return 221488
          }else if(searchData.duration==9){
            return 201951
          }else if(searchData.duration==10){
            return 221495
          }else{
            return 221495
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 201907
          }else if(searchData.duration==6){
            return 201926
          }else if(searchData.duration==8){
            return 201943
          }else if(searchData.duration==9){
            return 201951
          }else if(searchData.duration==10){
            return 201977
          }else{
            return 201977
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 202346
          }else if(searchData.duration==6){
            return 202361
          }else if(searchData.duration==8){
            return 202365
          }else if(searchData.duration==9){
            return 201948
          }else if(searchData.duration==10){
            return 202375
          }else{
            return 202375
          }
        }else{
            if(searchData.duration==5){
            return 221510
          }else if(searchData.duration==6){
            return 221517
          }else if(searchData.duration==8){
            return 221520
          }else if(searchData.duration==9){
            return 201951
          }else if(searchData.duration==10){
            return 221530
          }else{
            return 221530
          }
        }
      }else if(searchData.type=="Low"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 202453
          }else if(searchData.duration==6){
            return 202456
          }else if(searchData.duration==8){
            return 202458
          }else if(searchData.duration==9){
            return 202464
          }else if(searchData.duration==10){
            return 202468
          }else{
            return 202468
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221544
          }else if(searchData.duration==6){
            return 221547
          }else if(searchData.duration==8){
            return 221550
          }else if(searchData.duration==9){
            return 221552
          }else if(searchData.duration==10){
            return 221559
          }else{
            return 221559
          }
        }else if(searchData.type=="Family without kids"){
             if(searchData.duration==5){
            return 221567
          }else if(searchData.duration==6){
            return 221569
          }else if(searchData.duration==8){
            return 221571
          }else if(searchData.duration==9){
            return 221573
          }else if(searchData.duration==10){
            return 221580
          }else{
            return 221580
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 202000
          }else if(searchData.duration==6){
            return 202005
          }else if(searchData.duration==8){
            return 202008
          }else if(searchData.duration==9){
            return 202012
          }else if(searchData.duration==10){
            return 202022
          }else{
            return 202022
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 202432
          }else if(searchData.duration==6){
            return 202437
          }else if(searchData.duration==8){
            return 202441
          }else if(searchData.duration==9){
            return 202444
          }else if(searchData.duration==10){
            return 202448
          }else{
            return 202448
          }
        }else{
            if(searchData.duration==5){
            return 221544
          }else if(searchData.duration==6){
            return 221547
          }else if(searchData.duration==8){
            return 221550
          }else if(searchData.duration==9){
            return 221552
          }else if(searchData.duration==10){
            return 221559
          }else{
            return 221559
          }
        }
      }else if(searchData.type=="Medium"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 202473
          }else if(searchData.duration==6){
            return 202477
          }else if(searchData.duration==8){
            return 202480
          }else if(searchData.duration==9){
            return 202482
          }else if(searchData.duration==10){
            return 202487
          }else{
            return 202487
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221586
          }else if(searchData.duration==6){
            return 221589
          }else if(searchData.duration==8){
            return 221592
          }else if(searchData.duration==9){
            return 221595
          }else if(searchData.duration==10){
            return 221600
          }else{
            return 221600
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==5){
            return 202473
          }else if(searchData.duration==6){
            return 202477
          }else if(searchData.duration==8){
            return 202480
          }else if(searchData.duration==9){
            return 202482
          }else if(searchData.duration==10){
            return 202487
          }else{
            return 202487
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 202068
          }else if(searchData.duration==6){
            return 202099
          }else if(searchData.duration==8){
            return 202108
          }else if(searchData.duration==9){
            return 202115
          }else if(searchData.duration==10){
            return 202126
          }else{
            return 202126
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 202432
          }else if(searchData.duration==6){
            return 202437
          }else if(searchData.duration==8){
            return 202441
          }else if(searchData.duration==9){
            return 202444
          }else if(searchData.duration==10){
            return 202448
          }else{
            return 202448
          }
        }else{
            if(searchData.duration==5){
            return 221586
          }else if(searchData.duration==6){
            return 221589
          }else if(searchData.duration==8){
            return 221592
          }else if(searchData.duration==9){
            return 221595
          }else if(searchData.duration==10){
            return 221600
          }else{
            return 221600
          }
        }
      }else if(searchData.type=="High"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 221616
          }else if(searchData.duration==6){
            return 221618
          }else if(searchData.duration==8){
            return 221621
          }else if(searchData.duration==9){
            return 221623
          }else if(searchData.duration==10){
            return 221631
          }else{
            return 221631
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221639
          }else if(searchData.duration==6){
            return 221618
          }else if(searchData.duration==8){
            return 221646
          }else if(searchData.duration==9){
            return 221648
          }else if(searchData.duration==10){
            return 221652
          }else{
            return 221652
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==5){
            return 221659
          }else if(searchData.duration==6){
            return 221661
          }else if(searchData.duration==8){
            return 221663
          }else if(searchData.duration==9){
            return 221666
          }else if(searchData.duration==10){
            return 221670
          }else{
            return 221670
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 202140
          }else if(searchData.duration==6){
            return 202148
          }else if(searchData.duration==8){
            return 202156
          }else if(searchData.duration==9){
            return 202175
          }else if(searchData.duration==10){
            return 202206
          }else{
            return 202206
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 204497
          }else if(searchData.duration==6){
            return 204502
          }else if(searchData.duration==8){
            return 204506
          }else if(searchData.duration==9){
            return 204510
          }else if(searchData.duration==10){
            return 204515
          }else{
            return 204515
          }
        }else{
            if(searchData.duration==5){
            return 221616
          }else if(searchData.duration==6){
            return 221618
          }else if(searchData.duration==8){
            return 221621
          }else if(searchData.duration==9){
            return 221623
          }else if(searchData.duration==10){
            return 221631
          }else{
            return 221631
          }
        }
      }else if(searchData.type=="Luxury"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 204548
          }else if(searchData.duration==6){
            return 204554
          }else if(searchData.duration==8){
            return 204558
          }else if(searchData.duration==9){
            return 204563
          }else if(searchData.duration==10){
            return 204572
          }else{
            return 204572
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221681
          }else if(searchData.duration==6){
            return 221684
          }else if(searchData.duration==8){
            return 221687
          }else if(searchData.duration==9){
            return 221691
          }else if(searchData.duration==10){
            return 221697
          }else{
            return 221697
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==5){
            return 221705
          }else if(searchData.duration==6){
            return 221707
          }else if(searchData.duration==8){
            return 221710
          }else if(searchData.duration==9){
            return 221712
          }else if(searchData.duration==10){
            return 221716
          }else{
            return 221716
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 202225
          }else if(searchData.duration==6){
            return 202229
          }else if(searchData.duration==8){
            return 202239
          }else if(searchData.duration==9){
            return 202258
          }else if(searchData.duration==10){
            return 202284
          }else{
            return 202284
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 204521
          }else if(searchData.duration==6){
            return 204523
          }else if(searchData.duration==8){
            return 204527
          }else if(searchData.duration==9){
            return 204530
          }else if(searchData.duration==10){
            return 204540
          }else{
            return 204540
          }
        }else{
            if(searchData.duration==5){
            return 221720
          }else if(searchData.duration==6){
            return 221724
          }else if(searchData.duration==8){
            return 221728
          }else if(searchData.duration==9){
            return 221730
          }else if(searchData.duration==10){
            return 221734
          }else{
            return 221734
          }
        }
      }
     }else if(searchData.special=="Spiti Delhi"){
      if(searchData.type=="Cheapest"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 202392
          }else if(searchData.duration==6){
            return 202399
          }else if(searchData.duration==8){
            return 202408
          }else if(searchData.duration==9){
            return 202418
          }else if(searchData.duration==10){
            return 202427
          }else{
            return 202427
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221445
          }else if(searchData.duration==6){
            return 221449
          }else if(searchData.duration==8){
            return 221452
          }else if(searchData.duration==9){
            return 201948
          }else if(searchData.duration==10){
            return 221461
          }else{
            return 221461
          }
        }else if(searchData.type=="Family without kids"){
             if(searchData.duration==5){
            return 221479
          }else if(searchData.duration==6){
            return 221482
          }else if(searchData.duration==8){
            return 221487
          }else if(searchData.duration==9){
            return 201948
          }else if(searchData.duration==10){
            return 221494
          }else{
            return 221494
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 201886
          }else if(searchData.duration==6){
            return 201922
          }else if(searchData.duration==8){
            return 201939
          }else if(searchData.duration==9){
            return 201948
          }else if(searchData.duration==10){
            return 201976
          }else{
            return 201976
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 202344
          }else if(searchData.duration==6){
            return 202349
          }else if(searchData.duration==8){
            return 202363
          }else if(searchData.duration==9){
            return 202366
          }else if(searchData.duration==10){
            return 201970
          }else{
            return 201970
          }
        }else{
            if(searchData.duration==5){
            return 221506
          }else if(searchData.duration==6){
            return 221516
          }else if(searchData.duration==8){
            return 221519
          }else if(searchData.duration==9){
            return 201948
          }else if(searchData.duration==10){
            return 221529
          }else{
            return 221529
          }
        }
      }else if(searchData.type=="Low"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 202452
          }else if(searchData.duration==6){
            return 202455
          }else if(searchData.duration==8){
            return 202457
          }else if(searchData.duration==9){
            return 202462
          }else if(searchData.duration==10){
            return 202467
          }else{
            return 202467
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221540
          }else if(searchData.duration==6){
            return 221546
          }else if(searchData.duration==8){
            return 221548
          }else if(searchData.duration==9){
            return 221551
          }else if(searchData.duration==10){
            return 221556
          }else{
            return 221556
          }
        }else if(searchData.type=="Family without kids"){
             if(searchData.duration==5){
            return 221566
          }else if(searchData.duration==6){
            return 221568
          }else if(searchData.duration==8){
            return 221570
          }else if(searchData.duration==9){
            return 221572
          }else if(searchData.duration==10){
            return 221577
          }else{
            return 221577
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 201998
          }else if(searchData.duration==6){
            return 202002
          }else if(searchData.duration==8){
            return 202006
          }else if(searchData.duration==9){
            return 202009
          }else if(searchData.duration==10){
            return 202019
          }else{
            return 202019
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 202431
          }else if(searchData.duration==6){
            return 202433
          }else if(searchData.duration==8){
            return 202439
          }else if(searchData.duration==9){
            return 202442
          }else if(searchData.duration==10){
            return 202447
          }else{
            return 202447
          }
        }else{
            if(searchData.duration==5){
            return 221540
          }else if(searchData.duration==6){
            return 221546
          }else if(searchData.duration==8){
            return 221548
          }else if(searchData.duration==9){
            return 221551
          }else if(searchData.duration==10){
            return 221556
          }else{
            return 221556
          }
        }
      }else if(searchData.type=="Medium"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 202472
          }else if(searchData.duration==6){
            return 202476
          }else if(searchData.duration==8){
            return 202479
          }else if(searchData.duration==9){
            return 202481
          }else if(searchData.duration==10){
            return 202486
          }else{
            return 202486
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221585
          }else if(searchData.duration==6){
            return 221588
          }else if(searchData.duration==8){
            return 221590
          }else if(searchData.duration==9){
            return 221594
          }else if(searchData.duration==10){
            return 221598
          }else{
            return 221598
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==5){
            return 202472
          }else if(searchData.duration==6){
            return 202476
          }else if(searchData.duration==8){
            return 202479
          }else if(searchData.duration==9){
            return 202481
          }else if(searchData.duration==10){
            return 202486
          }else{
            return 202486
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 202061
          }else if(searchData.duration==6){
            return 202095
          }else if(searchData.duration==8){
            return 202103
          }else if(searchData.duration==9){
            return 202110
          }else if(searchData.duration==10){
            return 202123
          }else{
            return 202123
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 202431
          }else if(searchData.duration==6){
            return 202433
          }else if(searchData.duration==8){
            return 202439
          }else if(searchData.duration==9){
            return 202442
          }else if(searchData.duration==10){
            return 202447
          }else{
            return 202447
          }
        }else{
            if(searchData.duration==5){
            return 221585
          }else if(searchData.duration==6){
            return 221588
          }else if(searchData.duration==8){
            return 221590
          }else if(searchData.duration==9){
            return 221594
          }else if(searchData.duration==10){
            return 221598
          }else{
            return 221598
          }
        }
      }else if(searchData.type=="High"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 221614
          }else if(searchData.duration==6){
            return 221617
          }else if(searchData.duration==8){
            return 221620
          }else if(searchData.duration==9){
            return 221622
          }else if(searchData.duration==10){
            return 221629
          }else{
            return 221629
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221638
          }else if(searchData.duration==6){
            return 221640
          }else if(searchData.duration==8){
            return 221645
          }else if(searchData.duration==9){
            return 221647
          }else if(searchData.duration==10){
            return 221651
          }else{
            return 221651
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==5){
            return 221656
          }else if(searchData.duration==6){
            return 221660
          }else if(searchData.duration==8){
            return 221662
          }else if(searchData.duration==9){
            return 221664
          }else if(searchData.duration==10){
            return 221669
          }else{
            return 221669
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 202137
          }else if(searchData.duration==6){
            return 202146
          }else if(searchData.duration==8){
            return 202152
          }else if(searchData.duration==9){
            return 202169
          }else if(searchData.duration==10){
            return 202200
          }else{
            return 202200
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 204493
          }else if(searchData.duration==6){
            return 204500
          }else if(searchData.duration==8){
            return 204505
          }else if(searchData.duration==9){
            return 204508
          }else if(searchData.duration==10){
            return 204514
          }else{
            return 204514
          }
        }else{
            if(searchData.duration==5){
            return 221614
          }else if(searchData.duration==6){
            return 221617
          }else if(searchData.duration==8){
            return 221620
          }else if(searchData.duration==9){
            return 221622
          }else if(searchData.duration==10){
            return 221629
          }else{
            return 221629
          }
        }
      }else if(searchData.type=="Luxury"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==5){
            return 204547
          }else if(searchData.duration==6){
            return 204553
          }else if(searchData.duration==8){
            return 204555
          }else if(searchData.duration==9){
            return 204561
          }else if(searchData.duration==10){
            return 204571
          }else{
            return 204571
          }
        }else if(searchData.type=="Family with kids"){
           if(searchData.duration==5){
            return 221680
          }else if(searchData.duration==6){
            return 221682
          }else if(searchData.duration==8){
            return 221685
          }else if(searchData.duration==9){
            return 221689
          }else if(searchData.duration==10){
            return 221695
          }else{
            return 221695
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==5){
            return 221703
          }else if(searchData.duration==6){
            return 221706
          }else if(searchData.duration==8){
            return 221709
          }else if(searchData.duration==9){
            return 221711
          }else if(searchData.duration==10){
            return 221715
          }else{
            return 221715
          }
        }else if(searchData.type=="Party lovers"){
            if(searchData.duration==5){
            return 202218
          }else if(searchData.duration==6){
            return 202228
          }else if(searchData.duration==8){
            return 202234
          }else if(searchData.duration==9){
            return 202256
          }else if(searchData.duration==10){
            return 202280
          }else{
            return 202280
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==5){
            return 204519
          }else if(searchData.duration==6){
            return 202228
          }else if(searchData.duration==8){
            return 204526
          }else if(searchData.duration==9){
            return 204528
          }else if(searchData.duration==10){
            return 204538
          }else{
            return 204538
          }
        }else{
            if(searchData.duration==5){
            return 221719
          }else if(searchData.duration==6){
            return 221723
          }else if(searchData.duration==8){
            return 221726
          }else if(searchData.duration==9){
            return 221729
          }else if(searchData.duration==10){
            return 221733
          }else{
            return 221733
          }
        }
      }
     }else if(searchData.special=="Dalhousie/Dharamsala"){

     }else{
       if(searchData.type=="Cheapest"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else{
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }
      }else if(searchData.type=="Low"){
          if(searchData.budget=="Romantic"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else{
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }
      }else if(searchData.type=="Medium"){
          if(searchData.budget=="Romantic"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else{
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }
      }else if(searchData.type=="High"){
         if(searchData.budget=="Romantic"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else{
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }
      }else if(searchData.type=="Luxury"){
          if(searchData.budget=="Romantic"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Family without kids"){
        if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else if(searchData.type=="Adventure junkies"){
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }else{
            if(searchData.duration==3){
            return 202395
          }else if(searchData.duration==4){
            return 202401
          }else if(searchData.duration==5){
            return 202412
          }else{
            return 202426
          }
        }
      }
     }
  }else if(searchData.dest=="Japan"){
    if(searchData.special=="FD"){
   if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }else if(searchData.budget=="Low"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }else if(searchData.budget=="Medium"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }else if(searchData.budget=="High"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }else if(searchData.budget=="Luxury"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }
    }else{
       if(searchData.budget=="Cheapest"){
        if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }else if(searchData.budget=="Low"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }else if(searchData.budget=="Medium"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }else if(searchData.budget=="High"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }else if(searchData.budget=="Luxury"){
       if(searchData.type=="Romantic"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family with kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Family without kids"){
          if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Party lovers"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else if(searchData.type=="Adventure junkies"){
           if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }else{
            if(searchData.duration==7){
            return 226311
          }else if(searchData.duration==13){
            return 226313
          }else{
            return 226330
          }
        }
      }
    }
  }else if(searchData.dest=="Georgia"){
    if(searchData.budget=="Cheapest"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 245873
        }if(searchData.duration==4){
          return 245873
        }else if(searchData.duration==5){
          return 245874
        }else if(searchData.duration==6){
          return 245905
        }else{
          return 245875
        }
      }else if(searchData.type=="Family with kids"){
         if(searchData.duration==3){
          return 245876
        }if(searchData.duration==4){
          return 245876
        }else if(searchData.duration==5){
          return 245877
        }else if(searchData.duration==6){
          return 245879
        }else{
          return 245880
        }
      }else if(searchData.type=="Family without kids"){
         if(searchData.duration==3){
          return 245881
        }if(searchData.duration==4){
          return 245881
        }else if(searchData.duration==5){
          return 245883
        }else if(searchData.duration==6){
          return 245884
        }else{
          return 245887
        }
      }else if(searchData.type=="Party lovers"){
         if(searchData.duration==3){
          return 245185
        }if(searchData.duration==4){
          return 245199
        }else if(searchData.duration==5){
          return 245209
        }else if(searchData.duration==6){
          return 245215
        }else{
          return 245227
        }
      }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
          return 245866
        }if(searchData.duration==4){
          return 245868
        }else if(searchData.duration==5){
          return 245869
        }else if(searchData.duration==6){
          return 245870
        }else{
          return 245871
        }
      }else{
        if(searchData.duration==3){
          return 245185
        }if(searchData.duration==4){
          return 245199
        }else if(searchData.duration==5){
          return 245209
        }else if(searchData.duration==6){
          return 245215
        }else{
          return 245227
        }
      }
    }else if(searchData.budget=="Low"){
        if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 245873
        }if(searchData.duration==4){
          return 245873
        }else if(searchData.duration==5){
          return 245874
        }else if(searchData.duration==6){
          return 245905
        }else{
          return 245875
        }
      }else if(searchData.type=="Family with kids"){
         if(searchData.duration==3){
          return 245876
        }if(searchData.duration==4){
          return 245876
        }else if(searchData.duration==5){
          return 245877
        }else if(searchData.duration==6){
          return 245879
        }else{
          return 245880
        }
      }else if(searchData.type=="Family without kids"){
         if(searchData.duration==3){
          return 245881
        }if(searchData.duration==4){
          return 245881
        }else if(searchData.duration==5){
          return 245883
        }else if(searchData.duration==6){
          return 245884
        }else{
          return 245887
        }
      }else if(searchData.type=="Party lovers"){
         if(searchData.duration==3){
          return 245185
        }if(searchData.duration==4){
          return 245199
        }else if(searchData.duration==5){
          return 245209
        }else if(searchData.duration==6){
          return 245215
        }else{
          return 245227
        }
      }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
          return 245866
        }if(searchData.duration==4){
          return 245868
        }else if(searchData.duration==5){
          return 245869
        }else if(searchData.duration==6){
          return 245870
        }else{
          return 245871
        }
      }else{
        if(searchData.duration==3){
          return 245185
        }if(searchData.duration==4){
          return 245199
        }else if(searchData.duration==5){
          return 245209
        }else if(searchData.duration==6){
          return 245215
        }else{
          return 245227
        }
      }
    }else if(searchData.budget=="Medium"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 245551
        }if(searchData.duration==4){
          return 245551
        }else if(searchData.duration==5){
          return 245554
        }else if(searchData.duration==6){
          return 245898
        }else{
          return 245555
        }
      }else if(searchData.type=="Family with kids"){
         if(searchData.duration==3){
          return 245827
        }if(searchData.duration==4){
          return 245827
        }else if(searchData.duration==5){
          return 245828
        }else if(searchData.duration==6){
          return 245829
        }else{
          return 245830
        }
      }else if(searchData.type=="Family without kids"){
         if(searchData.duration==3){
          return 245843
        }if(searchData.duration==4){
          return 245843
        }else if(searchData.duration==5){
          return 245844
        }else if(searchData.duration==6){
          return 245845
        }else{
          return 245848
        }
      }else if(searchData.type=="Party lovers"){
         if(searchData.duration==3){
          return 245411
        }if(searchData.duration==4){
          return 245412
        }else if(searchData.duration==5){
          return 245413
        }else if(searchData.duration==6){
          return 245896
        }else{
          return 245414
        }
      }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
          return 245475
        }if(searchData.duration==4){
          return 245476
        }else if(searchData.duration==5){
          return 245482
        }else if(searchData.duration==6){
          return 245494
        }else{
          return 245495
        }
      }else{
        if(searchData.duration==3){
          return 245411
        }if(searchData.duration==4){
          return 245412
        }else if(searchData.duration==5){
          return 245413
        }else if(searchData.duration==6){
          return 245896
        }else{
          return 245414
        }
      }
    }else if(searchData.budget=="High"){
     if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 245566
        }if(searchData.duration==4){
          return 245566
        }else if(searchData.duration==5){
          return 245570
        }else if(searchData.duration==6){
          return 245573
        }else{
          return 245575
        }
      }else if(searchData.type=="Family with kids"){
         if(searchData.duration==3){
          return 245831
        }if(searchData.duration==4){
          return 245831
        }else if(searchData.duration==5){
          return 245832
        }else if(searchData.duration==6){
          return 245908
        }else{
          return 245833
        }
      }else if(searchData.type=="Family without kids"){
         if(searchData.duration==3){
          return 245849
        }if(searchData.duration==4){
          return 245849
        }else if(searchData.duration==5){
          return 245850
        }else if(searchData.duration==6){
          return 245851
        }else{
          return 245853
        }
      }else if(searchData.type=="Party lovers"){
          if(searchData.duration==3){
          return 245417
        }if(searchData.duration==4){
          return 245421
        }else if(searchData.duration==5){
          return 245423
        }else if(searchData.duration==6){
          return 245424
        }else{
          return 245430
        }
      }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
          return 245504
        }if(searchData.duration==4){
          return 245504
        }else if(searchData.duration==5){
          return 245506
        }else if(searchData.duration==6){
          return 245903
        }else{
          return 245507
        }
      }else{
        if(searchData.duration==3){
          return 245417
        }if(searchData.duration==4){
          return 245421
        }else if(searchData.duration==5){
          return 245423
        }else if(searchData.duration==6){
          return 245424
        }else{
          return 245430
        }
      }
    }else if(searchData.budget=="Luxury"){
      if(searchData.type=="Romantic"){
        if(searchData.duration==3){
          return 245584
        }if(searchData.duration==4){
          return 245584
        }else if(searchData.duration==5){
          return 245586
        }else if(searchData.duration==6){
          return 245901
        }else{
          return 245590
        }
      }else if(searchData.type=="Family with kids"){
         if(searchData.duration==3){
          return 245836
        }if(searchData.duration==4){
          return 245836
        }else if(searchData.duration==5){
          return 245838
        }else if(searchData.duration==6){
          return 245839
        }else{
          return 245840
        }
      }else if(searchData.type=="Family without kids"){
         if(searchData.duration==3){
          return 245857
        }if(searchData.duration==4){
          return 245857
        }else if(searchData.duration==5){
          return 245858
        }else if(searchData.duration==6){
          return 245859
        }else{
          return 245860
        }
      }else if(searchData.type=="Party lovers"){
         if(searchData.duration==3){
          return 245433
        }if(searchData.duration==4){
          return 245434
        }else if(searchData.duration==5){
          return 245435
        }else if(searchData.duration==6){
          return 245902
        }else{
          return 245438
        }
      }else if(searchData.type=="Adventure junkies"){
         if(searchData.duration==3){
          return 245515
        }if(searchData.duration==4){
          return 245515
        }else if(searchData.duration==5){
          return 245517
        }else if(searchData.duration==6){
          return 245521
        }else{
          return 245526
        }
      }else{
        if(searchData.duration==3){
          return 245433
        }if(searchData.duration==4){
          return 245434
        }else if(searchData.duration==5){
          return 245435
        }else if(searchData.duration==6){
          return 245902
        }else{
          return 245438
        }
      }
    }
  }
  else{
    return 1
  }
}

export function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
       const key = keyGetter(item);
       const collection = map.get(key);
       if (!collection) {
           map.set(key, [item]);
       } else {
           collection.push(item);
       }
  });
  return map;
}

export const samplelimit=(dest)=>{
  var desttype = 100000;
  switch (dest) {
    case "Kashmir":
      desttype = 100000;
      break;
    case "Himachal":
      desttype = 100000;
      break;
    case "Andaman":
      desttype = 4000;
      break;
    case "Goa":
      desttype = 4500;
      break;
    case "Rajasthan":
      desttype = 100000;
      break;
    case "Dubai":
      desttype = 8500;
      break;
    case "Sikkim-Darjeeling":
      desttype = 100000;
      break;
    case "Uttarakhand":
      desttype = 100000;
      break;
    case "Kerala":
      desttype = 4000;
      break;
    case "North-East":
      desttype = 100000;
      break;
    case "Thailand":
      desttype = 4850;
      break;
    case "Philippines":
      desttype = 15000;
      break;
    case "Indonesia":
      desttype = 4000;
      break;
    case "Maldives":
      desttype = 19500;
      break;
    case "Mauritius":
      desttype = 10000;
      break;
    case "Singapore":
      desttype = 9400;
      break;
    case "Malaysia":
      desttype = 5800;
      break;
    case "Ladakh":
      desttype = 100000;
      break;
      case "Australia":
        desttype = 100000;
        break;
      
      case "Tamil Nadu":
        desttype = 100000;
      break;
      case "Vietnam":
        desttype = 7200;
      break;
      case "Sri Lanka":
        desttype = 6500;
      break;
      case "Seychelles":
        desttype = 100000;
      break;
      case "Gujarat":
        desttype = 100000;
      break;
      case "Golden Triangle":
        desttype = 100000;
      break;
      case "Turkey":
        desttype = 100000;
        break;
    default:
      desttype = 100000;

}
return desttype;
}

export const samplelimitflight=(dest)=>{
  var desttype = 100000;
  switch (dest) {
    case "Kashmir":
      desttype = 100000;
      break;
    case "Himachal":
      desttype = 100000;
      break;
    case "Andaman":
      desttype = 10000;
      break;
    case "Goa":
      desttype = 9500;
      break;
    case "Rajasthan":
      desttype = 100000;
      break;
    case "Dubai":
      desttype = 15000;
      break;
    case "Sikkim-Darjeeling":
      desttype = 100000;
      break;
    case "Uttarakhand":
      desttype = 100000;
      break;
    case "Kerala":
      desttype = 8500;
      break;
    case "North-East":
      desttype = 100000;
      break;
    case "Thailand":
      desttype = 10700;
      break;
    case "Philippines":
      desttype = 25000;
      break;
    case "Indonesia":
      desttype = 15000;
      break;
    case "Maldives":
      desttype = 27500;
      break;
    case "Mauritius":
      desttype = 22500;
      break;
    case "Singapore":
      desttype = 15600;
      break;
    case "Malaysia":
      desttype = 12000;
      break;
    case "Ladakh":
      desttype = 100000;
      break;
      case "Australia":
        desttype = 100000;
        break;
      
      case "Tamil Nadu":
        desttype = 100000;
      break;
      case "Vietnam":
        desttype = 13500;
      break;
      case "Sri Lanka":
        desttype = 12000;
      break;
      case "Seychelles":
        desttype = 100000;
      break;
      case "Gujarat":
        desttype = 100000;
      break;
      case "Golden Triangle":
        desttype = 100000;
      break;
      case "Turkey":
        desttype = 100000;
        break;
    default:
      desttype = 100000;

}
return desttype;
}

export const specialoptions=(dest)=>{
  var desttype = [];
  switch (dest) {
    case "Kashmir":
      desttype = [];
      break;
    case "Himachal":
      desttype = [];
      break;
    case "Andaman":
      desttype = [];
      break;
    case "Goa":
      desttype = [];
      break;
    case "Rajasthan":
      desttype = [];
      break;
    case "Dubai":
      desttype = ["Abu Dhabi stay", "FD Packages"];
      break;
    case "Sikkim-Darjeeling":
      desttype = ["Only-Gangtok", "Lachen & Lachung"];
      break;
    case "Uttarakhand":
      desttype = [];
      break;
    case "Kerala":
      desttype = [];
      break;
    case "North-East":
      desttype = [];
      break;
    case "Thailand":
      desttype = ["Bangkok-Pattaya"];
      break;
    case "Philippines":
      desttype = [];
      break;
    case "Indonesia":
      desttype = ["Nusa Penida stay", "Gili stay", "Singapore stay", "Malaysia stay", "Special Packages"];
      break;
    case "Maldives":
      desttype = [];
      break;
    case "Mauritius":
      desttype = [];
      break;
    case "Singapore":
      desttype = ["2N Cruise", "Bintan", "Malaysia", "Bali"];
      break;
    case "Malaysia":
      desttype = [];
      break;
    case "Ladakh":
      desttype = [];
      break;
      case "Australia":
        desttype = [];
        break;
      
      case "Tamil Nadu":
        desttype = [];
      break;
      case "Vietnam":
        desttype = ["Cruise Stay", "Phu Quoc", "FD"];
      break;
      case "Sri Lanka":
        desttype = [];
      break;
      case "Seychelles":
        desttype = [];
      break;
      case "Gujarat":
        desttype = [];
      break;
      case "Golden Triangle":
        desttype = [];
      break;
      case "Azerbaijan":
        desttype = ["Shahdag", "Gabala"];
      break;
      case "Turkey":
        desttype = ["Multi-city"];
      break;
      case "Meghalaya":
        desttype = ["Kaziranga"];
      break;
      case "Himachal":
        desttype = ["Spiti"];
      break;
      case "Japan":
        desttype = ["FD"];
      break;
    default:
      desttype = [];

}
return desttype;
}

export const getconvdate=(trip) => {
  if(trip){
    if("converted_date" in trip){
      return trip.converted_date
    }else{
    if(Array.isArray(trip.status_history)){
      if(trip.trip_status=="Converted"){
        if(trip.status_history.length>0){
          return "date" in trip.status_history[trip.status_history.length-1]?trip.status_history[trip.status_history.length-1].date:""
        }else{
          return ""
        }
      }else{
        if(trip.status_history.length>1){
        return "date" in trip.status_history[trip.status_history.length-2]?trip.status_history[trip.status_history.length-2].date:""
        }else{
          return ""
        }
      }
    }else{
      // if("date" in trip.status_history){
      //   return trip.status_history.date
      // }else{
      if("cust_payments" in trip){
        return trip && "cust_payments" in trip && trip.cust_payments.length>0 && "date" in trip.cust_payments[0]?trip.cust_payments[0].date:""
      }else{
        return ""
      }
    }
    }
  
}else{
  return ""
}
}

export const checkserviceduration=(emp, emplist)=>{
  var empname=emplist.filter(e=>e.short_name==emp)
  if(empname.length>0){
    if("doj" in empname[0]){
      var diff=(new Date().getTime()-new Date(empname[0].doj).getTime())/(1000*60*60*24)
      return diff
    }else{
      return 0
    }
  }else{
    return 0
  }
}

export const getconvdatearray=(sh) => {
for(let i=0;i<sh.length;i++){
  if(sh[i].new_status=="Converted"){
    return sh[i].date
  }
}
}

export const gethotdatearray=(sh) => {
  for(let i=0;i<sh.length;i++){
    if(sh[i].new_status=="Hot"){
      return sh[i].date
    }
  }
  }

  

export const getprofit=(trip)=>{
  
  if("booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state=="Back to Sales" && trip.trip_status!=="Closed"){
    return 0
  }else{
  if(trip.cust_payments && trip.supplier_payments){
    const a=total(trip.cust_payments)
    const b=gettcs(trip)
    const c=gettaxes(trip) 
   const d=sptotal(trip.supplier_payments)
    
    
    return a-b-c-d
    
  }else{
    return 0
  }
}
}

export const getconvtarget=(dest, month)=>{
  var result=""
  if(dest=="Dubai"){
    if(month=="January 2024"){
      result=30
    }else if(month=="February 2024"){
      result=30
    }else if(month=="March 2024"){
      result=15
    }else if(month=="April 2024"){
      result=24
    }else if(month=="May 2024"){
      result=13
    }else if(month=="June 2024"){
      result=20
    }else if(month=="July 2024"){
      result=21
    }else if(month=="August 2024"){
      result=37
    }else if(month=="September 2024"){
      result=28
    }else if(month=="October 2024"){
      result=35
    }else if(month=="November 2024"){
      result=30
    }else if(month=="December 2024"){
      result=38
    }else if(month=="January 2025"){
      result=31
    }else if(month=="February 2025"){
      result=22
    }else if(month=="March 2025"){
      result=25
    }else if(month=="April 2025"){
      result=29
    }else if(month=="May 2025"){
      result=27
    }else if(month=="June 2025"){
      result=18
    }else if(month=="July 2025"){
      result=21
    }else if(month=="August 2025"){
      result=29
    }else if(month=="September 2025"){
      result=46
    }else if(month=="October 2025"){
      result=64
    }else if(month=="November 2025"){
      result=48
    }else if(month=="December 2025"){
      result=50
    }else if(month=="January 2026"){
      result=36
    }else if(month=="February 2026"){
      result=31
    }else if(month=="March 2026"){
      result=19
    }else if(month=="April 2026"){
      result=0
    }else if(month=="May 2026"){
      result=0
    }else if(month=="June 2026"){
      result=0
    }else if(month=="July 2026"){
      result=8
    }else if(month=="August 2026"){
      result=9
    }else if(month=="September 2026"){
      result=13
    }else if(month=="October 2026"){
      result=15
    }else if(month=="November 2026"){
      result=21
    }
    
  }
  else if(dest=="Andaman"){
    if(month=="January 2024"){
      result=26
    }else if(month=="February 2024"){
      result=19
    }else if(month=="March 2024"){
      result=26
    }else if(month=="April 2024"){
      result=12
    }else if(month=="May 2024"){
      result=4
    }else if(month=="June 2024"){
      result=6
    }else if(month=="July 2024"){
      result=15
    }else if(month=="August 2024"){
      result=30
    }else if(month=="September 2024"){
      result=6
    }else if(month=="October 2024"){
      result=7
    }else if(month=="November 2024"){
      result=2
    }else if(month=="December 2024"){
      result=2
    }else if(month=="January 2025"){
      result=2
    }else if(month=="February 2025"){
      result=1
    }else if(month=="March 2025"){
      result=11
    }else if(month=="April 2025"){
      result=8
    }else if(month=="May 2025"){
      result=9
    }else if(month=="June 2025"){
      result=1
    }else if(month=="July 2025"){
      result=1
    }else if(month=="August 2025"){
      result=13
    }else if(month=="September 2025"){
      result=12
    }else if(month=="October 2025"){
      result=18
    }else if(month=="November 2025"){
      result=14
    }else if(month=="December 2025"){
      result=14
    }else if(month=="January 2026"){
      result=22
    }else if(month=="February 2026"){
      result=21
    }else if(month=="March 2026"){
      result=21
    }else if(month=="April 2026"){
      result=16
    }else if(month=="May 2026"){
      result=13
    }else if(month=="June 2026"){
      result=14
    }else if(month=="July 2026"){
      result=8
    }else if(month=="August 2026"){
      result=9
    }else if(month=="September 2026"){
      result=11
    }else if(month=="October 2026"){
      result=19
    }else if(month=="November 2026"){
      result=18
    }
  }
  else if(dest=="Indonesia"){
    if(month=="January 2024"){
      result=37
    }else if(month=="February 2024"){
      result=46
    }else if(month=="March 2024"){
      result=59
    }else if(month=="April 2024"){
      result=30
    }else if(month=="May 2024"){
      result=46
    }else if(month=="June 2024"){
      result=43
    }else if(month=="July 2024"){
      result=41
    }else if(month=="August 2024"){
      result=53
    }else if(month=="September 2024"){
      result=41
    }else if(month=="October 2024"){
      result=36
    }else if(month=="November 2024"){
      result=39
    }else if(month=="December 2024"){
      result=43
    }else if(month=="January 2025"){
      result=43
    }else if(month=="February 2025"){
      result=57
    }else if(month=="March 2025"){
      result=47
    }else if(month=="April 2025"){
      result=50
    }else if(month=="May 2025"){
      result=55
    }else if(month=="June 2025"){
      result=52
    }else if(month=="July 2025"){
      result=61
    }else if(month=="August 2025"){
      result=50
    }else if(month=="September 2025"){
      result=38
    }else if(month=="October 2025"){
      result=34
    }else if(month=="November 2025"){
      result=26
    }else if(month=="December 2025"){
      result=28
    }else if(month=="January 2026"){
      result=27
    }else if(month=="February 2026"){
      result=43
    }else if(month=="March 2026"){
      result=31
    }else if(month=="April 2026"){
      result=26
    }else if(month=="May 2026"){
      result=32
    }else if(month=="June 2026"){
      result=17
    }else if(month=="July 2026"){
      result=15
    }else if(month=="August 2026"){
      result=9
    }else if(month=="September 2026"){
      result=28
    }else if(month=="October 2026"){
      result=20
    }else if(month=="November 2026"){
      result=14
    }
  }
  else if(dest=="Thailand"){
    if(month=="January 2024"){
      result=19
    }else if(month=="February 2024"){
      result=12
    }else if(month=="March 2024"){
      result=16
    }else if(month=="April 2024"){
      result=14
    }else if(month=="May 2024"){
      result=26
    }else if(month=="June 2024"){
      result=19
    }else if(month=="July 2024"){
      result=21
    }else if(month=="August 2024"){
      result=25
    }else if(month=="September 2024"){
      result=21
    }else if(month=="October 2024"){
      result=33
    }else if(month=="November 2024"){
      result=27
    }else if(month=="December 2024"){
      result=29
    }else if(month=="January 2025"){
      result=36
    }else if(month=="February 2025"){
      result=40
    }else if(month=="March 2025"){
      result=42
    }else if(month=="April 2025"){
      result=51
    }else if(month=="May 2025"){
      result=48
    }else if(month=="June 2025"){
      result=53
    }else if(month=="July 2025"){
      result=46
    }else if(month=="August 2025"){
      result=42
    }else if(month=="September 2025"){
      result=41
    }else if(month=="October 2025"){
      result=39
    }else if(month=="November 2025"){
      result=40
    }else if(month=="December 2025"){
      result=35
    }else if(month=="January 2026"){
      result=31
    }else if(month=="February 2026"){
      result=34
    }else if(month=="March 2026"){
      result=35
    }else if(month=="April 2026"){
      result=33
    }else if(month=="May 2026"){
      result=30
    }else if(month=="June 2026"){
      result=39
    }else if(month=="July 2026"){
      result=34
    }else if(month=="August 2026"){
      result=33
    }else if(month=="September 2026"){
      result=27
    }else if(month=="October 2026"){
      result=31
    }else if(month=="November 2026"){
      result=42
    }
  }
  else if(dest=="Singapore"){
    if(month=="January 2024"){
      result=5
    }else if(month=="February 2024"){
      result=13
    }else if(month=="March 2024"){
      result=21
    }else if(month=="April 2024"){
      result=19
    }else if(month=="May 2024"){
      result=22
    }else if(month=="June 2024"){
      result=18
    }else if(month=="July 2024"){
      result=15
    }else if(month=="August 2024"){
      result=21
    }else if(month=="September 2024"){
      result=13
    }else if(month=="October 2024"){
      result=14
    }else if(month=="November 2024"){
      result=17
    }else if(month=="December 2024"){
      result=20
    }else if(month=="January 2025"){
      result=18
    }else if(month=="February 2025"){
      result=27
    }else if(month=="March 2025"){
      result=34
    }else if(month=="April 2025"){
      result=30
    }else if(month=="May 2025"){
      result=38
    }else if(month=="June 2025"){
      result=31
    }else if(month=="July 2025"){
      result=30
    }else if(month=="August 2025"){
      result=31
    }else if(month=="September 2025"){
      result=27
    }else if(month=="October 2025"){
      result=34
    }else if(month=="November 2025"){
      result=29
    }else if(month=="December 2025"){
      result=19
    }else if(month=="January 2026"){
      result=12
    }else if(month=="February 2026"){
      result=21
    }else if(month=="March 2026"){
      result=30
    }else if(month=="April 2026"){
      result=35
    }else if(month=="May 2026"){
      result=40
    }else if(month=="June 2026"){
      result=30
    }else if(month=="July 2026"){
      result=33
    }else if(month=="August 2026"){
      result=33
    }else if(month=="September 2026"){
      result=34
    }else if(month=="October 2026"){
      result=38
    }else if(month=="November 2026"){
      result=26
    }
  }
  else if(dest=="Malaysia"){
    if(month=="January 2024"){
      result=8
    }else if(month=="February 2024"){
      result=4
    }else if(month=="March 2024"){
      result=7
    }else if(month=="April 2024"){
      result=7
    }else if(month=="May 2024"){
      result=16
    }else if(month=="June 2024"){
      result=13
    }else if(month=="July 2024"){
      result=25
    }else if(month=="August 2024"){
      result=17
    }else if(month=="September 2024"){
      result=14
    }else if(month=="October 2024"){
      result=20
    }else if(month=="November 2024"){
      result=20
    }else if(month=="December 2024"){
      result=24
    }else if(month=="January 2025"){
      result=24
    }else if(month=="February 2025"){
      result=21
    }else if(month=="March 2025"){
      result=15
    }else if(month=="April 2025"){
      result=20
    }else if(month=="May 2025"){
      result=22
    }else if(month=="June 2025"){
      result=34
    }else if(month=="July 2025"){
      result=31
    }else if(month=="August 2025"){
      result=31
    }else if(month=="September 2025"){
      result=28
    }else if(month=="October 2025"){
      result=31
    }else if(month=="November 2025"){
      result=30
    }else if(month=="December 2025"){
      result=23
    }else if(month=="January 2026"){
      result=21
    }else if(month=="February 2026"){
      result=25
    }else if(month=="March 2026"){
      result=25
    }else if(month=="April 2026"){
      result=30
    }else if(month=="May 2026"){
      result=24
    }else if(month=="June 2026"){
      result=21
    }else if(month=="July 2026"){
      result=24
    }else if(month=="August 2026"){
      result=21
    }else if(month=="September 2026"){
      result=21
    }else if(month=="October 2026"){
      result=21
    }else if(month=="November 2026"){
      result=10
    }
  }
  else if(dest=="Sri Lanka"){
    if(month=="January 2024"){
      result=2
    }else if(month=="February 2024"){
      result=3
    }else if(month=="March 2024"){
      result=6
    }else if(month=="April 2024"){
      result=6
    }else if(month=="May 2024"){
      result=9
    }else if(month=="June 2024"){
      result=4
    }else if(month=="July 2024"){
      result=6
    }else if(month=="August 2024"){
      result=3
    }else if(month=="September 2024"){
      result=6
    }else if(month=="October 2024"){
      result=6
    }else if(month=="November 2024"){
      result=5
    }else if(month=="December 2024"){
      result=2
    }else if(month=="January 2025"){
      result=3
    }else if(month=="February 2025"){
      result=2
    }else if(month=="March 2025"){
      result=1
    }else if(month=="April 2025"){
      result=1
    }else if(month=="May 2025"){
      result=1
    }else if(month=="June 2025"){
      result=1
    }else if(month=="July 2025"){
      result=1
    }else if(month=="August 2025"){
      result=1
    }else if(month=="September 2025"){
      result=1
    }else if(month=="October 2025"){
      result=1
    }else if(month=="November 2025"){
      result=2
    }else if(month=="December 2025"){
      result=1
    }else if(month=="January 2026"){
      result=1
    }else if(month=="February 2026"){
      result=1
    }else if(month=="March 2026"){
      result=1
    }else if(month=="April 2026"){
      result=1
    }else if(month=="May 2026"){
      result=1
    }else if(month=="June 2026"){
      result=1
    }else if(month=="July 2026"){
      result=1
    }else if(month=="August 2026"){
      result=1
    }else if(month=="September 2026"){
      result=1
    }else if(month=="October 2026"){
      result=2
    }else if(month=="November 2026"){
      result=8
    }
  }
  else if(dest=="Maldives"){
    if(month=="January 2024"){
      result=6
    }else if(month=="February 2024"){
      result=0
    }else if(month=="March 2024"){
      result=5
    }else if(month=="April 2024"){
      result=4
    }else if(month=="May 2024"){
      result=2
    }else if(month=="June 2024"){
      result=2
    }else if(month=="July 2024"){
      result=1
    }else if(month=="August 2024"){
      result=1
    }else if(month=="September 2024"){
      result=5
    }else if(month=="October 2024"){
      result=3
    }else if(month=="November 2024"){
      result=4
    }else if(month=="December 2024"){
      result=5
    }else if(month=="January 2025"){
      result=5
    }else if(month=="February 2025"){
      result=4
    }else if(month=="March 2025"){
      result=2
    }else if(month=="April 2025"){
      result=0
    }else if(month=="May 2025"){
      result=0
    }else if(month=="June 2025"){
      result=0
    }else if(month=="July 2025"){
      result=0
    }else if(month=="August 2025"){
      result=0
    }else if(month=="September 2025"){
      result=2
    }else if(month=="October 2025"){
      result=2
    }else if(month=="November 2025"){
      result=0
    }else if(month=="December 2025"){
      result=0
    }else if(month=="January 2026"){
      result=1
    }else if(month=="February 2026"){
      result=1
    }else if(month=="March 2026"){
      result=1
    }else if(month=="April 2026"){
      result=0
    }else if(month=="May 2026"){
      result=0
    }else if(month=="June 2026"){
      result=0
    }else if(month=="July 2026"){
      result=0
    }else if(month=="August 2026"){
      result=3
    }else if(month=="September 2026"){
      result=0
    }else if(month=="October 2026"){
      result=0
    }else if(month=="November 2026"){
      result=0
    }
  }
  else if(dest=="Kerala"){
    if(month=="January 2024"){
      result=2
    }else if(month=="February 2024"){
      result=3
    }else if(month=="March 2024"){
      result=2
    }else if(month=="April 2024"){
      result=1
    }else if(month=="May 2024"){
      result=0
    }else if(month=="June 2024"){
      result=0
    }else if(month=="July 2024"){
      result=1
    }else if(month=="August 2024"){
      result=8
    }else if(month=="September 2024"){
      result=6
    }else if(month=="October 2024"){
      result=5
    }else if(month=="November 2024"){
      result=3
    }else if(month=="December 2024"){
      result=5
    }else if(month=="January 2025"){
      result=2
    }else if(month=="February 2025"){
      result=3
    }else if(month=="March 2025"){
      result=2
    }else if(month=="April 2025"){
      result=1
    }else if(month=="May 2025"){
      result=5
    }else if(month=="June 2025"){
      result=12
    }else if(month=="July 2025"){
      result=6
    }else if(month=="August 2025"){
      result=3
    }else if(month=="September 2025"){
      result=1
    }else if(month=="October 2025"){
      result=1
    }else if(month=="November 2025"){
      result=1
    }else if(month=="December 2025"){
      result=1
    }else if(month=="January 2026"){
      result=1
    }else if(month=="February 2026"){
      result=1
    }else if(month=="March 2026"){
      result=1
    }else if(month=="April 2026"){
      result=0
    }else if(month=="May 2026"){
      result=0
    }else if(month=="June 2026"){
      result=0
    }else if(month=="July 2026"){
      result=0
    }else if(month=="August 2026"){
      result=0
    }else if(month=="September 2026"){
      result=0
    }else if(month=="October 2026"){
      result=0
    }else if(month=="November 2026"){
      result=2
    }
  }
  else if(dest=="Turkey"){
    if(month=="January 2024"){
      result=0
    }else if(month=="February 2024"){
      result=10
    }else if(month=="March 2024"){
      result=7
    }else if(month=="April 2024"){
      result=7
    }else if(month=="May 2024"){
      result=1
    }else if(month=="June 2024"){
      result=1
    }else if(month=="July 2024"){
      result=0
    }else if(month=="August 2024"){
      result=0
    }else if(month=="September 2024"){
      result=0
    }else if(month=="October 2024"){
      result=0
    }else if(month=="November 2024"){
      result=0
    }else if(month=="December 2024"){
      result=0
    }else if(month=="January 2025"){
      result=0
    }else if(month=="February 2025"){
      result=0
    }else if(month=="March 2025"){
      result=0
    }else if(month=="April 2025"){
      result=0
    }else if(month=="May 2025"){
      result=0
    }else if(month=="June 2025"){
      result=0
    }else if(month=="July 2025"){
      result=0
    }else if(month=="August 2025"){
      result=0
    }else if(month=="September 2025"){
      result=0
    }else if(month=="October 2025"){
      result=0
    }else if(month=="November 2025"){
      result=0
    }else if(month=="December 2025"){
      result=0
    }else if(month=="January 2026"){
      result=0
    }else if(month=="February 2026"){
      result=0
    }else if(month=="March 2026"){
      result=0
    }else if(month=="April 2026"){
      result=0
    }else if(month=="May 2026"){
      result=0
    }else if(month=="June 2026"){
      result=0
    }else if(month=="July 2026"){
      result=0
    }else if(month=="August 2026"){
      result=0
    }else if(month=="September 2026"){
      result=0
    }else if(month=="October 2026"){
      result=0
    }else if(month=="November 2026"){
      result=0
    }
  }
  else if(dest=="Kashmir"){
      if(month=="January 2024"){
        result=2
      }else if(month=="February 2024"){
        result=4
      }else if(month=="March 2024"){
        result=18
      }else if(month=="April 2024"){
        result=15
      }else if(month=="May 2024"){
        result=14
      }else if(month=="June 2024"){
        result=17
      }else if(month=="July 2024"){
        result=12
      }else if(month=="August 2024"){
        result=2
      }else if(month=="September 2024"){
        result=2
      }else if(month=="October 2024"){
        result=2
      }else if(month=="November 2024"){
        result=0
      }else if(month=="December 2024"){
        result=1
      }else if(month=="January 2025"){
        result=3
      }else if(month=="February 2025"){
        result=6
      }else if(month=="March 2025"){
        result=2
      }else if(month=="April 2025"){
        result=14
      }else if(month=="May 2025"){
      result=0
    }else if(month=="June 2025"){
      result=0
    }else if(month=="July 2025"){
      result=0
    }else if(month=="August 2025"){
      result=0
    }else if(month=="September 2025"){
      result=0
    }else if(month=="October 2025"){
      result=0
    }else if(month=="November 2025"){
      result=0
    }else if(month=="December 2025"){
      result=0
    }else if(month=="January 2026"){
      result=0
    }else if(month=="February 2026"){
      result=0
    }else if(month=="March 2026"){
      result=0
    }else if(month=="April 2026"){
      result=0
    }else if(month=="May 2026"){
      result=1
    }else if(month=="June 2026"){
      result=0
    }else if(month=="July 2026"){
      result=0
    }else if(month=="August 2026"){
      result=0
    }else if(month=="September 2026"){
      result=0
    }else if(month=="October 2026"){
      result=0
    }else if(month=="November 2026"){
      result=0
    }
  }
  else if(dest=="Vietnam"){
    if(month=="January 2024"){
      result=1
    }else if(month=="February 2024"){
      result=4
    }else if(month=="March 2024"){
      result=1
    }else if(month=="April 2024"){
      result=3
    }else if(month=="May 2024"){
      result=7
    }else if(month=="June 2024"){
      result=5
    }else if(month=="July 2024"){
      result=6
    }else if(month=="August 2024"){
      result=5
    }else if(month=="September 2024"){
      result=6
    }else if(month=="October 2024"){
      result=10
    }else if(month=="November 2024"){
      result=15
    }else if(month=="December 2024"){
      result=8
    }else if(month=="January 2025"){
      result=9
    }else if(month=="February 2025"){
      result=30
    }else if(month=="March 2025"){
      result=25
    }else if(month=="April 2025"){
      result=25
    }else if(month=="May 2025"){
      result=24
    }else if(month=="June 2025"){
      result=28
    }else if(month=="July 2025"){
      result=39
    }else if(month=="August 2025"){
      result=44
    }else if(month=="September 2025"){
      result=43
    }else if(month=="October 2025"){
      result=43
    }else if(month=="November 2025"){
      result=48
    }else if(month=="December 2025"){
      result=45
    }else if(month=="January 2026"){
      result=43
    }else if(month=="February 2026"){
      result=45
    }else if(month=="March 2026"){
      result=53
    }else if(month=="April 2026"){
      result=44
    }else if(month=="May 2026"){
      result=47
    }else if(month=="June 2026"){
      result=48
    }else if(month=="July 2026"){
      result=65
    }else if(month=="August 2026"){
      result=47
    }else if(month=="September 2026"){
      result=47
    }else if(month=="October 2026"){
      result=45
    }else if(month=="November 2026"){
      result=49
    }
  }
  else if(dest=="Azerbaijan"){
   
    if(month=="July 2024"){
      result=3
    }else if(month=="December 2024"){
      result=1
    }else if(month=="January 2025"){
      result=6
    }else if(month=="February 2025"){
      result=4
    }else if(month=="March 2025"){
      result=5
    }else if(month=="April 2025"){
      result=10
    }else if(month=="May 2025"){
      result=0
    }else if(month=="June 2025"){
      result=0
    }else if(month=="July 2025"){
      result=0
    }else if(month=="August 2025"){
      result=0
    }else if(month=="September 2025"){
      result=0
    }else if(month=="October 2025"){
      result=0
    }else if(month=="November 2025"){
      result=0
    }else if(month=="December 2025"){
      result=2
    }else if(month=="January 2026"){
      result=0
    }else if(month=="February 2026"){
      result=0
    }else if(month=="March 2026"){
      result=0
    }else if(month=="April 2026"){
      result=0
    }else if(month=="May 2026"){
      result=0
    }else if(month=="June 2026"){
      result=0
    }else if(month=="July 2026"){
      result=0
    }else if(month=="August 2026"){
      result=0
    }else if(month=="September 2026"){
      result=0
    }else if(month=="October 2026"){
      result=0
    }else if(month=="November 2026"){
      result=0
    }
  }
  else{
    if(month=="January 2024"){
      result=137
    }
    if(month=="February 2024"){
      result=148
    }
    if(month=="March 2024"){
      result=184
    }
    if(month=="April 2024"){
      result=143
    }
    if(month=="May 2024"){
      result=167
    }
    if(month=="June 2024"){
      result=163
    }
    if(month=="July 2024"){
      result=173
    }
    if(month=="August 2024"){
      result=205
    }
    if(month=="September 2024"){
      result=150
    }
    if(month=="October 2024"){
      result=170
    }
    if(month=="November 2024"){
      result=165
    }
    if(month=="December 2024"){
      result=184
    }
    if(month=="January 2025"){
      result=189
    }
    if(month=="February 2025"){
      result=229
    }
    if(month=="March 2025"){
      result=214
    }
    if(month=="April 2025"){
      result=247
    }
    if(month=="May 2025"){
      result=256
    }
    if(month=="June 2025"){
      result=241
    }
    if(month=="June 2025"){
      result=248
    }
    if(month=="July 2025"){
      result=249
    }
    if(month=="August 2025"){
      result=261
    }
     if(month=="September 2025"){
      result=249
    }
     if(month=="October 2025"){
      result=272
    }
    if(month=="November 2025"){
      result=242
    }
    if(month=="December 2025"){
      result=224
    }
    if(month=="January 2026"){
      result=195
    }
    if(month=="February 2026"){
      result=224
    }
    if(month=="March 2026"){
      result=219
    }
    if(month=="April 2026"){
      result=193
    }
    if(month=="May 2026"){
      result=200
    }
    if(month=="June 2026"){
      result=212
    }
    if(month=="July 2026"){
      result=207
    }
    if(month=="August 2026"){
      result=185
    }
    if(month=="September 2026"){
      result=200
    }
    if(month=="September 2026"){
      result=199
    }
    if(month=="September 2026"){
      result=196
    }
  }
  return result
}

export const paymentdate=(rule, dot)=>{
  var result=""
  if(rule=="Day of Booking"){
    result=new Date()
  }
  else if(rule=="3 days before date of travel"){
    result=DateCalc2(dot, -3)
  }
  else if(rule=="7 days before date of travel"){
    result=DateCalc2(dot, -7)
  }
  else if(rule=="15 days before date of travel"){
    result=DateCalc2(dot, -15)
  }
  else if(rule=="21 days before date of travel"){
    result=DateCalc2(dot, -21)
  }
  else if(rule=="30 days before date of travel"){
    result=DateCalc2(dot, -30)
  }
  else if(rule=="45 days before date of travel"){
    result=DateCalc2(dot, -45)
  }
  else if(rule=="Date of travel"){
    result=DateCalc2(dot, 0)
  }
  else if(rule=="Every 15 days post travel"){
    result=DateCalc2(dot, 7)
  }
  else if(rule=="Custom"){
    result=""
  }
   
  return result
}

export function fcheck2(dest, adult, child, price, duration) {
  var desttype = 0;
  if(price.airfare){
  switch (dest) {
    case "Kashmir":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Himachal":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Andaman":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>40000)
      desttype = 1;
      break;
    case "Goa":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Rajasthan":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Dubai":
      if((price.airfare/(adult+child))<8000 || (price.airfare/(adult+child))>40000)
      desttype = 1;
      break;
    case "Sikkim-Darjeeling":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>30000)
      desttype = 1;
      break;
    case "Uttarakhand":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Kerala":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "North-East":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Thailand":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>50000)
      desttype = 1;
      break;
    case "Philippines":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>50000)
      desttype = 1;
      break;
    case "Indonesia":
      if((price.airfare/(adult+child))<10000 || (price.airfare/(adult+child))>40000)
      desttype = 1;
      break;
    case "Maldives":
      if((price.airfare/(adult+child))<8000 || (price.airfare/(adult+child))>50000)
      desttype = 1;
      break;
    case "Mauritius":
      if((price.airfare/(adult+child))<10000 || (price.airfare/(adult+child))>80000)
      desttype = 1;;
      break;
    case "Singapore":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>25000)
      desttype = 1;
      break;
    case "Malaysia":
      if((price.airfare/(adult+child))<8000 || (price.airfare/(adult+child))>50000)
      desttype = 1;
      break;
    case "Ladakh":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>30000)
      desttype = 1;
      break;
    case "Vietnam":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>40000)
      desttype = 1;
      break;
      case "Sri Lanka":
      if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>40000)
      desttype = 1;
        break;
        case "Turkey":
          if((price.airfare/(adult+child))<5000 || (price.airfare/(adult+child))>100000)
          desttype = 1;
            break;
    default:
      desttype = 0;

}
  }
return desttype;
}

export function lcheck2(dest, adult, child, price, duration) {
  var desttype = 0;
  if(price.landprice){
  switch (dest) {
    case "Kashmir":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<2500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>8000)
      desttype = 1;
      break;
    case "Himachal":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<2500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>8000)
      desttype = 1;
      break;
    case "Andaman":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<3000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>8000)
      desttype = 1;
      break;
    case "Goa":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<2500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>8000)
      desttype = 1;
      break;
    case "Rajasthan":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<2500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>8000)
      desttype = 1;
      break;
    case "Dubai":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<5000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>12000)
      desttype = 1;
      break;
    case "Sikkim-Darjeeling":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<2500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>10000)
      desttype = 1;
      break;
    case "Uttarakhand":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<2500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>8000)
      desttype = 1;
      break;
    case "Kerala":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<2500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>8000)
      desttype = 1;
      break;
    case "North-East":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<2500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>8000)
      desttype = 1;
      break;
    case "Thailand":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<4000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>10000)
      desttype = 1;
      break;
     case "Philippines":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<4000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>10000)
      desttype = 1;
      break;
    case "Indonesia":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<3500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>10000)
      desttype = 1;
      break;
    case "Maldives":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<5000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>20000)
      desttype = 1;
      break;
    case "Mauritius":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<5000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>20000)
      desttype = 1;
      break;
    case "Singapore":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<4000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>12000)
      desttype = 1;
      break;
    case "Malaysia":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<3000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>8000)
      desttype = 1;
      break;
    case "Ladakh":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<3000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>10000)
      desttype = 1;
      break;
    case "Vietnam":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<4000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>12000)
      desttype = 1;
      break;
      case "Sri Lanka":
        if((((price.landprice+price.otheritems)/(adult+child))/duration)<3500 || (((price.landprice+price.otheritems)/(adult+child))/duration)>10000)
      desttype = 1;
        break;
        case "Turkey":
      if((((price.landprice+price.otheritems)/(adult+child))/duration)<5000 || (((price.landprice+price.otheritems)/(adult+child))/duration)>20000)
      desttype = 1;
        break;
    default:
      desttype = 0;

}
  }
return desttype;
}

export const checkquotefault=(dest, adult, child, sp, cp, duration)=>{
  let result=""

  const fcheckres=fcheck2(dest, adult, child, sp, duration)
  if(fcheckres){
    result=result+"Check flight prices"
  }
  const lcheckres=lcheck2(dest, adult, child, sp, duration)
  if(lcheckres){
    result=result+" || Check land prices"
  }
  if(result==""){
    result="All Good"
  }

  return result
}

export const gettimediff=(origin, deptime, destination, arrtime)=>{
  const origintimediff=gettimezone(origin)
  const desttimediff=gettimezone(destination)
  const originlocaltime=addMinutesToISODate(deptime, origintimediff)
  const destlocaltime=addMinutesToISODate(arrtime, desttimediff)
  //const timediff=desttimediff-origintimediff
  return (new Date(destlocaltime).getTime()-new Date(originlocaltime).getTime())/(1000*60)
}

export const addMinutesToISODate=(isoDate, minutesToAdd) =>{
  const date = new Date(isoDate); // Convert ISO date string to a Date object
  const updatedDate = new Date(date.getTime() + minutesToAdd * 60000); // Add minutes in milliseconds

  // Format the updated date in ISO format
  const isoFormat = updatedDate.toISOString().slice(0, 19) + 'Z';

  return isoFormat;
}

export const gettimezone=(city)=>{

  var curr = 0;
  switch (city) {
    case "Bangkok":
      curr = -90;
      break;
    case "Phuket":
      curr = -90;
      break;
    case "Krabi":
      curr = -90;
      break;
    case "Koh Samui":
      curr = -90;
      break;
    case "Singapore":
      curr = -150;
      break;
    case "Bangkok (DMK)":
      curr = -90;
      break;
    case "Istanbul":
      curr = 150;
      break;
      case "Antalya":
      curr = 150;
      break;
      case "Ankara":
      curr = 150;
      break;
      case "Izmir":
      curr = 150;
      break;
      case "Bodrum":
      curr = 150;
      break;
      case "Nevsehir":
      curr = 150;
      break;
      case "Konya":
      curr = 150;
      break;
      case "Dalaman":
      curr = 150;
      break;
    case "Berlin":
      curr = 270;
      break;
    case "Zurich":
      curr = 270;
      break;
    case "Kuala Lumpur":
      curr = -150;
      break;
    case "Langkawi":
      curr = -150;
      break;
    case "Penang":
      curr = -150;
      break;
    case "Denpasar":
      curr = -150;
      break;
    case "Male":
      curr = 30;
      break;
    case "Gan":
      curr = 30;
      break;
    case "Dubai":
      curr = 90;
      break;
    case "Abu Dhabi":
      curr = 90;
      break;
    case "Sharjah":
        curr = 90;
        break;
        case "Hanoi":
          curr = -90;
          break;
          case "Ho Chi Minh":
            curr = -90;
            break;
            case "Phu Quoc":
            curr = -90;
            break;
            case "Da Nang":
            curr = -90;
            break;
            case "Mauritius":
            curr = 90;
            break;
            case "Hong Kong":
            curr = -150;
            break;
    case "Baku":
      curr = 90;
      break;
      case "Almaty":
        curr = 30;
        break;
        case "Tbilisi":
          curr = 90;
          break;

    default:
      curr = 0;
  }
  // {city:"Bangkok", airport:"BKK", type:"INT"},
  // {city:"Bangkok (DMK)", airport:"DMK", type:"INT"},
  // {city:"Phuket", airport:"HKT", type:"INT"},
  // {city:"Krabi", airport:"KBV", type:"INT"},
  // {city:"Koh Samui", airport:"USM", type:"INT"},
  // {city:"Kuala Lumpur", airport:"KUL", type:"INT"},
  // {city:"Langkawi", airport:"LGK", type:"INT"},
  // {city:"Penang", airport:"PEN", type:"INT"},
  // {city:"Singapore", airport:"SIN", type:"INT"},
  // {city:"Male", airport:"MLE", type:"INT"},
  // {city:"Gan", airport:"GAN", type:"INT"},
  // {city:"Denpasar", airport:"DPS", type:"INT"},
  // {city:"Dubai", airport:"DXB", type:"INT"},
  // {city:"Abu Dhabi", airport:"AUH", type:"INT"},
  // {city:"Sharjah", airport:"SHJ", type:"INT"},
  // {city:"Colombo", airport:"CMB", type:"INT"},
  // {city:"Ho Chi Minh", airport:"SGN", type:"INT"},
  // {city:"Hanoi", airport:"HAN", type:"INT"},
  // {city:"Da Nang", airport:"DAD", type:"INT"},
  // {city:"Phu Quoc", airport:"PQC", type:"INT"},
  // {city:"Mauritius", airport:"MRU", type:"INT"},
  // {city:"Istanbul", airport:"IST", type:"INT"},
  // {city:"Antalya", airport:"AYT", type:"INT"},
  // {city:"Ankra", airport:"ESB", type:"INT"},
  // {city:"Izmir", airport:"ADB", type:"INT"},
  // {city:"Nevsehir", airport:"NAV", type:"INT"},
  // {city:"Konya", airport:"KYA", type:"INT"},
  // {city:"Bodrum", airport:"BJV", type:"INT"},
  // {city:"Dalaman", airport:"DLM", type:"INT"},
  // {city:"Paris", airport:"CDG", type:"INT"},
  // {city:"Geneva", airport:"GVA", type:"INT"},
  // {city:"Rome", airport:"FCO", type:"INT"},
  // {city:"London", airport:"LHR", type:"INT"},
  // {city:"Frankfurt", airport:"FRA", type:"INT"},
  // {city:"Amsterdam", airport:"AMS", type:"INT"},
  // {city:"Vienna", airport:"VIE", type:"INT"},
  // {city:"Munich", airport:"MUC", type:"INT"},
  // {city:"Barcelona", airport:"BCN", type:"INT"},
  // {city:"Madrid", airport:"MAD", type:"INT"},
  // {city:"Milan", airport:"MXP", type:"INT"},
  // {city:"Brussels", airport:"BRU", type:"INT"},
  // {city:"Dublin", airport:"DUB", type:"INT"},
  // {city:"Stockholm", airport:"ARN", type:"INT"},
  // {city:"Copenhagen", airport:"CPH", type:"INT"},
  // {city:"Zurich", airport:"ZRH", type:"INT"},
  // {city:"Athens", airport:"ATH", type:"INT"},
  // {city:"Warsaw", airport:"WAW", type:"INT"},
  // {city:"Budapest", airport:"BUD", type:"INT"},
  // {city:"Prague", airport:"PRG", type:"INT"},
  // {city:"Oslo", airport:"OSL", type:"INT"},
  // {city:"Nice", airport:"NCE", type:"INT"},
  // {city:"Berlin", airport:"BER", type:"INT"},
  // {city:"Lyon", airport:"LYS", type:"INT"},
  // {city:"Helsinki", airport:"HEL", type:"INT"},
  // {city:"Venice", airport:"VCE", type:"INT"},
  // {city:"Edinburgh", airport:"EDI", type:"INT"},
  // {city:"Zagreb", airport:"ZAG", type:"INT"},
  // {city:"Tbilisi", airport:"TBS", type:"INT"},
  // {city:"Baku", airport:"GYD", type:"INT"},
  // {city:"Hong Kong", airport:"HKG", type:"INT"},
  // {city:"Almaty", airport:"ALA", type:"INT"},

  return curr;
}

export function generateRandomAlphanumeric() {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let result = '';
  for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      result += characters[randomIndex];
  }
  return result;
}

export function addHoursToDate(isoDate, hoursToAdd) {
  // Parse the ISO date string to create a Date object
  //let date = new Date(isoDate);
  
  // Add the specified number of hours
  isoDate.setHours(isoDate.getHours() + hoursToAdd);
  
  // Return the new date
  return isoDate.toISOString();
}

export function countTextValues(array) {
  // Create an empty object to store the counts
  const countObject = {};
  //const countObject = [];
  // Iterate through the array
  array.forEach(text => {
    // If the text value already exists as a key in the object, increment its value
    if (countObject[text]) {
      countObject[text]++;
    } else {
      // If the text value does not exist as a key, add it with a value of 1
      countObject[text] = 1;
    }
  });

  const resultArray = Object.keys(countObject).map(key => ({
    name: key,
    count: countObject[key]
  }));
  // Return the final count object
  return resultArray;
}

export const auditscore=[
  {
    name:"Sidharth",
    score:200,
  },
  {
    name:"Zoya",
    score:200,
  },
  {
    name:"Hitesh",
    score:200,
  },
  {
    name:"Aryan",
    score:200,
  },
  {
    name:"Prachi",
    score:200,
  },
  {
    name:"Mayank",
    score:200,
  },
  {
    name:"Swati",
    score:200,
  },
  {
    name:"Tulsi",
    score:200,
  },
  {
    name:"Tushar",
    score:100,
  },
  {
    name:"Faisal",
    score:200,
  },
  {
    name:"ManishK",
    score:200,
  },
  {
    name:"Manish",
    score:200,
  },
  {
    name:"Prisha",
    score:100,
  },
  {
    name:"Charu",
    score:100,
  },
  {
    name:"Yash",
    score:50,
  },
  {
    name:"Qausain",
    score:100,
  },
  {
    name:"AbhishekS",
    score:100,
  },
  {
    name:"HarshP",
    score:100,
  },
  {
    name:"Suraj",
    score:100,
  },
  {
    name:"Muskaan",
    score:200,
  },
  {
    name:"Shavez",
    score:200,
  },
  {
    name:"Shivangi",
    score:200,
  },
  {
    name:"Priyanka",
    score:200,
  },
  {
    name:"Anushka",
    score:200,
  },
  {
    name:"Aarju",
    score:200,
  },
  {
    name:"Sushant",
    score:100,
  },
  {
    name:"Priyanshi",
    score:200,
  },
  {
    name:"Isha",
    score:200,
  },
  {
    name:"Diya",
    score:50,
  },
  {
    name:"Utkarsh",
    score:100,
  },
  {
    name:"Ritik",
    score:100,
  },
  {
    name:"Yogender",
    score:100,
  },
  {
    name:"Sanjay",
    score:100,
  },
  {
    name:"Fatima",
    score:100,
  },
]

export const getISOstring=(date, time)=>{
  //console.log(date, time)
  if(date && time){
    const year=date.slice(0,4)
    const month=date.slice(5,7)
    const date2=date.slice(8,10)

    const hour=time.slice(0,2)
    const min=time.slice(3,5)
 return (((new Date(year+"-"+month+"-"+date2+"T"+hour+":"+min+":00").getTime()-new Date().getTime())/(1000*60*60)).toFixed(2))
    
    //return year+"-"+month+"-"+date+"T"+hour+":"+min+":00"
  }else{
    return DateCalc(0)
  }

}

export function calculateAverage(arr, key) {
  // Check if the array is empty
  if (arr.length === 0) {
      return 0;
  }

  // Calculate the sum of the values associated with the specified key
  const sum = arr.reduce((acc, obj) => {
      // Check if the object has the key and if the value is a number
      if (obj.hasOwnProperty(key) && typeof obj[key] === 'number') {
          return acc + obj[key];
      }
      return acc;
  }, 0);

  // Calculate the number of valid entries (entries with the specified key and a numeric value)
  const count = arr.reduce((acc, obj) => {
      if (obj.hasOwnProperty(key) && typeof obj[key] === 'number') {
          return acc + 1;
      }
      return acc;
  }, 0);

  // Calculate and return the average
  return count === 0 ? 0 : sum / count;
}

export function calculateAveragewithoutzero(arr, key) {
  // Check if the array is empty
  if (arr.length === 0) {
      return 0;
  }

  // Calculate the sum of the values associated with the specified key, ignoring zeros
  const sum = arr.reduce((acc, obj) => {
      // Check if the object has the key, the value is a number, and the value is not zero
      if (obj.hasOwnProperty(key) && typeof obj[key] === 'number' && obj[key] !== 0) {
          return acc + obj[key];
      }
      return acc;
  }, 0);

  // Calculate the number of valid entries (entries with the specified key, a numeric value, and non-zero)
  const count = arr.reduce((acc, obj) => {
      if (obj.hasOwnProperty(key) && typeof obj[key] === 'number' && obj[key] !== 0) {
          return acc + 1;
      }
      return acc;
  }, 0);

  // Calculate and return the average
  return count === 0 ? 0 : sum / count;
}

export const gethotdate=(trip)=>{
  if(Array.isArray(trip.status_history)){
  if("status_history" in trip && trip.status_history.length>0){
  const sharr=trip.status_history.filter(sh=>sh.new_status=="Hot")
  return sharr.length>0 && "date" in sharr[sharr.length-1]?sharr[sharr.length-1].date:""
  }else{
    return ""
  }
}else{
  return trip.status_history.date
}
}

export const checktourpricecategory=(date, tour)=>{
  var temp=""
  if("rate_category" in tour && tour.rate_category.length>0){
    for(let i=0; i<tour.rate_category.length;i++){
      if(new Date(date).getTime()>=new Date(tour.rate_category[i].start_date).getTime() && new Date(date).getTime()<new Date(tour.rate_category[i].end_date).getTime()){
        temp= tour.rate_category[i].category
        break
    }
  }
  }
  return temp
  
}

export function findCommonElements(arr1, arr2) {
  // Use a Set to efficiently find common elements
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);
  
  // Filter through one of the sets to find common elements
  return Array.from(set1).filter(item => set2.has(item));
}

export const getcancdate=(trip)=>{
  if(Array.isArray(trip.status_history)){
  if("status_history" in trip && trip.status_history.length>0){
  const sharr=trip.status_history.filter(sh=>sh.new_status=="Cancelled")
  return sharr.length>0 && "date" in sharr[sharr.length-1]?sharr[sharr.length-1].date:""
  }else{
    return ""
  }
}else{
  return trip.status_history.date
}
}

export const getstate=(trip)=>{
  var temp=""
  if("booking" in trip && "transfer_state" in trip.booking){
    if(trip.booking.transfer_state=="Accepted"){
      temp= " (A)"
    }else if(trip.booking.transfer_state=="Requested"){
      temp= " (R)"
    }else if(trip.booking.transfer_state=="Just Converted"){
      temp= " (J)"
    }else if(trip.booking.transfer_state=="Back to Sales"){
      temp= " (B)"
    }else if(trip.booking.transfer_state=="NA"){
      temp= " (NA)"
    }
   
  }
  if("hold_ops" in trip && trip.hold_ops){
    temp="**"+temp
  }
  if("no_tax" in trip && trip.no_tax || "only_flight" in trip && trip.only_flight){
    temp="SC "+temp
  }
  if("no_tcs" in trip && trip.no_tax){
    temp="PD "+temp
  }
  return temp
}

export  function filterQuotes(arr) {
  const grouped = {};

  // Group by trip_id
  for (const item of arr) {
    if (!grouped[item.trip_id]) {
      grouped[item.trip_id] = [];
    }
    grouped[item.trip_id].push(item);
  }

  const result = [];
  //console.log(grouped)
  // Process each trip_id group
  for (const tripId in grouped) {
    const quotes = grouped[tripId];
    //console.log(quotes)
    if(quotes && quotes.length>0 && "trip_details" in quotes[0] && quotes[0].trip_details.length>0 && "quote" in quotes[0].trip_details[0]){
    if (quotes[0].trip_details[0].quote.length === 1) {
      const onlyQuote = quotes[0];
      if (onlyQuote.edit_count > 0) {
        result.push(onlyQuote);
      }
    } else {
      // Sort by quote_id ascending
      const sorted = quotes[0].trip_details[0].quote.sort((a, b) => b - a);
      const highest = sorted[0];
      //console.log(highest)
      const highestquote=arr.filter(q=>q.quote_id==highest)
      //console.log(highestquote)
      if(highestquote.length>0){
     
        result.push(highestquote[0]); // Keep all
      
    }
    }
    }
    // if (quotes.length === 1) {
    //   const [onlyQuote] = quotes;
    //   if (onlyQuote.edit_count > 0) {
    //     result.push(onlyQuote);
    //   }
    // } else {
    //   // Sort by quote_id ascending
    //   const sorted = quotes.sort((a, b) => a.quote_id - b.quote_id);
    //   const lowest = sorted[0];

    //   // Keep all except the lowest if its edit_count === 0
    //   if (lowest.edit_count === 0) {
    //     result.push(...sorted.slice(1));
    //   } else {
    //     result.push(...sorted); // Keep all
    //   }
    // }
  }

  return result;
}

export const getmanager=(tl, date)=>{
    if(tl){
    if(tl=="NitinK"){
      if(new Date(date).getTime()<new Date("2026-04-15").getTime()){
         return "RohitS"
      }else{
        return "RohitS"
      }
    }
     if(tl=="Qausain"){
      if(new Date(date).getTime()<new Date("2026-04-15").getTime()){
         return "RohitS"
      }else{
        return "Asgar"
      }
    }
     if(tl=="Sidharth"){
      if(new Date(date).getTime()<new Date("2026-04-15").getTime()){
         return "RohitS"
      }else if(new Date(date).getTime()>new Date("2026-10-01").getTime()){
        return "RohitS"
      }else{
        return "Asgar"
      }
    }
     if(tl=="Hitesh"){
      if(new Date(date).getTime()<new Date("2026-04-15").getTime()){
         return "RohitS"
      }else{
        return "Asgar"
      }
    }
     if(tl=="Rana"){
      if(new Date(date).getTime()<new Date("2026-04-15").getTime()){
         return "Abhishek"
      }else{
        return "RohitS"
      }
    }
     if(tl=="HarshB"){
      if(new Date(date).getTime()<new Date("2026-04-15").getTime()){
         return "Abhishek"
      }else{
        return "RohitS"
      }
    }
     if(tl=="Yadvinder"){
      if(new Date(date).getTime()<new Date("2026-04-15").getTime()){
         return "Abhishek"
      }else if(new Date(date).getTime()>new Date("2026-10-01").getTime()){
        return "Asgar"
      }else{
        return "RohitS"
      }
    }
    if(tl=="Tulsi"){
      if(new Date(date).getTime()>new Date("2026-10-01").getTime()){
         return "RohitS"
      }else{
        return ""
      }
    }
    if(tl=="Manish"){
      if(new Date(date).getTime()>new Date("2026-10-01").getTime()){
         return "Asgar"
      }else{
        return ""
      }
    }
   
  }else{
    return ""
  }
}

export  const BlinkingText = styled(Typography)({
    // animation: 'blink 1s steps(2, start) infinite',
    // '@keyframes blink': {
    //   to: { visibility: 'hidden' },
    // },
    color: 'red',
    animation: 'slowBlink 2s ease-in-out infinite',
  '@keyframes slowBlink': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0 },
  },
});

export const getnextpaymentdate=(cp)=>{
  var x=""
  if(cp.length>0){
    for(let i=0;i<cp.length;i++){
      if(cp[i].status=="Pending"){
        x=cp[i].date
        break
      }
    }
    return x
  }else{
    return "Not set"
  }
}

export const getnextpaymentamount=(cp)=>{
  var x=""
  if(cp.length>0){
    for(let i=0;i<cp.length;i++){
      if(cp[i].status=="Pending"){
        x=cp[i].amount
        break
      }
    }
    return x
  }else{
    return "Not set"
  }
}

export const geturgent=(trip)=>{
   
    if(trip){
      return "booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state=="Back to Sales"?"B2S":(getprofit(trip) - (total(trip.cust_payments)-pending(trip.cust_payments))<0?((total(trip.cust_payments)-pending(trip.cust_payments))<10000?"<10k":false):true)
    }else{
      return ""
    }
  }

export function getOfficeHourDiff(startISO, endISO) {
  const officeStartHour = 11;
  const officeEndHour = 20; // 8 PM

  let start = moment(startISO);
  let end = moment(endISO);

  if (!start.isValid() || !end.isValid()) return 0;
  if (end.isBefore(start)) return 0;

  let totalHours = 0;
  let current = start.clone().startOf("day");

  while (current.isSameOrBefore(end, "day")) {
    const dayStart = current.clone().hour(officeStartHour).minute(0);
    const dayEnd = current.clone().hour(officeEndHour).minute(0);

    // Case 1: Entire day is before start or after end → skip
    if (dayEnd.isBefore(start) || dayStart.isAfter(end)) {
      current.add(1, "day");
      continue;
    }

    // Real interval inside office hours
    const rangeStart = moment.max(dayStart, start);
    const rangeEnd = moment.min(dayEnd, end);

    const diff = rangeEnd.diff(rangeStart, "hours", true); // fractional hours allowed
    if (diff > 0) totalHours += diff;

    current.add(1, "day");
  }

  return Math.round(totalHours); // or keep decimals if needed
}

export const getcomment=(trip, type, c)=>{
  var ret=""
  
  // if(trip.trip_id==117592){
  //   console.log(type, c)
  
  
  
  const length="tl_comment" in trip? trip.tl_comment.length:0
  if(length>=c){
    // console.log(length)
    for(let i=length-c;i>=0;i--){
      // console.log(count)
      if(trip.tl_comment[i].status==type){
        // console.log(trip.tl_comment[i].comment)
        ret=trip.tl_comment[i].comment
        break;
      }
    }
  }
  // }
  
  return ret
}

export function checkDate(inputIsoDate) {
  const inputDate = new Date(inputIsoDate);
  const now = new Date();

  // Get "today"
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // Time windows
  const yesterday8pm = new Date(today);
  yesterday8pm.setDate(today.getDate() - 1);
  yesterday8pm.setHours(20, 0, 0, 0);

  const today11am = new Date(today);
  today11am.setHours(11, 0, 0, 0);

  const today12pm = new Date(today);
  today12pm.setHours(12, 0, 0, 0);

  const today8pm = new Date(today);
  today8pm.setHours(20, 0, 0, 0);

  // --- CONDITION A ---
  if (inputDate >= yesterday8pm && inputDate <= today11am && now<today12pm) {
    return true;
  }

  // --- CONDITION B ---
  if (inputDate >= today11am && inputDate <= today8pm) {
    const diffMs = Math.abs(now - inputDate);
    const diffMinutes = diffMs / (1000 * 60);

    if (diffMinutes <= 30) {
      return true;
    }
  }

  return false;
}

export const spundertl=[
  {month:10, year:2026, name:"Tulsi", number_sp:5},
  {month:10, year:2026, name:"Hitesh", number_sp:6},
  {month:10, year:2026, name:"Sidharth", number_sp:6},
  {month:10, year:2026, name:"Manish", number_sp:4.5},
  {month:10, year:2026, name:"NitinK", number_sp:6},
  {month:10, year:2026, name:"Yadvinder", number_sp:6},
  {month:10, year:2026, name:"Qausain", number_sp:5},

  {month:9, year:2026, name:"HarshB", number_sp:5},
  {month:9, year:2026, name:"Hitesh", number_sp:6},
  {month:9, year:2026, name:"Sidharth", number_sp:6},
  {month:9, year:2026, name:"Rana", number_sp:5},
  {month:9, year:2026, name:"NitinK", number_sp:7},
  {month:9, year:2026, name:"Yadvinder", number_sp:5},
  {month:9, year:2026, name:"Qausain", number_sp:5},

  {month:8, year:2026, name:"HarshB", number_sp:5},
  {month:8, year:2026, name:"Hitesh", number_sp:5},
  {month:8, year:2026, name:"Sidharth", number_sp:5},
  {month:8, year:2026, name:"Rana", number_sp:5},
  {month:8, year:2026, name:"NitinK", number_sp:6},
  {month:8, year:2026, name:"Yadvinder", number_sp:6},
  {month:8, year:2026, name:"Qausain", number_sp:4},

  {month:7, year:2026, name:"HarshB", number_sp:5},
  {month:7, year:2026, name:"Hitesh", number_sp:5},
  {month:7, year:2026, name:"Sidharth", number_sp:5},
  {month:7, year:2026, name:"Rana", number_sp:5},
  {month:7, year:2026, name:"NitinK", number_sp:6},
  {month:7, year:2026, name:"Yadvinder", number_sp:6},
  {month:7, year:2026, name:"Qausain", number_sp:5},

  {month:6, year:2026, name:"HarshB", number_sp:6},
  {month:6, year:2026, name:"Hitesh", number_sp:6},
  {month:6, year:2026, name:"Sidharth", number_sp:6},
  {month:6, year:2026, name:"Rana", number_sp:6},
  {month:6, year:2026, name:"NitinK", number_sp:5},
  {month:6, year:2026, name:"Yadvinder", number_sp:5},
  {month:6, year:2026, name:"Qausain", number_sp:5},

  {month:5, year:2026, name:"HarshB", number_sp:5},
  {month:5, year:2026, name:"Hitesh", number_sp:6},
  {month:5, year:2026, name:"Sidharth", number_sp:6},
  {month:5, year:2026, name:"Rana", number_sp:7},
  {month:5, year:2026, name:"NitinK", number_sp:5},
  {month:5, year:2026, name:"Yadvinder", number_sp:6},
  {month:5, year:2026, name:"Qausain", number_sp:6},

  {month:4, year:2026, name:"HarshB", number_sp:5},
  {month:4, year:2026, name:"Hitesh", number_sp:6},
  {month:4, year:2026, name:"Sidharth", number_sp:6},
  {month:4, year:2026, name:"Rana", number_sp:6},
  {month:4, year:2026, name:"NitinK", number_sp:5},
  {month:4, year:2026, name:"Yadvinder", number_sp:5},
  {month:4, year:2026, name:"Qausain", number_sp:6},

  {month:3, year:2026, name:"HarshB", number_sp:5},
  {month:3, year:2026, name:"Hitesh", number_sp:6},
  {month:3, year:2026, name:"Sidharth", number_sp:6},
  {month:3, year:2026, name:"Rana", number_sp:5},
  {month:3, year:2026, name:"NitinK", number_sp:5},
  {month:3, year:2026, name:"Yadvinder", number_sp:6},
  {month:3, year:2026, name:"Qausain", number_sp:7},

  {month:2, year:2026, name:"HarshB", number_sp:6},
  {month:2, year:2026, name:"Hitesh", number_sp:5},
  {month:2, year:2026, name:"Sidharth", number_sp:6},
  {month:2, year:2026, name:"Rana", number_sp:5},
  {month:2, year:2026, name:"NitinK", number_sp:6},
  {month:2, year:2026, name:"Yadvinder", number_sp:6},
  {month:2, year:2026, name:"Qausain", number_sp:6},

  {month:1, year:2026, name:"HarshB", number_sp:6},
  {month:1, year:2026, name:"Hitesh", number_sp:5},
  {month:1, year:2026, name:"Sidharth", number_sp:6},
  {month:1, year:2026, name:"Rana", number_sp:4},
  {month:1, year:2026, name:"NitinK", number_sp:5},
  {month:1, year:2026, name:"RahulPS", number_sp:5},
  {month:1, year:2026, name:"Qausain", number_sp:5},

  {month:12, year:2025, name:"HarshB", number_sp:7},
  {month:12, year:2025, name:"Hitesh", number_sp:7},
  {month:12, year:2025, name:"Sidharth", number_sp:6},
  {month:12, year:2025, name:"Rana", number_sp:5},
  {month:12, year:2025, name:"Vinit", number_sp:6},
  {month:12, year:2025, name:"RahulPS", number_sp:5},
  {month:12, year:2025, name:"Qausain", number_sp:5},

  {month:11, year:2025, name:"HarshB", number_sp:7},
  {month:11, year:2025, name:"Hitesh", number_sp:6},
  {month:11, year:2025, name:"Sidharth", number_sp:6},
  {month:11, year:2025, name:"Rana", number_sp:6},
  {month:11, year:2025, name:"Vinit", number_sp:6},
  {month:11, year:2025, name:"RahulPS", number_sp:6},
  {month:11, year:2025, name:"Qausain", number_sp:6},

  {month:10, year:2025, name:"HarshB", number_sp:6},
  {month:10, year:2025, name:"Hitesh", number_sp:7},
  {month:10, year:2025, name:"Sidharth", number_sp:6},
  {month:10, year:2025, name:"Rana", number_sp:6},
  {month:10, year:2025, name:"Vinit", number_sp:7},
  {month:10, year:2025, name:"RahulPS", number_sp:4},

  {month:9, year:2025, name:"HarshB", number_sp:5},
  {month:9, year:2025, name:"Hitesh", number_sp:7},
  {month:9, year:2025, name:"Sidharth", number_sp:6},
  {month:9, year:2025, name:"Rana", number_sp:6},
  {month:9, year:2025, name:"Vinit", number_sp:6},
  {month:9, year:2025, name:"Ashish", number_sp:6, old_value:0},

  {month:8, year:2025, name:"HarshB", number_sp:5},
  {month:8, year:2025, name:"Hitesh", number_sp:6},
  {month:8, year:2025, name:"Sidharth", number_sp:7},
  {month:8, year:2025, name:"Rana", number_sp:7},
  {month:8, year:2025, name:"Ashish", number_sp:6, old_value:0.01},

  {month:7, year:2025, name:"HarshB", number_sp:5},
  {month:7, year:2025, name:"Hitesh", number_sp:7, old_value:0.01},
  {month:7, year:2025, name:"Sidharth", number_sp:6, old_value:0.01},
  {month:7, year:2025, name:"Rana", number_sp:6, old_value:0.015},
  {month:7, year:2025, name:"Ashish", number_sp:6, old_value:0.015},

  {month:6, year:2025, name:"HarshB", number_sp:5, old_value:0.03},
  {month:6, year:2025, name:"Hitesh", number_sp:7, old_value:0.01},
  {month:6, year:2025, name:"Sidharth", number_sp:6, old_value:0.01},
  {month:6, year:2025, name:"Rana", number_sp:6, old_value:0.01},
  {month:6, year:2025, name:"RohitS", number_sp:6, old_value:0.02},

  {month:5, year:2025, name:"HarshB", number_sp:5, old_value:0.015},
  {month:5, year:2025, name:"Hitesh", number_sp:7, old_value:0.01},
  {month:5, year:2025, name:"Sidharth", number_sp:6, old_value:0.01},
  {month:5, year:2025, name:"Rana", number_sp:6, old_value:0.02},
  {month:5, year:2025, name:"RohitS", number_sp:6, old_value:0.025},

  {month:4, year:2025, name:"HarshB", number_sp:5, old_value:0.01},
  {month:4, year:2025, name:"Hitesh", number_sp:7, old_value:0.01},
  {month:4, year:2025, name:"Sidharth", number_sp:6, old_value:0.01},
  {month:4, year:2025, name:"Rana", number_sp:6, old_value:0.01},
  {month:4, year:2025, name:"RohitS", number_sp:6, old_value:0.015},

  {month:3, year:2025, name:"HarshB", number_sp:5, old_value:0.015},
  {month:3, year:2025, name:"Hitesh", number_sp:7, old_value:0.01},
  {month:3, year:2025, name:"Sidharth", number_sp:6, old_value:0.01},
  {month:3, year:2025, name:"ShubhamP", number_sp:6, old_value:0.01},
  {month:3, year:2025, name:"RohitS", number_sp:6, old_value:0.015},

  {month:2, year:2025, name:"HarshB", number_sp:5, old_value:0.01},
  {month:2, year:2025, name:"Hitesh", number_sp:7, old_value:0.01},
  {month:2, year:2025, name:"RohitS", number_sp:6, old_value:0.01},

  {month:1, year:2025, name:"HarshB", number_sp:5, old_value:0.01},
  {month:1, year:2025, name:"ShubhamP", number_sp:7, old_value:0.01},

  {month:12, year:2024, name:"HarshB", number_sp:5, old_value:0.02},
  {month:12, year:2024, name:"ShubhamP", number_sp:7, old_value:0.015},

  {month:11, year:2024, name:"HarshB", number_sp:5, old_value:0.01},
  {month:11, year:2024, name:"ShubhamP", number_sp:7, old_value:0.015},

  {month:10, year:2024, name:"HarshB", number_sp:5, old_value:0.02},
  {month:10, year:2024, name:"ShubhamP", number_sp:7, old_value:0.02},

  {month:9, year:2024, name:"HarshB", number_sp:5, old_value:0.02},
  {month:9, year:2024, name:"ShubhamP", number_sp:7, old_value:0.01},
 
]

export const removesalessupport=(cr)=>{
  return cr.filter(c=>!(Number(c.outbound_sec)<20 && (c.answered_agent_name=="Maria" || c.answered_agent_name=="JatinSejwal" || c.answered_agent_name=="Vinayak" || c.answered_agent_name=="AryanLohia")))
}

export const classifyleadcreationtime=(lead)=>{
    const date = new Date(lead.createdAt);

// Convert UTC to IST
const istHours = (date.getUTCHours() + 5) % 24;
const istMinutes = (date.getUTCMinutes() + 30) % 60;

// Handle minute overflow
let finalHours = istHours;
if (date.getUTCMinutes() + 30 >= 60) {
  finalHours = (finalHours + 1) % 24;
}

const totalMinutes = finalHours * 60 + istMinutes;

const start = 11 * 60; // 11:00 AM
const end = 19 * 60;   // 7:00 PM

const isBetween = totalMinutes >= start && totalMinutes < end;

//console.log(isBetween);

return isBetween

  }

export const checklq=(leadData)=>{
  if(newgetqualitylead(leadData)=="Iron" || newgetqualitylead(leadData)=="Copper" || newgetqualitylead(leadData)=="Silver"){
    return true
  }else{
    return false
  }

}

export const checkhq=(leadData)=>{
  if(newgetqualitylead(leadData)=="Platinum" || newgetqualitylead(leadData)=="Rhodium" || newgetqualitylead(leadData)=="Diamond" || newgetqualitylead(leadData)=="Gold"){
    return true
  }else{
    return false
  }

}

export const checkhqwithtitanium=(leadData)=>{
  if(newgetqualitylead(leadData)=="Platinum" || newgetqualitylead(leadData)=="Rhodium" || newgetqualitylead(leadData)=="Diamond" || newgetqualitylead(leadData)=="Gold" || newgetqualitylead(leadData)=="Titanium"){
    return true
  }else{
    return false
  }

}

export const checklqwithtitanium=(leadData)=>{
  if(newgetqualitylead(leadData)=="Silver" || newgetqualitylead(leadData)=="Copper" || newgetqualitylead(leadData)=="Iron" || newgetqualitylead(leadData)=="Titanium"){
    return true
  }else{
    return false
  }

}

export function isSameMonth(d1, d2) {
  

  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth()
  );
}

export function getLeadCallTimeSummary(lead) {
  return (lead.callrecord || []).reduce(
      (sum, record) => sum + (parseInt(record.outbound_sec) || 0),
      0
    )
  
}

export const getmaillist=(trip, emplist, type)=>{
  var sp=[]
  if(type==1){
    sp=emplist.filter(e=>e.short_name==trip.trip_owner)
  }else{
    sp=emplist.filter(e=>e.short_name=="booking" in trip && "ops_assigned" in trip.booking?trip.booking.ops_assigned:[])
  }
  
  if(sp.length>0){
    var spemail=sp[0].email
    var tlname=sp[0].reporting_manager
    var tl=emplist.filter(e=>e.short_name==tlname)
    if(tl.length>0){
      var tlemail=tl[0].email
      var mname=tl[0].reporting_manager
      var m=emplist.filter(e=>e.short_name==mname)
      if(m.length>0){
        var memail=m[0].email
        return [spemail, tlemail, memail]
      }else{
        return [spemail, tlemail]
      }
    }else{
      return [spemail]
    }
  }else{
    return {}
  }
}

export const getempTL=(emp, emplist)=>{
  var emp=emplist.filter(e=>e.short_name==emp)
  if(emp.length>0){
    return emp[0].reporting_manager
  }else{
    return ""
  }
}

export const getUnique = (result, field) => {
  return [...new Set(
    result.map(item => item[field])
  )]
    .filter(v => v != null && v !== "")
    .sort();
};

// export const BlinkingText = styled(Typography)({
//     // animation: 'blink 1s steps(2, start) infinite',
//     // '@keyframes blink': {
//     //   to: { visibility: 'hidden' },
//     // },
//     fontSize:48,
//     color: 'red',
//     animation: 'slowBlink 2s ease-in-out infinite',
//   '@keyframes slowBlink': {
//     '0%, 100%': { opacity: 1 },
//     '50%': { opacity: 0 },
//   },
//   });


